!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("kubra-kmap", [], e) : "object" == typeof exports ? exports["kubra-kmap"] = e() : t["kubra-kmap"] = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 189);
  }([function (t, e, n) {
    "use strict";

    e.__esModule = !0, e.default = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(134));

    e.default = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), (0, r.default)(t, i.key, i);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }();
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.KLayerEvents = e.KGeometryEvents = e.KGeometryType = e.LayerShowShape = e.LayerShowMarker = e.ErrorCodes = e.KMapVectorFormat = e.KMapLayerType = e.KMapSpecialMarker = e.KMapType = e.KMapApi = e.KMapEvent = void 0;

    var r,
        i = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(90));

    var o = e.KMapEvent = {
      CLICK: "click",
      DOUBLECLICK: "dblclick",
      RIGHTCLICK: "rightclick",
      VIEWCHANGED: "viewChanged"
    },
        a = e.KMapApi = {
      GOOGLE: "google",
      LEAFLET: "leaflet",
      BING: "bing"
    },
        s = e.KMapType = (r = {}, (0, i.default)(r, a.GOOGLE, {
      DEFAULT: "roadmap",
      ROAD: "roadmap",
      SATELLITE: "satellite",
      HYBRID: "hybrid",
      TERRAIN: "terrain"
    }), (0, i.default)(r, a.LEAFLET, {
      DEFAULT: "osmmapnik",
      ROAD: "osmmapnik",
      TOPO: "opentopomap",
      OPEN_CYCLE: "cycle",
      OSMDE: "osmde",
      MAP_QUEST: "mapquest",
      OSMHOT: "osmhot"
    }), (0, i.default)(r, a.BING, {
      DEFAULT: "road",
      SATELLITE: "aerial",
      CANVAS_DARK: "canvasDark",
      CANVAS_LIGHT: "canvasLight",
      BIRDSEYE: "birdseye",
      MERCURATOR: "mercurator",
      GRAYSCALE: "grayscale",
      ROAD: "road"
    }), r),
        u = e.KMapSpecialMarker = {
      ADDRESS: "address",
      GPS: "gps",
      LOCATION: "location",
      BOOKMARK: "bookmark"
    },
        l = e.KMapLayerType = {
      VECTOR: "vector",
      TILE: "tile",
      DRAW: "draw",
      ANIMATED_TILE: "animated_tile",
      CLUSTER: "cluster"
    },
        c = e.KMapVectorFormat = {
      JSON: "json",
      GEOJSON: "geojson"
    },
        h = e.ErrorCodes = {
      ADDRESS_NOT_FOUND: 1,
      ADDRESS_NOT_IN_BOUNDS: 2,
      ADDRESS_SEARCH_FAILED: 3,
      OUT_OF_BOUNDS: 4,
      LAT_LNG_NOT_FOUND: 5
    },
        f = e.LayerShowMarker = {
      NEVER: 0,
      ALWAYS: 1,
      ONLY_ON_SHAPE_SELECTION: 2
    },
        p = e.LayerShowShape = {
      NEVER: 0,
      ALWAYS: 1,
      ONLY_ON_MARKER_SELECTION: 2
    },
        d = e.KGeometryType = {
      POINT: "POINT",
      POLYGON: "POLYGON",
      POLYLINE: "POLYLINE"
    },
        v = e.KGeometryEvents = {
      CLICK: "click",
      DOUBLECLICK: "dblclick",
      RIGHTCLICK: "rightclick"
    },
        y = e.KLayerEvents = {
      CLICK: "click",
      DOUBLECLICK: "dblclick",
      RIGHTCLICK: "rightclick",
      DYNAMICSTYLES: "dynamic-styles",
      FRAMELOADED: "step",
      TILESLOADED: "tilesloaded",
      LOADED: "LOADED"
    };
    e.default = {
      KMapEvent: o,
      KMapApi: a,
      KMapType: s,
      KMapSpecialMarker: u,
      KMapLayerType: l,
      KMapVectorFormat: c,
      ErrorCodes: h,
      LayerShowMarker: f,
      LayerShowShape: p,
      KGeometryType: d,
      KGeometryEvents: v,
      KLayerEvents: y
    };
  }, function (t, e) {
    var n = t.exports = {
      version: "2.6.11"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var r = n(98);

    t.exports = function (t, e, n) {
      var i = null == t ? void 0 : r(t, e);
      return void 0 === i ? n : i;
    };
  }, function (t, e, n) {
    var r = n(63),
        i = n(47),
        o = n(373),
        a = n(8);

    t.exports = function (t, e) {
      return (a(t) ? r : o)(t, i(e, 3));
    };
  }, function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    t.exports = {
      default: n(199),
      __esModule: !0
    };
  }, function (t, e) {
    var n = Array.isArray;
    t.exports = n;
  }, function (t, e, n) {
    t.exports = {
      default: n(202),
      __esModule: !0
    };
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    var r = n(6),
        i = n(3),
        o = n(37),
        a = n(29),
        s = n(31),
        u = function u(t, e, n) {
      var l,
          c,
          h,
          f = t & u.F,
          p = t & u.G,
          d = t & u.S,
          v = t & u.P,
          y = t & u.B,
          m = t & u.W,
          g = p ? i : i[e] || (i[e] = {}),
          _ = g.prototype,
          b = p ? r : d ? r[e] : (r[e] || {}).prototype;

      for (l in p && (n = e), n) {
        (c = !f && b && void 0 !== b[l]) && s(g, l) || (h = c ? b[l] : n[l], g[l] = p && "function" != typeof b[l] ? n[l] : y && c ? o(h, r) : m && b[l] == h ? function (t) {
          var e = function e(_e, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t();

                case 1:
                  return new t(_e);

                case 2:
                  return new t(_e, n);
              }

              return new t(_e, n, r);
            }

            return t.apply(this, arguments);
          };

          return e.prototype = t.prototype, e;
        }(h) : v && "function" == typeof h ? o(Function.call, h) : h, v && ((g.virtual || (g.virtual = {}))[l] = h, t & u.R && _ && !_[l] && a(_, l, h)));
      }
    };

    u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
  }, function (t, e, n) {
    var r = n(85)("wks"),
        i = n(57),
        o = n(6).Symbol,
        a = "function" == typeof o;
    (t.exports = function (t) {
      return r[t] || (r[t] = a && o[t] || (a ? o : i)("Symbol." + t));
    }).store = r;
  }, function (t, e, n) {
    "use strict";

    var r = n(159),
        i = Object.prototype.toString;

    function o(t) {
      return "[object Array]" === i.call(t);
    }

    function a(t) {
      return void 0 === t;
    }

    function s(t) {
      return null !== t && "object" == typeof t;
    }

    function u(t) {
      return "[object Function]" === i.call(t);
    }

    function l(t, e) {
      if (null !== t && void 0 !== t) if ("object" != typeof t && (t = [t]), o(t)) for (var n = 0, r = t.length; n < r; n++) {
        e.call(null, t[n], n, t);
      } else for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && e.call(null, t[i], i, t);
      }
    }

    t.exports = {
      isArray: o,
      isArrayBuffer: function isArrayBuffer(t) {
        return "[object ArrayBuffer]" === i.call(t);
      },
      isBuffer: function isBuffer(t) {
        return null !== t && !a(t) && null !== t.constructor && !a(t.constructor) && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
      },
      isFormData: function isFormData(t) {
        return "undefined" != typeof FormData && t instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(t) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
      },
      isString: function isString(t) {
        return "string" == typeof t;
      },
      isNumber: function isNumber(t) {
        return "number" == typeof t;
      },
      isObject: s,
      isUndefined: a,
      isDate: function isDate(t) {
        return "[object Date]" === i.call(t);
      },
      isFile: function isFile(t) {
        return "[object File]" === i.call(t);
      },
      isBlob: function isBlob(t) {
        return "[object Blob]" === i.call(t);
      },
      isFunction: u,
      isStream: function isStream(t) {
        return s(t) && u(t.pipe);
      },
      isURLSearchParams: function isURLSearchParams(t) {
        return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
      },
      forEach: l,
      merge: function t() {
        var e = {};

        function n(n, r) {
          "object" == typeof e[r] && "object" == typeof n ? e[r] = t(e[r], n) : e[r] = n;
        }

        for (var r = 0, i = arguments.length; r < i; r++) {
          l(arguments[r], n);
        }

        return e;
      },
      deepMerge: function t() {
        var e = {};

        function n(n, r) {
          "object" == typeof e[r] && "object" == typeof n ? e[r] = t(e[r], n) : e[r] = "object" == typeof n ? t({}, n) : n;
        }

        for (var r = 0, i = arguments.length; r < i; r++) {
          l(arguments[r], n);
        }

        return e;
      },
      extend: function extend(t, e, n) {
        return l(e, function (e, i) {
          t[i] = n && "function" == typeof e ? r(e, n) : e;
        }), t;
      },
      trim: function trim(t) {
        return t.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(7));

    e.default = r.default || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(136),
        i = "object" == typeof self && self && self.Object === Object && self,
        o = r || i || Function("return this")();
    t.exports = o;
  }, function (t, e, n) {
    var r = n(298),
        i = n(102),
        o = n(302),
        a = n(8);

    t.exports = function (t, e) {
      return (a(t) ? r : i)(t, o(e));
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = i(n(16));

    function i(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var o = (0, i(n(335)).default)({
      on: function on(t, e) {
        if (!this.events()[t]) {
          var n = void 0;
          this.context && (n = this.context.addEvent(this, t)), this.events()[t] = {
            callbacks: [],
            listener: n
          };
        }

        this.events()[t].callbacks.push(e);
      },
      off: function off(t, e) {
        if (this.events()[t]) {
          if (!e) {
            var n = this.events()[t].listener;
            return n && this.context.removeEvent(n, t), void delete this.events()[t];
          }

          var r = this.events()[t].callbacks.indexOf(e);
          if (-1 !== r) if (this.context && 1 === this.events()[t].callbacks.length) {
            var i = this.events()[t].listener;
            this.context.removeEvent(i, t), delete this.events()[t];
          } else this.events()[t].callbacks.splice(r, 1);
        } else console.log("Event not found");
      },
      trigger: function trigger(t) {
        for (var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) {
          n[r - 1] = arguments[r];
        }

        this.events()[t] && this.events()[t].callbacks.forEach(function (t) {
          t.apply(void 0, n);
        });
      },
      events: function events() {
        return this._topics || (this._topics = {}), this._topics;
      },
      setEventContext: function setEventContext(t) {
        var e = this;
        this.context = t, (0, r.default)(this.events(), function (t, n) {
          var r = e.context.addEvent(e, n);
          e.events()[n].listener = r;
        });
      }
    });
    e.default = o;
  }, function (t, e, n) {
    var r = n(20),
        i = n(115),
        o = n(80),
        a = Object.defineProperty;
    e.f = n(21) ? Object.defineProperty : function (t, e, n) {
      if (r(t), e = o(e, !0), r(n), i) try {
        return a(t, e, n);
      } catch (t) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e, n) {
    var r = n(26);

    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e, n) {
    t.exports = !n(30)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    var r = n(91),
        i = n(92);

    t.exports = function (t) {
      return null != t && i(t.length) && !r(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return null != t && "object" == typeof t;
    };
  }, function (t, e, n) {
    var r = n(142),
        i = n(150),
        o = n(64),
        a = n(8),
        s = n(22),
        u = n(65),
        l = n(68),
        c = n(67),
        h = "[object Map]",
        f = "[object Set]",
        p = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (null == t) return !0;
      if (s(t) && (a(t) || "string" == typeof t || "function" == typeof t.splice || u(t) || c(t) || o(t))) return !t.length;
      var e = i(t);
      if (e == h || e == f) return !t.size;
      if (l(t)) return !r(t).length;

      for (var n in t) {
        if (p.call(t, n)) return !1;
      }

      return !0;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getStyleOptions = void 0;

    var r = p(n(104)),
        i = p(n(14)),
        o = p(n(7)),
        a = p(n(105)),
        s = p(n(50)),
        u = e.getStyleOptions = function () {
      var t = (0, a.default)(r.default.mark(function t(e, n, a) {
        var s,
            u,
            p,
            y,
            g,
            _,
            b,
            L,
            x,
            w,
            M = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : l.default;

        return r.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (s = new Intl.NumberFormat(h.default.getItem("locale")), !(u = m(e, n))) {
                  t.next = 16;
                  break;
                }

                if (p = u.range, y = (0, l.default)(p, "rangeStyles", {}), g = (0, l.default)(y, ["icon", "labelValue"]), _ = g, b = (0, l.default)(y, ["icon", "url"]), !g) {
                  t.next = 15;
                  break;
                }

                for (x = (L = /\$\{([\w_-]*)\}/g).exec(g); null !== x;) {
                  w = v(M(n, x[1], "")), (0, c.default)(w) && (w = s.format(w)), _ = _.replace(x[0], w), x = L.exec(g);
                }

                return t.next = 14, (0, f.default)(y.icon.url, _, y.icon.size, y.icon.labelAnchor);

              case 14:
                b = t.sent;

              case 15:
                return t.abrupt("return", (0, o.default)((0, i.default)({}, y, {
                  index: u.index,
                  icon: (0, i.default)({}, y.icon, {
                    url: b
                  })
                })));

              case 16:
                return t.abrupt("return", {
                  icon: {
                    url: d,
                    anchor: [0, 24],
                    size: [24, 24],
                    color: "#fff",
                    opacity: 1
                  },
                  zIndex: a,
                  shape: {
                    opacity: .6,
                    fillColor: "#000",
                    borderColor: "#000",
                    borderOpacity: .6,
                    borderWeight: 1
                  }
                });

              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n, r) {
        return t.apply(this, arguments);
      };
    }();

    e.extractValue = v, e.validateCondition = y, e.extractRangeForRecord = m;
    var l = p(n(4)),
        c = p(n(168)),
        h = p(n(169)),
        f = p(n(170));

    function p(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var d = n(51);

    function v(t) {
      return "object" === (void 0 === t ? "undefined" : (0, s.default)(t)) ? (0, l.default)(t, "val", (0, l.default)(t, "value")) : t;
    }

    function y(t, e, n) {
      switch (e) {
        case "=":
          return n === t;

        case "<":
          return n < t;

        case ">":
          return n > t;

        case "<=":
          return n <= t;

        case ">=":
          return n >= t;

        case "!=":
          return n !== t;

        default:
          return !1;
      }
    }

    function m(t, e) {
      for (var n = (0, l.default)(t, "ranges", []), r = 0; r < n.length; r += 1) {
        var i = n[r];
        if (((0, l.default)(i, "rangeCriteria") || []).reduce(function (t, n) {
          return t && y(n.value, n.condition, v((0, l.default)(e, n.field)));
        }, !0)) return {
          range: i,
          index: r
        };
      }

      return null;
    }

    e.default = u;
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == typeof t ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    var r = n(61),
        i = n(228),
        o = n(229),
        a = "[object Null]",
        s = "[object Undefined]",
        u = r ? r.toStringTag : void 0;

    t.exports = function (t) {
      return null == t ? void 0 === t ? s : a : u && u in Object(t) ? i(t) : o(t);
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.encodeCoords = e.processGeometries = e.decodeLine = e.loadAutoCompleteAPI = e.loadCss = void 0;
    var r = s(n(9)),
        i = s(n(7)),
        o = s(n(4)),
        a = s(n(374));

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.tileXYToQuadKey = h, e.getTileUrlFunction = f;

    var u = {},
        l = e.loadCss = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

      if (!u[t]) {
        var n = document.createElement("link");
        n.rel = "stylesheet", n.href = t, (0, i.default)(n, e), document.getElementsByTagName("head")[0].appendChild(n), u[t] = 1;
      }
    },
        c = e.loadAutoCompleteAPI = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return u[t] ? 1 === u[t] ? u[t] : r.default.resolve() : (u[t] = new r.default(function (n, r) {
        var o = document.createElement("script");
        o.type = "text/javascript", o.readyState ? o.onreadystatechange = function () {
          "loaded" !== o.readyState && "complete" !== o.readyState || (o.onreadystatechange = null, u[t] = "loaded", n());
        } : (o.onload = function () {
          u[t] = "loaded", n();
        }, o.onerror = function () {
          u[t] = "loaded", r();
        }), (0, i.default)(o, e), o.src = t, document.getElementsByTagName("head")[0].appendChild(o), u[t] = 1;
      }), u[t]);
    };

    function h(t, e, n) {
      for (var r = "", i = n; i > 0; i -= 1) {
        var o = 0,
            a = 1 << i - 1;
        0 != (t & a) && (o += 1), 0 != (e & a) && (o += 1, o += 1), r += o;
      }

      return r;
    }

    function f(t) {
      return -1 !== t.indexOf("{q}") ? function (e, n) {
        var r = h(e.x, e.y, n);
        return t.replace(/{q}/, r);
      } : function (e, n) {
        return t.replace(/{x}/, e.x).replace(/{y}/, e.y).replace(/{z}/, n);
      };
    }

    var p = e.decodeLine = function (t) {
      var e = [];

      try {
        for (var n = t.length, r = 0, i = null, o = 0, a = 0; r < n;) {
          var s = void 0,
              u = 0,
              l = 0;

          do {
            s = t.charCodeAt(r) - 63, r += 1, l |= (31 & s) << u, u += 5;
          } while (s >= 32);

          o += 1 & l ? ~(l >> 1) : l >> 1, u = 0, l = 0;

          do {
            s = t.charCodeAt(r) - 63, r += 1, l |= (31 & s) << u, u += 5;
          } while (s >= 32);

          i = [o / 1e5, (a += 1 & l ? ~(l >> 1) : l >> 1) / 1e5], e.push(i);
        }
      } catch (t) {}

      return e;
    },
        d = function d(t, e) {
      return e ? p(t) : "string" == typeof t ? function (t, e, n) {
        try {
          if (t && "string" == typeof t && e && n) return (0, a.default)(t).split(e).map(function (t) {
            var e = t.split(n);
            return [parseFloat(e[0]), parseFloat(e[1])];
          });
        } catch (t) {
          console.log(t);
        }

        return [];
      }(t, "|", ",") : t ? t.length > 1 && !t[0] ? [t] : t : [];
    },
        v = e.processGeometries = function (t, e, n, r) {
      var i = function i(t) {
        if (!t) return null;

        for (var n = [], r = 0; r < t.length; r += 1) {
          var i = t[r],
              o = d(i, e);
          o && o.length > 0 && n.push(o);
        }

        return n;
      },
          a = {};

      return n || (a.areas = i((0, o.default)(t, "geom.a")), a.lines = i((0, o.default)(t, "geom.l"))), r || (a.points = i((0, o.default)(t, "geom.p"))), a;
    },
        y = e.encodeCoords = function (t) {
      for (var e = function e(t) {
        var e = t << 1;
        return t < 0 && (e = ~e), function (t) {
          for (var e = t, n = ""; e >= 32;) {
            n += String.fromCharCode(63 + (32 | 31 & e)), e >>= 5;
          }

          return n += String.fromCharCode(e + 63);
        }(e);
      }, n = 0, r = 0, i = "", o = 0; o < t.length; o += 1) {
        var a = t[o],
            s = a.lat,
            u = a.lng,
            l = Math.floor(1e5 * s),
            c = Math.floor(1e5 * u),
            h = l - n,
            f = c - r;
        n = l, r = c, i += e(h) + e(f);
      }

      return i;
    };

    e.default = {
      loadCss: l,
      loadAutoCompleteAPI: c,
      getTileUrlFunction: f,
      processGeometries: v,
      decodeLine: p,
      encodeCoords: y,
      tileXYToQuadKey: h
    };
  }, function (t, e, n) {
    var r = n(19),
        i = n(41);
    t.exports = n(21) ? function (t, e, n) {
      return r.f(t, e, i(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e) {
    var n = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var r = n(117),
        i = n(56);

    t.exports = function (t) {
      return r(i(t));
    };
  }, function (t, e, n) {
    var r = n(252),
        i = n(255);

    t.exports = function (t, e) {
      var n = i(t, e);
      return r(n) ? n : void 0;
    };
  }, function (t, e, n) {
    t.exports = n(16);
  }, function (t, e, n) {
    t.exports = {
      default: n(364),
      __esModule: !0
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(4));

    function i(t) {
      return {
        latitude: (0, r.default)(t, "lat"),
        longitude: (0, r.default)(t, "lng")
      };
    }

    function o(t) {
      return {
        lat: (0, r.default)(t, "latitude"),
        lng: (0, r.default)(t, "longitude")
      };
    }

    e.transformCoordToBingLatLng = i, e.transformBingLatLngToCoord = o, e.default = {
      transformCoordToBingLatLng: i,
      transformBingLatLngToCoord: o
    };
  }, function (t, e, n) {
    var r = n(55);

    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, i) {
            return t.call(e, n, r, i);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e, n) {
    var r = n(56);

    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(50));

    e.default = function (t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" !== (void 0 === e ? "undefined" : (0, r.default)(e)) && "function" != typeof e ? t : e;
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = a(n(369)),
        i = a(n(114)),
        o = a(n(50));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.default = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === e ? "undefined" : (0, o.default)(e)));
      t.prototype = (0, i.default)(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (r.default ? (0, r.default)(t, e) : t.__proto__ = e);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e, n) {
    var r = n(116),
        i = n(86);

    t.exports = Object.keys || function (t) {
      return r(t, i);
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    t.exports = !0;
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    var r = n(140),
        i = n(142),
        o = n(22);

    t.exports = function (t) {
      return o(t) ? r(t) : i(t);
    };
  }, function (t, e, n) {
    var r = n(240),
        i = n(286),
        o = n(73),
        a = n(8),
        s = n(291);

    t.exports = function (t) {
      return "function" == typeof t ? t : null == t ? o : "object" == typeof t ? a(t) ? i(t[0], t[1]) : r(t) : s(t);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return t === e || t != t && e != e;
    };
  }, function (t, e, n) {
    var r = n(62),
        i = 1 / 0;

    t.exports = function (t) {
      if ("string" == typeof t || r(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -i ? "-0" : e;
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = a(n(321)),
        i = a(n(323)),
        o = "function" == typeof i.default && "symbol" == typeof r.default ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof i.default && t.constructor === i.default && t !== i.default.prototype ? "symbol" : typeof t;
    };

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.default = "function" == typeof i.default && "symbol" === o(r.default) ? function (t) {
      return void 0 === t ? "undefined" : o(t);
    } : function (t) {
      return t && "function" == typeof i.default && t.constructor === i.default && t !== i.default.prototype ? "symbol" : void 0 === t ? "undefined" : o(t);
    };
  }, function (t, e) {
    t.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTUuNSIgZmlsbD0iYmxhY2siIHN0cm9rZT0iI0VDRUNFQyIvPgo8cGF0aCBkPSJNMTQuODU3OSAyNi4wMjNDOC44MDM4IDE3LjI0NjQgNy42ODAwNSAxNi4zNDU3IDcuNjgwMDUgMTMuMTIwMUM3LjY4MDA1IDguNzAxODIgMTEuMjYxOCA1LjEyMDEyIDE1LjY4MDEgNS4xMjAxMkMyMC4wOTgzIDUuMTIwMTIgMjMuNjgwMSA4LjcwMTgyIDIzLjY4MDEgMTMuMTIwMUMyMy42ODAxIDE2LjM0NTcgMjIuNTU2MyAxNy4yNDY0IDE2LjUwMjIgMjYuMDIzQzE2LjEwNDkgMjYuNTk2OSAxNS4yNTUxIDI2LjU5NjkgMTQuODU3OSAyNi4wMjNaTTE1LjY4MDEgMTYuNDUzNEMxNy41MjEgMTYuNDUzNCAxOS4wMTM0IDE0Ljk2MTEgMTkuMDEzNCAxMy4xMjAxQzE5LjAxMzQgMTEuMjc5MiAxNy41MjEgOS43ODY3OCAxNS42ODAxIDkuNzg2NzhDMTMuODM5MSA5Ljc4Njc4IDEyLjM0NjcgMTEuMjc5MiAxMi4zNDY3IDEzLjEyMDFDMTIuMzQ2NyAxNC45NjExIDEzLjgzOTEgMTYuNDUzNCAxNS42ODAxIDE2LjQ1MzRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
  }, function (t, e, n) {
    var r = n(97);

    t.exports = function (t, e) {
      return r(t, e);
    };
  }, function (t, e, n) {
    "use strict";

    var r = function (t, e) {
      for (var n = e.toString(), r = "return " + n, i = n.match(/.*\(([^)]*)\)/)[1], o = /['"]!!!([^'"]*)['"]/g, a = [];;) {
        var s = o.exec(r);
        if (!s) break;
        a.push(s);
      }

      return a.reverse().forEach(function (e) {
        r = r.slice(0, e.index) + t[e[1]] + r.substr(e.index + e[0].length);
      }), r = r.replace(/\/\*[^*]*\*\//g, " ").replace(/\s+/g, " "), new Function(i, r)();
    }({
      zousan: n(431).toString(),
      thenable: n(434).toString()
    }, function t(e, n) {
      function r() {
        return i.apply(e, arguments);
      }

      Function.prototype.$asyncbind || Object.defineProperty(Function.prototype, "$asyncbind", {
        value: t,
        enumerable: !1,
        configurable: !0,
        writable: !0
      }), t.trampoline || (t.trampoline = function (t, e, n, r, i) {
        return function o(a) {
          for (; a;) {
            if (a.then) return a = a.then(o, r), i ? void 0 : a;

            try {
              if (a.pop) {
                if (a.length) return a.pop() ? e.call(t) : a;
                a = n;
              } else a = a.call(t);
            } catch (t) {
              return r(t);
            }
          }
        };
      }), t.LazyThenable || (t.LazyThenable = "!!!thenable"(), t.EagerThenable = t.Thenable = (t.EagerThenableFactory = "!!!zousan")());
      var i = this;

      switch (n) {
        case !0:
          return new t.Thenable(r);

        case 0:
          return new t.LazyThenable(r);

        case void 0:
          return r.then = r, r;

        default:
          return function () {
            try {
              return i.apply(e, arguments);
            } catch (t) {
              return n(t);
            }
          };
      }
    });

    function i(t, e) {
      if (Function.prototype.$asyncspawn || Object.defineProperty(Function.prototype, "$asyncspawn", {
        value: i,
        enumerable: !1,
        configurable: !0,
        writable: !0
      }), this instanceof Function) {
        var n = this;
        return new t(function (t, r) {
          var i = n.call(e, t, r);
          !function e(n, o) {
            var a;

            try {
              if ((a = n.call(i, o)).done) {
                if (a.value !== t) {
                  if (a.value && a.value === a.value.then) return a.value(t, r);
                  t && t(a.value), t = null;
                }

                return;
              }

              a.value.then ? a.value.then(function (t) {
                e(i.next, t);
              }, function (t) {
                e(i.throw, t);
              }) : e(i.next, a.value);
            } catch (t) {
              return r && r(t), void (r = null);
            }
          }(i.next);
        });
      }
    }

    r(), i(), t.exports = {
      $asyncbind: r,
      $asyncspawn: i
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    !function (t) {
      t && t.__esModule;
    }(n(53));

    var r = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }();

    var i = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.options = e;
      }

      return r(t, [{
        key: "getParamString",
        value: function value(t) {
          return Object.keys(t).map(function (e) {
            return encodeURIComponent(e) + "=" + encodeURIComponent(t[e]);
          }).join("&");
        }
      }, {
        key: "search",
        value: function value(t) {
          return new Promise(function (e, n) {
            var r, i, o, a;
            return r = t.query, i = ~location.protocol.indexOf("http") ? location.protocol : "https:", o = this.endpoint({
              query: r,
              protocol: i
            }), fetch(o).then(function (t) {
              return t.json().then(function (t) {
                return a = t, e(this.parse({
                  data: a
                }));
              }.$asyncbind(this, n), n);
            }.$asyncbind(this, n), n);
          }.$asyncbind(this));
        }
      }]), t;
    }();

    e.default = i;
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e) {
    var n = 0,
        r = Math.random();

    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e, n) {
    var r = n(19).f,
        i = n(31),
        o = n(12)("toStringTag");

    t.exports = function (t, e, n) {
      t && !i(t = n ? t : t.prototype, o) && r(t, o, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, n) {
    var r = n(135),
        i = n(226),
        o = n(227);

    t.exports = function (t, e, n) {
      return e == e ? o(t, e, n) : r(t, i, n);
    };
  }, function (t, e, n) {
    var r = n(15).Symbol;
    t.exports = r;
  }, function (t, e, n) {
    var r = n(27),
        i = n(23),
        o = "[object Symbol]";

    t.exports = function (t) {
      return "symbol" == typeof t || i(t) && r(t) == o;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r;) {
        i[n] = e(t[n], n, t);
      }

      return i;
    };
  }, function (t, e, n) {
    var r = n(234),
        i = n(23),
        o = Object.prototype,
        a = o.hasOwnProperty,
        s = o.propertyIsEnumerable,
        u = r(function () {
      return arguments;
    }()) ? r : function (t) {
      return i(t) && a.call(t, "callee") && !s.call(t, "callee");
    };
    t.exports = u;
  }, function (t, e, n) {
    (function (t) {
      var r = n(15),
          i = n(235),
          o = e && !e.nodeType && e,
          a = o && "object" == typeof t && t && !t.nodeType && t,
          s = a && a.exports === o ? r.Buffer : void 0,
          u = (s ? s.isBuffer : void 0) || i;
      t.exports = u;
    }).call(this, n(93)(t));
  }, function (t, e) {
    var n = 9007199254740991,
        r = /^(?:0|[1-9]\d*)$/;

    t.exports = function (t, e) {
      var i = typeof t;
      return !!(e = null == e ? n : e) && ("number" == i || "symbol" != i && r.test(t)) && t > -1 && t % 1 == 0 && t < e;
    };
  }, function (t, e, n) {
    var r = n(236),
        i = n(141),
        o = n(237),
        a = o && o.isTypedArray,
        s = a ? i(a) : r;
    t.exports = s;
  }, function (t, e) {
    var n = Object.prototype;

    t.exports = function (t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || n);
    };
  }, function (t, e, n) {
    var r = n(242),
        i = n(243),
        o = n(244),
        a = n(245),
        s = n(246);

    function u(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    u.prototype.clear = r, u.prototype.delete = i, u.prototype.get = o, u.prototype.has = a, u.prototype.set = s, t.exports = u;
  }, function (t, e, n) {
    var r = n(48);

    t.exports = function (t, e) {
      for (var n = t.length; n--;) {
        if (r(t[n][0], e)) return n;
      }

      return -1;
    };
  }, function (t, e, n) {
    var r = n(33)(Object, "create");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(264);

    t.exports = function (t, e) {
      var n = t.__data__;
      return r(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r,
        i = L(n(14)),
        o = L(n(50)),
        a = L(n(7)),
        s = L(n(0)),
        u = L(n(1)),
        l = L(n(16)),
        c = L(n(52)),
        h = L(n(336)),
        f = L(n(34)),
        p = L(n(338)),
        d = L(n(8)),
        v = L(n(4)),
        y = L(n(359)),
        m = L(n(360)),
        g = L(n(362)),
        _ = L(n(158)),
        b = n(2);

    function L(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var x = (0, L(n(18)).default)(r = function () {
      function t(e, n, r) {
        (0, s.default)(this, t);
        var i = r.zIndex;
        this._props = (0, a.default)({
          layerShowMarker: b.LayerShowMarker.ALWAYS,
          layerShowShape: b.LayerShowShape.ALWAYS,
          visible: !0
        }, r, {
          style: this.getFormattedStyles(r.style, i)
        }), this._sources = n, this._name = e, this._isIndexed = (0, g.default)(this._sources, function (t) {
          return "string" == typeof t && /(\{q\}|\{x\}|\{y\}|\{z\})/.test(t);
        }), this._lastLoadedZoom = 0, this._loadedSrc = {}, this._cached = {}, this._payload = [], this.loadData = (0, m.default)(this._loadData.bind(this), 500);
      }

      return (0, u.default)(t, [{
        key: "setSources",
        value: function value(t) {
          this._sources = t;
          var e = (0, g.default)(this._sources, function (t) {
            return "string" == typeof t && /(\{q\}|\{x\}|\{y\}|\{z\})/.test(t);
          });
          e !== this._isIndexed && (e ? this._kmap.on(b.KMapEvent.VIEWCHANGED, this.loadData) : this._kmap.off(b.KMapEvent.VIEWCHANGED, this.loadData), this._isIndexed = e), this.reload();
        }
      }, {
        key: "setMap",
        value: function value(t) {
          return this._kmap = t, this._layer = t.map.createVectorLayer(this.name, this._props), this.setEventContext(this._layer), this._props.zIndex && this._layer.setZIndex(this._props.zIndex), this._isIndexed && this._kmap.on(b.KMapEvent.VIEWCHANGED, (0, m.default)(this.loadData, 100)), this.loadData(), this;
        }
      }, {
        key: "_getAxiosData",
        value: function value(t, e) {
          var n = this;
          return _.default.all(t).then(function () {
            for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
              r[i] = arguments[i];
            }

            r[0].forEach(function (t) {
              n._cached[e] ? (0, y.default)(n._cached[e], (0, v.default)(t, "data"), function (t, e) {
                return (0, d.default)(t) ? t.concat(e) : (0, p.default)({}, t, e);
              }) : n._cached[e] = (0, v.default)(t, "data");
            }), n.processData(n._cached[e]), n._loadedSrc[e] = 1, n.trigger(b.KLayerEvents.LOADED);
          }).catch(function () {
            n._cached[e] = {}, n._loadedSrc[e] = 1, "root" === e && n.processData({
              file_data: [],
              features: []
            });
          });
        }
      }, {
        key: "_validZoom",
        value: function value(t) {
          return !(this._props.minZoom && t < this._props.minZoom || this._props.maxZoom && t > this._props.maxZoom);
        }
      }, {
        key: "_generateAxiosUrl",
        value: function value(t) {
          var e = _.default.CancelToken.source();

          return this._payload.push(e), _.default.get(t, {
            cancelToken: _.default.CancelToken.source().token
          });
        }
      }, {
        key: "_loadIndexLayer",
        value: function value(e) {
          var n = this,
              r = this._kmap.getBBox();

          if (r) {
            if (t.getTiles(r, e - 1).forEach(function (t) {
              if (n._loadedSrc[t.q]) return null;
              if (n._cached[t.q]) return n._loadedSrc[t.q] = 1, n.processData(n._cached[t.q]);

              var r = n._sources.filter(function (t) {
                return "string" == typeof t && /(\{q\}|\{x\}|\{y\}|\{z\})/.test(t);
              }).map(function (r) {
                var i = r.replace("{q}", t.q).replace("{x}", t.x).replace("{y}", t.y).replace("{z}", e - 1);
                return n._generateAxiosUrl(i);
              });

              return n._getAxiosData(r, t.q);
            }), this._cached.nonIndexedUrls && !this._loadedSrc.nonIndexedUrls) this.processData(this._cached.nonIndexedUrls);else {
              var i = this._sources.filter(function (t) {
                return !/(\{q\}|\{x\}|\{y\}|\{z\})/.test(t);
              }).map(function (t) {
                return n._generateAxiosUrl(t);
              });

              this._getAxiosData(i, "nonIndexedUrls");
            }
            this._lastLoadedZoom = e;
          }
        }
      }, {
        key: "_loadData",
        value: function value() {
          var t = this;

          if (this._props.visible) {
            var e = this._kmap.getZoom();

            if (this._validZoom(e)) {
              if (this._isIndexed) this._lastLoadedZoom !== e && this.clear(), setTimeout(function () {
                return t._loadIndexLayer(e);
              }, 0);else if (!this._loadedSrc.root) if (this._cached.root) this.processData(this._cached.root);else {
                var n = this._sources.filter(function (t) {
                  return "string" == typeof t;
                }).map(function (e) {
                  return t._generateAxiosUrl(e);
                });

                this._getAxiosData(n, "root");
              }
              this._loadedSrc.dataObjects || (this._sources.forEach(function (e) {
                return "object" === (void 0 === e ? "undefined" : (0, o.default)(e)) && t.processData(e);
              }), this._loadedSrc.dataObjects = 1);
            } else this.clear();
          }
        }
      }, {
        key: "processData",
        value: function value() {}
      }, {
        key: "clear",
        value: function value() {
          this._cancelCurrentPayload(), this._layer && this._layer.clear(), this._loadedSrc = {};
        }
      }, {
        key: "reload",
        value: function value() {
          this.clear(), this._cached = {}, this._layer && this.loadData();
        }
      }, {
        key: "remove",
        value: function value() {
          this._cancelCurrentPayload(), this._layer && (this._isIndexed && this._kmap.off(b.KMapEvent.VIEWCHANGED, this.loadData), this._layer.remove());
        }
      }, {
        key: "setClustering",
        value: function value(t) {
          this._cluster = !this._isIndexed && t, this._layer && this._layer.setClustering && this._layer.setClustering(this._cluster);
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._layer && this._layer.setZIndex(t), this._props.zIndex = t;
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._props.visible = t, this._layer && (t && this.loadData(), this._layer.toggle(t));
        }
      }, {
        key: "getFormattedStyles",
        value: function value(t, e) {
          var n = this;
          return (0, i.default)({}, t, {
            ranges: (0, v.default)(t, ["ranges"], []).map(function (t) {
              return (0, i.default)({}, t, {
                rangeStyles: {
                  zIndex: e || (0, v.default)(n._props, "zIndex"),
                  shape: {
                    opacity: (0, v.default)(t, ["rangeStyles", "shape", "opacity"], 1),
                    fillColor: (0, v.default)(t, ["rangeStyles", "shape", "fillColor"], "#000"),
                    borderColor: (0, v.default)(t, ["rangeStyles", "shape", "borderColor"], "#000"),
                    borderOpacity: (0, v.default)(t, ["rangeStyles", "shape", "borderOpacity"], 1),
                    borderWeight: (0, v.default)(t, ["rangeStyles", "shape", "borderWeight"], 1)
                  },
                  icon: (0, v.default)(t, ["rangeStyles", "icon"])
                }
              });
            }, [])
          });
        }
      }, {
        key: "setStyle",
        value: function value(t) {
          this._props.style = this.getFormattedStyles(t), this.clear(), this.loadData();
        }
      }, {
        key: "receiveProps",
        value: function value(t) {
          var e = this,
              n = {
            zIndex: this.setZIndex,
            visible: this.toggle,
            style: this.setStyle,
            source: this.setSources
          };
          (0, f.default)(n, function (n, r) {
            (0, h.default)(t, r) && !(0, c.default)(t[r], e._props[r]) && n.call(e, t[r]);
          });
        }
      }, {
        key: "_cancelCurrentPayload",
        value: function value() {
          (0, l.default)(this._payload, function (t) {
            t.cancel();
          }), this._payload.length = 0;
        }
      }, {
        key: "name",
        get: function get() {
          return this._name;
        }
      }, {
        key: "props",
        get: function get() {
          return this._props;
        }
      }, {
        key: "source",
        get: function get() {
          return this._sources;
        }
      }], [{
        key: "getTiles",
        value: function value(e, n) {
          for (var r = t.project(e.north, e.west, n), i = t.project(e.south, e.east, n), o = [], a = r.y; a <= i.y; a += 1) {
            for (var s = r.x; s <= i.x; s += 1) {
              o.push({
                x: s,
                y: a,
                q: t.calculateQuadKey(s, a, n)
              });
            }
          }

          return o;
        }
      }, {
        key: "calculateQuadKey",
        value: function value(t, e, n) {
          for (var r = [], i = n; i > 0; i--) {
            var o = "0",
                a = 1 << i - 1;
            0 != (t & a) && o++, 0 != (e & a) && (o++, o++), r.push(o);
          }

          return r.join("");
        }
      }, {
        key: "project",
        value: function value(t, e, n) {
          var r = Math.sin(t * (Math.PI / 180)),
              i = 1 << n;
          return r = Math.min(Math.max(r, -.9999), .9999), {
            x: Math.floor((.5 + e / 360) * i),
            y: Math.floor((.5 - Math.log((1 + r) / (1 - r)) / (4 * Math.PI)) * i)
          };
        }
      }]), t;
    }()) || r;
    e.default = x;
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = o(n(35)),
        i = o(n(366));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.default = function t(e, n, o) {
      null === e && (e = Function.prototype);
      var a = (0, i.default)(e, n);

      if (void 0 === a) {
        var s = (0, r.default)(e);
        return null === s ? void 0 : t(s, n, o);
      }

      if ("value" in a) return a.value;
      var u = a.get;
      return void 0 !== u ? u.call(o) : void 0;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.KDrawEvents = e.DrawingMode = void 0;

    var r,
        i = _(n(7)),
        o = _(n(0)),
        a = _(n(1)),
        s = _(n(14)),
        u = _(n(52)),
        l = _(n(34)),
        c = _(n(383)),
        h = _(n(386)),
        f = _(n(16)),
        p = _(n(110)),
        d = _(n(4)),
        v = n(28),
        y = _(n(18)),
        m = _(n(180)),
        g = n(2);

    function _(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var b = n(390),
        L = n(391),
        x = (e.DrawingMode = (0, s.default)({}, g.KGeometryType, {
      CIRCLE: "CIRCLE",
      RECTANGLE: "RECTANGLE"
    }), e.KDrawEvents = {
      POINT_COMPLETE: "POINT_COMPLETE",
      POLYGON_COMPLETE: "POLYGON_COMPLETE",
      POLYLINE_COMPLETE: "POLYLINE_COMPLETE",
      RECTANGLE_COMPLETE: "RECTANGLE_COMPLETE",
      CIRCLE_COMPLETE: "CIRCLE_COMPLETE"
    }),
        w = function w(t, e) {
      var n = (0, d.default)(t, "points", []),
          r = (0, d.default)(t, "areas", []),
          i = (0, d.default)(t, "lines", []);
      return e ? {
        p: 0 === n.length ? null : n.map(function (t) {
          return (0, v.encodeCoords)(t);
        }),
        a: 0 === r.length ? null : r.map(function (t) {
          return (0, v.encodeCoords)(t);
        }),
        l: 0 === i.length ? null : i.map(function (t) {
          return (0, v.encodeCoords)(t);
        })
      } : {
        p: 0 === n.length ? null : n.map(function (t) {
          return t.map(function (t) {
            return [t.lat, t.lng];
          });
        }),
        a: 0 === r.length ? null : r.map(function (t) {
          return t.map(function (t) {
            return [t.lat, t.lng];
          });
        }),
        l: 0 === i.length ? null : i.map(function (t) {
          return t.map(function (t) {
            return [t.lat, t.lng];
          });
        })
      };
    },
        M = {
      shape: {
        borderWeight: 3,
        borderColor: "#F0F",
        borderOpacity: 1,
        fillColor: "#F0F",
        opacity: .6
      },
      icon: {
        url: L,
        size: [26, 26],
        anchor: [13, 13],
        opacity: 1
      }
    },
        k = {
      shape: {
        borderWeight: 3,
        borderColor: "#F0F",
        borderOpacity: 1,
        fillColor: "#F0F",
        opacity: .6
      },
      icon: {
        url: b,
        size: [26, 26],
        anchor: [13, 13],
        opacity: 1
      }
    },
        C = (0, y.default)(r = function () {
      function t(e, n) {
        (0, o.default)(this, t), this._props = n, this._name = e, this._data = [], this._compress = (0, d.default)(this._props, "compress", !0);
        var r = (0, d.default)(this._props, "zIndex", 1e3) + 1;
        this._selectStyle = (0, s.default)({}, k, {
          zIndex: r
        });
      }

      return (0, a.default)(t, [{
        key: "setMap",
        value: function value(t) {
          return this._map = t, this._dataLayer = new m.default(this._name + "data", [], this._props), this._dataLayer.setMap(t), this._drawManager = t.map.createDrawLayer(this._props), this.setEventContext(this), this._selectedRecord = null, this._drawManager.initialize();
        }
      }, {
        key: "toggle",
        value: function value(t) {
          t || this.clearSelection(), this._dataLayer.toggle(t);
        }
      }, {
        key: "setData",
        value: function value(t) {
          t && (this._data = t, this._refreshDataLayer(t));
        }
      }, {
        key: "getSelectedGeometry",
        value: function value() {
          return w(this._drawManager.getSelectedGeometry(), this._compress);
        }
      }, {
        key: "deleteVector",
        value: function value(t) {
          var e = (0, p.default)(this._data, t);
          this._data.splice(e, 1), this._refreshDataLayer(this._data);
        }
      }, {
        key: "_refreshDataLayer",
        value: function value(t) {
          this._dataLayer.clear(), this._dataLayer.processJsonData({
            file_data: t
          });
        }
      }, {
        key: "panToRecord",
        value: function value(t, e) {
          if (t) {
            var n = this._props.layerShowMarker === g.LayerShowMarker.ALWAYS,
                r = this._props.layerShowShape === g.LayerShowShape.ALWAYS,
                i = e;
            e || (i = (0, v.processGeometries)(t, this._compress, !r, !n));
            var o = {
              north: -180,
              south: 180,
              east: -180,
              west: 180
            };
            (0, f.default)(i, function (t) {
              return t && t.forEach(function (t) {
                return t.forEach(function (t) {
                  t[0] < o.south && (o.south = t[0]), t[0] > o.north && (o.north = t[0]), t[1] < o.west && (o.west = t[1]), t[1] > o.east && (o.east = t[1]);
                });
              });
            }), this._map.setBBox(o);
          }
        }
      }, {
        key: "selectRecord",
        value: function value(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

          if (this._drawManager.clear(), this._isEditing = !1, this._selectedRecord !== t) {
            var n = (0, p.default)(this._data, t);
            if (-1 === n) return;
            this._selectedRecord = this._data[n], this._refreshDataLayer((0, h.default)(this._data, this._selectedRecord));
          }

          var r = this._props.layerShowMarker === g.LayerShowMarker.ALWAYS,
              i = this._props.layerShowShape === g.LayerShowShape.ALWAYS,
              o = (0, v.processGeometries)(this._selectedRecord, this._compress, !i, !r);
          e && (o.points || o.areas || o.lines) && this.panToRecord(t, o), o.points && this._drawManager.addPoints(o, this._selectStyle), o.areas && this._drawManager.addPolygons(o, this._selectStyle), o.lines && this._drawManager.addPolylines(o, this._selectStyle);
        }
      }, {
        key: "startEdit",
        value: function value(t, e) {
          (this._selectedRecord || t) && (t && t !== this._selectedRecord && this.selectRecord(t), this._isEditing = !0, this._drawManager.startEdit(M, e));
        }
      }, {
        key: "stopEdit",
        value: function value(t) {
          if (this._isEditing) {
            var e = (0, i.default)({}, this._selectedRecord, {
              geom: this.getSelectedGeometry()
            });
            this._drawManager.stopEdit(), this._selectedRecord = e, this.selectRecord(e, !1), t && t(e);
          } else t(null);
        }
      }, {
        key: "cancelEdit",
        value: function value() {
          this._selectedRecord && (this._isEditing = !1, this._drawManager.setDrawingMode(null), this._drawManager.clear(), this.selectRecord(this._selectedRecord, !1));
        }
      }, {
        key: "createVector",
        value: function value(t, e, n) {
          var r = this,
              o = t.drawingMode;
          this._selectedRecord = n || {}, n && this._refreshDataLayer((0, c.default)(this._data, n)), this._drawManager.clear(), this._drawManager.setDrawingMode(o, M), this.on(o + "_COMPLETE", function (t) {
            r.off(o + "_COMPLETE");
            var n = (0, i.default)({}, r._selectedRecord, {
              geom: w(t, r._compress)
            });
            r._selectedRecord = n, r.selectRecord(n, !1), e && e(n);
          });
        }
      }, {
        key: "clearSelection",
        value: function value() {
          this._dataLayer.clear(), this._drawManager.setDrawingMode(null), this._selectedRecord = null, this._isEditing = !1, this._drawManager.clear();
        }
      }, {
        key: "setDrawingMode",
        value: function value(t, e) {
          this._drawManager.setDrawingMode(t, e);
        }
      }, {
        key: "remove",
        value: function value() {
          this._isEditing = !1, this._drawManager.remove();
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case g.KLayerEvents.DOUBLECLICK:
            case g.KLayerEvents.CLICK:
            case g.KLayerEvents.RIGHTCLICK:
              return this._dataLayer.on(e, function () {
                for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
                  r[i] = arguments[i];
                }

                n.trigger.apply(n, [e].concat(r));
              });

            case x.POINT_COMPLETE:
            case x.POLYGON_COMPLETE:
            case x.POLYLINE_COMPLETE:
            case x.RECTANGLE_COMPLETE:
            case x.CIRCLE_COMPLETE:
              return this._drawManager.on(e, function () {
                for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
                  r[i] = arguments[i];
                }

                n.trigger.apply(n, [e].concat(r));
              });

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          switch (e) {
            case g.KLayerEvents.DOUBLECLICK:
            case g.KLayerEvents.CLICK:
            case g.KLayerEvents.RIGHTCLICK:
              return this._dataLayer.off(e);

            case x.POINT_COMPLETE:
            case x.POLYGON_COMPLETE:
            case x.POLYLINE_COMPLETE:
            case x.RECTANGLE_COMPLETE:
            case x.CIRCLE_COMPLETE:
              return this._drawManager.off(e);

            default:
              return null;
          }
        }
      }, {
        key: "receiveProps",
        value: function value(t) {
          var e = this,
              n = {
            visible: this.toggle
          };
          (0, l.default)(t, function (r, i) {
            (0, u.default)(r, e._props[i]) || n[i] && n[i].call(e, t[i]);
          });
        }
      }, {
        key: "name",
        get: function get() {
          return this._name;
        }
      }]), t;
    }()) || r;

    e.default = C;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.convertKShapeToPolylineOption = e.convertKShapeToPolygonOption = e.convertKIconToGoogleIcon = void 0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(101));

    var i = e.convertKIconToGoogleIcon = (0, r.default)(function (t) {
      return {
        anchor: t.anchor ? new google.maps.Point(t.anchor[0], t.anchor[1]) : void 0,
        scaledSize: t.size ? new google.maps.Size(t.size[0], t.size[1]) : void 0,
        labelClass: "kmap-marker-label",
        labelStyle: {
          opacity: t.opacity
        },
        labelOrigin: t.labelAnchor ? new google.maps.Point(t.labelAnchor[0], t.labelAnchor[1]) : void 0,
        url: t.url
      };
    }, function () {
      for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) {
        e[n] = arguments[n];
      }

      return e[0].url;
    }),
        o = e.convertKShapeToPolygonOption = (0, r.default)(function (t) {
      return {
        strokeWeight: t.shape.borderWeight,
        strokeColor: t.shape.borderColor,
        strokeOpacity: t.shape.borderOpacity,
        fillColor: t.shape.fillColor,
        fillOpacity: t.shape.opacity,
        zIndex: t.zIndex
      };
    }, function (t) {
      return t.shape;
    }),
        a = e.convertKShapeToPolylineOption = (0, r.default)(function (t) {
      return {
        strokeWeight: t.shape.borderWeight,
        strokeColor: t.shape.borderColor,
        strokeOpacity: t.shape.borderOpacity,
        zIndex: t.zIndex
      };
    }, function (t) {
      return t.shape;
    });
    e.default = {
      convertKIconToGoogleIcon: i,
      convertKShapeToPolygonOption: o,
      convertKShapeToPolylineOption: a
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = e.createElement = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          r = document.createElement(t);
      return r.className = e, n && n.appendChild(r), r;
    };

    e.createScriptElement = function (t, e) {
      var n = r("script", null, document.body);
      return n.setAttribute("type", "text/javascript"), new Promise(function (r) {
        window[e] = function (t) {
          n.remove(), delete window[e], r(t);
        }, n.setAttribute("src", t);
      });
    }, e.addClassName = function (t, e) {
      t && !t.classList.contains(e) && t.classList.add(e);
    }, e.removeClassName = function (t, e) {
      t && t.classList.contains(e) && t.classList.remove(e);
    };
  }, function (t, e, n) {
    var r = n(26),
        i = n(6).document,
        o = r(i) && r(i.createElement);

    t.exports = function (t) {
      return o ? i.createElement(t) : {};
    };
  }, function (t, e, n) {
    var r = n(26);

    t.exports = function (t, e) {
      if (!r(t)) return t;
      var n, i;
      if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
      if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, n) {
    var r = n(20),
        i = n(196),
        o = n(86),
        a = n(84)("IE_PROTO"),
        s = function s() {},
        _u = function u() {
      var t,
          e = n(79)("iframe"),
          r = o.length;

      for (e.style.display = "none", n(118).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _u = t.F; r--;) {
        delete _u.prototype[o[r]];
      }

      return _u();
    };

    t.exports = Object.create || function (t, e) {
      var n;
      return null !== t ? (s.prototype = r(t), n = new s(), s.prototype = null, n[a] = t) : n = _u(), void 0 === e ? n : i(n, e);
    };
  }, function (t, e, n) {
    var r = n(83),
        i = Math.min;

    t.exports = function (t) {
      return t > 0 ? i(r(t), 9007199254740991) : 0;
    };
  }, function (t, e) {
    var n = Math.ceil,
        r = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e, n) {
    var r = n(85)("keys"),
        i = n(57);

    t.exports = function (t) {
      return r[t] || (r[t] = i(t));
    };
  }, function (t, e, n) {
    var r = n(3),
        i = n(6),
        o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
    (t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: r.version,
      mode: n(44) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    "use strict";

    var r = n(203)(!0);
    n(120)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
          e = this._t,
          n = this._i;
      return n >= e.length ? {
        value: void 0,
        done: !0
      } : (t = r(e, n), this._i += t.length, {
        value: t,
        done: !1
      });
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(55);

    t.exports.f = function (t) {
      return new function (t) {
        var e, n;
        this.promise = new t(function (t, r) {
          if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
          e = t, n = r;
        }), this.resolve = r(e), this.reject = r(n);
      }(t);
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(134));

    e.default = function (t, e, n) {
      return e in t ? (0, r.default)(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    };
  }, function (t, e, n) {
    var r = n(27),
        i = n(17),
        o = "[object AsyncFunction]",
        a = "[object Function]",
        s = "[object GeneratorFunction]",
        u = "[object Proxy]";

    t.exports = function (t) {
      if (!i(t)) return !1;
      var e = r(t);
      return e == a || e == s || e == o || e == u;
    };
  }, function (t, e) {
    var n = 9007199254740991;

    t.exports = function (t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, n) {
    var r = n(69),
        i = n(247),
        o = n(248),
        a = n(249),
        s = n(250),
        u = n(251);

    function l(t) {
      var e = this.__data__ = new r(t);
      this.size = e.size;
    }

    l.prototype.clear = i, l.prototype.delete = o, l.prototype.get = a, l.prototype.has = s, l.prototype.set = u, t.exports = l;
  }, function (t, e, n) {
    var r = n(33)(n(15), "Map");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(256),
        i = n(263),
        o = n(265),
        a = n(266),
        s = n(267);

    function u(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    u.prototype.clear = r, u.prototype.delete = i, u.prototype.get = o, u.prototype.has = a, u.prototype.set = s, t.exports = u;
  }, function (t, e, n) {
    var r = n(268),
        i = n(23);

    t.exports = function t(e, n, o, a, s) {
      return e === n || (null == e || null == n || !i(e) && !i(n) ? e != e && n != n : r(e, n, o, a, t, s));
    };
  }, function (t, e, n) {
    var r = n(99),
        i = n(49);

    t.exports = function (t, e) {
      for (var n = 0, o = (e = r(e, t)).length; null != t && n < o;) {
        t = t[i(e[n++])];
      }

      return n && n == o ? t : void 0;
    };
  }, function (t, e, n) {
    var r = n(8),
        i = n(100),
        o = n(287),
        a = n(153);

    t.exports = function (t, e) {
      return r(t) ? t : i(t, e) ? [t] : o(a(t));
    };
  }, function (t, e, n) {
    var r = n(8),
        i = n(62),
        o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        a = /^\w*$/;

    t.exports = function (t, e) {
      if (r(t)) return !1;
      var n = typeof t;
      return !("number" != n && "symbol" != n && "boolean" != n && null != t && !i(t)) || a.test(t) || !o.test(t) || null != e && t in Object(e);
    };
  }, function (t, e, n) {
    var r = n(96),
        i = "Expected a function";

    function o(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(i);

      var n = function n() {
        var r = arguments,
            i = e ? e.apply(this, r) : r[0],
            o = n.cache;
        if (o.has(i)) return o.get(i);
        var a = t.apply(this, r);
        return n.cache = o.set(i, a) || o, a;
      };

      return n.cache = new (o.Cache || r)(), n;
    }

    o.Cache = r, t.exports = o;
  }, function (t, e, n) {
    var r = n(299),
        i = n(301)(r);
    t.exports = i;
  }, function (t, e) {
    var n,
        r,
        i = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        r = a;
      }
    }();
    var u,
        l = [],
        c = !1,
        h = -1;

    function f() {
      c && u && (c = !1, u.length ? l = u.concat(l) : h = -1, l.length && p());
    }

    function p() {
      if (!c) {
        var t = s(f);
        c = !0;

        for (var e = l.length; e;) {
          for (u = l, l = []; ++h < e;) {
            u && u[h].run();
          }

          h = -1, e = l.length;
        }

        u = null, c = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }

    function d(t, e) {
      this.fun = t, this.array = e;
    }

    function v() {}

    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      l.push(new d(t, e)), 1 !== l.length || c || s(p);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = v, i.addListener = v, i.once = v, i.off = v, i.removeListener = v, i.removeAllListeners = v, i.emit = v, i.prependListener = v, i.prependOnceListener = v, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    t.exports = n(319);
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(9));

    e.default = function (t) {
      return function () {
        var e = t.apply(this, arguments);
        return new r.default(function (t, n) {
          return function i(o, a) {
            try {
              var s = e[o](a),
                  u = s.value;
            } catch (t) {
              return void n(t);
            }

            if (!s.done) return r.default.resolve(u).then(function (t) {
              i("next", t);
            }, function (t) {
              i("throw", t);
            });
            t(u);
          }("next");
        });
      };
    };
  }, function (t, e, n) {
    e.f = n(12);
  }, function (t, e, n) {
    var r = n(6),
        i = n(3),
        o = n(44),
        a = n(106),
        s = n(19).f;

    t.exports = function (t) {
      var e = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});
      "_" == t.charAt(0) || t in e || s(e, t, {
        value: a.f(t)
      });
    };
  }, function (t, e, n) {
    var r = n(58),
        i = n(41),
        o = n(32),
        a = n(80),
        s = n(31),
        u = n(115),
        l = Object.getOwnPropertyDescriptor;
    e.f = n(21) ? l : function (t, e) {
      if (t = o(t), e = a(e, !0), u) try {
        return l(t, e);
      } catch (t) {}
      if (s(t, e)) return i(!r.f.call(t, e), t[e]);
    };
  }, function (t, e, n) {
    var r = n(173);

    t.exports = function (t, e, n) {
      "__proto__" == e && r ? r(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    };
  }, function (t, e, n) {
    var r = n(135),
        i = n(47),
        o = n(137),
        a = Math.max;

    t.exports = function (t, e, n) {
      var s = null == t ? 0 : t.length;
      if (!s) return -1;
      var u = null == n ? 0 : o(n);
      return u < 0 && (u = a(s + u, 0)), r(t, i(e, 3), u);
    };
  }, function (t, e, n) {
    var r = n(11),
        i = n(3),
        o = n(30);

    t.exports = function (t, e) {
      var n = (i.Object || {})[t] || Object[t],
          a = {};
      a[t] = e(n), r(r.S + r.F * o(function () {
        n(1);
      }), "Object", a);
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var n = function (t, e) {
            var n = t[1] || "",
                r = t[3];
            if (!r) return n;

            if (e && "function" == typeof btoa) {
              var i = function (t) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */";
              }(r),
                  o = r.sources.map(function (t) {
                return "/*# sourceURL=" + r.sourceRoot + t + " */";
              });

              return [n].concat(o).concat([i]).join("\n");
            }

            return [n].join("\n");
          }(e, t);

          return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
        }).join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var r = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          "number" == typeof o && (r[o] = !0);
        }

        for (i = 0; i < t.length; i++) {
          var a = t[i];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
        }
      }, e;
    };
  }, function (t, e, n) {
    var r = {},
        i = function (t) {
      var e;
      return function () {
        return void 0 === e && (e = t.apply(this, arguments)), e;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        o = function (t) {
      var e = {};
      return function (t) {
        if ("function" == typeof t) return t();

        if (void 0 === e[t]) {
          var n = function (t) {
            return document.querySelector(t);
          }.call(this, t);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        a = null,
        s = 0,
        u = [],
        l = n(192);

    function c(t, e) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n],
            o = r[i.id];

        if (o) {
          o.refs++;

          for (var a = 0; a < o.parts.length; a++) {
            o.parts[a](i.parts[a]);
          }

          for (; a < i.parts.length; a++) {
            o.parts.push(y(i.parts[a], e));
          }
        } else {
          var s = [];

          for (a = 0; a < i.parts.length; a++) {
            s.push(y(i.parts[a], e));
          }

          r[i.id] = {
            id: i.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function h(t, e) {
      for (var n = [], r = {}, i = 0; i < t.length; i++) {
        var o = t[i],
            a = e.base ? o[0] + e.base : o[0],
            s = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function f(t, e) {
      var n = o(t.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = u[u.length - 1];
      if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), u.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
        if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var i = o(t.insertInto + " " + t.insertAt.before);
        n.insertBefore(e, i);
      }
    }

    function p(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = u.indexOf(t);
      e >= 0 && u.splice(e, 1);
    }

    function d(t) {
      var e = document.createElement("style");
      return void 0 === t.attrs.type && (t.attrs.type = "text/css"), v(e, t.attrs), f(t, e), e;
    }

    function v(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }

    function y(t, e) {
      var n, r, i, o;

      if (e.transform && t.css) {
        if (!(o = e.transform(t.css))) return function () {};
        t.css = o;
      }

      if (e.singleton) {
        var u = s++;
        n = a || (a = d(e)), r = g.bind(null, n, u, !1), i = g.bind(null, n, u, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", v(e, t.attrs), f(t, e), e;
      }(e), r = function (t, e, n) {
        var r = n.css,
            i = n.sourceMap,
            o = void 0 === e.convertToAbsoluteUrls && i;
        (e.convertToAbsoluteUrls || o) && (r = l(r));
        i && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
        var a = new Blob([r], {
          type: "text/css"
        }),
            s = t.href;
        t.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
      }.bind(null, n, e), i = function i() {
        p(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = d(e), r = function (t, e) {
        var n = e.css,
            r = e.media;
        r && t.setAttribute("media", r);
        if (t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), i = function i() {
        p(n);
      });

      return r(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          r(t = e);
        } else i();
      };
    }

    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var n = h(t, e);
      return c(n, e), function (t) {
        for (var i = [], o = 0; o < n.length; o++) {
          var a = n[o];
          (s = r[a.id]).refs--, i.push(s);
        }

        t && c(h(t, e), e);

        for (o = 0; o < i.length; o++) {
          var s;

          if (0 === (s = i[o]).refs) {
            for (var u = 0; u < s.parts.length; u++) {
              s.parts[u]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var m = function () {
      var t = [];
      return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();

    function g(t, e, n, r) {
      var i = n ? "" : r.css;
      if (t.styleSheet) t.styleSheet.cssText = m(e, i);else {
        var o = document.createTextNode(i),
            a = t.childNodes;
        a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(o, a[e]) : t.appendChild(o);
      }
    }
  }, function (t, e, n) {
    t.exports = {
      default: n(194),
      __esModule: !0
    };
  }, function (t, e, n) {
    t.exports = !n(21) && !n(30)(function () {
      return 7 != Object.defineProperty(n(79)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    var r = n(31),
        i = n(32),
        o = n(197)(!1),
        a = n(84)("IE_PROTO");

    t.exports = function (t, e) {
      var n,
          s = i(t),
          u = 0,
          l = [];

      for (n in s) {
        n != a && r(s, n) && l.push(n);
      }

      for (; e.length > u;) {
        r(s, n = e[u++]) && (~o(l, n) || l.push(n));
      }

      return l;
    };
  }, function (t, e, n) {
    var r = n(43);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e, n) {
    var r = n(6).document;
    t.exports = r && r.documentElement;
  }, function (t, e) {}, function (t, e, n) {
    "use strict";

    var r = n(44),
        i = n(11),
        o = n(121),
        a = n(29),
        s = n(45),
        u = n(204),
        l = n(59),
        c = n(122),
        h = n(12)("iterator"),
        f = !([].keys && "next" in [].keys()),
        p = function p() {
      return this;
    };

    t.exports = function (t, e, n, d, v, y, m) {
      u(n, e, d);

      var g,
          _,
          b,
          L = function L(t) {
        if (!f && t in k) return k[t];

        switch (t) {
          case "keys":
          case "values":
            return function () {
              return new n(this, t);
            };
        }

        return function () {
          return new n(this, t);
        };
      },
          x = e + " Iterator",
          w = "values" == v,
          M = !1,
          k = t.prototype,
          C = k[h] || k["@@iterator"] || v && k[v],
          E = C || L(v),
          I = v ? w ? L("entries") : E : void 0,
          A = "Array" == e && k.entries || C;

      if (A && (b = c(A.call(new t()))) !== Object.prototype && b.next && (l(b, x, !0), r || "function" == typeof b[h] || a(b, h, p)), w && C && "values" !== C.name && (M = !0, E = function E() {
        return C.call(this);
      }), r && !m || !f && !M && k[h] || a(k, h, E), s[e] = E, s[x] = p, v) if (g = {
        values: w ? E : L("values"),
        keys: y ? E : L("keys"),
        entries: I
      }, m) for (_ in g) {
        _ in k || o(k, _, g[_]);
      } else i(i.P + i.F * (f || M), e, g);
      return g;
    };
  }, function (t, e, n) {
    t.exports = n(29);
  }, function (t, e, n) {
    var r = n(31),
        i = n(38),
        o = n(84)("IE_PROTO"),
        a = Object.prototype;

    t.exports = Object.getPrototypeOf || function (t) {
      return t = i(t), r(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
    };
  }, function (t, e, n) {
    n(205);

    for (var r = n(6), i = n(29), o = n(45), a = n(12)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), u = 0; u < s.length; u++) {
      var l = s[u],
          c = r[l],
          h = c && c.prototype;
      h && !h[a] && i(h, a, l), o[l] = o.Array;
    }
  }, function (t, e, n) {
    var r = n(43),
        i = n(12)("toStringTag"),
        o = "Arguments" == r(function () {
      return arguments;
    }());

    t.exports = function (t) {
      var e, n, a;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = Object(t), i)) ? n : o ? r(e) : "Object" == (a = r(e)) && "function" == typeof e.callee ? "Arguments" : a;
    };
  }, function (t, e, n) {
    var r = n(20);

    t.exports = function (t, e, n, i) {
      try {
        return i ? e(r(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t.return;
        throw void 0 !== o && r(o.call(t)), e;
      }
    };
  }, function (t, e, n) {
    var r = n(45),
        i = n(12)("iterator"),
        o = Array.prototype;

    t.exports = function (t) {
      return void 0 !== t && (r.Array === t || o[i] === t);
    };
  }, function (t, e, n) {
    var r = n(124),
        i = n(12)("iterator"),
        o = n(45);

    t.exports = n(3).getIteratorMethod = function (t) {
      if (void 0 != t) return t[i] || t["@@iterator"] || o[r(t)];
    };
  }, function (t, e, n) {
    var r = n(20),
        i = n(55),
        o = n(12)("species");

    t.exports = function (t, e) {
      var n,
          a = r(t).constructor;
      return void 0 === a || void 0 == (n = r(a)[o]) ? e : i(n);
    };
  }, function (t, e, n) {
    var r,
        i,
        o,
        a = n(37),
        s = n(211),
        u = n(118),
        l = n(79),
        c = n(6),
        h = c.process,
        f = c.setImmediate,
        p = c.clearImmediate,
        d = c.MessageChannel,
        v = c.Dispatch,
        y = 0,
        m = {},
        g = function g() {
      var t = +this;

      if (m.hasOwnProperty(t)) {
        var e = m[t];
        delete m[t], e();
      }
    },
        _ = function _(t) {
      g.call(t.data);
    };

    f && p || (f = function f(t) {
      for (var e = [], n = 1; arguments.length > n;) {
        e.push(arguments[n++]);
      }

      return m[++y] = function () {
        s("function" == typeof t ? t : Function(t), e);
      }, r(y), y;
    }, p = function p(t) {
      delete m[t];
    }, "process" == n(43)(h) ? r = function r(t) {
      h.nextTick(a(g, t, 1));
    } : v && v.now ? r = function r(t) {
      v.now(a(g, t, 1));
    } : d ? (o = (i = new d()).port2, i.port1.onmessage = _, r = a(o.postMessage, o, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (r = function r(t) {
      c.postMessage(t + "", "*");
    }, c.addEventListener("message", _, !1)) : r = "onreadystatechange" in l("script") ? function (t) {
      u.appendChild(l("script")).onreadystatechange = function () {
        u.removeChild(this), g.call(t);
      };
    } : function (t) {
      setTimeout(a(g, t, 1), 0);
    }), t.exports = {
      set: f,
      clear: p
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    };
  }, function (t, e, n) {
    var r = n(20),
        i = n(26),
        o = n(89);

    t.exports = function (t, e) {
      if (r(t), i(e) && e.constructor === t) return e;
      var n = o.f(t);
      return (0, n.resolve)(e), n.promise;
    };
  }, function (t, e, n) {
    var r = n(12)("iterator"),
        i = !1;

    try {
      var o = [7][r]();
      o.return = function () {
        i = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}

    t.exports = function (t, e) {
      if (!e && !i) return !1;
      var n = !1;

      try {
        var o = [7],
            a = o[r]();
        a.next = function () {
          return {
            done: n = !0
          };
        }, o[r] = function () {
          return a;
        }, t(o);
      } catch (t) {}

      return n;
    };
  }, function (t, e) {
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, e, n) {
    t.exports = {
      default: n(223),
      __esModule: !0
    };
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      for (var i = t.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) {
        if (e(t[o], o, t)) return o;
      }

      return -1;
    };
  }, function (t, e, n) {
    (function (e) {
      var n = "object" == typeof e && e && e.Object === Object && e;
      t.exports = n;
    }).call(this, n(10));
  }, function (t, e, n) {
    var r = n(231);

    t.exports = function (t) {
      var e = r(t),
          n = e % 1;
      return e == e ? n ? e - n : e : 0;
    };
  }, function (t, e, n) {
    var r = n(17),
        i = n(62),
        o = NaN,
        a = /^\s+|\s+$/g,
        s = /^[-+]0x[0-9a-f]+$/i,
        u = /^0b[01]+$/i,
        l = /^0o[0-7]+$/i,
        c = parseInt;

    t.exports = function (t) {
      if ("number" == typeof t) return t;
      if (i(t)) return o;

      if (r(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = r(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = t.replace(a, "");
      var n = u.test(t);
      return n || l.test(t) ? c(t.slice(2), n ? 2 : 8) : s.test(t) ? o : +t;
    };
  }, function (t, e, n) {
    var r = n(232),
        i = n(46);

    t.exports = function (t) {
      return null == t ? [] : r(t, i(t));
    };
  }, function (t, e, n) {
    var r = n(233),
        i = n(64),
        o = n(8),
        a = n(65),
        s = n(66),
        u = n(67),
        l = Object.prototype.hasOwnProperty;

    t.exports = function (t, e) {
      var n = o(t),
          c = !n && i(t),
          h = !n && !c && a(t),
          f = !n && !c && !h && u(t),
          p = n || c || h || f,
          d = p ? r(t.length, String) : [],
          v = d.length;

      for (var y in t) {
        !e && !l.call(t, y) || p && ("length" == y || h && ("offset" == y || "parent" == y) || f && ("buffer" == y || "byteLength" == y || "byteOffset" == y) || s(y, v)) || d.push(y);
      }

      return d;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return function (e) {
        return t(e);
      };
    };
  }, function (t, e, n) {
    var r = n(68),
        i = n(238),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!r(t)) return i(t);
      var e = [];

      for (var n in Object(t)) {
        o.call(t, n) && "constructor" != n && e.push(n);
      }

      return e;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return function (n) {
        return t(e(n));
      };
    };
  }, function (t, e) {
    var n = Function.prototype.toString;

    t.exports = function (t) {
      if (null != t) {
        try {
          return n.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    };
  }, function (t, e, n) {
    var r = n(146),
        i = n(271),
        o = n(147),
        a = 1,
        s = 2;

    t.exports = function (t, e, n, u, l, c) {
      var h = n & a,
          f = t.length,
          p = e.length;
      if (f != p && !(h && p > f)) return !1;
      var d = c.get(t);
      if (d && c.get(e)) return d == e;
      var v = -1,
          y = !0,
          m = n & s ? new r() : void 0;

      for (c.set(t, e), c.set(e, t); ++v < f;) {
        var g = t[v],
            _ = e[v];
        if (u) var b = h ? u(_, g, v, e, t, c) : u(g, _, v, t, e, c);

        if (void 0 !== b) {
          if (b) continue;
          y = !1;
          break;
        }

        if (m) {
          if (!i(e, function (t, e) {
            if (!o(m, e) && (g === t || l(g, t, n, u, c))) return m.push(e);
          })) {
            y = !1;
            break;
          }
        } else if (g !== _ && !l(g, _, n, u, c)) {
          y = !1;
          break;
        }
      }

      return c.delete(t), c.delete(e), y;
    };
  }, function (t, e, n) {
    var r = n(96),
        i = n(269),
        o = n(270);

    function a(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.__data__ = new r(); ++e < n;) {
        this.add(t[e]);
      }
    }

    a.prototype.add = a.prototype.push = i, a.prototype.has = o, t.exports = a;
  }, function (t, e) {
    t.exports = function (t, e) {
      return t.has(e);
    };
  }, function (t, e, n) {
    var r = n(15).Uint8Array;
    t.exports = r;
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length, i = 0, o = []; ++n < r;) {
        var a = t[n];
        e(a, n, t) && (o[i++] = a);
      }

      return o;
    };
  }, function (t, e, n) {
    var r = n(281),
        i = n(95),
        o = n(282),
        a = n(283),
        s = n(284),
        u = n(27),
        l = n(144),
        c = l(r),
        h = l(i),
        f = l(o),
        p = l(a),
        d = l(s),
        v = u;
    (r && "[object DataView]" != v(new r(new ArrayBuffer(1))) || i && "[object Map]" != v(new i()) || o && "[object Promise]" != v(o.resolve()) || a && "[object Set]" != v(new a()) || s && "[object WeakMap]" != v(new s())) && (v = function v(t) {
      var e = u(t),
          n = "[object Object]" == e ? t.constructor : void 0,
          r = n ? l(n) : "";
      if (r) switch (r) {
        case c:
          return "[object DataView]";

        case h:
          return "[object Map]";

        case f:
          return "[object Promise]";

        case p:
          return "[object Set]";

        case d:
          return "[object WeakMap]";
      }
      return e;
    }), t.exports = v;
  }, function (t, e, n) {
    var r = n(17);

    t.exports = function (t) {
      return t == t && !r(t);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return function (n) {
        return null != n && n[t] === e && (void 0 !== e || t in Object(n));
      };
    };
  }, function (t, e, n) {
    var r = n(154);

    t.exports = function (t) {
      return null == t ? "" : r(t);
    };
  }, function (t, e, n) {
    var r = n(61),
        i = n(63),
        o = n(8),
        a = n(62),
        s = 1 / 0,
        u = r ? r.prototype : void 0,
        l = u ? u.toString : void 0;

    t.exports = function t(e) {
      if ("string" == typeof e) return e;
      if (o(e)) return i(e, t) + "";
      if (a(e)) return l ? l.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -s ? "-0" : n;
    };
  }, function (t, e, n) {
    var r = n(99),
        i = n(64),
        o = n(8),
        a = n(66),
        s = n(92),
        u = n(49);

    t.exports = function (t, e, n) {
      for (var l = -1, c = (e = r(e, t)).length, h = !1; ++l < c;) {
        var f = u(e[l]);
        if (!(h = null != t && n(t, f))) break;
        t = t[f];
      }

      return h || ++l != c ? h : !!(c = null == t ? 0 : t.length) && s(c) && a(f, c) && (o(t) || i(t));
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = -1,
          i = t.length;
      e < 0 && (e = -e > i ? 0 : i + e), (n = n > i ? i : n) < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;

      for (var o = Array(i); ++r < i;) {
        o[r] = t[r + e];
      }

      return o;
    };
  }, function (t, e, n) {
    var r = n(300)();
    t.exports = r;
  }, function (t, e, n) {
    t.exports = n(303);
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t, e) {
      return function () {
        for (var n = new Array(arguments.length), r = 0; r < n.length; r++) {
          n[r] = arguments[r];
        }

        return t.apply(e, n);
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13);

    function i(t) {
      return encodeURIComponent(t).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    t.exports = function (t, e, n) {
      if (!e) return t;
      var o;
      if (n) o = n(e);else if (r.isURLSearchParams(e)) o = e.toString();else {
        var a = [];
        r.forEach(e, function (t, e) {
          null !== t && void 0 !== t && (r.isArray(t) ? e += "[]" : t = [t], r.forEach(t, function (t) {
            r.isDate(t) ? t = t.toISOString() : r.isObject(t) && (t = JSON.stringify(t)), a.push(i(e) + "=" + i(t));
          }));
        }), o = a.join("&");
      }

      if (o) {
        var s = t.indexOf("#");
        -1 !== s && (t = t.slice(0, s)), t += (-1 === t.indexOf("?") ? "?" : "&") + o;
      }

      return t;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      return !(!t || !t.__CANCEL__);
    };
  }, function (t, e, n) {
    "use strict";

    (function (e) {
      var r = n(13),
          i = n(308),
          o = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      function a(t, e) {
        !r.isUndefined(t) && r.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
      }

      var s = {
        adapter: function () {
          var t;
          return "undefined" != typeof XMLHttpRequest ? t = n(163) : void 0 !== e && "[object process]" === Object.prototype.toString.call(e) && (t = n(163)), t;
        }(),
        transformRequest: [function (t, e) {
          return i(e, "Accept"), i(e, "Content-Type"), r.isFormData(t) || r.isArrayBuffer(t) || r.isBuffer(t) || r.isStream(t) || r.isFile(t) || r.isBlob(t) ? t : r.isArrayBufferView(t) ? t.buffer : r.isURLSearchParams(t) ? (a(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : r.isObject(t) ? (a(e, "application/json;charset=utf-8"), JSON.stringify(t)) : t;
        }],
        transformResponse: [function (t) {
          if ("string" == typeof t) try {
            t = JSON.parse(t);
          } catch (t) {}
          return t;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        validateStatus: function validateStatus(t) {
          return t >= 200 && t < 300;
        },
        headers: {
          common: {
            Accept: "application/json, text/plain, */*"
          }
        }
      };
      r.forEach(["delete", "get", "head"], function (t) {
        s.headers[t] = {};
      }), r.forEach(["post", "put", "patch"], function (t) {
        s.headers[t] = r.merge(o);
      }), t.exports = s;
    }).call(this, n(103));
  }, function (t, e, n) {
    "use strict";

    var r = n(13),
        i = n(309),
        o = n(160),
        a = n(311),
        s = n(314),
        u = n(315),
        l = n(164);

    t.exports = function (t) {
      return new Promise(function (e, c) {
        var h = t.data,
            f = t.headers;
        r.isFormData(h) && delete f["Content-Type"];
        var p = new XMLHttpRequest();

        if (t.auth) {
          var d = t.auth.username || "",
              v = t.auth.password || "";
          f.Authorization = "Basic " + btoa(d + ":" + v);
        }

        var y = a(t.baseURL, t.url);

        if (p.open(t.method.toUpperCase(), o(y, t.params, t.paramsSerializer), !0), p.timeout = t.timeout, p.onreadystatechange = function () {
          if (p && 4 === p.readyState && (0 !== p.status || p.responseURL && 0 === p.responseURL.indexOf("file:"))) {
            var n = "getAllResponseHeaders" in p ? s(p.getAllResponseHeaders()) : null,
                r = {
              data: t.responseType && "text" !== t.responseType ? p.response : p.responseText,
              status: p.status,
              statusText: p.statusText,
              headers: n,
              config: t,
              request: p
            };
            i(e, c, r), p = null;
          }
        }, p.onabort = function () {
          p && (c(l("Request aborted", t, "ECONNABORTED", p)), p = null);
        }, p.onerror = function () {
          c(l("Network Error", t, null, p)), p = null;
        }, p.ontimeout = function () {
          var e = "timeout of " + t.timeout + "ms exceeded";
          t.timeoutErrorMessage && (e = t.timeoutErrorMessage), c(l(e, t, "ECONNABORTED", p)), p = null;
        }, r.isStandardBrowserEnv()) {
          var m = n(316),
              g = (t.withCredentials || u(y)) && t.xsrfCookieName ? m.read(t.xsrfCookieName) : void 0;
          g && (f[t.xsrfHeaderName] = g);
        }

        if ("setRequestHeader" in p && r.forEach(f, function (t, e) {
          void 0 === h && "content-type" === e.toLowerCase() ? delete f[e] : p.setRequestHeader(e, t);
        }), r.isUndefined(t.withCredentials) || (p.withCredentials = !!t.withCredentials), t.responseType) try {
          p.responseType = t.responseType;
        } catch (e) {
          if ("json" !== t.responseType) throw e;
        }
        "function" == typeof t.onDownloadProgress && p.addEventListener("progress", t.onDownloadProgress), "function" == typeof t.onUploadProgress && p.upload && p.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function (t) {
          p && (p.abort(), c(t), p = null);
        }), void 0 === h && (h = null), p.send(h);
      });
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(310);

    t.exports = function (t, e, n, i, o) {
      var a = new Error(t);
      return r(a, e, n, i, o);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13);

    t.exports = function (t, e) {
      e = e || {};
      var n = {},
          i = ["url", "method", "params", "data"],
          o = ["headers", "auth", "proxy"],
          a = ["baseURL", "url", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"];
      r.forEach(i, function (t) {
        void 0 !== e[t] && (n[t] = e[t]);
      }), r.forEach(o, function (i) {
        r.isObject(e[i]) ? n[i] = r.deepMerge(t[i], e[i]) : void 0 !== e[i] ? n[i] = e[i] : r.isObject(t[i]) ? n[i] = r.deepMerge(t[i]) : void 0 !== t[i] && (n[i] = t[i]);
      }), r.forEach(a, function (r) {
        void 0 !== e[r] ? n[r] = e[r] : void 0 !== t[r] && (n[r] = t[r]);
      });
      var s = i.concat(o).concat(a),
          u = Object.keys(e).filter(function (t) {
        return -1 === s.indexOf(t);
      });
      return r.forEach(u, function (r) {
        void 0 !== e[r] ? n[r] = e[r] : void 0 !== t[r] && (n[r] = t[r]);
      }), n;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      this.message = t;
    }

    r.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, r.prototype.__CANCEL__ = !0, t.exports = r;
  }, function (t, e, n) {
    var r = n(116),
        i = n(86).concat("length", "prototype");

    e.f = Object.getOwnPropertyNames || function (t) {
      return r(t, i);
    };
  }, function (t, e, n) {
    var r = n(27),
        i = n(23),
        o = "[object Number]";

    t.exports = function (t) {
      return "number" == typeof t || i(t) && r(t) == o;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = {
      _data: {},
      setItem: function setItem(t, e) {
        this._data[t] = e;
      },
      getItem: function getItem(t) {
        return Object.prototype.hasOwnProperty.call(this._data, t) ? this._data[t] : null;
      },
      removeItem: function removeItem(t) {
        delete this._data[t];
      },
      clear: function clear() {
        this._data = {};
      }
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.createImageWithText = void 0;
    var r = a(n(9));
    n(332);
    var i = a(n(101)),
        o = a(n(139));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var s = e.createImageWithText = (0, i.default)(function (t, e, n, i) {
      return new r.default(function (r) {
        var o = document.createElement("canvas");
        o.width = n[0], o.height = n[1];
        var a = o.getContext("2d"),
            s = document.createElement("img");
        s.crossOrigin = "Anonymous", s.onload = function () {
          if (".svg" === t.substr(-4).toLowerCase() ? a.drawSvg(t, 0, 0, n[0], n[1], {
            useCORS: !0
          }) : a.drawImage(s, 0, 0, n[0], n[1]), e) {
            a.font = '600 12px Roboto, HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif', a.textBaseline = "middle", a.textAlign = "center";
            var u = o.width / 2,
                l = o.height / 2;
            i && (u = i[0], l = i[1]), a.fillText(e, u, l);
          }

          r(o.toDataURL());
        }, s.onerror = function () {
          r(t);
        }, s.src = t;
      });
    }, function () {
      for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) {
        e[n] = arguments[n];
      }

      return (0, o.default)(e).join("_");
    });
    e.default = s;
  }, function (t, e, n) {
    var r = n(94),
        i = n(172),
        o = n(157),
        a = n(339),
        s = n(17),
        u = n(177),
        l = n(176);

    t.exports = function t(e, n, c, h, f) {
      e !== n && o(n, function (o, u) {
        if (f || (f = new r()), s(o)) a(e, n, u, c, t, h, f);else {
          var p = h ? h(l(e, u), o, u + "", e, n, f) : void 0;
          void 0 === p && (p = o), i(e, u, p);
        }
      }, u);
    };
  }, function (t, e, n) {
    var r = n(109),
        i = n(48);

    t.exports = function (t, e, n) {
      (void 0 === n || i(t[e], n)) && (void 0 !== n || e in t) || r(t, e, n);
    };
  }, function (t, e, n) {
    var r = n(33),
        i = function () {
      try {
        var t = r(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();

    t.exports = i;
  }, function (t, e, n) {
    var r = n(143)(Object.getPrototypeOf, Object);
    t.exports = r;
  }, function (t, e, n) {
    var r = n(22),
        i = n(23);

    t.exports = function (t) {
      return i(t) && r(t);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
    };
  }, function (t, e, n) {
    var r = n(140),
        i = n(350),
        o = n(22);

    t.exports = function (t) {
      return o(t) ? r(t, !0) : i(t);
    };
  }, function (t, e, n) {
    var r = n(179),
        i = n(358);

    t.exports = function (t) {
      return r(function (e, n) {
        var r = -1,
            o = n.length,
            a = o > 1 ? n[o - 1] : void 0,
            s = o > 2 ? n[2] : void 0;

        for (a = t.length > 3 && "function" == typeof a ? (o--, a) : void 0, s && i(n[0], n[1], s) && (a = o < 3 ? void 0 : a, o = 1), e = Object(e); ++r < o;) {
          var u = n[r];
          u && t(e, u, r, a);
        }

        return e;
      });
    };
  }, function (t, e, n) {
    var r = n(73),
        i = n(352),
        o = n(354);

    t.exports = function (t, e) {
      return o(i(t, e, r), t + "");
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = _(n(104)),
        i = _(n(105)),
        o = _(n(9)),
        a = _(n(35)),
        s = _(n(0)),
        u = _(n(1)),
        l = _(n(39)),
        c = _(n(75)),
        h = _(n(40)),
        f = _(n(4)),
        p = _(n(5)),
        d = n(28),
        v = _(n(181)),
        y = _(n(25)),
        m = _(n(182)),
        g = n(2);

    function _(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var b = function (t) {
      function e(t, n, r) {
        (0, s.default)(this, e);
        var i = (0, l.default)(this, (e.__proto__ || (0, a.default)(e)).call(this, t, n, r));
        return i._activeStyles = new m.default(), i;
      }

      return (0, h.default)(e, t), (0, u.default)(e, [{
        key: "clear",
        value: function value() {
          (0, c.default)(e.prototype.__proto__ || (0, a.default)(e.prototype), "clear", this).call(this), this._activeStyles.clear();
        }
      }, {
        key: "processGeoJsonData",
        value: function value(t) {
          var e = this;
          if (!t || !t.features) return o.default.resolve();
          var n = this._props.layerShowMarker === g.LayerShowMarker.ALWAYS,
              a = this._props.layerShowShape === g.LayerShowShape.ALWAYS;
          return o.default.all((0, p.default)(t.features, function () {
            var t = (0, i.default)(r.default.mark(function t(i) {
              var o, s;
              return r.default.wrap(function (t) {
                for (;;) {
                  switch (t.prev = t.next) {
                    case 0:
                      if (i.geometry) {
                        t.next = 2;
                        break;
                      }

                      return t.abrupt("return");

                    case 2:
                      if (o = (0, v.default)(i.geometry), i.styleOptions) {
                        t.next = 7;
                        break;
                      }

                      return t.next = 6, (0, y.default)(e._props.style, i.properties, e._props.zIndex);

                    case 6:
                      i.styleOptions = t.sent;

                    case 7:
                      s = i.styleOptions, e._props.dynamic && void 0 !== (0, f.default)(s, "index") && (e._activeStyles.addItem(e._props.style.ranges[s.index], s.index, !0, !1), delete s.index), n && e._layer.addPoints(o, i.properties, s), a && (e._layer.addPolygons(o, i.properties, s), e._layer.addPolylines(o, i.properties, s));

                    case 11:
                    case "end":
                      return t.stop();
                  }
                }
              }, t, e);
            }));
            return function (e) {
              return t.apply(this, arguments);
            };
          }())).then(function () {
            e._props.dynamic && e.trigger(g.KLayerEvents.DYNAMICSTYLES, e._activeStyles.legends);
          });
        }
      }, {
        key: "processJsonData",
        value: function value(t) {
          var e = this;
          if (!t || !t.file_data) return o.default.resolve();
          var n = this._props.layerShowMarker === g.LayerShowMarker.ALWAYS,
              a = this._props.layerShowShape === g.LayerShowShape.ALWAYS,
              s = (0, f.default)(this._props, "compress", !0);
          return o.default.all((0, p.default)(t.file_data, function () {
            var t = (0, i.default)(r.default.mark(function t(i) {
              var o, u;
              return r.default.wrap(function (t) {
                for (;;) {
                  switch (t.prev = t.next) {
                    case 0:
                      if (o = (0, d.processGeometries)(i, s, !a, !n)) {
                        t.next = 3;
                        break;
                      }

                      return t.abrupt("return");

                    case 3:
                      return t.next = 5, (0, y.default)(e._props.style, i.desc, e._props.zIndex);

                    case 5:
                      u = t.sent, e._props.dynamic && void 0 !== (0, f.default)(u, "index") && (e._activeStyles.addItem(e._props.style.ranges[u.index], u.index, n, a), delete u.index), n && e._layer.addPoints(o, i.desc, u, i.id), a && (e._layer.addPolygons(o, i.desc, u, i.id), e._layer.addPolylines(o, i.desc, u, i.id));

                    case 9:
                    case "end":
                      return t.stop();
                  }
                }
              }, t, e);
            }));
            return function (e) {
              return t.apply(this, arguments);
            };
          }())).then(function () {
            e._props.dynamic && e.trigger(g.KLayerEvents.DYNAMICSTYLES, e._activeStyles.legends);
          });
        }
      }, {
        key: "processData",
        value: function value(t) {
          return this._props.format === g.KMapVectorFormat.GEOJSON ? this.processGeoJsonData(t) : this.processJsonData(t);
        }
      }]), e;
    }(_(n(74)).default);

    e.default = b;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return [t[1], t[0]];
    }

    function i(t) {
      var e = {
        points: [],
        areas: [],
        lines: []
      };
      return t.forEach(function (t) {
        switch (t.type.toLowerCase()) {
          case "point":
            return e.points.push([r(t.coordinates)]);

          case "polygon":
            var n = t.coordinates.map(function (t) {
              return t.map(function (t) {
                return r(t);
              });
            });
            return e.areas = n, null;

          case "linestring":
            var i = t.coordinates.map(function (t) {
              return r(t);
            });
            return e.lines.push(i);
        }

        return null;
      }), e;
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.transposeLatLng = r, e.convertGeometryCollection = i, e.default = function (t) {
      var e = {
        points: [],
        areas: [],
        lines: []
      };

      switch (t.type.toLowerCase()) {
        case "point":
          e.points.push([r(t.coordinates)]);
          break;

        case "polygon":
          var n = t.coordinates.map(function (t) {
            return t.map(function (t) {
              return r(t);
            });
          });
          e.areas = n;
          break;

        case "linestring":
          var o = t.coordinates.map(function (t) {
            return r(t);
          });
          e.lines.push(o);
          break;

        case "geometrycollection":
          e = i(t.geometries);
      }

      return e;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = a(n(0)),
        i = a(n(1)),
        o = a(n(4));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var s = function () {
      function t() {
        (0, r.default)(this, t), this._activeStyles = [];
      }

      return (0, i.default)(t, [{
        key: "addItem",
        value: function value(t, e) {
          !this._activeStyles[e] && (0, o.default)(t, "showInLegend", !0) && (this._activeStyles[e] = t);
        }
      }, {
        key: "removeItem",
        value: function value(t) {
          t > -1 && this._activeStyles.splice(t, 1);
        }
      }, {
        key: "clear",
        value: function value() {
          this._activeStyles = [];
        }
      }, {
        key: "legends",
        get: function get() {
          return this._activeStyles;
        }
      }]), t;
    }();

    e.default = s;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = u(n(14)),
        i = u(n(0)),
        o = u(n(1)),
        a = n(28),
        s = n(2);

    function u(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function l(t, e, n) {
      var r = Math.pow(2, n),
          i = Math.PI - 2 * Math.PI * e / r;
      return {
        lng: t / r * 360 - 180,
        lat: 180 / Math.PI * Math.atan(.5 * (Math.exp(i) - Math.exp(-i)))
      };
    }

    function c(t, e, n) {
      return new google.maps.LatLngBounds(l(t, e, n), l(t + 1, e + 1, n));
    }

    var h = function () {
      function t(e, n, o) {
        (0, i.default)(this, t), this._source = n, this._map = o;
        var a = (0, r.default)({}, e, {
          getTileUrl: this._getTileUrlFunction(),
          tileSize: new google.maps.Size(e.tileSize, e.tileSize)
        });
        this._props = a, a.bounds && (this._allowedBounds = new google.maps.LatLngBounds({
          lat: a.bounds.south,
          lng: a.bounds.west
        }, {
          lat: a.bounds.north,
          lng: a.bounds.east
        })), this._tile = new google.maps.ImageMapType(a), this._overlayIndex = this._map.overlayMapTypes.getLength(), !1 !== this._props.enabled && this._map.overlayMapTypes.push(this._tile), !1 === this._props.visible && this.toggle(!1);
      }

      return (0, o.default)(t, [{
        key: "remove",
        value: function value() {
          this._props.enabled = !1;

          var t = this._map.overlayMapTypes.indexOf(this._tile);

          t >= 0 && this._map.overlayMapTypes.removeAt(t);
        }
      }, {
        key: "enable",
        value: function value() {
          !1 === this._props.enabled && (this._props.enabled = !0, this._map.overlayMapTypes.push(this._tile), !1 === this._props.visible && this.toggle(!1));
        }
      }, {
        key: "disable",
        value: function value() {
          this._props.enabled = !1, this._props.visible = !1, this.remove();
        }
      }, {
        key: "toggle",
        value: function value(t) {
          return this._props.visible = t, t ? this._tile.setOpacity(this._props.opacity) : this._tile.setOpacity(0);
        }
      }, {
        key: "setOpacity",
        value: function value(t) {
          this._props.opacity = t, this._props.visible && this._tile.setOpacity(t);
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._tile.set("zIndex", t);
        }
      }, {
        key: "setSource",
        value: function value(t) {
          this._source = t, this.remove(), this._map.overlayMapTypes.setAt(this._overlayIndex, this._tile);
        }
      }, {
        key: "_getTileUrlFunction",
        value: function value() {
          var t = this;
          return -1 !== this._source.indexOf("{q}") ? function (e, n) {
            if (t._allowedBounds && !t._allowedBounds.intersects(c(e.x, e.y, n))) return null;
            var r = (0, a.tileXYToQuadKey)(e.x, e.y, n);
            return t._source.replace(/{q}/, r);
          } : function (e, n) {
            return t._allowedBounds && !t._allowedBounds.intersects(c(e.x, e.y, n)) ? null : t._source.replace(/{x}/, e.x).replace(/{y}/, e.y).replace(/{z}/, n);
          };
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          switch (e) {
            case s.KLayerEvents.TILESLOADED:
              return this._tile.addListener("tilesloaded", function () {
                t.trigger(e);
              });

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          google.maps.event.removeListener(t);
        }
      }, {
        key: "enabled",
        get: function get() {
          return this._props.enabled;
        }
      }, {
        key: "tile",
        get: function get() {
          return this._tile;
        }
      }]), t;
    }();

    e.default = h;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r,
        i = h(n(7)),
        o = h(n(0)),
        a = h(n(1)),
        s = h(n(406)),
        u = h(n(110)),
        l = h(n(18)),
        c = n(2);

    function h(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var f = (0, l.default)(r = function () {
      function t(e, n, r) {
        (0, o.default)(this, t), this._map = r, this._tileProp = (0, i.default)({
          frameRate: 1e3
        }, e, {
          visible: !1,
          enabled: !1
        }), this._sources = n || [], this._layers = [], this._loaded = [], this._step = this._sources.length - 1, this._toggle = !0;
      }

      return (0, a.default)(t, [{
        key: "remove",
        value: function value() {
          this.stop(), this._layers.forEach(function (t) {
            return t.remove();
          });
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._toggle = void 0 !== t ? t : !this._toggle, this._sources.length > 0 && (this._toggle ? (this._layers[this._step].enable(), this._layers[this._step].toggle(!0)) : (this.stop(), this._layers[this._step].disable()));
        }
      }, {
        key: "setOpacity",
        value: function value(t) {
          this._tileProp.opacity = t, this._layers.forEach(function (e) {
            return e.setOpacity(t);
          });
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._tileProp.zIndex = t, this._layers.forEach(function (e) {
            return e.setZIndex(t);
          });
        }
      }, {
        key: "setSources",
        value: function value(t) {
          var e = this;
          t && t.length || this.remove();
          var n = t.length - 1,
              r = [],
              i = [],
              o = this._layers[this._step],
              a = !1;
          this._interval && (this.pause(), a = !0), t.forEach(function (t, n) {
            var o = (0, u.default)(e._sources, function (e) {
              return e === t;
            });
            o >= 0 && (r[n] = e._layers[o], i[n] = e._loaded[o], e._layers[o] = null);
          }), this._layers = (0, s.default)(this._layers);

          for (var l = function l(n) {
            if (0 === e._layers.length) return "break";
            -1 === (0, u.default)(e._sources, function (e) {
              return e === t[n];
            }) && (r[n] = e._layers.pop(), r[n].setSource(t[n]));
          }, c = 0; c < n; c += 1) {
            if ("break" === l(c)) break;
          }

          a ? (o.toggle(!1), this.play()) : (o.disable(), this._step = n), this._layers.forEach(function (t) {
            return t.remove();
          }), this._loaded = i, this._layers = r, this._sources = t;
        }
      }, {
        key: "setFrameRate",
        value: function value(t) {
          t && (this._tileProp.frameRate = t);
        }
      }, {
        key: "loadedTile",
        value: function value(t) {
          this._loaded[t] = !0, 0 === t && this.trigger(c.KLayerEvents.TILESLOADED);
        }
      }, {
        key: "play",
        value: function value() {
          var t = this,
              e = this._sources.length;
          e && (this._layers.forEach(function (t) {
            return t.enable();
          }), this._interval = window.setInterval(function () {
            var n = 0;
            t._step < e - 1 && (n = t._step + 1), t._loaded[n] && t._layers[t._step] && (t._layers[t._step].toggle(!1), t._step = n, t._layers[t._step].toggle(!0), t.trigger(c.KLayerEvents.FRAMELOADED, t._step));
          }, this._tileProp.frameRate));
        }
      }, {
        key: "stop",
        value: function value() {
          this._interval = window.clearInterval(this._interval), this._loaded = [], this._layers.length > 0 && (this._layers.forEach(function (t) {
            return t.disable();
          }), this._step = this._sources.length - 1, this._layers[this._step] && (this._layers[this._step].enable(), this._layers[this._step].toggle(!0)));
        }
      }, {
        key: "pause",
        value: function value() {
          this._interval = window.clearInterval(this._interval);
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          this.on(e, function (n) {
            t.trigger(e, n);
          });
        }
      }, {
        key: "removeEvent",
        value: function value() {}
      }, {
        key: "sources",
        get: function get() {
          return this._sources;
        }
      }, {
        key: "step",
        get: function get() {
          return this._step;
        }
      }, {
        key: "frameRate",
        get: function get() {
          return this._tileProp.frameRate;
        }
      }]), t;
    }()) || r;
    e.default = f;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    !function (t) {
      t && t.__esModule;
    }(n(53));

    var r = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        i = n(78),
        o = n(186);

    var a = function () {
      function t() {
        var e = this,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = n.handleSubmit,
            o = void 0 === r ? function () {} : r,
            a = n.searchLabel,
            s = void 0 === a ? "search" : a,
            u = n.classNames,
            l = void 0 === u ? {} : u;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var c = (0, i.createElement)("div", ["geosearch", l.container].join(" ")),
            h = (0, i.createElement)("form", ["", l.form].join(" "), c),
            f = (0, i.createElement)("input", ["glass", l.input].join(" "), h);
        f.type = "text", f.placeholder = s, f.addEventListener("input", function (t) {
          e.onInput(t);
        }, !1), f.addEventListener("keyup", function (t) {
          e.onKeyUp(t);
        }, !1), f.addEventListener("keypress", function (t) {
          e.onKeyPress(t);
        }, !1), f.addEventListener("focus", function (t) {
          e.onFocus(t);
        }, !1), f.addEventListener("blur", function (t) {
          e.onBlur(t);
        }, !1), this.elements = {
          container: c,
          form: h,
          input: f
        }, this.handleSubmit = o;
      }

      return r(t, [{
        key: "onFocus",
        value: function value() {
          (0, i.addClassName)(this.elements.form, "active");
        }
      }, {
        key: "onBlur",
        value: function value() {
          (0, i.removeClassName)(this.elements.form, "active");
        }
      }, {
        key: "onSubmit",
        value: function value(t) {
          return new Promise(function (e, n) {
            var r, o, a;
            return t.preventDefault(), t.stopPropagation(), o = (r = this.elements).input, a = r.container, (0, i.removeClassName)(a, "error"), (0, i.addClassName)(a, "pending"), this.handleSubmit({
              query: o.value
            }).then(function (t) {
              return (0, i.removeClassName)(a, "pending"), e();
            }.$asyncbind(this, n), n);
          }.$asyncbind(this));
        }
      }, {
        key: "onInput",
        value: function value() {
          var t = this.elements.container;
          this.hasError && ((0, i.removeClassName)(t, "error"), this.hasError = !1);
        }
      }, {
        key: "onKeyUp",
        value: function value(t) {
          var e = this.elements,
              n = e.container,
              r = e.input;
          t.keyCode === o.ESCAPE_KEY && ((0, i.removeClassName)(n, "pending"), (0, i.removeClassName)(n, "active"), r.value = "", document.body.focus(), document.body.blur());
        }
      }, {
        key: "onKeyPress",
        value: function value(t) {
          t.keyCode === o.ENTER_KEY && this.onSubmit(t);
        }
      }, {
        key: "setQuery",
        value: function value(t) {
          this.elements.input.value = t;
        }
      }]), t;
    }();

    e.default = a;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = e.ENTER_KEY = 13,
        i = e.ESCAPE_KEY = 27,
        o = e.ARROW_DOWN_KEY = 40,
        a = e.ARROW_UP_KEY = 38,
        s = e.ARROW_LEFT_KEY = 37,
        u = e.ARROW_RIGHT_KEY = 39;
    e.SPECIAL_KEYS = [r, i, o, a, s, u];
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = u(n(7)),
          i = u(n(0)),
          o = u(n(1)),
          a = n(2),
          s = n(28);

      function u(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      var l = void 0;

      var c = function () {
        function e(n, o, a) {
          if ((0, i.default)(this, e), this._map = a, this._props = (0, r.default)({}, n), n.zIndex || (this._props.zIndex = 2), n.bounds) {
            var u = n.bounds;
            this._props.bounds = [[u.south, u.west], [u.north, u.east]];
          }

          this._source = o, /{q}/.test(this._source) ? (l || (l = t.L.TileLayer.extend({
            getTileUrl: function getTileUrl(t) {
              return L.Util.template(this._url, {
                q: (0, s.tileXYToQuadKey)(t.x, t.y, this._getZoomForUrl())
              });
            }
          })), this._tile = new l(this._source, this._props)) : this._tile = L.tileLayer(this._source, this._props), !1 !== this._props.enabled && this._tile.addTo(a), !1 === this._props.visible && this.toggle(!1);
        }

        return (0, o.default)(e, [{
          key: "remove",
          value: function value() {
            return this._props.enabled = !1, this._map.removeLayer(this._tile);
          }
        }, {
          key: "enable",
          value: function value() {
            !1 === this._props.enabled && (this._map.addLayer(this._tile), this._props.enabled = !0, !1 === this._props.visible && this.toggle(!1));
          }
        }, {
          key: "disable",
          value: function value() {
            this._props.enabled = !1, this._props.visible = !1, this.remove();
          }
        }, {
          key: "toggle",
          value: function value(t) {
            this._props.visible = t, !1 !== this.enabled && (this._tile.getContainer().style.display = t ? "" : "none");
          }
        }, {
          key: "setOpacity",
          value: function value(t) {
            this._tile.setOpacity(t);
          }
        }, {
          key: "setZIndex",
          value: function value(t) {
            this._tile.setZIndex(t);
          }
        }, {
          key: "setSource",
          value: function value(t) {
            this._source = t, this._tile.setUrl(t, !1);
          }
        }, {
          key: "addEvent",
          value: function value(t, e) {
            switch (e) {
              case a.KLayerEvents.TILESLOADED:
                return this._tile.on("load", function () {
                  t.trigger(e);
                });

              default:
                return null;
            }
          }
        }, {
          key: "removeEvent",
          value: function value(t, e) {
            switch (e) {
              case a.KLayerEvents.TILESLOADED:
                this._tile.off("load", t);

            }
          }
        }, {
          key: "enabled",
          get: function get() {
            return this._props.enabled;
          }
        }, {
          key: "tile",
          get: function get() {
            return this._tile;
          }
        }]), e;
      }();

      e.default = c;
    }).call(this, n(10));
  }, function (t, e) {
    t.exports = "data:image/svg+xml;base64,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";
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), n(190);

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(193));

    e.default = r.default;
  }, function (t, e, n) {
    var r = n(191);
    "string" == typeof r && (r = [[t.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(113)(r, i);
    r.locals && (t.exports = r.locals);
  }, function (t, e, n) {
    (t.exports = n(112)(!1)).push([t.i, ".leaflet-tooltip.kmap-marker-label{background:transparent;border:0;box-shadow:none}.kmap-marker-label{font-family:Roboto, monospace;font-size:12px;font-weight:600}.kmap-cluster-label div{display:flex;align-items:center;justify-content:center;background:transparent no-repeat 0 0;height:100%}.kmap-no-click{cursor:default}\n", ""]);
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var n = e.protocol + "//" + e.host,
          r = n + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var i,
            o = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? t : (i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : r + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
      });
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var r,
        i,
        o,
        a,
        s,
        u = z(n(114)),
        l = z(n(14)),
        c = z(n(9)),
        h = z(n(218)),
        f = z(n(7)),
        p = z(n(0)),
        d = z(n(1)),
        v = z(n(90)),
        y = z(n(225)),
        m = z(n(239)),
        g = z(n(24)),
        _ = z(n(16)),
        b = z(n(4)),
        L = z(n(158)),
        x = n(25),
        w = z(n(169)),
        M = n(2),
        k = z(n(18)),
        C = z(n(74)),
        E = z(n(180)),
        I = z(n(382)),
        A = z(n(76)),
        P = z(n(392)),
        O = z(n(393)),
        T = z(n(394)),
        S = z(n(397)),
        D = z(n(398)),
        j = z(n(417)),
        N = z(n(427));

    function z(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var B = (r = {}, (0, v.default)(r, M.KMapApi.GOOGLE, D.default), (0, v.default)(r, M.KMapApi.LEAFLET, N.default), (0, v.default)(r, M.KMapApi.BING, j.default), r),
        R = n(51),
        G = n(51),
        Z = n(51),
        U = n(456),
        V = n(51),
        K = n(457),
        H = (i = {}, (0, v.default)(i, M.KMapSpecialMarker.ADDRESS, {
      url: G
    }), (0, v.default)(i, M.KMapSpecialMarker.BOOKMARK, {
      url: Z
    }), (0, v.default)(i, M.KMapSpecialMarker.GPS, {
      url: U
    }), (0, v.default)(i, M.KMapSpecialMarker.LOCATION, {
      url: V
    }), i),
        Y = (0, k.default)((s = a = function () {
      function t() {
        (0, p.default)(this, t);
      }

      return (0, d.default)(t, [{
        key: "_checkZoom",
        value: function value(t) {
          var e = t;
          return this._mapParams.maxZoom && this._mapParams.maxZoom < t && (e = this._mapParams.maxZoom), this._mapParams.minZoom && this._mapParams.minZoom > t && (e = this._mapParams.minZoom), e;
        }
      }, {
        key: "initialize",
        value: function value(t) {
          var e = this,
              n = (0, f.default)({
            startCenter: {
              lat: 0,
              lng: 0
            },
            startZoom: 5,
            center: t.startCenter || {
              lat: 0,
              lng: 0
            },
            zoom: t.startZoom || 5,
            showScalebar: !0,
            maxZoom: 21,
            minZoom: 1
          }, t);
          n.mapType = n.mapType ? n.mapType : M.KMapType[n.api].DEFAULT, n.allowedBBox && (n.allowedBBox = {
            north: n.allowedBBox.north > n.allowedBBox.south ? n.allowedBBox.north : n.allowedBBox.south,
            south: n.allowedBBox.north > n.allowedBBox.south ? n.allowedBBox.south : n.allowedBBox.north,
            east: n.allowedBBox.east > n.allowedBBox.west ? n.allowedBBox.east : n.allowedBBox.west,
            west: n.allowedBBox.east > n.allowedBBox.west ? n.allowedBBox.west : n.allowedBBox.east
          }), this._mapParams = n, this._layers = {}, this._kGeometries = [], this._selectedGeometry = [], this.setEventContext(this.map), this.map.initialize(document.getElementById(t.id), n), this.on(M.KMapEvent.CLICK, this._removeLayerClickGeometry.bind(this)), this.on(M.KMapEvent.VIEWCHANGED, function (t) {
            e._lastLoadedZoom !== t.zoom && (e._removeLayerClickGeometry(), e._lastLoadedZoom = t.zoom);
          });
        }
      }, {
        key: "configureMap",
        value: function value(t) {
          this._mapParams = (0, f.default)({}, this._mapParams, t);
        }
      }, {
        key: "getMapId",
        value: function value() {
          return this._mapParams.id;
        }
      }, {
        key: "getMapParams",
        value: function value() {
          return this._mapParams;
        }
      }, {
        key: "setMapType",
        value: function value(t) {
          return this._mapParams = (0, f.default)({}, this._mapParams, {
            mapType: t
          }), this.map.setMapType(t);
        }
      }, {
        key: "getMapType",
        value: function value() {
          return this._mapParams.mapType;
        }
      }, {
        key: "zoomIn",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
          this.setZoom(this.getZoom() + t);
        }
      }, {
        key: "zoomOut",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
          this.setZoom(this.getZoom() - t);
        }
      }, {
        key: "setZoom",
        value: function value(t) {
          this.map.setZoom(this._checkZoom(t));
        }
      }, {
        key: "getZoom",
        value: function value() {
          return this.map.getZoom();
        }
      }, {
        key: "getMinZoom",
        value: function value() {
          return this._mapParams.minZoom;
        }
      }, {
        key: "getMaxZoom",
        value: function value() {
          return this._mapParams.maxZoom;
        }
      }, {
        key: "getCenter",
        value: function value() {
          return this.map.getCenter();
        }
      }, {
        key: "setCenter",
        value: function value(t) {
          t && t.lat && t.lng && this.map.setCenter(t);
        }
      }, {
        key: "getView",
        value: function value() {
          return this.map.getView();
        }
      }, {
        key: "setView",
        value: function value(t) {
          this.map.setView(t);
        }
      }, {
        key: "getBBox",
        value: function value() {
          return this.map.getBounds();
        }
      }, {
        key: "setBBox",
        value: function value(t) {
          return this.map.fitBounds(t);
        }
      }, {
        key: "getAllowableBBox",
        value: function value() {
          return this._mapParams.allowableBBox;
        }
      }, {
        key: "panBy",
        value: function value(t, e) {
          this.map.panBy(t, e);
        }
      }, {
        key: "goToOverview",
        value: function value() {
          this.map.setView({
            center: this._mapParams.startCenter,
            zoom: this._mapParams.startZoom
          });
        }
      }, {
        key: "getOverview",
        value: function value() {
          return {
            center: this._mapParams.startCenter,
            zoom: this._mapParams.startZoom
          };
        }
      }, {
        key: "goToAddress",
        value: function value(t, e) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : M.KMapSpecialMarker.ADDRESS,
              i = t.match(/^\s*([-+]?[1-8]?\d(\.\d+)?|90(\.0+)?)\s*[,]?\s*([-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?))\s*$/),
              o = e;

          if (i) {
            var a = (0, h.default)(i[1]),
                s = (0, h.default)(i[4]);
            return o || (o = this._mapParams.maxZoom), this.goToPoint({
              center: {
                lat: a,
                lng: s
              },
              zoom: o
            }, r, {
              address: t
            }).then(function (e) {
              return {
                geometry: e,
                success: !0,
                address: t
              };
            });
          }

          return this.map.goToAddress(t).then(function (e) {
            if (!e) throw new Error(M.ErrorCodes.ADDRESS_NOT_FOUND);
            o || (o = n.getZoom());
            var i = {
              center: e.location,
              zoom: o
            },
                a = {
              address: e.address || t
            };
            return e.bounds && (n.map.fitBounds(e.bounds), delete i.zoom), n.goToPoint(i, r, a).then(function (t) {
              return {
                geometry: t,
                success: !0,
                address: a.address
              };
            });
          }, function (t) {
            throw new Error(t.error);
          });
        }
      }, {
        key: "searchAddress",
        value: function value(t) {
          return this.map.searchAddress(t);
        }
      }, {
        key: "goToPoint",
        value: function value(t) {
          var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : M.KMapSpecialMarker.GPS,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return this.deleteAllSpecialMarkers(), new c.default(function (i, o) {
            if ((0, b.default)(t, "center")) {
              if (e.map.contains(t.center)) {
                if (e.map.setView(t), n) {
                  var a = (0, l.default)({
                    url: R,
                    anchor: [16, 16],
                    opacity: 1,
                    size: [32, 32],
                    scale: 2,
                    zIndex: 2e3
                  }, H[n]),
                      s = new S.default(t.center, M.KGeometryType.POINT, a, r);
                  e._kGeometries.push(s), s.setMap(e), i(s);
                } else i();
              } else o(new Error(M.ErrorCodes.OUT_OF_BOUNDS));
            } else o(new Error(M.ErrorCodes.LAT_LNG_NOT_FOUND));
          });
        }
      }, {
        key: "deleteAllSpecialMarkers",
        value: function value() {
          this._kGeometries.forEach(function (t) {
            return t.remove();
          }), this._kGeometries.length = 0;
        }
      }, {
        key: "loadVectorLayer",
        value: function value(e, n, r) {
          var i = void 0;
          return i = r.format === t.layerFormat.GEOJSON ? new O.default(e, n, r) : new E.default(e, n, r), this.setLayerClickable(i, r), i;
        }
      }, {
        key: "_removeLayerClickGeometry",
        value: function value() {
          this._lSpecialGeom && this._lSpecialGeom.geometry && (this._lSpecialGeom.geometry.remove(), this._lSpecialGeom = null);
        }
      }, {
        key: "removeSelected",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              e = arguments[1];
          0 === (0, b.default)(this, "_selectedGeometry", []).length || t || ((0, _.default)(this._selectedGeometry, function (t) {
            t.remove();
          }), this._selectedGeometry = []), !(0, g.default)(e) && t && (0, m.default)(this._selectedGeometry, e).forEach(function (t) {
            return t.remove();
          });
        }
      }, {
        key: "setLayerClickable",
        value: function value(t, e) {
          var n = this;
          !1 !== (0, b.default)(e, "clickable") ? e.layerShowMarker !== M.LayerShowMarker.ONLY_ON_SHAPE_SELECTION && e.layerShowShape !== M.LayerShowShape.ONLY_ON_MARKER_SELECTION || t.on("click", function (r) {
            var i = n._selectedGeometry;

            n._removeLayerClickGeometry();

            var o = void 0;
            (0, b.default)(r, "geom.points") && e.layerShowMarker === M.LayerShowMarker.ONLY_ON_SHAPE_SELECTION ? o = n.selectElement(r.geom, M.KGeometryType.POINT, {}, r.kStyle.icon) : e.layerShowShape === M.LayerShowShape.ONLY_ON_MARKER_SELECTION && ((0, b.default)(r, "geom.areas") ? o = n.selectElement(r.geom, M.KGeometryType.POLYGON, {}, r.kStyle.shape) : (0, b.default)(r, "geom.lines") && (o = n.selectElement(r.geom, M.KGeometryType.POLYLINE, {}, r.kStyle.shape))), n._selectedGeometry = i, n._lSpecialGeom = {
              geometry: o,
              layerName: t.name
            };
          }) : t.off("click");
        }
      }, {
        key: "loadLayer",
        value: function value(t, e, n) {
          var r = void 0;
          if (this._layers[t]) return c.default.resolve(this.setLayerParams(t, n));

          switch (n.type) {
            case M.KMapLayerType.TILE:
              r = new I.default(t, e, n);
              break;

            case M.KMapLayerType.ANIMATED_TILE:
              r = new P.default(t, e, n);
              break;

            case M.KMapLayerType.DRAW:
              r = new A.default(t, n);
              break;

            case M.KMapLayerType.CLUSTER:
              r = new T.default(t, e, n), this.setLayerClickable(r, n);
              break;

            default:
              r = new E.default(t, e, n), this.setLayerClickable(r, n);
          }

          var i = r.setMap(this);
          return this._layers[t] = {
            layer: r,
            layerParams: n,
            source: e
          }, c.default.resolve(i).then(function () {
            return r;
          });
        }
      }, {
        key: "removeLayer",
        value: function value(t) {
          this._layers[t] && (this._layers[t].layer.remove(), delete this._layers[t], this._lSpecialGeom && this._lSpecialGeom.layerName === t && this._removeLayerClickGeometry());
        }
      }, {
        key: "mapRegisterEvent",
        value: function value(t, e) {
          this.on(t, e);
        }
      }, {
        key: "layerRegisterEvent",
        value: function value(t, e, n) {
          this._layers[t] && this._layers[t].layer.on(e, n);
        }
      }, {
        key: "setLayerVisibility",
        value: function value(t, e) {
          this._layers[t] && (this._layers[t].layer.toggle(e), !e && this._lSpecialGeom && this._lSpecialGeom.layerName === t && this._removeLayerClickGeometry());
        }
      }, {
        key: "getLayerParams",
        value: function value(t) {
          return this._layers[t] ? this._layers[t].layerParams : null;
        }
      }, {
        key: "setLayerParams",
        value: function value(t, e) {
          if (!this._layers[t]) throw new Error("LayerName " + t + " does not exist");
          var n = this._layers[t],
              r = n.layer;
          r.receiveProps(e), (0, b.default)(e, "visible", !0) || this._lSpecialGeom && this._lSpecialGeom.layerName === t && this._removeLayerClickGeometry();
          var i = n.layerParams.clickable;
          return n.layerParams = (0, f.default)({}, n.layerParams, e), e.clickable !== i && this.setLayerClickable(r, n.layerParams), r;
        }
      }, {
        key: "reloadLayer",
        value: function value(t) {
          if (this._layers[t]) {
            var e = this._layers[t].layer;
            e instanceof C.default && e.reload();
          }
        }
      }, {
        key: "startLayerAnimation",
        value: function value(t) {
          if (this._layers[t]) {
            var e = this._layers[t].layer;
            e instanceof P.default && e.play();
          }
        }
      }, {
        key: "stopLayerAnimation",
        value: function value(t) {
          if (this._layers[t]) {
            var e = this._layers[t].layer;
            e instanceof P.default && e.stop();
          }
        }
      }, {
        key: "layerDispatch",
        value: function value(t, e) {
          if (this._layers[e] && "function" == typeof this._layers[e].layer[t]) {
            for (var n, r = arguments.length, i = Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++) {
              i[o - 2] = arguments[o];
            }

            (n = this._layers[e].layer)[t].apply(n, i);
          }
        }
      }, {
        key: "selectElement",
        value: function value(t, e, n, r) {
          var i = void 0,
              o = t;

          switch (e) {
            case M.KGeometryType.POINT:
              o = (0, b.default)(t, "points[0][0]", t);
              var a = void 0;
              a = r ? (0, f.default)({
                url: R,
                anchor: [16, 16],
                size: [32, 32],
                color: "#fff",
                opacity: 1
              }, r) : {
                url: K,
                anchor: [28, 28],
                size: [56, 56],
                color: "#0F0",
                opacity: .6,
                scale: 2,
                zIndex: 2
              }, i = new S.default(o, M.KGeometryType.POINT, a, n);
              break;

            case M.KGeometryType.POLYGON:
              o = (0, b.default)(t, "areas", t), i = new S.default(o, M.KGeometryType.POLYGON, (0, f.default)({
                fillColor: "#222",
                opacity: .6,
                borderColor: "#222",
                borderWeight: 1,
                borderOpacity: 1
              }, r), n);
              break;

            case M.KGeometryType.POLYLINE:
              o = (0, b.default)(t, "lines[0]", t), i = new S.default(o, M.KGeometryType.POLYLINE, (0, f.default)({
                color: "#222",
                opacity: .6,
                width: 1
              }, r), n);
          }

          return this._selectedGeometry.push(i), i && i.setMap(this), i;
        }
      }, {
        key: "map",
        get: function get() {
          return this._apiMap;
        }
      }], [{
        key: "setLocale",
        value: function value(t) {
          w.default.setItem("locale", t);
        }
      }, {
        key: "createMap",
        value: function value(e) {
          if (!e) throw new Error("empty map params passed");
          var n = (0, y.default)(t.api, e.api) ? e.api : t.api.GOOGLE,
              r = (0, f.default)({}, e, {
            api: n
          }),
              i = B[n],
              o = e.locale || w.default.getItem("locale") || "en";
          return w.default.setItem("locale", o), new c.default(function (e) {
            i.setUp(r.apiKey, r.libraries).then(function () {
              var n = (0, f.default)((0, u.default)(t.prototype), {
                _apiMap: new i()
              });
              n.initialize(r), e(n);
            });
          });
        }
      }, {
        key: "getValidMapTypes",
        value: function value(e) {
          return t.mapType[e];
        }
      }, {
        key: "setKmapHttpHeaders",
        value: function value(t) {
          L.default.defaults.headers = t;
        }
      }, {
        key: "setKmapHttpRequestInterceptor",
        value: function value(t, e) {
          return L.default.interceptors.request.use(t, e);
        }
      }, {
        key: "setKmapHttpResponseInterceptor",
        value: function value(t, e) {
          return L.default.interceptors.response.use(t, e);
        }
      }, {
        key: "removeKmapHttpInterceptor",
        value: function value() {
          L.default.interceptors.request.forEach(function (t, e) {
            return L.default.interceptors.request.eject(e);
          }), L.default.interceptors.response.forEach(function (t, e) {
            return L.default.interceptors.response.eject(e);
          });
        }
      }, {
        key: "api",
        get: function get() {
          return M.KMapApi;
        }
      }, {
        key: "mapType",
        get: function get() {
          return M.KMapType;
        }
      }, {
        key: "event",
        get: function get() {
          return M.KMapEvent;
        }
      }, {
        key: "specialMarker",
        get: function get() {
          return M.KMapSpecialMarker;
        }
      }, {
        key: "layerType",
        get: function get() {
          return M.KMapLayerType;
        }
      }, {
        key: "layerFormat",
        get: function get() {
          return M.KMapVectorFormat;
        }
      }, {
        key: "layerShowMarker",
        get: function get() {
          return M.LayerShowMarker;
        }
      }, {
        key: "layerShowShape",
        get: function get() {
          return M.LayerShowShape;
        }
      }, {
        key: "layerEvent",
        get: function get() {
          return M.KLayerEvents;
        }
      }, {
        key: "errorCodes",
        get: function get() {
          return M.ErrorCodes;
        }
      }, {
        key: "geometryTypes",
        get: function get() {
          return M.KGeometryType;
        }
      }, {
        key: "kubraAxios",
        get: function get() {
          return L.default;
        }
      }]), t;
    }(), a.extractRangeForRecord = x.extractRangeForRecord, o = s)) || o;
    e.default = Y;
  }, function (t, e, n) {
    n(195);
    var r = n(3).Object;

    t.exports = function (t, e) {
      return r.create(t, e);
    };
  }, function (t, e, n) {
    var r = n(11);
    r(r.S, "Object", {
      create: n(81)
    });
  }, function (t, e, n) {
    var r = n(19),
        i = n(20),
        o = n(42);
    t.exports = n(21) ? Object.defineProperties : function (t, e) {
      i(t);

      for (var n, a = o(e), s = a.length, u = 0; s > u;) {
        r.f(t, n = a[u++], e[n]);
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(32),
        i = n(82),
        o = n(198);

    t.exports = function (t) {
      return function (e, n, a) {
        var s,
            u = r(e),
            l = i(u.length),
            c = o(a, l);

        if (t && n != n) {
          for (; l > c;) {
            if ((s = u[c++]) != s) return !0;
          }
        } else for (; l > c; c++) {
          if ((t || c in u) && u[c] === n) return t || c || 0;
        }

        return !t && -1;
      };
    };
  }, function (t, e, n) {
    var r = n(83),
        i = Math.max,
        o = Math.min;

    t.exports = function (t, e) {
      return (t = r(t)) < 0 ? i(t + e, 0) : o(t, e);
    };
  }, function (t, e, n) {
    n(200), t.exports = n(3).Object.assign;
  }, function (t, e, n) {
    var r = n(11);
    r(r.S + r.F, "Object", {
      assign: n(201)
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(21),
        i = n(42),
        o = n(87),
        a = n(58),
        s = n(38),
        u = n(117),
        l = Object.assign;
    t.exports = !l || n(30)(function () {
      var t = {},
          e = {},
          n = Symbol(),
          r = "abcdefghijklmnopqrst";
      return t[n] = 7, r.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != l({}, t)[n] || Object.keys(l({}, e)).join("") != r;
    }) ? function (t, e) {
      for (var n = s(t), l = arguments.length, c = 1, h = o.f, f = a.f; l > c;) {
        for (var p, d = u(arguments[c++]), v = h ? i(d).concat(h(d)) : i(d), y = v.length, m = 0; y > m;) {
          p = v[m++], r && !f.call(d, p) || (n[p] = d[p]);
        }
      }

      return n;
    } : l;
  }, function (t, e, n) {
    n(119), n(88), n(123), n(208), n(216), n(217), t.exports = n(3).Promise;
  }, function (t, e, n) {
    var r = n(83),
        i = n(56);

    t.exports = function (t) {
      return function (e, n) {
        var o,
            a,
            s = String(i(e)),
            u = r(n),
            l = s.length;
        return u < 0 || u >= l ? t ? "" : void 0 : (o = s.charCodeAt(u)) < 55296 || o > 56319 || u + 1 === l || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? s.charAt(u) : o : t ? s.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536;
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(81),
        i = n(41),
        o = n(59),
        a = {};
    n(29)(a, n(12)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = r(a, {
        next: i(1, n)
      }), o(t, e + " Iterator");
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(206),
        i = n(207),
        o = n(45),
        a = n(32);
    t.exports = n(120)(Array, "Array", function (t, e) {
      this._t = a(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;
      return !t || n >= t.length ? (this._t = void 0, i(1)) : i(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]]);
    }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        value: e,
        done: !!t
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r,
        i,
        o,
        a,
        s = n(44),
        u = n(6),
        l = n(37),
        c = n(124),
        h = n(11),
        f = n(26),
        p = n(55),
        d = n(209),
        v = n(210),
        y = n(128),
        m = n(129).set,
        g = n(212)(),
        _ = n(89),
        b = n(130),
        L = n(213),
        x = n(131),
        w = u.TypeError,
        M = u.process,
        k = M && M.versions,
        C = k && k.v8 || "",
        _E = u.Promise,
        I = "process" == c(M),
        A = function A() {},
        P = i = _.f,
        O = !!function () {
      try {
        var t = _E.resolve(1),
            e = (t.constructor = {})[n(12)("species")] = function (t) {
          t(A, A);
        };

        return (I || "function" == typeof PromiseRejectionEvent) && t.then(A) instanceof e && 0 !== C.indexOf("6.6") && -1 === L.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        T = function T(t) {
      var e;
      return !(!f(t) || "function" != typeof (e = t.then)) && e;
    },
        S = function S(t, e) {
      if (!t._n) {
        t._n = !0;
        var n = t._c;
        g(function () {
          for (var r = t._v, i = 1 == t._s, o = 0, a = function a(e) {
            var n,
                o,
                a,
                s = i ? e.ok : e.fail,
                u = e.resolve,
                l = e.reject,
                c = e.domain;

            try {
              s ? (i || (2 == t._h && N(t), t._h = 1), !0 === s ? n = r : (c && c.enter(), n = s(r), c && (c.exit(), a = !0)), n === e.promise ? l(w("Promise-chain cycle")) : (o = T(n)) ? o.call(n, u, l) : u(n)) : l(r);
            } catch (t) {
              c && !a && c.exit(), l(t);
            }
          }; n.length > o;) {
            a(n[o++]);
          }

          t._c = [], t._n = !1, e && !t._h && D(t);
        });
      }
    },
        D = function D(t) {
      m.call(u, function () {
        var e,
            n,
            r,
            i = t._v,
            o = j(t);
        if (o && (e = b(function () {
          I ? M.emit("unhandledRejection", i, t) : (n = u.onunhandledrejection) ? n({
            promise: t,
            reason: i
          }) : (r = u.console) && r.error && r.error("Unhandled promise rejection", i);
        }), t._h = I || j(t) ? 2 : 1), t._a = void 0, o && e.e) throw e.v;
      });
    },
        j = function j(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        N = function N(t) {
      m.call(u, function () {
        var e;
        I ? M.emit("rejectionHandled", t) : (e = u.onrejectionhandled) && e({
          promise: t,
          reason: t._v
        });
      });
    },
        z = function z(t) {
      var e = this;
      e._d || (e._d = !0, (e = e._w || e)._v = t, e._s = 2, e._a || (e._a = e._c.slice()), S(e, !0));
    },
        B = function B(t) {
      var e,
          n = this;

      if (!n._d) {
        n._d = !0, n = n._w || n;

        try {
          if (n === t) throw w("Promise can't be resolved itself");
          (e = T(t)) ? g(function () {
            var r = {
              _w: n,
              _d: !1
            };

            try {
              e.call(t, l(B, r, 1), l(z, r, 1));
            } catch (t) {
              z.call(r, t);
            }
          }) : (n._v = t, n._s = 1, S(n, !1));
        } catch (t) {
          z.call({
            _w: n,
            _d: !1
          }, t);
        }
      }
    };

    O || (_E = function E(t) {
      d(this, _E, "Promise", "_h"), p(t), r.call(this);

      try {
        t(l(B, this, 1), l(z, this, 1));
      } catch (t) {
        z.call(this, t);
      }
    }, (r = function r(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }).prototype = n(214)(_E.prototype, {
      then: function then(t, e) {
        var n = P(y(this, _E));
        return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = I ? M.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && S(this, !1), n.promise;
      },
      catch: function _catch(t) {
        return this.then(void 0, t);
      }
    }), o = function o() {
      var t = new r();
      this.promise = t, this.resolve = l(B, t, 1), this.reject = l(z, t, 1);
    }, _.f = P = function P(t) {
      return t === _E || t === a ? new o(t) : i(t);
    }), h(h.G + h.W + h.F * !O, {
      Promise: _E
    }), n(59)(_E, "Promise"), n(215)("Promise"), a = n(3).Promise, h(h.S + h.F * !O, "Promise", {
      reject: function reject(t) {
        var e = P(this);
        return (0, e.reject)(t), e.promise;
      }
    }), h(h.S + h.F * (s || !O), "Promise", {
      resolve: function resolve(t) {
        return x(s && this === a ? _E : this, t);
      }
    }), h(h.S + h.F * !(O && n(132)(function (t) {
      _E.all(t).catch(A);
    })), "Promise", {
      all: function all(t) {
        var e = this,
            n = P(e),
            r = n.resolve,
            i = n.reject,
            o = b(function () {
          var n = [],
              o = 0,
              a = 1;
          v(t, !1, function (t) {
            var s = o++,
                u = !1;
            n.push(void 0), a++, e.resolve(t).then(function (t) {
              u || (u = !0, n[s] = t, --a || r(n));
            }, i);
          }), --a || r(n);
        });
        return o.e && i(o.v), n.promise;
      },
      race: function race(t) {
        var e = this,
            n = P(e),
            r = n.reject,
            i = b(function () {
          v(t, !1, function (t) {
            e.resolve(t).then(n.resolve, r);
          });
        });
        return i.e && r(i.v), n.promise;
      }
    });
  }, function (t, e) {
    t.exports = function (t, e, n, r) {
      if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!");
      return t;
    };
  }, function (t, e, n) {
    var r = n(37),
        i = n(125),
        o = n(126),
        a = n(20),
        s = n(82),
        u = n(127),
        l = {},
        c = {};
    (e = t.exports = function (t, e, n, h, f) {
      var p,
          d,
          v,
          y,
          m = f ? function () {
        return t;
      } : u(t),
          g = r(n, h, e ? 2 : 1),
          _ = 0;
      if ("function" != typeof m) throw TypeError(t + " is not iterable!");

      if (o(m)) {
        for (p = s(t.length); p > _; _++) {
          if ((y = e ? g(a(d = t[_])[0], d[1]) : g(t[_])) === l || y === c) return y;
        }
      } else for (v = m.call(t); !(d = v.next()).done;) {
        if ((y = i(v, g, d.value, e)) === l || y === c) return y;
      }
    }).BREAK = l, e.RETURN = c;
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var r = void 0 === n;

      switch (e.length) {
        case 0:
          return r ? t() : t.call(n);

        case 1:
          return r ? t(e[0]) : t.call(n, e[0]);

        case 2:
          return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]);

        case 3:
          return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);

        case 4:
          return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);
      }

      return t.apply(n, e);
    };
  }, function (t, e, n) {
    var r = n(6),
        i = n(129).set,
        o = r.MutationObserver || r.WebKitMutationObserver,
        a = r.process,
        s = r.Promise,
        u = "process" == n(43)(a);

    t.exports = function () {
      var t,
          e,
          n,
          l = function l() {
        var r, i;

        for (u && (r = a.domain) && r.exit(); t;) {
          i = t.fn, t = t.next;

          try {
            i();
          } catch (r) {
            throw t ? n() : e = void 0, r;
          }
        }

        e = void 0, r && r.enter();
      };

      if (u) n = function n() {
        a.nextTick(l);
      };else if (!o || r.navigator && r.navigator.standalone) {
        if (s && s.resolve) {
          var c = s.resolve(void 0);

          n = function n() {
            c.then(l);
          };
        } else n = function n() {
          i.call(r, l);
        };
      } else {
        var h = !0,
            f = document.createTextNode("");
        new o(l).observe(f, {
          characterData: !0
        }), n = function n() {
          f.data = h = !h;
        };
      }
      return function (r) {
        var i = {
          fn: r,
          next: void 0
        };
        e && (e.next = i), t || (t = i, n()), e = i;
      };
    };
  }, function (t, e, n) {
    var r = n(6).navigator;
    t.exports = r && r.userAgent || "";
  }, function (t, e, n) {
    var r = n(29);

    t.exports = function (t, e, n) {
      for (var i in e) {
        n && t[i] ? t[i] = e[i] : r(t, i, e[i]);
      }

      return t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(6),
        i = n(3),
        o = n(19),
        a = n(21),
        s = n(12)("species");

    t.exports = function (t) {
      var e = "function" == typeof i[t] ? i[t] : r[t];
      a && e && !e[s] && o.f(e, s, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(11),
        i = n(3),
        o = n(6),
        a = n(128),
        s = n(131);
    r(r.P + r.R, "Promise", {
      finally: function _finally(t) {
        var e = a(this, i.Promise || o.Promise),
            n = "function" == typeof t;
        return this.then(n ? function (n) {
          return s(e, t()).then(function () {
            return n;
          });
        } : t, n ? function (n) {
          return s(e, t()).then(function () {
            throw n;
          });
        } : t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(11),
        i = n(89),
        o = n(130);
    r(r.S, "Promise", {
      try: function _try(t) {
        var e = i.f(this),
            n = o(t);
        return (n.e ? e.reject : e.resolve)(n.v), e.promise;
      }
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(219),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(220), t.exports = n(3).Number.parseFloat;
  }, function (t, e, n) {
    var r = n(11),
        i = n(221);
    r(r.S + r.F * (Number.parseFloat != i), "Number", {
      parseFloat: i
    });
  }, function (t, e, n) {
    var r = n(6).parseFloat,
        i = n(222).trim;
    t.exports = 1 / r(n(133) + "-0") != -1 / 0 ? function (t) {
      var e = i(String(t), 3),
          n = r(e);
      return 0 === n && "-" == e.charAt(0) ? -0 : n;
    } : r;
  }, function (t, e, n) {
    var r = n(11),
        i = n(56),
        o = n(30),
        a = n(133),
        s = "[" + a + "]",
        u = RegExp("^" + s + s + "*"),
        l = RegExp(s + s + "*$"),
        c = function c(t, e, n) {
      var i = {},
          s = o(function () {
        return !!a[t]() || "​" != "​"[t]();
      }),
          u = i[t] = s ? e(h) : a[t];
      n && (i[n] = u), r(r.P + r.F * s, "String", i);
    },
        h = c.trim = function (t, e) {
      return t = String(i(t)), 1 & e && (t = t.replace(u, "")), 2 & e && (t = t.replace(l, "")), t;
    };

    t.exports = c;
  }, function (t, e, n) {
    n(224);
    var r = n(3).Object;

    t.exports = function (t, e, n) {
      return r.defineProperty(t, e, n);
    };
  }, function (t, e, n) {
    var r = n(11);
    r(r.S + r.F * !n(21), "Object", {
      defineProperty: n(19).f
    });
  }, function (t, e, n) {
    var r = n(60),
        i = n(22),
        o = n(230),
        a = n(137),
        s = n(139),
        u = Math.max;

    t.exports = function (t, e, n, l) {
      t = i(t) ? t : s(t), n = n && !l ? a(n) : 0;
      var c = t.length;
      return n < 0 && (n = u(c + n, 0)), o(t) ? n <= c && t.indexOf(e, n) > -1 : !!c && r(t, e, n) > -1;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t != t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      for (var r = n - 1, i = t.length; ++r < i;) {
        if (t[r] === e) return r;
      }

      return -1;
    };
  }, function (t, e, n) {
    var r = n(61),
        i = Object.prototype,
        o = i.hasOwnProperty,
        a = i.toString,
        s = r ? r.toStringTag : void 0;

    t.exports = function (t) {
      var e = o.call(t, s),
          n = t[s];

      try {
        t[s] = void 0;
        var r = !0;
      } catch (t) {}

      var i = a.call(t);
      return r && (e ? t[s] = n : delete t[s]), i;
    };
  }, function (t, e) {
    var n = Object.prototype.toString;

    t.exports = function (t) {
      return n.call(t);
    };
  }, function (t, e, n) {
    var r = n(27),
        i = n(8),
        o = n(23),
        a = "[object String]";

    t.exports = function (t) {
      return "string" == typeof t || !i(t) && o(t) && r(t) == a;
    };
  }, function (t, e, n) {
    var r = n(138),
        i = 1 / 0,
        o = 1.7976931348623157e308;

    t.exports = function (t) {
      return t ? (t = r(t)) === i || t === -i ? (t < 0 ? -1 : 1) * o : t == t ? t : 0 : 0 === t ? t : 0;
    };
  }, function (t, e, n) {
    var r = n(63);

    t.exports = function (t, e) {
      return r(e, function (e) {
        return t[e];
      });
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = Array(t); ++n < t;) {
        r[n] = e(n);
      }

      return r;
    };
  }, function (t, e, n) {
    var r = n(27),
        i = n(23),
        o = "[object Arguments]";

    t.exports = function (t) {
      return i(t) && r(t) == o;
    };
  }, function (t, e) {
    t.exports = function () {
      return !1;
    };
  }, function (t, e, n) {
    var r = n(27),
        i = n(92),
        o = n(23),
        a = {};
    a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, t.exports = function (t) {
      return o(t) && i(t.length) && !!a[r(t)];
    };
  }, function (t, e, n) {
    (function (t) {
      var r = n(136),
          i = e && !e.nodeType && e,
          o = i && "object" == typeof t && t && !t.nodeType && t,
          a = o && o.exports === i && r.process,
          s = function () {
        try {
          var t = o && o.require && o.require("util").types;

          return t || a && a.binding && a.binding("util");
        } catch (t) {}
      }();

      t.exports = s;
    }).call(this, n(93)(t));
  }, function (t, e, n) {
    var r = n(143)(Object.keys, Object);
    t.exports = r;
  }, function (t, e, n) {
    var r = n(47),
        i = n(294);

    t.exports = function (t, e) {
      var n = [];
      if (!t || !t.length) return n;
      var o = -1,
          a = [],
          s = t.length;

      for (e = r(e, 3); ++o < s;) {
        var u = t[o];
        e(u, o, t) && (n.push(u), a.push(o));
      }

      return i(t, a), n;
    };
  }, function (t, e, n) {
    var r = n(241),
        i = n(285),
        o = n(152);

    t.exports = function (t) {
      var e = i(t);
      return 1 == e.length && e[0][2] ? o(e[0][0], e[0][1]) : function (n) {
        return n === t || r(n, t, e);
      };
    };
  }, function (t, e, n) {
    var r = n(94),
        i = n(97),
        o = 1,
        a = 2;

    t.exports = function (t, e, n, s) {
      var u = n.length,
          l = u,
          c = !s;
      if (null == t) return !l;

      for (t = Object(t); u--;) {
        var h = n[u];
        if (c && h[2] ? h[1] !== t[h[0]] : !(h[0] in t)) return !1;
      }

      for (; ++u < l;) {
        var f = (h = n[u])[0],
            p = t[f],
            d = h[1];

        if (c && h[2]) {
          if (void 0 === p && !(f in t)) return !1;
        } else {
          var v = new r();
          if (s) var y = s(p, d, f, t, e, v);
          if (!(void 0 === y ? i(d, p, o | a, s, v) : y)) return !1;
        }
      }

      return !0;
    };
  }, function (t, e) {
    t.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (t, e, n) {
    var r = n(70),
        i = Array.prototype.splice;

    t.exports = function (t) {
      var e = this.__data__,
          n = r(e, t);
      return !(n < 0 || (n == e.length - 1 ? e.pop() : i.call(e, n, 1), --this.size, 0));
    };
  }, function (t, e, n) {
    var r = n(70);

    t.exports = function (t) {
      var e = this.__data__,
          n = r(e, t);
      return n < 0 ? void 0 : e[n][1];
    };
  }, function (t, e, n) {
    var r = n(70);

    t.exports = function (t) {
      return r(this.__data__, t) > -1;
    };
  }, function (t, e, n) {
    var r = n(70);

    t.exports = function (t, e) {
      var n = this.__data__,
          i = r(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    };
  }, function (t, e, n) {
    var r = n(69);

    t.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = this.__data__,
          n = e.delete(t);
      return this.size = e.size, n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return this.__data__.get(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return this.__data__.has(t);
    };
  }, function (t, e, n) {
    var r = n(69),
        i = n(95),
        o = n(96),
        a = 200;

    t.exports = function (t, e) {
      var n = this.__data__;

      if (n instanceof r) {
        var s = n.__data__;
        if (!i || s.length < a - 1) return s.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new o(s);
      }

      return n.set(t, e), this.size = n.size, this;
    };
  }, function (t, e, n) {
    var r = n(91),
        i = n(253),
        o = n(17),
        a = n(144),
        s = /^\[object .+?Constructor\]$/,
        u = Function.prototype,
        l = Object.prototype,
        c = u.toString,
        h = l.hasOwnProperty,
        f = RegExp("^" + c.call(h).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    t.exports = function (t) {
      return !(!o(t) || i(t)) && (r(t) ? f : s).test(a(t));
    };
  }, function (t, e, n) {
    var r = n(254),
        i = function () {
      var t = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    }();

    t.exports = function (t) {
      return !!i && i in t;
    };
  }, function (t, e, n) {
    var r = n(15)["__core-js_shared__"];
    t.exports = r;
  }, function (t, e) {
    t.exports = function (t, e) {
      return null == t ? void 0 : t[e];
    };
  }, function (t, e, n) {
    var r = n(257),
        i = n(69),
        o = n(95);

    t.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (o || i)(),
        string: new r()
      };
    };
  }, function (t, e, n) {
    var r = n(258),
        i = n(259),
        o = n(260),
        a = n(261),
        s = n(262);

    function u(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    u.prototype.clear = r, u.prototype.delete = i, u.prototype.get = o, u.prototype.has = a, u.prototype.set = s, t.exports = u;
  }, function (t, e, n) {
    var r = n(71);

    t.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (t, e, n) {
    var r = n(71),
        i = "__lodash_hash_undefined__",
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;

      if (r) {
        var n = e[t];
        return n === i ? void 0 : n;
      }

      return o.call(e, t) ? e[t] : void 0;
    };
  }, function (t, e, n) {
    var r = n(71),
        i = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      var e = this.__data__;
      return r ? void 0 !== e[t] : i.call(e, t);
    };
  }, function (t, e, n) {
    var r = n(71),
        i = "__lodash_hash_undefined__";

    t.exports = function (t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = r && void 0 === e ? i : e, this;
    };
  }, function (t, e, n) {
    var r = n(72);

    t.exports = function (t) {
      var e = r(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };
  }, function (t, e, n) {
    var r = n(72);

    t.exports = function (t) {
      return r(this, t).get(t);
    };
  }, function (t, e, n) {
    var r = n(72);

    t.exports = function (t) {
      return r(this, t).has(t);
    };
  }, function (t, e, n) {
    var r = n(72);

    t.exports = function (t, e) {
      var n = r(this, t),
          i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    };
  }, function (t, e, n) {
    var r = n(94),
        i = n(145),
        o = n(272),
        a = n(275),
        s = n(150),
        u = n(8),
        l = n(65),
        c = n(67),
        h = 1,
        f = "[object Arguments]",
        p = "[object Array]",
        d = "[object Object]",
        v = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n, y, m, g) {
      var _ = u(t),
          b = u(e),
          L = _ ? p : s(t),
          x = b ? p : s(e),
          w = (L = L == f ? d : L) == d,
          M = (x = x == f ? d : x) == d,
          k = L == x;

      if (k && l(t)) {
        if (!l(e)) return !1;
        _ = !0, w = !1;
      }

      if (k && !w) return g || (g = new r()), _ || c(t) ? i(t, e, n, y, m, g) : o(t, e, L, n, y, m, g);

      if (!(n & h)) {
        var C = w && v.call(t, "__wrapped__"),
            E = M && v.call(e, "__wrapped__");

        if (C || E) {
          var I = C ? t.value() : t,
              A = E ? e.value() : e;
          return g || (g = new r()), m(I, A, n, y, g);
        }
      }

      return !!k && (g || (g = new r()), a(t, e, n, y, m, g));
    };
  }, function (t, e) {
    var n = "__lodash_hash_undefined__";

    t.exports = function (t) {
      return this.__data__.set(t, n), this;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return this.__data__.has(t);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
        if (e(t[n], n, t)) return !0;
      }

      return !1;
    };
  }, function (t, e, n) {
    var r = n(61),
        i = n(148),
        o = n(48),
        a = n(145),
        s = n(273),
        u = n(274),
        l = 1,
        c = 2,
        h = "[object Boolean]",
        f = "[object Date]",
        p = "[object Error]",
        d = "[object Map]",
        v = "[object Number]",
        y = "[object RegExp]",
        m = "[object Set]",
        g = "[object String]",
        _ = "[object Symbol]",
        b = "[object ArrayBuffer]",
        L = "[object DataView]",
        x = r ? r.prototype : void 0,
        w = x ? x.valueOf : void 0;

    t.exports = function (t, e, n, r, x, M, k) {
      switch (n) {
        case L:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case b:
          return !(t.byteLength != e.byteLength || !M(new i(t), new i(e)));

        case h:
        case f:
        case v:
          return o(+t, +e);

        case p:
          return t.name == e.name && t.message == e.message;

        case y:
        case g:
          return t == e + "";

        case d:
          var C = s;

        case m:
          var E = r & l;
          if (C || (C = u), t.size != e.size && !E) return !1;
          var I = k.get(t);
          if (I) return I == e;
          r |= c, k.set(t, e);
          var A = a(C(t), C(e), r, x, M, k);
          return k.delete(t), A;

        case _:
          if (w) return w.call(t) == w.call(e);
      }

      return !1;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t, r) {
        n[++e] = [r, t];
      }), n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    };
  }, function (t, e, n) {
    var r = n(276),
        i = 1,
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n, a, s, u) {
      var l = n & i,
          c = r(t),
          h = c.length;
      if (h != r(e).length && !l) return !1;

      for (var f = h; f--;) {
        var p = c[f];
        if (!(l ? p in e : o.call(e, p))) return !1;
      }

      var d = u.get(t);
      if (d && u.get(e)) return d == e;
      var v = !0;
      u.set(t, e), u.set(e, t);

      for (var y = l; ++f < h;) {
        var m = t[p = c[f]],
            g = e[p];
        if (a) var _ = l ? a(g, m, p, e, t, u) : a(m, g, p, t, e, u);

        if (!(void 0 === _ ? m === g || s(m, g, n, a, u) : _)) {
          v = !1;
          break;
        }

        y || (y = "constructor" == p);
      }

      if (v && !y) {
        var b = t.constructor,
            L = e.constructor;
        b != L && "constructor" in t && "constructor" in e && !("function" == typeof b && b instanceof b && "function" == typeof L && L instanceof L) && (v = !1);
      }

      return u.delete(t), u.delete(e), v;
    };
  }, function (t, e, n) {
    var r = n(277),
        i = n(279),
        o = n(46);

    t.exports = function (t) {
      return r(t, o, i);
    };
  }, function (t, e, n) {
    var r = n(278),
        i = n(8);

    t.exports = function (t, e, n) {
      var o = e(t);
      return i(t) ? o : r(o, n(t));
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = e.length, i = t.length; ++n < r;) {
        t[i + n] = e[n];
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(149),
        i = n(280),
        o = Object.prototype.propertyIsEnumerable,
        a = Object.getOwnPropertySymbols,
        s = a ? function (t) {
      return null == t ? [] : (t = Object(t), r(a(t), function (e) {
        return o.call(t, e);
      }));
    } : i;
    t.exports = s;
  }, function (t, e) {
    t.exports = function () {
      return [];
    };
  }, function (t, e, n) {
    var r = n(33)(n(15), "DataView");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(33)(n(15), "Promise");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(33)(n(15), "Set");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(33)(n(15), "WeakMap");
    t.exports = r;
  }, function (t, e, n) {
    var r = n(151),
        i = n(46);

    t.exports = function (t) {
      for (var e = i(t), n = e.length; n--;) {
        var o = e[n],
            a = t[o];
        e[n] = [o, a, r(a)];
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(97),
        i = n(4),
        o = n(289),
        a = n(100),
        s = n(151),
        u = n(152),
        l = n(49),
        c = 1,
        h = 2;

    t.exports = function (t, e) {
      return a(t) && s(e) ? u(l(t), e) : function (n) {
        var a = i(n, t);
        return void 0 === a && a === e ? o(n, t) : r(e, a, c | h);
      };
    };
  }, function (t, e, n) {
    var r = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        i = /\\(\\)?/g,
        o = n(288)(function (t) {
      var e = [];
      return 46 === t.charCodeAt(0) && e.push(""), t.replace(r, function (t, n, r, o) {
        e.push(r ? o.replace(i, "$1") : n || t);
      }), e;
    });
    t.exports = o;
  }, function (t, e, n) {
    var r = n(101),
        i = 500;

    t.exports = function (t) {
      var e = r(t, function (t) {
        return n.size === i && n.clear(), t;
      }),
          n = e.cache;
      return e;
    };
  }, function (t, e, n) {
    var r = n(290),
        i = n(155);

    t.exports = function (t, e) {
      return null != t && i(t, e, r);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return null != t && e in Object(t);
    };
  }, function (t, e, n) {
    var r = n(292),
        i = n(293),
        o = n(100),
        a = n(49);

    t.exports = function (t) {
      return o(t) ? r(a(t)) : i(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    };
  }, function (t, e, n) {
    var r = n(98);

    t.exports = function (t) {
      return function (e) {
        return r(e, t);
      };
    };
  }, function (t, e, n) {
    var r = n(295),
        i = n(66),
        o = Array.prototype.splice;

    t.exports = function (t, e) {
      for (var n = t ? e.length : 0, a = n - 1; n--;) {
        var s = e[n];

        if (n == a || s !== u) {
          var u = s;
          i(s) ? o.call(t, s, 1) : r(t, s);
        }
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(99),
        i = n(296),
        o = n(297),
        a = n(49);

    t.exports = function (t, e) {
      return e = r(e, t), null == (t = o(t, e)) || delete t[a(i(e))];
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };
  }, function (t, e, n) {
    var r = n(98),
        i = n(156);

    t.exports = function (t, e) {
      return e.length < 2 ? t : r(t, i(e, 0, -1));
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t);) {
        ;
      }

      return t;
    };
  }, function (t, e, n) {
    var r = n(157),
        i = n(46);

    t.exports = function (t, e) {
      return t && r(t, e, i);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return function (e, n, r) {
        for (var i = -1, o = Object(e), a = r(e), s = a.length; s--;) {
          var u = a[t ? s : ++i];
          if (!1 === n(o[u], u, o)) break;
        }

        return e;
      };
    };
  }, function (t, e, n) {
    var r = n(22);

    t.exports = function (t, e) {
      return function (n, i) {
        if (null == n) return n;
        if (!r(n)) return t(n, i);

        for (var o = n.length, a = e ? o : -1, s = Object(n); (e ? a-- : ++a < o) && !1 !== i(s[a], a, s);) {
          ;
        }

        return n;
      };
    };
  }, function (t, e, n) {
    var r = n(73);

    t.exports = function (t) {
      return "function" == typeof t ? t : r;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13),
        i = n(159),
        o = n(304),
        a = n(165);

    function s(t) {
      var e = new o(t),
          n = i(o.prototype.request, e);
      return r.extend(n, o.prototype, e), r.extend(n, e), n;
    }

    var u = s(n(162));
    u.Axios = o, u.create = function (t) {
      return s(a(u.defaults, t));
    }, u.Cancel = n(166), u.CancelToken = n(317), u.isCancel = n(161), u.all = function (t) {
      return Promise.all(t);
    }, u.spread = n(318), t.exports = u, t.exports.default = u;
  }, function (t, e, n) {
    "use strict";

    var r = n(13),
        i = n(160),
        o = n(305),
        a = n(306),
        s = n(165);

    function u(t) {
      this.defaults = t, this.interceptors = {
        request: new o(),
        response: new o()
      };
    }

    u.prototype.request = function (t) {
      "string" == typeof t ? (t = arguments[1] || {}).url = arguments[0] : t = t || {}, (t = s(this.defaults, t)).method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
      var e = [a, void 0],
          n = Promise.resolve(t);

      for (this.interceptors.request.forEach(function (t) {
        e.unshift(t.fulfilled, t.rejected);
      }), this.interceptors.response.forEach(function (t) {
        e.push(t.fulfilled, t.rejected);
      }); e.length;) {
        n = n.then(e.shift(), e.shift());
      }

      return n;
    }, u.prototype.getUri = function (t) {
      return t = s(this.defaults, t), i(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
    }, r.forEach(["delete", "get", "head", "options"], function (t) {
      u.prototype[t] = function (e, n) {
        return this.request(r.merge(n || {}, {
          method: t,
          url: e
        }));
      };
    }), r.forEach(["post", "put", "patch"], function (t) {
      u.prototype[t] = function (e, n, i) {
        return this.request(r.merge(i || {}, {
          method: t,
          url: e,
          data: n
        }));
      };
    }), t.exports = u;
  }, function (t, e, n) {
    "use strict";

    var r = n(13);

    function i() {
      this.handlers = [];
    }

    i.prototype.use = function (t, e) {
      return this.handlers.push({
        fulfilled: t,
        rejected: e
      }), this.handlers.length - 1;
    }, i.prototype.eject = function (t) {
      this.handlers[t] && (this.handlers[t] = null);
    }, i.prototype.forEach = function (t) {
      r.forEach(this.handlers, function (e) {
        null !== e && t(e);
      });
    }, t.exports = i;
  }, function (t, e, n) {
    "use strict";

    var r = n(13),
        i = n(307),
        o = n(161),
        a = n(162);

    function s(t) {
      t.cancelToken && t.cancelToken.throwIfRequested();
    }

    t.exports = function (t) {
      return s(t), t.headers = t.headers || {}, t.data = i(t.data, t.headers, t.transformRequest), t.headers = r.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers), r.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (e) {
        delete t.headers[e];
      }), (t.adapter || a.adapter)(t).then(function (e) {
        return s(t), e.data = i(e.data, e.headers, t.transformResponse), e;
      }, function (e) {
        return o(e) || (s(t), e && e.response && (e.response.data = i(e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
      });
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13);

    t.exports = function (t, e, n) {
      return r.forEach(n, function (n) {
        t = n(t, e);
      }), t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13);

    t.exports = function (t, e) {
      r.forEach(t, function (n, r) {
        r !== e && r.toUpperCase() === e.toUpperCase() && (t[e] = n, delete t[r]);
      });
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(164);

    t.exports = function (t, e, n) {
      var i = n.config.validateStatus;
      !i || i(n.status) ? t(n) : e(r("Request failed with status code " + n.status, n.config, null, n.request, n));
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t, e, n, r, i) {
      return t.config = e, n && (t.code = n), t.request = r, t.response = i, t.isAxiosError = !0, t.toJSON = function () {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      }, t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(312),
        i = n(313);

    t.exports = function (t, e) {
      return t && !r(e) ? i(t, e) : e;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t, e) {
      return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13),
        i = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    t.exports = function (t) {
      var e,
          n,
          o,
          a = {};
      return t ? (r.forEach(t.split("\n"), function (t) {
        if (o = t.indexOf(":"), e = r.trim(t.substr(0, o)).toLowerCase(), n = r.trim(t.substr(o + 1)), e) {
          if (a[e] && i.indexOf(e) >= 0) return;
          a[e] = "set-cookie" === e ? (a[e] ? a[e] : []).concat([n]) : a[e] ? a[e] + ", " + n : n;
        }
      }), a) : a;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13);
    t.exports = r.isStandardBrowserEnv() ? function () {
      var t,
          e = /(msie|trident)/i.test(navigator.userAgent),
          n = document.createElement("a");

      function i(t) {
        var r = t;
        return e && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
        };
      }

      return t = i(window.location.href), function (e) {
        var n = r.isString(e) ? i(e) : e;
        return n.protocol === t.protocol && n.host === t.host;
      };
    }() : function () {
      return !0;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(13);
    t.exports = r.isStandardBrowserEnv() ? {
      write: function write(t, e, n, i, o, a) {
        var s = [];
        s.push(t + "=" + encodeURIComponent(e)), r.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), r.isString(i) && s.push("path=" + i), r.isString(o) && s.push("domain=" + o), !0 === a && s.push("secure"), document.cookie = s.join("; ");
      },
      read: function read(t) {
        var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
        return e ? decodeURIComponent(e[3]) : null;
      },
      remove: function remove(t) {
        this.write(t, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(166);

    function i(t) {
      if ("function" != typeof t) throw new TypeError("executor must be a function.");
      var e;
      this.promise = new Promise(function (t) {
        e = t;
      });
      var n = this;
      t(function (t) {
        n.reason || (n.reason = new r(t), e(n.reason));
      });
    }

    i.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, i.source = function () {
      var t;
      return {
        token: new i(function (e) {
          t = e;
        }),
        cancel: t
      };
    }, t.exports = i;
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    };
  }, function (t, e, n) {
    (function (e) {
      var r = "object" == typeof e ? e : "object" == typeof window ? window : "object" == typeof self ? self : this,
          i = r.regeneratorRuntime && Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime") >= 0,
          o = i && r.regeneratorRuntime;
      if (r.regeneratorRuntime = void 0, t.exports = n(320), i) r.regeneratorRuntime = o;else try {
        delete r.regeneratorRuntime;
      } catch (t) {
        r.regeneratorRuntime = void 0;
      }
    }).call(this, n(10));
  }, function (t, e, n) {
    (function (e) {
      !function (e) {
        "use strict";

        var n,
            r = Object.prototype,
            i = r.hasOwnProperty,
            o = "function" == typeof Symbol ? Symbol : {},
            a = o.iterator || "@@iterator",
            s = o.asyncIterator || "@@asyncIterator",
            u = o.toStringTag || "@@toStringTag",
            l = "object" == typeof t,
            c = e.regeneratorRuntime;
        if (c) l && (t.exports = c);else {
          (c = e.regeneratorRuntime = l ? t.exports : {}).wrap = b;
          var h = "suspendedStart",
              f = "suspendedYield",
              p = "executing",
              d = "completed",
              v = {},
              y = {};

          y[a] = function () {
            return this;
          };

          var m = Object.getPrototypeOf,
              g = m && m(m(O([])));
          g && g !== r && i.call(g, a) && (y = g);

          var _ = M.prototype = x.prototype = Object.create(y);

          w.prototype = _.constructor = M, M.constructor = w, M[u] = w.displayName = "GeneratorFunction", c.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === w || "GeneratorFunction" === (e.displayName || e.name));
          }, c.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, M) : (t.__proto__ = M, u in t || (t[u] = "GeneratorFunction")), t.prototype = Object.create(_), t;
          }, c.awrap = function (t) {
            return {
              __await: t
            };
          }, k(C.prototype), C.prototype[s] = function () {
            return this;
          }, c.AsyncIterator = C, c.async = function (t, e, n, r) {
            var i = new C(b(t, e, n, r));
            return c.isGeneratorFunction(e) ? i : i.next().then(function (t) {
              return t.done ? t.value : i.next();
            });
          }, k(_), _[u] = "Generator", _[a] = function () {
            return this;
          }, _.toString = function () {
            return "[object Generator]";
          }, c.keys = function (t) {
            var e = [];

            for (var n in t) {
              e.push(n);
            }

            return e.reverse(), function n() {
              for (; e.length;) {
                var r = e.pop();
                if (r in t) return n.value = r, n.done = !1, n;
              }

              return n.done = !0, n;
            };
          }, c.values = O, P.prototype = {
            constructor: P,
            reset: function reset(t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(A), !t) for (var e in this) {
                "t" === e.charAt(0) && i.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = n);
              }
            },
            stop: function stop() {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function dispatchException(t) {
              if (this.done) throw t;
              var e = this;

              function r(r, i) {
                return s.type = "throw", s.arg = t, e.next = r, i && (e.method = "next", e.arg = n), !!i;
              }

              for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                var a = this.tryEntries[o],
                    s = a.completion;
                if ("root" === a.tryLoc) return r("end");

                if (a.tryLoc <= this.prev) {
                  var u = i.call(a, "catchLoc"),
                      l = i.call(a, "finallyLoc");

                  if (u && l) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  } else if (u) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                  } else {
                    if (!l) throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function abrupt(t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];

                if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                  var o = r;
                  break;
                }
              }

              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, v) : this.complete(a);
            },
            complete: function complete(t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), v;
            },
            finish: function finish(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), A(n), v;
              }
            },
            catch: function _catch(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];

                if (n.tryLoc === t) {
                  var r = n.completion;

                  if ("throw" === r.type) {
                    var i = r.arg;
                    A(n);
                  }

                  return i;
                }
              }

              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(t, e, r) {
              return this.delegate = {
                iterator: O(t),
                resultName: e,
                nextLoc: r
              }, "next" === this.method && (this.arg = n), v;
            }
          };
        }

        function b(t, e, n, r) {
          var i = e && e.prototype instanceof x ? e : x,
              o = Object.create(i.prototype),
              a = new P(r || []);
          return o._invoke = function (t, e, n) {
            var r = h;
            return function (i, o) {
              if (r === p) throw new Error("Generator is already running");

              if (r === d) {
                if ("throw" === i) throw o;
                return T();
              }

              for (n.method = i, n.arg = o;;) {
                var a = n.delegate;

                if (a) {
                  var s = E(a, n);

                  if (s) {
                    if (s === v) continue;
                    return s;
                  }
                }

                if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                  if (r === h) throw r = d, n.arg;
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                r = p;
                var u = L(t, e, n);

                if ("normal" === u.type) {
                  if (r = n.done ? d : f, u.arg === v) continue;
                  return {
                    value: u.arg,
                    done: n.done
                  };
                }

                "throw" === u.type && (r = d, n.method = "throw", n.arg = u.arg);
              }
            };
          }(t, n, a), o;
        }

        function L(t, e, n) {
          try {
            return {
              type: "normal",
              arg: t.call(e, n)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        function x() {}

        function w() {}

        function M() {}

        function k(t) {
          ["next", "throw", "return"].forEach(function (e) {
            t[e] = function (t) {
              return this._invoke(e, t);
            };
          });
        }

        function C(t) {
          function n(e, r, o, a) {
            var s = L(t[e], t, r);

            if ("throw" !== s.type) {
              var u = s.arg,
                  l = u.value;
              return l && "object" == typeof l && i.call(l, "__await") ? Promise.resolve(l.__await).then(function (t) {
                n("next", t, o, a);
              }, function (t) {
                n("throw", t, o, a);
              }) : Promise.resolve(l).then(function (t) {
                u.value = t, o(u);
              }, a);
            }

            a(s.arg);
          }

          var r;
          "object" == typeof e.process && e.process.domain && (n = e.process.domain.bind(n)), this._invoke = function (t, e) {
            function i() {
              return new Promise(function (r, i) {
                n(t, e, r, i);
              });
            }

            return r = r ? r.then(i, i) : i();
          };
        }

        function E(t, e) {
          var r = t.iterator[e.method];

          if (r === n) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator.return && (e.method = "return", e.arg = n, E(t, e), "throw" === e.method)) return v;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return v;
          }

          var i = L(r, t.iterator, e.arg);
          if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, v;
          var o = i.arg;
          return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = n), e.delegate = null, v) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, v);
        }

        function I(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function A(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function P(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(I, this), this.reset(!0);
        }

        function O(t) {
          if (t) {
            var e = t[a];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var r = -1,
                  o = function e() {
                for (; ++r < t.length;) {
                  if (i.call(t, r)) return e.value = t[r], e.done = !1, e;
                }

                return e.value = n, e.done = !0, e;
              };

              return o.next = o;
            }
          }

          return {
            next: T
          };
        }

        function T() {
          return {
            value: n,
            done: !0
          };
        }
      }("object" == typeof e ? e : "object" == typeof window ? window : "object" == typeof self ? self : this);
    }).call(this, n(10));
  }, function (t, e, n) {
    t.exports = {
      default: n(322),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(88), n(123), t.exports = n(106).f("iterator");
  }, function (t, e, n) {
    t.exports = {
      default: n(324),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(325), n(119), n(330), n(331), t.exports = n(3).Symbol;
  }, function (t, e, n) {
    "use strict";

    var r = n(6),
        i = n(31),
        o = n(21),
        a = n(11),
        s = n(121),
        u = n(326).KEY,
        l = n(30),
        c = n(85),
        h = n(59),
        f = n(57),
        p = n(12),
        d = n(106),
        v = n(107),
        y = n(327),
        m = n(328),
        g = n(20),
        _ = n(26),
        b = n(38),
        L = n(32),
        x = n(80),
        w = n(41),
        M = n(81),
        k = n(329),
        C = n(108),
        E = n(87),
        I = n(19),
        A = n(42),
        P = C.f,
        O = I.f,
        T = k.f,
        _S = r.Symbol,
        D = r.JSON,
        j = D && D.stringify,
        N = p("_hidden"),
        z = p("toPrimitive"),
        B = {}.propertyIsEnumerable,
        R = c("symbol-registry"),
        G = c("symbols"),
        Z = c("op-symbols"),
        U = Object.prototype,
        V = "function" == typeof _S && !!E.f,
        K = r.QObject,
        H = !K || !K.prototype || !K.prototype.findChild,
        Y = o && l(function () {
      return 7 != M(O({}, "a", {
        get: function get() {
          return O(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (t, e, n) {
      var r = P(U, e);
      r && delete U[e], O(t, e, n), r && t !== U && O(U, e, r);
    } : O,
        F = function F(t) {
      var e = G[t] = M(_S.prototype);
      return e._k = t, e;
    },
        W = V && "symbol" == typeof _S.iterator ? function (t) {
      return "symbol" == typeof t;
    } : function (t) {
      return t instanceof _S;
    },
        X = function X(t, e, n) {
      return t === U && X(Z, e, n), g(t), e = x(e, !0), g(n), i(G, e) ? (n.enumerable ? (i(t, N) && t[N][e] && (t[N][e] = !1), n = M(n, {
        enumerable: w(0, !1)
      })) : (i(t, N) || O(t, N, w(1, {})), t[N][e] = !0), Y(t, e, n)) : O(t, e, n);
    },
        q = function q(t, e) {
      g(t);

      for (var n, r = y(e = L(e)), i = 0, o = r.length; o > i;) {
        X(t, n = r[i++], e[n]);
      }

      return t;
    },
        J = function J(t) {
      var e = B.call(this, t = x(t, !0));
      return !(this === U && i(G, t) && !i(Z, t)) && (!(e || !i(this, t) || !i(G, t) || i(this, N) && this[N][t]) || e);
    },
        Q = function Q(t, e) {
      if (t = L(t), e = x(e, !0), t !== U || !i(G, e) || i(Z, e)) {
        var n = P(t, e);
        return !n || !i(G, e) || i(t, N) && t[N][e] || (n.enumerable = !0), n;
      }
    },
        $ = function $(t) {
      for (var e, n = T(L(t)), r = [], o = 0; n.length > o;) {
        i(G, e = n[o++]) || e == N || e == u || r.push(e);
      }

      return r;
    },
        tt = function tt(t) {
      for (var e, n = t === U, r = T(n ? Z : L(t)), o = [], a = 0; r.length > a;) {
        !i(G, e = r[a++]) || n && !i(U, e) || o.push(G[e]);
      }

      return o;
    };

    V || (s((_S = function S() {
      if (this instanceof _S) throw TypeError("Symbol is not a constructor!");

      var t = f(arguments.length > 0 ? arguments[0] : void 0),
          e = function e(n) {
        this === U && e.call(Z, n), i(this, N) && i(this[N], t) && (this[N][t] = !1), Y(this, t, w(1, n));
      };

      return o && H && Y(U, t, {
        configurable: !0,
        set: e
      }), F(t);
    }).prototype, "toString", function () {
      return this._k;
    }), C.f = Q, I.f = X, n(167).f = k.f = $, n(58).f = J, E.f = tt, o && !n(44) && s(U, "propertyIsEnumerable", J, !0), d.f = function (t) {
      return F(p(t));
    }), a(a.G + a.W + a.F * !V, {
      Symbol: _S
    });

    for (var et = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), nt = 0; et.length > nt;) {
      p(et[nt++]);
    }

    for (var rt = A(p.store), it = 0; rt.length > it;) {
      v(rt[it++]);
    }

    a(a.S + a.F * !V, "Symbol", {
      for: function _for(t) {
        return i(R, t += "") ? R[t] : R[t] = _S(t);
      },
      keyFor: function keyFor(t) {
        if (!W(t)) throw TypeError(t + " is not a symbol!");

        for (var e in R) {
          if (R[e] === t) return e;
        }
      },
      useSetter: function useSetter() {
        H = !0;
      },
      useSimple: function useSimple() {
        H = !1;
      }
    }), a(a.S + a.F * !V, "Object", {
      create: function create(t, e) {
        return void 0 === e ? M(t) : q(M(t), e);
      },
      defineProperty: X,
      defineProperties: q,
      getOwnPropertyDescriptor: Q,
      getOwnPropertyNames: $,
      getOwnPropertySymbols: tt
    });
    var ot = l(function () {
      E.f(1);
    });
    a(a.S + a.F * ot, "Object", {
      getOwnPropertySymbols: function getOwnPropertySymbols(t) {
        return E.f(b(t));
      }
    }), D && a(a.S + a.F * (!V || l(function () {
      var t = _S();

      return "[null]" != j([t]) || "{}" != j({
        a: t
      }) || "{}" != j(Object(t));
    })), "JSON", {
      stringify: function stringify(t) {
        for (var e, n, r = [t], i = 1; arguments.length > i;) {
          r.push(arguments[i++]);
        }

        if (n = e = r[1], (_(e) || void 0 !== t) && !W(t)) return m(e) || (e = function e(t, _e2) {
          if ("function" == typeof n && (_e2 = n.call(this, t, _e2)), !W(_e2)) return _e2;
        }), r[1] = e, j.apply(D, r);
      }
    }), _S.prototype[z] || n(29)(_S.prototype, z, _S.prototype.valueOf), h(_S, "Symbol"), h(Math, "Math", !0), h(r.JSON, "JSON", !0);
  }, function (t, e, n) {
    var r = n(57)("meta"),
        i = n(26),
        o = n(31),
        a = n(19).f,
        s = 0,
        u = Object.isExtensible || function () {
      return !0;
    },
        l = !n(30)(function () {
      return u(Object.preventExtensions({}));
    }),
        c = function c(t) {
      a(t, r, {
        value: {
          i: "O" + ++s,
          w: {}
        }
      });
    },
        h = t.exports = {
      KEY: r,
      NEED: !1,
      fastKey: function fastKey(t, e) {
        if (!i(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;

        if (!o(t, r)) {
          if (!u(t)) return "F";
          if (!e) return "E";
          c(t);
        }

        return t[r].i;
      },
      getWeak: function getWeak(t, e) {
        if (!o(t, r)) {
          if (!u(t)) return !0;
          if (!e) return !1;
          c(t);
        }

        return t[r].w;
      },
      onFreeze: function onFreeze(t) {
        return l && h.NEED && u(t) && !o(t, r) && c(t), t;
      }
    };
  }, function (t, e, n) {
    var r = n(42),
        i = n(87),
        o = n(58);

    t.exports = function (t) {
      var e = r(t),
          n = i.f;
      if (n) for (var a, s = n(t), u = o.f, l = 0; s.length > l;) {
        u.call(t, a = s[l++]) && e.push(a);
      }
      return e;
    };
  }, function (t, e, n) {
    var r = n(43);

    t.exports = Array.isArray || function (t) {
      return "Array" == r(t);
    };
  }, function (t, e, n) {
    var r = n(32),
        i = n(167).f,
        o = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    t.exports.f = function (t) {
      return a && "[object Window]" == o.call(t) ? function (t) {
        try {
          return i(t);
        } catch (t) {
          return a.slice();
        }
      }(t) : i(r(t));
    };
  }, function (t, e, n) {
    n(107)("asyncIterator");
  }, function (t, e, n) {
    n(107)("observable");
  }, function (t, e, n) {
    t.exports = function (t, e) {
      "use strict";

      var n;
      return t = t && t.hasOwnProperty("default") ? t.default : t, e = e && e.hasOwnProperty("default") ? e.default : e, function (n) {
        var r;
        n.exports, (r = window).DOMParser = window.DOMParser;
        var i = r.document;

        function o(t, e) {
          var n;
          return (n = i.createElement("canvas")).width = t, n.height = e, n;
        }

        var a,
            s = function s(t, e, n) {
          if (null != t || null != e || null != n) {
            var r = y(n || {});
            "string" == typeof t && (t = i.getElementById(t)), null != t.svg && t.svg.stop(), t.childNodes && 1 == t.childNodes.length && "OBJECT" == t.childNodes[0].nodeName || (t.svg = r);
            var o = t.getContext("2d");
            void 0 !== e.documentElement ? r.loadXmlDoc(o, e) : "<" == e.substr(0, 1) ? r.loadXml(o, e) : r.load(o, e);
          } else for (var a = i.querySelectorAll("svg"), u = 0; u < a.length; u++) {
            var l = a[u],
                c = i.createElement("canvas");
            if (void 0 !== l.clientWidth && void 0 !== l.clientHeight) c.width = l.clientWidth, c.height = l.clientHeight;else {
              var h = l.getBoundingClientRect();
              c.width = h.width, c.height = h.height;
            }
            l.parentNode.insertBefore(c, l), l.parentNode.removeChild(l);
            var f = i.createElement("div");
            f.appendChild(l), s(c, f.innerHTML);
          }
        };

        "undefined" == typeof Element || (void 0 !== Element.prototype.matches ? a = function a(t, e) {
          return t.matches(e);
        } : void 0 !== Element.prototype.webkitMatchesSelector ? a = function a(t, e) {
          return t.webkitMatchesSelector(e);
        } : void 0 !== Element.prototype.mozMatchesSelector ? a = function a(t, e) {
          return t.mozMatchesSelector(e);
        } : void 0 !== Element.prototype.msMatchesSelector ? a = function a(t, e) {
          return t.msMatchesSelector(e);
        } : void 0 !== Element.prototype.oMatchesSelector ? a = function a(t, e) {
          return t.oMatchesSelector(e);
        } : ("function" != typeof jQuery && "function" != typeof Zepto || (a = function a(t, e) {
          return $(t).is(e);
        }), void 0 === a && "undefined" != typeof Sizzle && (a = Sizzle.matchesSelector)));
        var u = /(\[[^\]]+\])/g,
            l = /(#[^\s\+>~\.\[:]+)/g,
            c = /(\.[^\s\+>~\.\[:]+)/g,
            h = /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi,
            f = /(:[\w-]+\([^\)]*\))/gi,
            p = /(:[^\s\+>~\.\[:]+)/g,
            d = /([^\s\+>~\.\[:]+)/g;

        function v(t) {
          var e = [0, 0, 0],
              n = function n(_n, r) {
            var i = t.match(_n);
            null != i && (e[r] += i.length, t = t.replace(_n, " "));
          };

          return t = (t = t.replace(/:not\(([^\)]*)\)/g, "     $1 ")).replace(/{[\s\S]*/gm, " "), n(u, 1), n(l, 0), n(c, 1), n(h, 2), n(f, 1), n(p, 1), t = (t = t.replace(/[\*\s\+>~]/g, " ")).replace(/[#\.]/g, " "), n(d, 2), e.join("");
        }

        function y(n) {
          var s = {
            opts: n,
            FRAMERATE: 30,
            MAX_VIRTUAL_PIXELS: 3e4,
            rootEmSize: 12,
            emSize: 12,
            log: function log() {}
          };
          1 == s.opts.log && "undefined" != typeof console && (s.log = function (t) {
            console.log(t);
          }), s.init = function (t) {
            var e = 0;
            s.UniqueId = function () {
              return "canvg" + ++e;
            }, s.Definitions = {}, s.Styles = {}, s.StylesSpecificity = {}, s.Animations = [], s.Images = [], s.ctx = t, s.ViewPort = new function () {
              this.viewPorts = [], this.Clear = function () {
                this.viewPorts = [];
              }, this.SetCurrent = function (t, e) {
                this.viewPorts.push({
                  width: t,
                  height: e
                });
              }, this.RemoveCurrent = function () {
                this.viewPorts.pop();
              }, this.Current = function () {
                return this.viewPorts[this.viewPorts.length - 1];
              }, this.width = function () {
                return this.Current().width;
              }, this.height = function () {
                return this.Current().height;
              }, this.ComputeSize = function (t) {
                return null != t && "number" == typeof t ? t : "x" == t ? this.width() : "y" == t ? this.height() : Math.sqrt(Math.pow(this.width(), 2) + Math.pow(this.height(), 2)) / Math.sqrt(2);
              };
            }();
          }, s.init(), s.ImagesLoaded = function () {
            for (var t = 0; t < s.Images.length; t++) {
              if (!s.Images[t].loaded) return !1;
            }

            return !0;
          }, s.trim = function (t) {
            return t.replace(/^\s+|\s+$/g, "");
          }, s.compressSpaces = function (t) {
            return t.replace(/(?!\u3000)\s+/gm, " ");
          }, s.ajax = function (t) {
            var e;
            return (e = r.XMLHttpRequest ? new r.XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP")) ? (e.open("GET", t, !1), e.send(null), e.responseText) : null;
          }, s.parseXml = function (t) {
            if ("undefined" != typeof Windows && void 0 !== Windows.Data && void 0 !== Windows.Data.Xml) {
              var e = new Windows.Data.Xml.Dom.XmlDocument(),
                  i = new Windows.Data.Xml.Dom.XmlLoadSettings();
              return i.prohibitDtd = !1, e.loadXml(t, i), e;
            }

            if (!r.DOMParser) return t = t.replace(/<!DOCTYPE svg[^>]*>/, ""), (e = new ActiveXObject("Microsoft.XMLDOM")).async = "false", e.loadXML(t), e;

            try {
              var o = n.xmldom ? new r.DOMParser(n.xmldom) : new r.DOMParser();
              return o.parseFromString(t, "image/svg+xml");
            } catch (e) {
              return (o = n.xmldom ? new r.DOMParser(n.xmldom) : new r.DOMParser()).parseFromString(t, "text/xml");
            }
          }, s.Property = function (t, e) {
            this.name = t, this.value = e;
          }, s.Property.prototype.getValue = function () {
            return this.value;
          }, s.Property.prototype.hasValue = function () {
            return null != this.value && "" !== this.value;
          }, s.Property.prototype.numValue = function () {
            if (!this.hasValue()) return 0;
            var t = parseFloat(this.value);
            return (this.value + "").match(/%$/) && (t /= 100), t;
          }, s.Property.prototype.valueOrDefault = function (t) {
            return this.hasValue() ? this.value : t;
          }, s.Property.prototype.numValueOrDefault = function (t) {
            return this.hasValue() ? this.numValue() : parseFloat(t);
          }, s.Property.prototype.addOpacity = function (e) {
            var n = this.value;

            if (null != e.value && "" != e.value && "string" == typeof this.value) {
              var r = new t(this.value);
              r.ok && (n = "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + e.numValue() + ")");
            }

            return new s.Property(this.name, n);
          }, s.Property.prototype.getDefinition = function () {
            var t = this.value.match(/#([^\)'"]+)/);
            return t && (t = t[1]), t || (t = this.value), s.Definitions[t];
          }, s.Property.prototype.isUrlDefinition = function () {
            return 0 == this.value.indexOf("url(");
          }, s.Property.prototype.getFillStyleDefinition = function (t, e) {
            var n = this.getDefinition();
            if (null != n && n.createGradient) return n.createGradient(s.ctx, t, e);

            if (null != n && n.createPattern) {
              if (n.getHrefAttribute().hasValue()) {
                var r = n.attribute("patternTransform");
                n = n.getHrefAttribute().getDefinition(), r.hasValue() && (n.attribute("patternTransform", !0).value = r.value);
              }

              return n.createPattern(s.ctx, t, e);
            }

            return null;
          }, s.Property.prototype.getDPI = function () {
            return 96;
          }, s.Property.prototype.getREM = function () {
            return s.rootEmSize;
          }, s.Property.prototype.getEM = function () {
            return s.emSize;
          }, s.Property.prototype.getUnits = function () {
            return (this.value + "").replace(/[0-9\.\-]/g, "");
          }, s.Property.prototype.isPixels = function () {
            if (!this.hasValue()) return !1;
            var t = this.value + "";
            return !!t.match(/px$/) || !!t.match(/^[0-9]+$/);
          }, s.Property.prototype.toPixels = function (t, e) {
            if (!this.hasValue()) return 0;
            var n = this.value + "";
            if (n.match(/rem$/)) return this.numValue() * this.getREM(t);
            if (n.match(/em$/)) return this.numValue() * this.getEM(t);
            if (n.match(/ex$/)) return this.numValue() * this.getEM(t) / 2;
            if (n.match(/px$/)) return this.numValue();
            if (n.match(/pt$/)) return this.numValue() * this.getDPI(t) * (1 / 72);
            if (n.match(/pc$/)) return 15 * this.numValue();
            if (n.match(/cm$/)) return this.numValue() * this.getDPI(t) / 2.54;
            if (n.match(/mm$/)) return this.numValue() * this.getDPI(t) / 25.4;
            if (n.match(/in$/)) return this.numValue() * this.getDPI(t);
            if (n.match(/%$/)) return this.numValue() * s.ViewPort.ComputeSize(t);
            var r = this.numValue();
            return e && r < 1 ? r * s.ViewPort.ComputeSize(t) : r;
          }, s.Property.prototype.toMilliseconds = function () {
            return this.hasValue() ? (this.value + "").match(/ms$/) ? this.numValue() : 1e3 * this.numValue() : 0;
          }, s.Property.prototype.toRadians = function () {
            if (!this.hasValue()) return 0;
            var t = this.value + "";
            return t.match(/deg$/) ? this.numValue() * (Math.PI / 180) : t.match(/grad$/) ? this.numValue() * (Math.PI / 200) : t.match(/rad$/) ? this.numValue() : this.numValue() * (Math.PI / 180);
          };
          var u = {
            baseline: "alphabetic",
            "before-edge": "top",
            "text-before-edge": "top",
            middle: "middle",
            central: "middle",
            "after-edge": "bottom",
            "text-after-edge": "bottom",
            ideographic: "ideographic",
            alphabetic: "alphabetic",
            hanging: "hanging",
            mathematical: "alphabetic"
          };
          return s.Property.prototype.toTextBaseline = function () {
            return this.hasValue() ? u[this.value] : null;
          }, s.Font = new function () {
            this.Styles = "normal|italic|oblique|inherit", this.Variants = "normal|small-caps|inherit", this.Weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit", this.CreateFont = function (t, e, n, r, i, o) {
              var a = null != o ? this.Parse(o) : this.CreateFont("", "", "", "", "", s.ctx.font);
              return {
                fontFamily: i = i || a.fontFamily,
                fontSize: r || a.fontSize,
                fontStyle: t || a.fontStyle,
                fontWeight: n || a.fontWeight,
                fontVariant: e || a.fontVariant,
                toString: function toString() {
                  return [this.fontStyle, this.fontVariant, this.fontWeight, this.fontSize, this.fontFamily].join(" ");
                }
              };
            };
            var t = this;

            this.Parse = function (e) {
              for (var n = {}, r = s.trim(s.compressSpaces(e || "")).split(" "), i = {
                fontSize: !1,
                fontStyle: !1,
                fontWeight: !1,
                fontVariant: !1
              }, o = "", a = 0; a < r.length; a++) {
                i.fontStyle || -1 == t.Styles.indexOf(r[a]) ? i.fontVariant || -1 == t.Variants.indexOf(r[a]) ? i.fontWeight || -1 == t.Weights.indexOf(r[a]) ? i.fontSize ? "inherit" != r[a] && (o += r[a]) : ("inherit" != r[a] && (n.fontSize = r[a].split("/")[0]), i.fontStyle = i.fontVariant = i.fontWeight = i.fontSize = !0) : ("inherit" != r[a] && (n.fontWeight = r[a]), i.fontStyle = i.fontVariant = i.fontWeight = !0) : ("inherit" != r[a] && (n.fontVariant = r[a]), i.fontStyle = i.fontVariant = !0) : ("inherit" != r[a] && (n.fontStyle = r[a]), i.fontStyle = !0);
              }

              return "" != o && (n.fontFamily = o), n;
            };
          }(), s.ToNumberArray = function (t) {
            for (var e = (t || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [], n = 0; n < e.length; n++) {
              e[n] = parseFloat(e[n]);
            }

            return e;
          }, s.Point = function (t, e) {
            this.x = t, this.y = e;
          }, s.Point.prototype.angleTo = function (t) {
            return Math.atan2(t.y - this.y, t.x - this.x);
          }, s.Point.prototype.applyTransform = function (t) {
            var e = this.x * t[0] + this.y * t[2] + t[4],
                n = this.x * t[1] + this.y * t[3] + t[5];
            this.x = e, this.y = n;
          }, s.CreatePoint = function (t) {
            var e = s.ToNumberArray(t);
            return new s.Point(e[0], e[1]);
          }, s.CreatePath = function (t) {
            for (var e = s.ToNumberArray(t), n = [], r = 0; r < e.length; r += 2) {
              n.push(new s.Point(e[r], e[r + 1]));
            }

            return n;
          }, s.BoundingBox = function (t, e, n, r) {
            this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN, this.x = function () {
              return this.x1;
            }, this.y = function () {
              return this.y1;
            }, this.width = function () {
              return this.x2 - this.x1;
            }, this.height = function () {
              return this.y2 - this.y1;
            }, this.addPoint = function (t, e) {
              null != t && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = t, this.x2 = t), t < this.x1 && (this.x1 = t), t > this.x2 && (this.x2 = t)), null != e && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = e, this.y2 = e), e < this.y1 && (this.y1 = e), e > this.y2 && (this.y2 = e));
            }, this.addX = function (t) {
              this.addPoint(t, null);
            }, this.addY = function (t) {
              this.addPoint(null, t);
            }, this.addBoundingBox = function (t) {
              this.addPoint(t.x1, t.y1), this.addPoint(t.x2, t.y2);
            }, this.addQuadraticCurve = function (t, e, n, r, i, o) {
              var a = t + 2 / 3 * (n - t),
                  s = e + 2 / 3 * (r - e),
                  u = a + 1 / 3 * (i - t),
                  l = s + 1 / 3 * (o - e);
              this.addBezierCurve(t, e, a, u, s, l, i, o);
            }, this.addBezierCurve = function (t, e, n, r, i, o, a, s) {
              var u = [t, e],
                  l = [n, r],
                  c = [i, o],
                  h = [a, s];
              this.addPoint(u[0], u[1]), this.addPoint(h[0], h[1]);

              for (var f = 0; f <= 1; f++) {
                var p = function p(t) {
                  return Math.pow(1 - t, 3) * u[f] + 3 * Math.pow(1 - t, 2) * t * l[f] + 3 * (1 - t) * Math.pow(t, 2) * c[f] + Math.pow(t, 3) * h[f];
                },
                    d = 6 * u[f] - 12 * l[f] + 6 * c[f],
                    v = -3 * u[f] + 9 * l[f] - 9 * c[f] + 3 * h[f],
                    y = 3 * l[f] - 3 * u[f];

                if (0 != v) {
                  var m = Math.pow(d, 2) - 4 * y * v;

                  if (!(m < 0)) {
                    var g = (-d + Math.sqrt(m)) / (2 * v);
                    0 < g && g < 1 && (0 == f && this.addX(p(g)), 1 == f && this.addY(p(g)));

                    var _ = (-d - Math.sqrt(m)) / (2 * v);

                    0 < _ && _ < 1 && (0 == f && this.addX(p(_)), 1 == f && this.addY(p(_)));
                  }
                } else {
                  if (0 == d) continue;
                  var b = -y / d;
                  0 < b && b < 1 && (0 == f && this.addX(p(b)), 1 == f && this.addY(p(b)));
                }
              }
            }, this.isPointInBox = function (t, e) {
              return this.x1 <= t && t <= this.x2 && this.y1 <= e && e <= this.y2;
            }, this.addPoint(t, e), this.addPoint(n, r);
          }, s.Transform = function (t) {
            var e = this;
            this.Type = {}, this.Type.translate = function (t) {
              this.p = s.CreatePoint(t), this.apply = function (t) {
                t.translate(this.p.x || 0, this.p.y || 0);
              }, this.unapply = function (t) {
                t.translate(-1 * this.p.x || 0, -1 * this.p.y || 0);
              }, this.applyToPoint = function (t) {
                t.applyTransform([1, 0, 0, 1, this.p.x || 0, this.p.y || 0]);
              };
            }, this.Type.rotate = function (t) {
              var e = s.ToNumberArray(t);
              this.angle = new s.Property("angle", e[0]), this.cx = e[1] || 0, this.cy = e[2] || 0, this.apply = function (t) {
                t.translate(this.cx, this.cy), t.rotate(this.angle.toRadians()), t.translate(-this.cx, -this.cy);
              }, this.unapply = function (t) {
                t.translate(this.cx, this.cy), t.rotate(-1 * this.angle.toRadians()), t.translate(-this.cx, -this.cy);
              }, this.applyToPoint = function (t) {
                var e = this.angle.toRadians();
                t.applyTransform([1, 0, 0, 1, this.p.x || 0, this.p.y || 0]), t.applyTransform([Math.cos(e), Math.sin(e), -Math.sin(e), Math.cos(e), 0, 0]), t.applyTransform([1, 0, 0, 1, -this.p.x || 0, -this.p.y || 0]);
              };
            }, this.Type.scale = function (t) {
              this.p = s.CreatePoint(t), this.apply = function (t) {
                t.scale(this.p.x || 1, this.p.y || this.p.x || 1);
              }, this.unapply = function (t) {
                t.scale(1 / this.p.x || 1, 1 / this.p.y || this.p.x || 1);
              }, this.applyToPoint = function (t) {
                t.applyTransform([this.p.x || 0, 0, 0, this.p.y || 0, 0, 0]);
              };
            }, this.Type.matrix = function (t) {
              this.m = s.ToNumberArray(t), this.apply = function (t) {
                t.transform(this.m[0], this.m[1], this.m[2], this.m[3], this.m[4], this.m[5]);
              }, this.unapply = function (t) {
                var e = this.m[0],
                    n = this.m[2],
                    r = this.m[4],
                    i = this.m[1],
                    o = this.m[3],
                    a = this.m[5],
                    s = 1 / (e * (1 * o - 0 * a) - n * (1 * i - 0 * a) + r * (0 * i - 0 * o));
                t.transform(s * (1 * o - 0 * a), s * (0 * a - 1 * i), s * (0 * r - 1 * n), s * (1 * e - 0 * r), s * (n * a - r * o), s * (r * i - e * a));
              }, this.applyToPoint = function (t) {
                t.applyTransform(this.m);
              };
            }, this.Type.SkewBase = function (t) {
              this.base = e.Type.matrix, this.base(t), this.angle = new s.Property("angle", t);
            }, this.Type.SkewBase.prototype = new this.Type.matrix(), this.Type.skewX = function (t) {
              this.base = e.Type.SkewBase, this.base(t), this.m = [1, 0, Math.tan(this.angle.toRadians()), 1, 0, 0];
            }, this.Type.skewX.prototype = new this.Type.SkewBase(), this.Type.skewY = function (t) {
              this.base = e.Type.SkewBase, this.base(t), this.m = [1, Math.tan(this.angle.toRadians()), 0, 1, 0, 0];
            }, this.Type.skewY.prototype = new this.Type.SkewBase(), this.transforms = [], this.apply = function (t) {
              for (var e = 0; e < this.transforms.length; e++) {
                this.transforms[e].apply(t);
              }
            }, this.unapply = function (t) {
              for (var e = this.transforms.length - 1; 0 <= e; e--) {
                this.transforms[e].unapply(t);
              }
            }, this.applyToPoint = function (t) {
              for (var e = 0; e < this.transforms.length; e++) {
                this.transforms[e].applyToPoint(t);
              }
            };

            for (var n = s.trim(s.compressSpaces(t)).replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/), r = 0; r < n.length; r++) {
              if ("none" !== n[r]) {
                var i = s.trim(n[r].split("(")[0]),
                    o = n[r].split("(")[1].replace(")", ""),
                    a = this.Type[i];

                if (void 0 !== a) {
                  var u = new a(o);
                  u.type = i, this.transforms.push(u);
                }
              }
            }
          }, s.AspectRatio = function (t, e, n, r, i, o, a, u, l, c) {
            var h = (e = (e = s.compressSpaces(e)).replace(/^defer\s/, "")).split(" ")[0] || "xMidYMid",
                f = e.split(" ")[1] || "meet",
                p = n / r,
                d = i / o,
                v = Math.min(p, d),
                y = Math.max(p, d);
            "meet" == f && (r *= v, o *= v), "slice" == f && (r *= y, o *= y), l = new s.Property("refX", l), c = new s.Property("refY", c), l.hasValue() && c.hasValue() ? t.translate(-v * l.toPixels("x"), -v * c.toPixels("y")) : (h.match(/^xMid/) && ("meet" == f && v == d || "slice" == f && y == d) && t.translate(n / 2 - r / 2, 0), h.match(/YMid$/) && ("meet" == f && v == p || "slice" == f && y == p) && t.translate(0, i / 2 - o / 2), h.match(/^xMax/) && ("meet" == f && v == d || "slice" == f && y == d) && t.translate(n - r, 0), h.match(/YMax$/) && ("meet" == f && v == p || "slice" == f && y == p) && t.translate(0, i - o)), "none" == h ? t.scale(p, d) : "meet" == f ? t.scale(v, v) : "slice" == f && t.scale(y, y), t.translate(null == a ? 0 : -a, null == u ? 0 : -u);
          }, s.Element = {}, s.EmptyProperty = new s.Property("EMPTY", ""), s.Element.ElementBase = function (t) {
            this.attributes = {}, this.styles = {}, this.stylesSpecificity = {}, this.children = [], this.attribute = function (t, e) {
              var n = this.attributes[t];
              return null != n ? n : (1 == e && (n = new s.Property(t, ""), this.attributes[t] = n), n || s.EmptyProperty);
            }, this.getHrefAttribute = function () {
              for (var t in this.attributes) {
                if ("href" == t || t.match(/:href$/)) return this.attributes[t];
              }

              return s.EmptyProperty;
            }, this.style = function (t, e, n) {
              var r = this.styles[t];
              if (null != r) return r;
              var i = this.attribute(t);
              if (null != i && i.hasValue()) return this.styles[t] = i;

              if (1 != n) {
                var o = this.parent;

                if (null != o) {
                  var a = o.style(t);
                  if (null != a && a.hasValue()) return a;
                }
              }

              return 1 == e && (r = new s.Property(t, ""), this.styles[t] = r), r || s.EmptyProperty;
            }, this.render = function (t) {
              if ("none" != this.style("display").value && "hidden" != this.style("visibility").value) {
                if (t.save(), this.style("mask").hasValue()) {
                  var e = this.style("mask").getDefinition();
                  null != e && e.apply(t, this);
                } else if (this.style("filter").hasValue()) {
                  var n = this.style("filter").getDefinition();
                  null != n && n.apply(t, this);
                } else this.setContext(t), this.renderChildren(t), this.clearContext(t);

                t.restore();
              }
            }, this.setContext = function () {}, this.clearContext = function () {}, this.renderChildren = function (t) {
              for (var e = 0; e < this.children.length; e++) {
                this.children[e].render(t);
              }
            }, this.addChild = function (t, e) {
              var n = t;
              e && (n = s.CreateElement(t)), n.parent = this, "title" != n.type && this.children.push(n);
            }, this.addStylesFromStyleDefinition = function () {
              for (var e in s.Styles) {
                if ("@" != e[0] && a(t, e)) {
                  var n = s.Styles[e],
                      r = s.StylesSpecificity[e];
                  if (null != n) for (var i in n) {
                    var o = this.stylesSpecificity[i];
                    void 0 === o && (o = "000"), o <= r && (this.styles[i] = n[i], this.stylesSpecificity[i] = r);
                  }
                }
              }
            };
            var e,
                n = new RegExp("^[A-Z-]+$");

            if (null != t && 1 == t.nodeType) {
              for (var r = 0; r < t.attributes.length; r++) {
                var i = t.attributes[r],
                    o = (e = i.nodeName, n.test(e) ? e.toLowerCase() : e);
                this.attributes[o] = new s.Property(o, i.value);
              }

              if (this.addStylesFromStyleDefinition(), this.attribute("style").hasValue()) {
                var u = this.attribute("style").value.split(";");

                for (r = 0; r < u.length; r++) {
                  if ("" != s.trim(u[r])) {
                    var l = u[r].split(":"),
                        c = s.trim(l[0]),
                        h = s.trim(l[1]);
                    this.styles[c] = new s.Property(c, h);
                  }
                }
              }

              for (this.attribute("id").hasValue() && null == s.Definitions[this.attribute("id").value] && (s.Definitions[this.attribute("id").value] = this), r = 0; r < t.childNodes.length; r++) {
                var f = t.childNodes[r];

                if (1 == f.nodeType && this.addChild(f, !0), this.captureTextNodes && (3 == f.nodeType || 4 == f.nodeType)) {
                  var p = f.value || f.text || f.textContent || "";
                  "" != s.compressSpaces(p) && this.addChild(new s.Element.tspan(f), !1);
                }
              }
            }
          }, s.Element.RenderedElementBase = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.calculateOpacity = function () {
              for (var t = 1, e = this; null != e;) {
                var n = e.style("opacity", !1, !0);
                n.hasValue() && (t *= n.numValue()), e = e.parent;
              }

              return t;
            }, this.setContext = function (t, e) {
              if (!e) {
                var n;
                if (this.style("fill").isUrlDefinition()) null != (n = this.style("fill").getFillStyleDefinition(this, this.style("fill-opacity"))) && (t.fillStyle = n);else if (this.style("fill").hasValue()) {
                  var r;
                  "currentColor" == (r = this.style("fill")).value && (r.value = this.style("color").value), "inherit" != r.value && (t.fillStyle = "none" == r.value ? "rgba(0,0,0,0)" : r.value);
                }
                if (this.style("fill-opacity").hasValue() && (r = (r = new s.Property("fill", t.fillStyle)).addOpacity(this.style("fill-opacity")), t.fillStyle = r.value), this.style("stroke").isUrlDefinition()) null != (n = this.style("stroke").getFillStyleDefinition(this, this.style("stroke-opacity"))) && (t.strokeStyle = n);else if (this.style("stroke").hasValue()) {
                  var i;
                  "currentColor" == (i = this.style("stroke")).value && (i.value = this.style("color").value), "inherit" != i.value && (t.strokeStyle = "none" == i.value ? "rgba(0,0,0,0)" : i.value);
                }

                if (this.style("stroke-opacity").hasValue() && (i = (i = new s.Property("stroke", t.strokeStyle)).addOpacity(this.style("stroke-opacity")), t.strokeStyle = i.value), this.style("stroke-width").hasValue()) {
                  var o = this.style("stroke-width").toPixels();
                  t.lineWidth = 0 == o ? .001 : o;
                }

                if (this.style("stroke-linecap").hasValue() && (t.lineCap = this.style("stroke-linecap").value), this.style("stroke-linejoin").hasValue() && (t.lineJoin = this.style("stroke-linejoin").value), this.style("stroke-miterlimit").hasValue() && (t.miterLimit = this.style("stroke-miterlimit").value), this.style("paint-order").hasValue() && (t.paintOrder = this.style("paint-order").value), this.style("stroke-dasharray").hasValue() && "none" != this.style("stroke-dasharray").value) {
                  var a = s.ToNumberArray(this.style("stroke-dasharray").value);
                  void 0 !== t.setLineDash ? t.setLineDash(a) : void 0 !== t.webkitLineDash ? t.webkitLineDash = a : void 0 === t.mozDash || 1 == a.length && 0 == a[0] || (t.mozDash = a);
                  var u = this.style("stroke-dashoffset").toPixels();
                  void 0 !== t.lineDashOffset ? t.lineDashOffset = u : void 0 !== t.webkitLineDashOffset ? t.webkitLineDashOffset = u : void 0 !== t.mozDashOffset && (t.mozDashOffset = u);
                }
              }

              if (void 0 !== t.font) if (this.style("font").hasValue()) t.font = this.style("font").value;else {
                t.font = s.Font.CreateFont(this.style("font-style").value, this.style("font-variant").value, this.style("font-weight").value, this.style("font-size").hasValue() ? this.style("font-size").toPixels() + "px" : "", this.style("font-family").value).toString();
                var l = this.style("font-size", !1, !1);
                l.isPixels() && (s.emSize = l.toPixels());
              }

              if (this.style("transform", !1, !0).hasValue() && new s.Transform(this.style("transform", !1, !0).value).apply(t), this.style("clip-path", !1, !0).hasValue()) {
                var c = this.style("clip-path", !1, !0).getDefinition();
                null != c && c.apply(t);
              }

              t.globalAlpha = this.calculateOpacity();
            };
          }, s.Element.RenderedElementBase.prototype = new s.Element.ElementBase(), s.Element.PathElementBase = function (t) {
            this.base = s.Element.RenderedElementBase, this.base(t), this.path = function (t) {
              return null != t && t.beginPath(), new s.BoundingBox();
            }, this.renderChildren = function (t) {
              this.path(t), s.Mouse.checkPath(this, t), "" != t.fillStyle && ("inherit" != this.style("fill-rule").valueOrDefault("inherit") ? t.fill(this.style("fill-rule").value) : t.fill()), "" != t.strokeStyle && t.stroke();
              var e = this.getMarkers();

              if (null != e) {
                if (this.style("marker-start").isUrlDefinition() && (n = this.style("marker-start").getDefinition()).render(t, e[0][0], e[0][1]), this.style("marker-mid").isUrlDefinition()) for (var n = this.style("marker-mid").getDefinition(), r = 1; r < e.length - 1; r++) {
                  n.render(t, e[r][0], e[r][1]);
                }
                this.style("marker-end").isUrlDefinition() && (n = this.style("marker-end").getDefinition()).render(t, e[e.length - 1][0], e[e.length - 1][1]);
              }
            }, this.getBoundingBox = function () {
              return this.path();
            }, this.getMarkers = function () {
              return null;
            };
          }, s.Element.PathElementBase.prototype = new s.Element.RenderedElementBase(), s.SetDefaults = function (t) {
            t.strokeStyle = "rgba(0,0,0,0)", t.lineCap = "butt", t.lineJoin = "miter", t.miterLimit = 4;
          }, s.Element.svg = function (t) {
            this.base = s.Element.RenderedElementBase, this.base(t), this.baseClearContext = this.clearContext, this.clearContext = function (t) {
              this.baseClearContext(t), s.ViewPort.RemoveCurrent();
            }, this.baseSetContext = this.setContext, this.setContext = function (t) {
              if (s.SetDefaults(t), t.canvas.style && void 0 !== t.font && void 0 !== r.getComputedStyle) {
                t.font = r.getComputedStyle(t.canvas).getPropertyValue("font");
                var e = new s.Property("fontSize", s.Font.Parse(t.font).fontSize);
                e.hasValue() && (s.rootEmSize = s.emSize = e.toPixels("y"));
              }

              this.baseSetContext(t), this.attribute("x").hasValue() || (this.attribute("x", !0).value = 0), this.attribute("y").hasValue() || (this.attribute("y", !0).value = 0), t.translate(this.attribute("x").toPixels("x"), this.attribute("y").toPixels("y"));
              var n = s.ViewPort.width(),
                  i = s.ViewPort.height();

              if (this.attribute("width").hasValue() || (this.attribute("width", !0).value = "100%"), this.attribute("height").hasValue() || (this.attribute("height", !0).value = "100%"), void 0 === this.root) {
                n = this.attribute("width").toPixels("x"), i = this.attribute("height").toPixels("y");
                var o = 0,
                    a = 0;
                this.attribute("refX").hasValue() && this.attribute("refY").hasValue() && (o = -this.attribute("refX").toPixels("x"), a = -this.attribute("refY").toPixels("y")), "visible" != this.attribute("overflow").valueOrDefault("hidden") && (t.beginPath(), t.moveTo(o, a), t.lineTo(n, a), t.lineTo(n, i), t.lineTo(o, i), t.closePath(), t.clip());
              }

              if (s.ViewPort.SetCurrent(n, i), this.attribute("viewBox").hasValue()) {
                var u = s.ToNumberArray(this.attribute("viewBox").value),
                    l = u[0],
                    c = u[1];
                n = u[2], i = u[3], s.AspectRatio(t, this.attribute("preserveAspectRatio").value, s.ViewPort.width(), n, s.ViewPort.height(), i, l, c, this.attribute("refX").value, this.attribute("refY").value), s.ViewPort.RemoveCurrent(), s.ViewPort.SetCurrent(u[2], u[3]);
              }
            };
          }, s.Element.svg.prototype = new s.Element.RenderedElementBase(), s.Element.rect = function (t) {
            this.base = s.Element.PathElementBase, this.base(t), this.path = function (t) {
              var e = this.attribute("x").toPixels("x"),
                  n = this.attribute("y").toPixels("y"),
                  r = this.attribute("width").toPixels("x"),
                  i = this.attribute("height").toPixels("y"),
                  o = this.attribute("rx").toPixels("x"),
                  a = this.attribute("ry").toPixels("y");

              if (this.attribute("rx").hasValue() && !this.attribute("ry").hasValue() && (a = o), this.attribute("ry").hasValue() && !this.attribute("rx").hasValue() && (o = a), o = Math.min(o, r / 2), a = Math.min(a, i / 2), null != t) {
                var u = (Math.sqrt(2) - 1) / 3 * 4;
                t.beginPath(), 0 < i && 0 < r && (t.moveTo(e + o, n), t.lineTo(e + r - o, n), t.bezierCurveTo(e + r - o + u * o, n, e + r, n + a - u * a, e + r, n + a), t.lineTo(e + r, n + i - a), t.bezierCurveTo(e + r, n + i - a + u * a, e + r - o + u * o, n + i, e + r - o, n + i), t.lineTo(e + o, n + i), t.bezierCurveTo(e + o - u * o, n + i, e, n + i - a + u * a, e, n + i - a), t.lineTo(e, n + a), t.bezierCurveTo(e, n + a - u * a, e + o - u * o, n, e + o, n), t.closePath());
              }

              return new s.BoundingBox(e, n, e + r, n + i);
            };
          }, s.Element.rect.prototype = new s.Element.PathElementBase(), s.Element.circle = function (t) {
            this.base = s.Element.PathElementBase, this.base(t), this.path = function (t) {
              var e = this.attribute("cx").toPixels("x"),
                  n = this.attribute("cy").toPixels("y"),
                  r = this.attribute("r").toPixels();
              return null != t && 0 < r && (t.beginPath(), t.arc(e, n, r, 0, 2 * Math.PI, !1), t.closePath()), new s.BoundingBox(e - r, n - r, e + r, n + r);
            };
          }, s.Element.circle.prototype = new s.Element.PathElementBase(), s.Element.ellipse = function (t) {
            this.base = s.Element.PathElementBase, this.base(t), this.path = function (t) {
              var e = (Math.sqrt(2) - 1) / 3 * 4,
                  n = this.attribute("rx").toPixels("x"),
                  r = this.attribute("ry").toPixels("y"),
                  i = this.attribute("cx").toPixels("x"),
                  o = this.attribute("cy").toPixels("y");
              return null != t && (t.beginPath(), t.moveTo(i + n, o), t.bezierCurveTo(i + n, o + e * r, i + e * n, o + r, i, o + r), t.bezierCurveTo(i - e * n, o + r, i - n, o + e * r, i - n, o), t.bezierCurveTo(i - n, o - e * r, i - e * n, o - r, i, o - r), t.bezierCurveTo(i + e * n, o - r, i + n, o - e * r, i + n, o), t.closePath()), new s.BoundingBox(i - n, o - r, i + n, o + r);
            };
          }, s.Element.ellipse.prototype = new s.Element.PathElementBase(), s.Element.line = function (t) {
            this.base = s.Element.PathElementBase, this.base(t), this.getPoints = function () {
              return [new s.Point(this.attribute("x1").toPixels("x"), this.attribute("y1").toPixels("y")), new s.Point(this.attribute("x2").toPixels("x"), this.attribute("y2").toPixels("y"))];
            }, this.path = function (t) {
              var e = this.getPoints();
              return null != t && (t.beginPath(), t.moveTo(e[0].x, e[0].y), t.lineTo(e[1].x, e[1].y)), new s.BoundingBox(e[0].x, e[0].y, e[1].x, e[1].y);
            }, this.getMarkers = function () {
              var t = this.getPoints(),
                  e = t[0].angleTo(t[1]);
              return [[t[0], e], [t[1], e]];
            };
          }, s.Element.line.prototype = new s.Element.PathElementBase(), s.Element.polyline = function (t) {
            this.base = s.Element.PathElementBase, this.base(t), this.points = s.CreatePath(this.attribute("points").value), this.path = function (t) {
              var e = new s.BoundingBox(this.points[0].x, this.points[0].y);
              null != t && (t.beginPath(), t.moveTo(this.points[0].x, this.points[0].y));

              for (var n = 1; n < this.points.length; n++) {
                e.addPoint(this.points[n].x, this.points[n].y), null != t && t.lineTo(this.points[n].x, this.points[n].y);
              }

              return e;
            }, this.getMarkers = function () {
              for (var t = [], e = 0; e < this.points.length - 1; e++) {
                t.push([this.points[e], this.points[e].angleTo(this.points[e + 1])]);
              }

              return 0 < t.length && t.push([this.points[this.points.length - 1], t[t.length - 1][1]]), t;
            };
          }, s.Element.polyline.prototype = new s.Element.PathElementBase(), s.Element.polygon = function (t) {
            this.base = s.Element.polyline, this.base(t), this.basePath = this.path, this.path = function (t) {
              var e = this.basePath(t);
              return null != t && (t.lineTo(this.points[0].x, this.points[0].y), t.closePath()), e;
            };
          }, s.Element.polygon.prototype = new s.Element.polyline(), s.Element.path = function (t) {
            this.base = s.Element.PathElementBase, this.base(t);
            var e = this.attribute("d").value;
            e = e.replace(/,/gm, " ");

            for (var n = 0; n < 2; n++) {
              e = e.replace(/([MmZzLlHhVvCcSsQqTtAa])([^\s])/gm, "$1 $2");
            }

            for (e = (e = e.replace(/([^\s])([MmZzLlHhVvCcSsQqTtAa])/gm, "$1 $2")).replace(/([0-9])([+\-])/gm, "$1 $2"), n = 0; n < 2; n++) {
              e = e.replace(/(\.[0-9]*)(\.)/gm, "$1 $2");
            }

            e = e.replace(/([Aa](\s+[0-9]+){3})\s+([01])\s*([01])/gm, "$1 $3 $4 "), e = s.compressSpaces(e), e = s.trim(e), this.PathParser = new function (t) {
              this.tokens = t.split(" "), this.reset = function () {
                this.i = -1, this.command = "", this.previousCommand = "", this.start = new s.Point(0, 0), this.control = new s.Point(0, 0), this.current = new s.Point(0, 0), this.points = [], this.angles = [];
              }, this.isEnd = function () {
                return this.i >= this.tokens.length - 1;
              }, this.isCommandOrEnd = function () {
                return !!this.isEnd() || null != this.tokens[this.i + 1].match(/^[A-Za-z]$/);
              }, this.isRelativeCommand = function () {
                switch (this.command) {
                  case "m":
                  case "l":
                  case "h":
                  case "v":
                  case "c":
                  case "s":
                  case "q":
                  case "t":
                  case "a":
                  case "z":
                    return !0;
                }

                return !1;
              }, this.getToken = function () {
                return this.i++, this.tokens[this.i];
              }, this.getScalar = function () {
                return parseFloat(this.getToken());
              }, this.nextCommand = function () {
                this.previousCommand = this.command, this.command = this.getToken();
              }, this.getPoint = function () {
                var t = new s.Point(this.getScalar(), this.getScalar());
                return this.makeAbsolute(t);
              }, this.getAsControlPoint = function () {
                var t = this.getPoint();
                return this.control = t;
              }, this.getAsCurrentPoint = function () {
                var t = this.getPoint();
                return this.current = t;
              }, this.getReflectedControlPoint = function () {
                return "c" != this.previousCommand.toLowerCase() && "s" != this.previousCommand.toLowerCase() && "q" != this.previousCommand.toLowerCase() && "t" != this.previousCommand.toLowerCase() ? this.current : new s.Point(2 * this.current.x - this.control.x, 2 * this.current.y - this.control.y);
              }, this.makeAbsolute = function (t) {
                return this.isRelativeCommand() && (t.x += this.current.x, t.y += this.current.y), t;
              }, this.addMarker = function (t, e, n) {
                null != n && 0 < this.angles.length && null == this.angles[this.angles.length - 1] && (this.angles[this.angles.length - 1] = this.points[this.points.length - 1].angleTo(n)), this.addMarkerAngle(t, null == e ? null : e.angleTo(t));
              }, this.addMarkerAngle = function (t, e) {
                this.points.push(t), this.angles.push(e);
              }, this.getMarkerPoints = function () {
                return this.points;
              }, this.getMarkerAngles = function () {
                for (var t = 0; t < this.angles.length; t++) {
                  if (null == this.angles[t]) for (var e = t + 1; e < this.angles.length; e++) {
                    if (null != this.angles[e]) {
                      this.angles[t] = this.angles[e];
                      break;
                    }
                  }
                }

                return this.angles;
              };
            }(e), this.path = function (t) {
              var e = this.PathParser;
              e.reset();
              var n = new s.BoundingBox();

              for (null != t && t.beginPath(); !e.isEnd();) {
                switch (e.nextCommand(), e.command) {
                  case "M":
                  case "m":
                    var r = e.getAsCurrentPoint();

                    for (e.addMarker(r), n.addPoint(r.x, r.y), null != t && t.moveTo(r.x, r.y), e.start = e.current; !e.isCommandOrEnd();) {
                      r = e.getAsCurrentPoint(), e.addMarker(r, e.start), n.addPoint(r.x, r.y), null != t && t.lineTo(r.x, r.y);
                    }

                    break;

                  case "L":
                  case "l":
                    for (; !e.isCommandOrEnd();) {
                      var i = e.current;
                      r = e.getAsCurrentPoint(), e.addMarker(r, i), n.addPoint(r.x, r.y), null != t && t.lineTo(r.x, r.y);
                    }

                    break;

                  case "H":
                  case "h":
                    for (; !e.isCommandOrEnd();) {
                      var o = new s.Point((e.isRelativeCommand() ? e.current.x : 0) + e.getScalar(), e.current.y);
                      e.addMarker(o, e.current), e.current = o, n.addPoint(e.current.x, e.current.y), null != t && t.lineTo(e.current.x, e.current.y);
                    }

                    break;

                  case "V":
                  case "v":
                    for (; !e.isCommandOrEnd();) {
                      o = new s.Point(e.current.x, (e.isRelativeCommand() ? e.current.y : 0) + e.getScalar()), e.addMarker(o, e.current), e.current = o, n.addPoint(e.current.x, e.current.y), null != t && t.lineTo(e.current.x, e.current.y);
                    }

                    break;

                  case "C":
                  case "c":
                    for (; !e.isCommandOrEnd();) {
                      var a = e.current,
                          u = e.getPoint(),
                          l = e.getAsControlPoint(),
                          c = e.getAsCurrentPoint();
                      e.addMarker(c, l, u), n.addBezierCurve(a.x, a.y, u.x, u.y, l.x, l.y, c.x, c.y), null != t && t.bezierCurveTo(u.x, u.y, l.x, l.y, c.x, c.y);
                    }

                    break;

                  case "S":
                  case "s":
                    for (; !e.isCommandOrEnd();) {
                      a = e.current, u = e.getReflectedControlPoint(), l = e.getAsControlPoint(), c = e.getAsCurrentPoint(), e.addMarker(c, l, u), n.addBezierCurve(a.x, a.y, u.x, u.y, l.x, l.y, c.x, c.y), null != t && t.bezierCurveTo(u.x, u.y, l.x, l.y, c.x, c.y);
                    }

                    break;

                  case "Q":
                  case "q":
                    for (; !e.isCommandOrEnd();) {
                      a = e.current, l = e.getAsControlPoint(), c = e.getAsCurrentPoint(), e.addMarker(c, l, l), n.addQuadraticCurve(a.x, a.y, l.x, l.y, c.x, c.y), null != t && t.quadraticCurveTo(l.x, l.y, c.x, c.y);
                    }

                    break;

                  case "T":
                  case "t":
                    for (; !e.isCommandOrEnd();) {
                      a = e.current, l = e.getReflectedControlPoint(), e.control = l, c = e.getAsCurrentPoint(), e.addMarker(c, l, l), n.addQuadraticCurve(a.x, a.y, l.x, l.y, c.x, c.y), null != t && t.quadraticCurveTo(l.x, l.y, c.x, c.y);
                    }

                    break;

                  case "A":
                  case "a":
                    for (; !e.isCommandOrEnd();) {
                      a = e.current;
                      var h = e.getScalar(),
                          f = e.getScalar(),
                          p = e.getScalar() * (Math.PI / 180),
                          d = e.getScalar(),
                          v = e.getScalar(),
                          y = (c = e.getAsCurrentPoint(), new s.Point(Math.cos(p) * (a.x - c.x) / 2 + Math.sin(p) * (a.y - c.y) / 2, -Math.sin(p) * (a.x - c.x) / 2 + Math.cos(p) * (a.y - c.y) / 2)),
                          m = Math.pow(y.x, 2) / Math.pow(h, 2) + Math.pow(y.y, 2) / Math.pow(f, 2);
                      1 < m && (h *= Math.sqrt(m), f *= Math.sqrt(m));
                      var g = (d == v ? -1 : 1) * Math.sqrt((Math.pow(h, 2) * Math.pow(f, 2) - Math.pow(h, 2) * Math.pow(y.y, 2) - Math.pow(f, 2) * Math.pow(y.x, 2)) / (Math.pow(h, 2) * Math.pow(y.y, 2) + Math.pow(f, 2) * Math.pow(y.x, 2)));
                      isNaN(g) && (g = 0);

                      var _ = new s.Point(g * h * y.y / f, g * -f * y.x / h),
                          b = new s.Point((a.x + c.x) / 2 + Math.cos(p) * _.x - Math.sin(p) * _.y, (a.y + c.y) / 2 + Math.sin(p) * _.x + Math.cos(p) * _.y),
                          L = function L(t) {
                        return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2));
                      },
                          x = function x(t, e) {
                        return (t[0] * e[0] + t[1] * e[1]) / (L(t) * L(e));
                      },
                          w = function w(t, e) {
                        return (t[0] * e[1] < t[1] * e[0] ? -1 : 1) * Math.acos(x(t, e));
                      },
                          M = w([1, 0], [(y.x - _.x) / h, (y.y - _.y) / f]),
                          k = [(y.x - _.x) / h, (y.y - _.y) / f],
                          C = [(-y.x - _.x) / h, (-y.y - _.y) / f],
                          E = w(k, C);

                      x(k, C) <= -1 && (E = Math.PI), 1 <= x(k, C) && (E = 0);
                      var I = 1 - v ? 1 : -1,
                          A = M + I * (E / 2),
                          P = new s.Point(b.x + h * Math.cos(A), b.y + f * Math.sin(A));

                      if (e.addMarkerAngle(P, A - I * Math.PI / 2), e.addMarkerAngle(c, A - I * Math.PI), n.addPoint(c.x, c.y), null != t && !isNaN(M) && !isNaN(E)) {
                        x = f < h ? h : f;
                        var O = f < h ? 1 : h / f,
                            T = f < h ? f / h : 1;
                        t.translate(b.x, b.y), t.rotate(p), t.scale(O, T), t.arc(0, 0, x, M, M + E, 1 - v), t.scale(1 / O, 1 / T), t.rotate(-p), t.translate(-b.x, -b.y);
                      }
                    }

                    break;

                  case "Z":
                  case "z":
                    null != t && n.x1 !== n.x2 && n.y1 !== n.y2 && t.closePath(), e.current = e.start;
                }
              }

              return n;
            }, this.getMarkers = function () {
              for (var t = this.PathParser.getMarkerPoints(), e = this.PathParser.getMarkerAngles(), n = [], r = 0; r < t.length; r++) {
                n.push([t[r], e[r]]);
              }

              return n;
            };
          }, s.Element.path.prototype = new s.Element.PathElementBase(), s.Element.pattern = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.createPattern = function (t, e, n) {
              var r = this.attribute("width").toPixels("x", !0),
                  i = this.attribute("height").toPixels("y", !0),
                  a = new s.Element.svg();
              a.attributes.viewBox = new s.Property("viewBox", this.attribute("viewBox").value), a.attributes.width = new s.Property("width", r + "px"), a.attributes.height = new s.Property("height", i + "px"), a.attributes.transform = new s.Property("transform", this.attribute("patternTransform").value), a.children = this.children;
              var u = o(r, i),
                  l = u.getContext("2d");
              this.attribute("x").hasValue() && this.attribute("y").hasValue() && l.translate(this.attribute("x").toPixels("x", !0), this.attribute("y").toPixels("y", !0)), n.hasValue() ? this.styles["fill-opacity"] = n : delete this.styles["fill-opacity"];

              for (var c = -1; c <= 1; c++) {
                for (var h = -1; h <= 1; h++) {
                  l.save(), a.attributes.x = new s.Property("x", c * u.width), a.attributes.y = new s.Property("y", h * u.height), a.render(l), l.restore();
                }
              }

              return t.createPattern(u, "repeat");
            };
          }, s.Element.pattern.prototype = new s.Element.ElementBase(), s.Element.marker = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.baseRender = this.render, this.render = function (t, e, n) {
              if (e) {
                t.translate(e.x, e.y), "auto" == this.attribute("orient").valueOrDefault("auto") && t.rotate(n), "strokeWidth" == this.attribute("markerUnits").valueOrDefault("strokeWidth") && t.scale(t.lineWidth, t.lineWidth), t.save();
                var r = new s.Element.svg();
                r.attributes.viewBox = new s.Property("viewBox", this.attribute("viewBox").value), r.attributes.refX = new s.Property("refX", this.attribute("refX").value), r.attributes.refY = new s.Property("refY", this.attribute("refY").value), r.attributes.width = new s.Property("width", this.attribute("markerWidth").value), r.attributes.height = new s.Property("height", this.attribute("markerHeight").value), r.attributes.fill = new s.Property("fill", this.attribute("fill").valueOrDefault("black")), r.attributes.stroke = new s.Property("stroke", this.attribute("stroke").valueOrDefault("none")), r.children = this.children, r.render(t), t.restore(), "strokeWidth" == this.attribute("markerUnits").valueOrDefault("strokeWidth") && t.scale(1 / t.lineWidth, 1 / t.lineWidth), "auto" == this.attribute("orient").valueOrDefault("auto") && t.rotate(-n), t.translate(-e.x, -e.y);
              }
            };
          }, s.Element.marker.prototype = new s.Element.ElementBase(), s.Element.defs = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.render = function () {};
          }, s.Element.defs.prototype = new s.Element.ElementBase(), s.Element.GradientBase = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.stops = [];

            for (var e = 0; e < this.children.length; e++) {
              var n = this.children[e];
              "stop" == n.type && this.stops.push(n);
            }

            this.getGradient = function () {}, this.gradientUnits = function () {
              return this.attribute("gradientUnits").valueOrDefault("objectBoundingBox");
            }, this.attributesToInherit = ["gradientUnits"], this.inheritStopContainer = function (t) {
              for (var e = 0; e < this.attributesToInherit.length; e++) {
                var n = this.attributesToInherit[e];
                !this.attribute(n).hasValue() && t.attribute(n).hasValue() && (this.attribute(n, !0).value = t.attribute(n).value);
              }
            }, this.createGradient = function (t, e, n) {
              var r = this;
              this.getHrefAttribute().hasValue() && (r = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(r));

              var i = function i(t) {
                return n.hasValue() ? new s.Property("color", t).addOpacity(n).value : t;
              },
                  a = this.getGradient(t, e);

              if (null == a) return i(r.stops[r.stops.length - 1].color);

              for (var u = 0; u < r.stops.length; u++) {
                a.addColorStop(r.stops[u].offset, i(r.stops[u].color));
              }

              if (this.attribute("gradientTransform").hasValue()) {
                var l = s.ViewPort.viewPorts[0],
                    c = new s.Element.rect();
                c.attributes.x = new s.Property("x", -s.MAX_VIRTUAL_PIXELS / 3), c.attributes.y = new s.Property("y", -s.MAX_VIRTUAL_PIXELS / 3), c.attributes.width = new s.Property("width", s.MAX_VIRTUAL_PIXELS), c.attributes.height = new s.Property("height", s.MAX_VIRTUAL_PIXELS);
                var h = new s.Element.g();
                h.attributes.transform = new s.Property("transform", this.attribute("gradientTransform").value), h.children = [c];
                var f = new s.Element.svg();
                f.attributes.x = new s.Property("x", 0), f.attributes.y = new s.Property("y", 0), f.attributes.width = new s.Property("width", l.width), f.attributes.height = new s.Property("height", l.height), f.children = [h];
                var p = o(l.width, l.height),
                    d = p.getContext("2d");
                return d.fillStyle = a, f.render(d), d.createPattern(p, "no-repeat");
              }

              return a;
            };
          }, s.Element.GradientBase.prototype = new s.Element.ElementBase(), s.Element.linearGradient = function (t) {
            this.base = s.Element.GradientBase, this.base(t), this.attributesToInherit.push("x1"), this.attributesToInherit.push("y1"), this.attributesToInherit.push("x2"), this.attributesToInherit.push("y2"), this.getGradient = function (t, e) {
              var n = "objectBoundingBox" == this.gradientUnits() ? e.getBoundingBox(t) : null;
              this.attribute("x1").hasValue() || this.attribute("y1").hasValue() || this.attribute("x2").hasValue() || this.attribute("y2").hasValue() || (this.attribute("x1", !0).value = 0, this.attribute("y1", !0).value = 0, this.attribute("x2", !0).value = 1, this.attribute("y2", !0).value = 0);
              var r = "objectBoundingBox" == this.gradientUnits() ? n.x() + n.width() * this.attribute("x1").numValue() : this.attribute("x1").toPixels("x"),
                  i = "objectBoundingBox" == this.gradientUnits() ? n.y() + n.height() * this.attribute("y1").numValue() : this.attribute("y1").toPixels("y"),
                  o = "objectBoundingBox" == this.gradientUnits() ? n.x() + n.width() * this.attribute("x2").numValue() : this.attribute("x2").toPixels("x"),
                  a = "objectBoundingBox" == this.gradientUnits() ? n.y() + n.height() * this.attribute("y2").numValue() : this.attribute("y2").toPixels("y");
              return r == o && i == a ? null : t.createLinearGradient(r, i, o, a);
            };
          }, s.Element.linearGradient.prototype = new s.Element.GradientBase(), s.Element.radialGradient = function (t) {
            this.base = s.Element.GradientBase, this.base(t), this.attributesToInherit.push("cx"), this.attributesToInherit.push("cy"), this.attributesToInherit.push("r"), this.attributesToInherit.push("fx"), this.attributesToInherit.push("fy"), this.attributesToInherit.push("fr"), this.getGradient = function (t, e) {
              var n = e.getBoundingBox(t);
              this.attribute("cx").hasValue() || (this.attribute("cx", !0).value = "50%"), this.attribute("cy").hasValue() || (this.attribute("cy", !0).value = "50%"), this.attribute("r").hasValue() || (this.attribute("r", !0).value = "50%");
              var r = "objectBoundingBox" == this.gradientUnits() ? n.x() + n.width() * this.attribute("cx").numValue() : this.attribute("cx").toPixels("x"),
                  i = "objectBoundingBox" == this.gradientUnits() ? n.y() + n.height() * this.attribute("cy").numValue() : this.attribute("cy").toPixels("y"),
                  o = r,
                  a = i;
              this.attribute("fx").hasValue() && (o = "objectBoundingBox" == this.gradientUnits() ? n.x() + n.width() * this.attribute("fx").numValue() : this.attribute("fx").toPixels("x")), this.attribute("fy").hasValue() && (a = "objectBoundingBox" == this.gradientUnits() ? n.y() + n.height() * this.attribute("fy").numValue() : this.attribute("fy").toPixels("y"));
              var s = "objectBoundingBox" == this.gradientUnits() ? (n.width() + n.height()) / 2 * this.attribute("r").numValue() : this.attribute("r").toPixels(),
                  u = this.attribute("fr").toPixels();
              return t.createRadialGradient(o, a, u, r, i, s);
            };
          }, s.Element.radialGradient.prototype = new s.Element.GradientBase(), s.Element.stop = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.offset = this.attribute("offset").numValue(), this.offset < 0 && (this.offset = 0), 1 < this.offset && (this.offset = 1);
            var e = this.style("stop-color", !0);
            "" === e.value && (e.value = "#000"), this.style("stop-opacity").hasValue() && (e = e.addOpacity(this.style("stop-opacity"))), this.color = e.value;
          }, s.Element.stop.prototype = new s.Element.ElementBase(), s.Element.AnimateBase = function (t) {
            this.base = s.Element.ElementBase, this.base(t), s.Animations.push(this), this.duration = 0, this.begin = this.attribute("begin").toMilliseconds(), this.maxDuration = this.begin + this.attribute("dur").toMilliseconds(), this.getProperty = function () {
              var t = this.attribute("attributeType").value,
                  e = this.attribute("attributeName").value;
              return "CSS" == t ? this.parent.style(e, !0) : this.parent.attribute(e, !0);
            }, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.calcValue = function () {
              return "";
            }, this.update = function (t) {
              if (null == this.initialValue && (this.initialValue = this.getProperty().value, this.initialUnits = this.getProperty().getUnits()), this.duration > this.maxDuration) {
                if ("indefinite" == this.attribute("repeatCount").value || "indefinite" == this.attribute("repeatDur").value) this.duration = 0;else if ("freeze" != this.attribute("fill").valueOrDefault("remove") || this.frozen) {
                  if ("remove" == this.attribute("fill").valueOrDefault("remove") && !this.removed) return this.removed = !0, this.getProperty().value = this.parent.animationFrozen ? this.parent.animationFrozenValue : this.initialValue, !0;
                } else this.frozen = !0, this.parent.animationFrozen = !0, this.parent.animationFrozenValue = this.getProperty().value;
                return !1;
              }

              this.duration = this.duration + t;
              var e = !1;

              if (this.begin < this.duration) {
                var n = this.calcValue();
                this.attribute("type").hasValue() && (n = this.attribute("type").value + "(" + n + ")"), this.getProperty().value = n, e = !0;
              }

              return e;
            }, this.from = this.attribute("from"), this.to = this.attribute("to"), this.values = this.attribute("values"), this.values.hasValue() && (this.values.value = this.values.value.split(";")), this.progress = function () {
              var t = {
                progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
              };

              if (this.values.hasValue()) {
                var e = t.progress * (this.values.value.length - 1),
                    n = Math.floor(e),
                    r = Math.ceil(e);
                t.from = new s.Property("from", parseFloat(this.values.value[n])), t.to = new s.Property("to", parseFloat(this.values.value[r])), t.progress = (e - n) / (r - n);
              } else t.from = this.from, t.to = this.to;

              return t;
            };
          }, s.Element.AnimateBase.prototype = new s.Element.ElementBase(), s.Element.animate = function (t) {
            this.base = s.Element.AnimateBase, this.base(t), this.calcValue = function () {
              var t = this.progress(),
                  e = t.from.numValue() + (t.to.numValue() - t.from.numValue()) * t.progress;
              return "%" === this.initialUnits && (e *= 100), e + this.initialUnits;
            };
          }, s.Element.animate.prototype = new s.Element.AnimateBase(), s.Element.animateColor = function (e) {
            this.base = s.Element.AnimateBase, this.base(e), this.calcValue = function () {
              var e = this.progress(),
                  n = new t(e.from.value),
                  r = new t(e.to.value);

              if (n.ok && r.ok) {
                var i = n.r + (r.r - n.r) * e.progress,
                    o = n.g + (r.g - n.g) * e.progress,
                    a = n.b + (r.b - n.b) * e.progress;
                return "rgb(" + parseInt(i, 10) + "," + parseInt(o, 10) + "," + parseInt(a, 10) + ")";
              }

              return this.attribute("from").value;
            };
          }, s.Element.animateColor.prototype = new s.Element.AnimateBase(), s.Element.animateTransform = function (t) {
            this.base = s.Element.AnimateBase, this.base(t), this.calcValue = function () {
              for (var t = this.progress(), e = s.ToNumberArray(t.from.value), n = s.ToNumberArray(t.to.value), r = "", i = 0; i < e.length; i++) {
                r += e[i] + (n[i] - e[i]) * t.progress + " ";
              }

              return r;
            };
          }, s.Element.animateTransform.prototype = new s.Element.animate(), s.Element.font = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.horizAdvX = this.attribute("horiz-adv-x").numValue(), this.isRTL = !1, this.isArabic = !1, this.fontFace = null, this.missingGlyph = null, this.glyphs = [];

            for (var e = 0; e < this.children.length; e++) {
              var n = this.children[e];
              "font-face" == n.type ? (this.fontFace = n).style("font-family").hasValue() && (s.Definitions[n.style("font-family").value] = this) : "missing-glyph" == n.type ? this.missingGlyph = n : "glyph" == n.type && ("" != n.arabicForm ? (this.isRTL = !0, this.isArabic = !0, void 0 === this.glyphs[n.unicode] && (this.glyphs[n.unicode] = []), this.glyphs[n.unicode][n.arabicForm] = n) : this.glyphs[n.unicode] = n);
            }

            this.render = function () {};
          }, s.Element.font.prototype = new s.Element.ElementBase(), s.Element.fontface = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.ascent = this.attribute("ascent").value, this.descent = this.attribute("descent").value, this.unitsPerEm = this.attribute("units-per-em").numValue();
          }, s.Element.fontface.prototype = new s.Element.ElementBase(), s.Element.missingglyph = function (t) {
            this.base = s.Element.path, this.base(t), this.horizAdvX = 0;
          }, s.Element.missingglyph.prototype = new s.Element.path(), s.Element.glyph = function (t) {
            this.base = s.Element.path, this.base(t), this.horizAdvX = this.attribute("horiz-adv-x").numValue(), this.unicode = this.attribute("unicode").value, this.arabicForm = this.attribute("arabic-form").value;
          }, s.Element.glyph.prototype = new s.Element.path(), s.Element.text = function (t) {
            this.captureTextNodes = !0, this.base = s.Element.RenderedElementBase, this.base(t), this.baseSetContext = this.setContext, this.setContext = function (t) {
              this.baseSetContext(t);
              var e = this.style("dominant-baseline").toTextBaseline();
              null == e && (e = this.style("alignment-baseline").toTextBaseline()), null != e && (t.textBaseline = e);
            }, this.initializeCoordinates = function (t) {
              this.x = this.attribute("x").toPixels("x"), this.y = this.attribute("y").toPixels("y"), this.attribute("dx").hasValue() && (this.x += this.attribute("dx").toPixels("x")), this.attribute("dy").hasValue() && (this.y += this.attribute("dy").toPixels("y")), this.x += this.getAnchorDelta(t, this, 0);
            }, this.getBoundingBox = function (t) {
              this.initializeCoordinates(t);

              for (var e = null, n = 0; n < this.children.length; n++) {
                var r = this.getChildBoundingBox(t, this, this, n);
                null == e ? e = r : e.addBoundingBox(r);
              }

              return e;
            }, this.renderChildren = function (t) {
              this.initializeCoordinates(t);

              for (var e = 0; e < this.children.length; e++) {
                this.renderChild(t, this, this, e);
              }

              s.Mouse.checkBoundingBox(this, this.getBoundingBox(t));
            }, this.getAnchorDelta = function (t, e, n) {
              var r = this.style("text-anchor").valueOrDefault("start");
              if ("start" == r) return 0;

              for (var i = 0, o = n; o < e.children.length; o++) {
                var a = e.children[o];
                if (n < o && a.attribute("x").hasValue()) break;
                i += a.measureTextRecursive(t);
              }

              return -1 * ("end" == r ? i : i / 2);
            }, this.adjustChildCoordinates = function (t, e, n, r) {
              var i = n.children[r];
              if ("function" != typeof i.measureText) return i;

              if (i.attribute("x").hasValue()) {
                i.x = i.attribute("x").toPixels("x") + e.getAnchorDelta(t, n, r);
                var o = i.attribute("text-anchor").valueOrDefault("start");

                if ("start" !== o) {
                  var a = i.measureTextRecursive(t);
                  i.x += -1 * ("end" == o ? a : a / 2);
                }

                i.attribute("dx").hasValue() && (i.x += i.attribute("dx").toPixels("x"));
              } else i.attribute("dx").hasValue() && (e.x += i.attribute("dx").toPixels("x")), i.x = e.x;

              return e.x = i.x + i.measureText(t), i.attribute("y").hasValue() ? (i.y = i.attribute("y").toPixels("y"), i.attribute("dy").hasValue() && (i.y += i.attribute("dy").toPixels("y"))) : (i.attribute("dy").hasValue() && (e.y += i.attribute("dy").toPixels("y")), i.y = e.y), e.y = i.y, i;
            }, this.getChildBoundingBox = function (t, e, n, r) {
              var i = this.adjustChildCoordinates(t, e, n, r),
                  o = i.getBoundingBox(t);

              for (r = 0; r < i.children.length; r++) {
                var a = e.getChildBoundingBox(t, e, i, r);
                o.addBoundingBox(a);
              }

              return o;
            }, this.renderChild = function (t, e, n, r) {
              var i = this.adjustChildCoordinates(t, e, n, r);

              for (i.render(t), r = 0; r < i.children.length; r++) {
                e.renderChild(t, e, i, r);
              }
            };
          }, s.Element.text.prototype = new s.Element.RenderedElementBase(), s.Element.TextElementBase = function (t) {
            this.base = s.Element.RenderedElementBase, this.base(t), this.getGlyph = function (t, e, n) {
              var r = e[n],
                  i = null;

              if (t.isArabic) {
                var o = "isolated";
                (0 == n || " " == e[n - 1]) && n < e.length - 2 && " " != e[n + 1] && (o = "terminal"), 0 < n && " " != e[n - 1] && n < e.length - 2 && " " != e[n + 1] && (o = "medial"), 0 < n && " " != e[n - 1] && (n == e.length - 1 || " " == e[n + 1]) && (o = "initial"), void 0 !== t.glyphs[r] && null == (i = t.glyphs[r][o]) && "glyph" == t.glyphs[r].type && (i = t.glyphs[r]);
              } else i = t.glyphs[r];

              return null == i && (i = t.missingGlyph), i;
            }, this.renderChildren = function (t) {
              var e = this.parent.style("font-family").getDefinition();
              if (null == e) "stroke" == t.paintOrder ? ("" != t.strokeStyle && t.strokeText(s.compressSpaces(this.getText()), this.x, this.y), "" != t.fillStyle && t.fillText(s.compressSpaces(this.getText()), this.x, this.y)) : ("" != t.fillStyle && t.fillText(s.compressSpaces(this.getText()), this.x, this.y), "" != t.strokeStyle && t.strokeText(s.compressSpaces(this.getText()), this.x, this.y));else {
                var n = this.parent.style("font-size").numValueOrDefault(s.Font.Parse(s.ctx.font).fontSize),
                    r = this.parent.style("font-style").valueOrDefault(s.Font.Parse(s.ctx.font).fontStyle),
                    i = this.getText();
                e.isRTL && (i = i.split("").reverse().join(""));

                for (var o = s.ToNumberArray(this.parent.attribute("dx").value), a = 0; a < i.length; a++) {
                  var u = this.getGlyph(e, i, a),
                      l = n / e.fontFace.unitsPerEm;
                  t.translate(this.x, this.y), t.scale(l, -l);
                  var c = t.lineWidth;
                  t.lineWidth = t.lineWidth * e.fontFace.unitsPerEm / n, "italic" == r && t.transform(1, 0, .4, 1, 0, 0), u.render(t), "italic" == r && t.transform(1, 0, -.4, 1, 0, 0), t.lineWidth = c, t.scale(1 / l, -1 / l), t.translate(-this.x, -this.y), this.x += n * (u.horizAdvX || e.horizAdvX) / e.fontFace.unitsPerEm, void 0 === o[a] || isNaN(o[a]) || (this.x += o[a]);
                }
              }
            }, this.getText = function () {}, this.measureTextRecursive = function (t) {
              for (var e = this.measureText(t), n = 0; n < this.children.length; n++) {
                e += this.children[n].measureTextRecursive(t);
              }

              return e;
            }, this.measureText = function (t) {
              var e = this.parent.style("font-family").getDefinition();

              if (null != e) {
                var n = this.parent.style("font-size").numValueOrDefault(s.Font.Parse(s.ctx.font).fontSize),
                    r = 0,
                    i = this.getText();
                e.isRTL && (i = i.split("").reverse().join(""));

                for (var o = s.ToNumberArray(this.parent.attribute("dx").value), a = 0; a < i.length; a++) {
                  r += (this.getGlyph(e, i, a).horizAdvX || e.horizAdvX) * n / e.fontFace.unitsPerEm, void 0 === o[a] || isNaN(o[a]) || (r += o[a]);
                }

                return r;
              }

              var u = s.compressSpaces(this.getText());
              if (!t.measureText) return 10 * u.length;
              t.save(), this.setContext(t, !0);
              var l = t.measureText(u).width;
              return t.restore(), l;
            }, this.getBoundingBox = function (t) {
              var e = this.parent.style("font-size").numValueOrDefault(s.Font.Parse(s.ctx.font).fontSize);
              return new s.BoundingBox(this.x, this.y - e, this.x + this.measureText(t), this.y);
            };
          }, s.Element.TextElementBase.prototype = new s.Element.RenderedElementBase(), s.Element.tspan = function (t) {
            this.captureTextNodes = !0, this.base = s.Element.TextElementBase, this.base(t), this.text = s.compressSpaces(t.value || t.text || t.textContent || ""), this.getText = function () {
              return 0 < this.children.length ? "" : this.text;
            };
          }, s.Element.tspan.prototype = new s.Element.TextElementBase(), s.Element.tref = function (t) {
            this.base = s.Element.TextElementBase, this.base(t), this.getText = function () {
              var t = this.getHrefAttribute().getDefinition();
              if (null != t) return t.children[0].getText();
            };
          }, s.Element.tref.prototype = new s.Element.TextElementBase(), s.Element.a = function (t) {
            this.base = s.Element.TextElementBase, this.base(t), this.hasText = 0 < t.childNodes.length;

            for (var e = 0; e < t.childNodes.length; e++) {
              3 != t.childNodes[e].nodeType && (this.hasText = !1);
            }

            this.text = this.hasText ? t.childNodes[0].value || t.childNodes[0].data : "", this.getText = function () {
              return this.text;
            }, this.baseRenderChildren = this.renderChildren, this.renderChildren = function (t) {
              if (this.hasText) {
                this.baseRenderChildren(t);
                var e = new s.Property("fontSize", s.Font.Parse(s.ctx.font).fontSize);
                s.Mouse.checkBoundingBox(this, new s.BoundingBox(this.x, this.y - e.toPixels("y"), this.x + this.measureText(t), this.y));
              } else if (0 < this.children.length) {
                var n = new s.Element.g();
                n.children = this.children, n.parent = this, n.render(t);
              }
            }, this.onclick = function () {
              r.open(this.getHrefAttribute().value);
            }, this.onmousemove = function () {
              s.ctx.canvas.style.cursor = "pointer";
            };
          }, s.Element.a.prototype = new s.Element.TextElementBase(), s.Element.textPath = function (t) {
            this.base = s.Element.TextElementBase, this.base(t);
            var e = this.getHrefAttribute().getDefinition();
            this.text = s.compressSpaces(t.value || t.text || t.textContent || ""), this.renderChildren = function (t) {
              this.setTextData(t), t.save();
              var e = this.parent.style("text-decoration").value,
                  n = this.fontSize(),
                  r = this.glyphInfo,
                  i = t.fillStyle;
              "underline" === e && t.beginPath();

              for (var o = 0; o < r.length; o++) {
                var a = r[o].p0,
                    u = r[o].p1,
                    l = r[o].text;
                t.save(), t.translate(a.x, a.y), t.rotate(r[o].rotation), "" != t.fillStyle && t.fillText(s.compressSpaces(l), 0, 0), "" != t.strokeStyle && t.strokeText(s.compressSpaces(l), 0, 0), t.restore(), "underline" === e && (0 === o && t.moveTo(a.x, a.y + n / 8), t.lineTo(u.x, u.y + n / 5));
              }

              "underline" === e && (t.lineWidth = n / 20, t.strokeStyle = i, t.stroke(), t.closePath()), t.restore();
            }, this.path = function (t) {
              var e = this.dataArray;
              null != t && t.beginPath();

              for (var n = 0; n < e.length; n++) {
                var r = e[n].command,
                    i = e[n].points;

                switch (r) {
                  case "L":
                    null != t && t.lineTo(i[0], i[1]);
                    break;

                  case "M":
                    null != t && t.moveTo(i[0], i[1]);
                    break;

                  case "C":
                    null != t && t.bezierCurveTo(i[0], i[1], i[2], i[3], i[4], i[5]);
                    break;

                  case "Q":
                    null != t && t.quadraticCurveTo(i[0], i[1], i[2], i[3]);
                    break;

                  case "A":
                    var o = i[0],
                        a = i[1],
                        s = i[2],
                        u = i[3],
                        l = i[4],
                        c = i[5],
                        h = i[6],
                        f = i[7],
                        p = u < s ? s : u,
                        d = u < s ? 1 : s / u,
                        v = u < s ? u / s : 1;
                    null != t && (t.translate(o, a), t.rotate(h), t.scale(d, v), t.arc(0, 0, p, l, l + c, 1 - f), t.scale(1 / d, 1 / v), t.rotate(-h), t.translate(-o, -a));
                    break;

                  case "z":
                    null != t && t.closePath();
                }
              }
            }, this.getText = function () {
              return this.text;
            }, this.fontSize = function () {
              return this.parent.style("font-size").numValueOrDefault(s.Font.Parse(s.ctx.font).fontSize);
            }, this.measureText = function (t, e) {
              var n = this.parent.style("font-family").getDefinition();

              if (e = e || this.getText(), null != n) {
                var r = this.fontSize(),
                    i = 0;
                n.isRTL && (e = e.split("").reverse().join(""));

                for (var o = s.ToNumberArray(this.parent.attribute("dx").value), a = 0; a < e.length; a++) {
                  i += (this.getGlyph(n, e, a).horizAdvX || n.horizAdvX) * r / n.fontFace.unitsPerEm, void 0 === o[a] || isNaN(o[a]) || (i += o[a]);
                }

                return i;
              }

              var u = s.compressSpaces(e);
              if (!t.measureText) return 10 * u.length;
              t.save(), this.setContext(t);
              var l = t.measureText(u).width;
              return t.restore(), l;
            }, this.setTextData = function (t) {
              if (!this.hasOwnProperty("glyphInfo")) {
                var e = this,
                    n = this.getText().split(""),
                    r = this.getText().split(" ").length - 1,
                    i = s.ToNumberArray(this.parent.attribute("dx").valueOrDefault("0")),
                    o = 0,
                    a = this.parent.style("text-anchor").valueOrDefault("start"),
                    u = this.style("letter-spacing"),
                    l = this.parent.style("letter-spacing");
                u.hasValue() && "inherit" !== u.getValue() ? u.hasValue() && "initial" !== u.getValue() && "unset" !== u.getValue() && (o = u.toPixels()) : o = l.toPixels(), this.letterSpacingCache = [];

                for (var c = 0; c < this.getText().length; c++) {
                  this.letterSpacingCache.push(void 0 !== i[c] ? i[c] : o);
                }

                var h = this.letterSpacingCache.reduce(function (t, e) {
                  return t + e || 0;
                }, 0);
                this.textWidth = this.measureText(t), this.textHeight = this.fontSize();
                var f = Math.max(this.textWidth + h, 0);
                this.glyphInfo = [];
                var p = this.getPathLength(),
                    d = this.style("startOffset").numValueOrDefault(0) * p,
                    v = 0;
                "middle" !== a && "center" !== a || (v = -f / 2), "end" !== a && "right" !== a || (v = -f), v += d;

                var y = function y(n, i) {
                  var o,
                      s = e.measureText(t, n);
                  " " === n && "justify" === a && f < p && (s += (p - f) / r), -1 < i && (v += (o = (o = i) || 0, e.letterSpacingCache[o] || 0));
                  var u = e.textHeight / 20,
                      l = {
                    p0: e.getEquidistantPointOnPath(v, u),
                    p1: e.getEquidistantPointOnPath(v + s, u)
                  };
                  return v += s, l;
                };

                for (c = 0; c < n.length; c++) {
                  var m = y(n[c], c);

                  if (void 0 !== m.p0 && void 0 !== m.p1) {
                    var g = e.getLineLength(m.p0.x, m.p0.y, m.p1.x, m.p1.y),
                        _ = e.getPointOnLine(0 + g / 2, m.p0.x, m.p0.y, m.p1.x, m.p1.y),
                        b = Math.atan2(m.p1.y - m.p0.y, m.p1.x - m.p0.x);

                    this.glyphInfo.push({
                      transposeX: _.x,
                      transposeY: _.y,
                      text: n[c],
                      rotation: b,
                      p0: m.p0,
                      p1: m.p1
                    });
                  }
                }
              }
            }, this.parsePathData = function (t) {
              if (this.pathLength = void 0, !t) return [];
              var e = [],
                  n = t.PathParser;

              for (n.reset(); !n.isEnd();) {
                var r = [],
                    i = null,
                    o = n.current ? n.current.x : 0,
                    a = n.current ? n.current.y : 0;
                n.nextCommand();
                var u = n.command.toUpperCase();

                switch (n.command) {
                  case "M":
                  case "m":
                    var l = n.getAsCurrentPoint();

                    for (r.push(l.x, l.y), n.start = n.current; !n.isCommandOrEnd();) {
                      l = n.getAsCurrentPoint(), r.push(l.x, l.y), i = "L";
                    }

                    break;

                  case "L":
                  case "l":
                    for (; !n.isCommandOrEnd();) {
                      l = n.getAsCurrentPoint(), r.push(l.x, l.y);
                    }

                    i = "L";
                    break;

                  case "H":
                  case "h":
                    for (; !n.isCommandOrEnd();) {
                      var c = new s.Point((n.isRelativeCommand() ? n.current.x : 0) + n.getScalar(), n.current.y);
                      r.push(c.x, c.y), n.current = c;
                    }

                    i = "L";
                    break;

                  case "V":
                  case "v":
                    for (; !n.isCommandOrEnd();) {
                      c = new s.Point(n.current.x, (n.isRelativeCommand() ? n.current.y : 0) + n.getScalar()), r.push(c.x, c.y), n.current = c;
                    }

                    i = "L";
                    break;

                  case "C":
                  case "c":
                    for (; !n.isCommandOrEnd();) {
                      var h = n.getPoint(),
                          f = n.getAsControlPoint(),
                          p = n.getAsCurrentPoint();
                      r.push(h.x, h.y, f.x, f.y, p.x, p.y);
                    }

                    break;

                  case "S":
                  case "s":
                    for (; !n.isCommandOrEnd();) {
                      h = n.getReflectedControlPoint(), f = n.getAsControlPoint(), p = n.getAsCurrentPoint(), r.push(h.x, h.y, f.x, f.y, p.x, p.y);
                    }

                    i = "C";
                    break;

                  case "Q":
                  case "q":
                    for (; !n.isCommandOrEnd();) {
                      f = n.getAsControlPoint(), p = n.getAsCurrentPoint(), r.push(f.x, f.y, p.x, p.y);
                    }

                    break;

                  case "T":
                  case "t":
                    for (; !n.isCommandOrEnd();) {
                      f = n.getReflectedControlPoint(), n.control = f, p = n.getAsCurrentPoint(), r.push(f.x, f.y, p.x, p.y);
                    }

                    i = "Q";
                    break;

                  case "A":
                  case "a":
                    for (; !n.isCommandOrEnd();) {
                      var d = n.current,
                          v = n.getScalar(),
                          y = n.getScalar(),
                          m = n.getScalar() * (Math.PI / 180),
                          g = n.getScalar(),
                          _ = n.getScalar(),
                          b = (p = n.getAsCurrentPoint(), new s.Point(Math.cos(m) * (d.x - p.x) / 2 + Math.sin(m) * (d.y - p.y) / 2, -Math.sin(m) * (d.x - p.x) / 2 + Math.cos(m) * (d.y - p.y) / 2)),
                          L = Math.pow(b.x, 2) / Math.pow(v, 2) + Math.pow(b.y, 2) / Math.pow(y, 2);

                      1 < L && (v *= Math.sqrt(L), y *= Math.sqrt(L));
                      var x = (g == _ ? -1 : 1) * Math.sqrt((Math.pow(v, 2) * Math.pow(y, 2) - Math.pow(v, 2) * Math.pow(b.y, 2) - Math.pow(y, 2) * Math.pow(b.x, 2)) / (Math.pow(v, 2) * Math.pow(b.y, 2) + Math.pow(y, 2) * Math.pow(b.x, 2)));
                      isNaN(x) && (x = 0);

                      var w = new s.Point(x * v * b.y / y, x * -y * b.x / v),
                          M = new s.Point((d.x + p.x) / 2 + Math.cos(m) * w.x - Math.sin(m) * w.y, (d.y + p.y) / 2 + Math.sin(m) * w.x + Math.cos(m) * w.y),
                          k = function k(t) {
                        return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2));
                      },
                          C = function C(t, e) {
                        return (t[0] * e[0] + t[1] * e[1]) / (k(t) * k(e));
                      },
                          E = function E(t, e) {
                        return (t[0] * e[1] < t[1] * e[0] ? -1 : 1) * Math.acos(C(t, e));
                      },
                          I = E([1, 0], [(b.x - w.x) / v, (b.y - w.y) / y]),
                          A = [(b.x - w.x) / v, (b.y - w.y) / y],
                          P = [(-b.x - w.x) / v, (-b.y - w.y) / y],
                          O = E(A, P);

                      C(A, P) <= -1 && (O = Math.PI), 1 <= C(A, P) && (O = 0), 0 === _ && 0 < O && (O -= 2 * Math.PI), 1 === _ && O < 0 && (O += 2 * Math.PI), r = [M.x, M.y, v, y, I, O, m, _];
                    }

                    break;

                  case "Z":
                  case "z":
                    n.current = n.start;
                }

                "Z" !== u ? e.push({
                  command: i || u,
                  points: r,
                  start: {
                    x: o,
                    y: a
                  },
                  pathLength: this.calcLength(o, a, i || u, r)
                }) : e.push({
                  command: "z",
                  points: [],
                  start: void 0,
                  pathLength: 0
                });
              }

              return e;
            }, this.getPathLength = function () {
              if (void 0 === this.pathLength || null === this.pathLength || isNaN(this.pathLength)) for (var t = this.pathLength = 0; t < this.dataArray.length; t++) {
                0 < this.dataArray[t].pathLength && (this.pathLength += this.dataArray[t].pathLength);
              }
              return this.pathLength;
            }, this.getPointOnPath = function (t) {
              var e = 0,
                  n = this.getPathLength(),
                  r = void 0;
              if (!(t < -5e-5 || n < t - 5e-5)) for (var i = 0; i < this.dataArray.length; i++) {
                var o = this.dataArray[i];

                if (!o || !(o.pathLength < 5e-5 || e + o.pathLength + 5e-5 < t)) {
                  var a = t - e,
                      s = void 0;

                  switch (o.command) {
                    case "L":
                      r = this.getPointOnLine(a, o.start.x, o.start.y, o.points[0], o.points[1], o.start.x, o.start.y);
                      break;

                    case "A":
                      var u = o.points[4],
                          l = o.points[5],
                          c = o.points[4] + l;
                      if (s = u + a / o.pathLength * l, l < 0 && s < c || 0 <= l && c < s) break;
                      r = this.getPointOnEllipticalArc(o.points[0], o.points[1], o.points[2], o.points[3], s, o.points[6]);
                      break;

                    case "C":
                      1 < (s = a / o.pathLength) && (s = 1), r = this.getPointOnCubicBezier(s, o.start.x, o.start.y, o.points[0], o.points[1], o.points[2], o.points[3], o.points[4], o.points[5]);
                      break;

                    case "Q":
                      1 < (s = a / o.pathLength) && (s = 1), r = this.getPointOnQuadraticBezier(s, o.start.x, o.start.y, o.points[0], o.points[1], o.points[2], o.points[3]);
                  }

                  if (void 0 !== r && r !== {}) return r;
                  break;
                }

                e += o.pathLength;
              }
            }, this.buildEquidistantCache = function (t, e) {
              var n = this.getPathLength();

              if (e = e || .25, t = t || n / 100, this.equidistantCache = this.equidistantCache || {}, !this.equidistantCache.hasOwnProperty("points") || this.equidistantCache.step != t || this.equidistantCache.precision != e) {
                this.equidistantCache = {
                  step: t,
                  precision: e,
                  points: []
                };

                for (var r = 0, i = 0; i <= n; i += e) {
                  var o = this.getPointOnPath(i),
                      a = this.getPointOnPath(i + e);
                  void 0 !== o && void 0 !== a && t <= (r += this.getLineLength(o.x, o.y, a.x, a.y)) && (this.equidistantCache.points.push({
                    x: o.x,
                    y: o.y,
                    distance: i
                  }), r -= t);
                }
              }
            }, this.getEquidistantPointOnPath = function (t, e, n) {
              if (this.buildEquidistantCache(e, n), !(t < 0 || 5e-5 < t - this.getPathLength())) {
                var r = Math.round(t / this.getPathLength() * (this.equidistantCache.points.length - 1));
                return this.equidistantCache.points[r] || void 0;
              }
            }, this.getLineLength = function (t, e, n, r) {
              return Math.sqrt((n - t) * (n - t) + (r - e) * (r - e));
            }, this.getPointOnLine = function (t, e, n, r, i, o, a) {
              void 0 === o && (o = e), void 0 === a && (a = n);
              var s = (i - n) / (r - e + 1e-8),
                  u = Math.sqrt(t * t / (1 + s * s));
              r < e && (u *= -1);
              var l,
                  c = s * u;
              if (r === e) l = {
                x: o,
                y: a + c
              };else if ((a - n) / (o - e + 1e-8) === s) l = {
                x: o + u,
                y: a + c
              };else {
                var h,
                    f,
                    p = this.getLineLength(e, n, r, i);
                if (p < 1e-8) return;
                var d = (o - e) * (r - e) + (a - n) * (i - n);
                h = e + (d /= p * p) * (r - e), f = n + d * (i - n);
                var v = this.getLineLength(o, a, h, f),
                    y = Math.sqrt(t * t - v * v);
                u = Math.sqrt(y * y / (1 + s * s)), r < e && (u *= -1), l = {
                  x: h + u,
                  y: f + (c = s * u)
                };
              }
              return l;
            }, this.getPointOnCubicBezier = function (t, e, n, r, i, o, a, s, u) {
              function l(t) {
                return t * t * t;
              }

              function c(t) {
                return 3 * t * t * (1 - t);
              }

              function h(t) {
                return 3 * t * (1 - t) * (1 - t);
              }

              function f(t) {
                return (1 - t) * (1 - t) * (1 - t);
              }

              return {
                x: s * l(t) + o * c(t) + r * h(t) + e * f(t),
                y: u * l(t) + a * c(t) + i * h(t) + n * f(t)
              };
            }, this.getPointOnQuadraticBezier = function (t, e, n, r, i, o, a) {
              function s(t) {
                return t * t;
              }

              function u(t) {
                return 2 * t * (1 - t);
              }

              function l(t) {
                return (1 - t) * (1 - t);
              }

              return {
                x: o * s(t) + r * u(t) + e * l(t),
                y: a * s(t) + i * u(t) + n * l(t)
              };
            }, this.getPointOnEllipticalArc = function (t, e, n, r, i, o) {
              var a = Math.cos(o),
                  s = Math.sin(o),
                  u = n * Math.cos(i),
                  l = r * Math.sin(i);
              return {
                x: t + (u * a - l * s),
                y: e + (u * s + l * a)
              };
            }, this.calcLength = function (t, e, n, r) {
              var i, o, a, s;

              switch (n) {
                case "L":
                  return this.getLineLength(t, e, r[0], r[1]);

                case "C":
                  for (i = 0, o = this.getPointOnCubicBezier(0, t, e, r[0], r[1], r[2], r[3], r[4], r[5]), s = .01; s <= 1; s += .01) {
                    a = this.getPointOnCubicBezier(s, t, e, r[0], r[1], r[2], r[3], r[4], r[5]), i += this.getLineLength(o.x, o.y, a.x, a.y), o = a;
                  }

                  return i;

                case "Q":
                  for (i = 0, o = this.getPointOnQuadraticBezier(0, t, e, r[0], r[1], r[2], r[3]), s = .01; s <= 1; s += .01) {
                    a = this.getPointOnQuadraticBezier(s, t, e, r[0], r[1], r[2], r[3]), i += this.getLineLength(o.x, o.y, a.x, a.y), o = a;
                  }

                  return i;

                case "A":
                  i = 0;
                  var u = r[4],
                      l = r[5],
                      c = r[4] + l,
                      h = Math.PI / 180;
                  if (Math.abs(u - c) < h && (h = Math.abs(u - c)), o = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], u, 0), l < 0) for (s = u - h; c < s; s -= h) {
                    a = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], s, 0), i += this.getLineLength(o.x, o.y, a.x, a.y), o = a;
                  } else for (s = u + h; s < c; s += h) {
                    a = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], s, 0), i += this.getLineLength(o.x, o.y, a.x, a.y), o = a;
                  }
                  return a = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], c, 0), i += this.getLineLength(o.x, o.y, a.x, a.y);
              }

              return 0;
            }, this.dataArray = this.parsePathData(e);
          }, s.Element.textPath.prototype = new s.Element.TextElementBase(), s.Element.image = function (t) {
            this.base = s.Element.RenderedElementBase, this.base(t);
            var e = this.getHrefAttribute().value;

            if ("" != e) {
              var n = e.match(/\.svg$/);
              if (s.Images.push(this), this.loaded = !1, n) this.img = s.ajax(e), this.loaded = !0;else {
                this.img = i.createElement("img"), 1 == s.opts.useCORS && (this.img.crossOrigin = "Anonymous");
                var r = this;
                this.img.onload = function () {
                  r.loaded = !0;
                }, this.img.onerror = function () {
                  s.log('ERROR: image "' + e + '" not found'), r.loaded = !0;
                }, this.img.src = e;
              }
              this.renderChildren = function (t) {
                var e = this.attribute("x").toPixels("x"),
                    i = this.attribute("y").toPixels("y"),
                    o = this.attribute("width").toPixels("x"),
                    a = this.attribute("height").toPixels("y");
                0 != o && 0 != a && (t.save(), n ? t.drawSvg(this.img, e, i, o, a) : (t.translate(e, i), s.AspectRatio(t, this.attribute("preserveAspectRatio").value, o, this.img.width, a, this.img.height, 0, 0), r.loaded && (void 0 === this.img.complete || this.img.complete) && t.drawImage(this.img, 0, 0)), t.restore());
              }, this.getBoundingBox = function () {
                var t = this.attribute("x").toPixels("x"),
                    e = this.attribute("y").toPixels("y"),
                    n = this.attribute("width").toPixels("x"),
                    r = this.attribute("height").toPixels("y");
                return new s.BoundingBox(t, e, t + n, e + r);
              };
            }
          }, s.Element.image.prototype = new s.Element.RenderedElementBase(), s.Element.g = function (t) {
            this.base = s.Element.RenderedElementBase, this.base(t), this.getBoundingBox = function (t) {
              for (var e = new s.BoundingBox(), n = 0; n < this.children.length; n++) {
                e.addBoundingBox(this.children[n].getBoundingBox(t));
              }

              return e;
            };
          }, s.Element.g.prototype = new s.Element.RenderedElementBase(), s.Element.symbol = function (t) {
            this.base = s.Element.RenderedElementBase, this.base(t), this.render = function () {};
          }, s.Element.symbol.prototype = new s.Element.RenderedElementBase(), s.ParseExternalUrl = function (t) {
            var e = t.match(/url\(('([^']+)'|"([^"]+)"|([^'"\)]+))\)/) || [];
            return e[2] || e[3] || e[4];
          }, s.Element.style = function (t) {
            this.base = s.Element.ElementBase, this.base(t);

            for (var e = "", n = 0; n < t.childNodes.length; n++) {
              e += t.childNodes[n].data;
            }

            e = e.replace(/(\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "");
            var r = (e = s.compressSpaces(e)).split("}");

            for (n = 0; n < r.length; n++) {
              if ("" != s.trim(r[n])) for (var i = r[n].split("{"), o = i[0].split(","), a = i[1].split(";"), u = 0; u < o.length; u++) {
                var l = s.trim(o[u]);

                if ("" != l) {
                  for (var c = s.Styles[l] || {}, h = 0; h < a.length; h++) {
                    var f = a[h].indexOf(":"),
                        p = a[h].substr(0, f),
                        d = a[h].substr(f + 1, a[h].length - f);
                    null != p && null != d && (c[s.trim(p)] = new s.Property(s.trim(p), s.trim(d)));
                  }

                  if (s.Styles[l] = c, s.StylesSpecificity[l] = v(l), "@font-face" == l) for (var y = c["font-family"].value.replace(/"/g, ""), m = c.src.value.split(","), g = 0; g < m.length; g++) {
                    if (0 < m[g].indexOf('format("svg")')) {
                      var _ = s.ParseExternalUrl(m[g]);

                      if (_) for (var b = s.parseXml(s.ajax(_)).getElementsByTagName("font"), L = 0; L < b.length; L++) {
                        var x = s.CreateElement(b[L]);
                        s.Definitions[y] = x;
                      }
                    }
                  }
                }
              }
            }
          }, s.Element.style.prototype = new s.Element.ElementBase(), s.Element.use = function (t) {
            this.base = s.Element.RenderedElementBase, this.base(t), this.baseSetContext = this.setContext, this.setContext = function (t) {
              this.baseSetContext(t), this.attribute("x").hasValue() && t.translate(this.attribute("x").toPixels("x"), 0), this.attribute("y").hasValue() && t.translate(0, this.attribute("y").toPixels("y"));
            };
            var e = this.getHrefAttribute().getDefinition();
            this.path = function (t) {
              null != e && e.path(t);
            }, this.elementTransform = function () {
              if (null != e && e.style("transform", !1, !0).hasValue()) return new s.Transform(e.style("transform", !1, !0).value);
            }, this.getBoundingBox = function (t) {
              if (null != e) return e.getBoundingBox(t);
            }, this.renderChildren = function (t) {
              if (null != e) {
                var n = e;
                "symbol" == e.type && ((n = new s.Element.svg()).type = "svg", n.attributes.viewBox = new s.Property("viewBox", e.attribute("viewBox").value), n.attributes.preserveAspectRatio = new s.Property("preserveAspectRatio", e.attribute("preserveAspectRatio").value), n.attributes.overflow = new s.Property("overflow", e.attribute("overflow").value), n.children = e.children), "svg" == n.type && (this.attribute("width").hasValue() && (n.attributes.width = new s.Property("width", this.attribute("width").value)), this.attribute("height").hasValue() && (n.attributes.height = new s.Property("height", this.attribute("height").value)));
                var r = n.parent;
                n.parent = null, n.render(t), n.parent = r;
              }
            };
          }, s.Element.use.prototype = new s.Element.RenderedElementBase(), s.Element.mask = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.apply = function (t, e) {
              var n = this.attribute("x").toPixels("x"),
                  r = this.attribute("y").toPixels("y"),
                  i = this.attribute("width").toPixels("x"),
                  a = this.attribute("height").toPixels("y");

              if (0 == i && 0 == a) {
                for (var u = new s.BoundingBox(), l = 0; l < this.children.length; l++) {
                  u.addBoundingBox(this.children[l].getBoundingBox(t));
                }

                n = Math.floor(u.x1), r = Math.floor(u.y1), i = Math.floor(u.width()), a = Math.floor(u.height());
              }

              var c = e.style("mask").value;
              e.style("mask").value = "";
              var h = o(n + i, r + a),
                  f = h.getContext("2d");
              s.SetDefaults(f), this.renderChildren(f), new s.Element.feColorMatrix({
                nodeType: 1,
                childNodes: [],
                attributes: [{
                  nodeName: "type",
                  value: "luminanceToAlpha"
                }, {
                  nodeName: "includeOpacity",
                  value: "true"
                }]
              }).apply(f, 0, 0, n + i, r + a);
              var p = o(n + i, r + a),
                  d = p.getContext("2d");
              s.SetDefaults(d), e.render(d), d.globalCompositeOperation = "destination-in", d.fillStyle = f.createPattern(h, "no-repeat"), d.fillRect(0, 0, n + i, r + a), t.fillStyle = d.createPattern(p, "no-repeat"), t.fillRect(0, 0, n + i, r + a), e.style("mask").value = c;
            }, this.render = function () {};
          }, s.Element.mask.prototype = new s.Element.ElementBase(), s.Element.clipPath = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.apply = function (t) {
              var e = "undefined" != typeof CanvasRenderingContext2D,
                  n = t.beginPath,
                  r = t.closePath;
              e && (CanvasRenderingContext2D.prototype.beginPath = function () {}, CanvasRenderingContext2D.prototype.closePath = function () {}), n.call(t);

              for (var i = 0; i < this.children.length; i++) {
                var o = this.children[i];

                if (void 0 !== o.path) {
                  var a = void 0 !== o.elementTransform && o.elementTransform();
                  !a && o.style("transform", !1, !0).hasValue() && (a = new s.Transform(o.style("transform", !1, !0).value)), a && a.apply(t), o.path(t), e && (CanvasRenderingContext2D.prototype.closePath = r), a && a.unapply(t);
                }
              }

              r.call(t), t.clip(), e && (CanvasRenderingContext2D.prototype.beginPath = n, CanvasRenderingContext2D.prototype.closePath = r);
            }, this.render = function () {};
          }, s.Element.clipPath.prototype = new s.Element.ElementBase(), s.Element.filter = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.apply = function (t, e) {
              var n = e.getBoundingBox(t),
                  r = Math.floor(n.x1),
                  i = Math.floor(n.y1),
                  a = Math.floor(n.width()),
                  u = Math.floor(n.height()),
                  l = e.style("filter").value;
              e.style("filter").value = "";

              for (var c = 0, h = 0, f = 0; f < this.children.length; f++) {
                var p = this.children[f].extraFilterDistance || 0;
                c = Math.max(c, p), h = Math.max(h, p);
              }

              var d = o(a + 2 * c, u + 2 * h),
                  v = d.getContext("2d");

              for (s.SetDefaults(v), v.translate(-r + c, -i + h), e.render(v), f = 0; f < this.children.length; f++) {
                "function" == typeof this.children[f].apply && this.children[f].apply(v, 0, 0, a + 2 * c, u + 2 * h);
              }

              t.drawImage(d, 0, 0, a + 2 * c, u + 2 * h, r - c, i - h, a + 2 * c, u + 2 * h), e.style("filter", !0).value = l;
            }, this.render = function () {};
          }, s.Element.filter.prototype = new s.Element.ElementBase(), s.Element.feDropShadow = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.addStylesFromStyleDefinition(), this.apply = function () {};
          }, s.Element.feDropShadow.prototype = new s.Element.ElementBase(), s.Element.feMorphology = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.apply = function () {};
          }, s.Element.feMorphology.prototype = new s.Element.ElementBase(), s.Element.feComposite = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.apply = function () {};
          }, s.Element.feComposite.prototype = new s.Element.ElementBase(), s.Element.feColorMatrix = function (t) {
            this.base = s.Element.ElementBase, this.base(t);
            var e = s.ToNumberArray(this.attribute("values").value);

            switch (this.attribute("type").valueOrDefault("matrix")) {
              case "saturate":
                var n = e[0];
                e = [.213 + .787 * n, .715 - .715 * n, .072 - .072 * n, 0, 0, .213 - .213 * n, .715 + .285 * n, .072 - .072 * n, 0, 0, .213 - .213 * n, .715 - .715 * n, .072 + .928 * n, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
                break;

              case "hueRotate":
                var r = e[0] * Math.PI / 180,
                    i = function i(t, e, n) {
                  return t + Math.cos(r) * e + Math.sin(r) * n;
                };

                e = [i(.213, .787, -.213), i(.715, -.715, -.715), i(.072, -.072, .928), 0, 0, i(.213, -.213, .143), i(.715, .285, .14), i(.072, -.072, -.283), 0, 0, i(.213, -.213, -.787), i(.715, -.715, .715), i(.072, .928, .072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
                break;

              case "luminanceToAlpha":
                e = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, .2125, .7154, .0721, 0, 0, 0, 0, 0, 0, 1];
            }

            function o(t, e, n, r, i, o) {
              return t[n * r * 4 + 4 * e + o];
            }

            function a(t, e, n, r, i, o, a) {
              t[n * r * 4 + 4 * e + o] = a;
            }

            function u(t, n) {
              var r = e[t];
              return r * (r < 0 ? n - 255 : n);
            }

            var l = this.attribute("includeOpacity").hasValue();

            this.apply = function (t, e, n, r, i) {
              var s = t.getImageData(0, 0, r, i);

              for (n = 0; n < i; n++) {
                for (e = 0; e < r; e++) {
                  var c = o(s.data, e, n, r, 0, 0),
                      h = o(s.data, e, n, r, 0, 1),
                      f = o(s.data, e, n, r, 0, 2),
                      p = o(s.data, e, n, r, 0, 3),
                      d = u(0, c) + u(1, h) + u(2, f) + u(3, p) + u(4, 1),
                      v = u(5, c) + u(6, h) + u(7, f) + u(8, p) + u(9, 1),
                      y = u(10, c) + u(11, h) + u(12, f) + u(13, p) + u(14, 1),
                      m = u(15, c) + u(16, h) + u(17, f) + u(18, p) + u(19, 1);
                  l && (d = v = y = 0, m *= p / 255), a(s.data, e, n, r, 0, 0, d), a(s.data, e, n, r, 0, 1, v), a(s.data, e, n, r, 0, 2, y), a(s.data, e, n, r, 0, 3, m);
                }
              }

              t.clearRect(0, 0, r, i), t.putImageData(s, 0, 0);
            };
          }, s.Element.feColorMatrix.prototype = new s.Element.ElementBase(), s.Element.feGaussianBlur = function (t) {
            this.base = s.Element.ElementBase, this.base(t), this.blurRadius = Math.floor(this.attribute("stdDeviation").numValue()), this.extraFilterDistance = this.blurRadius, this.apply = function (t, n, r, o, a) {
              e && void 0 !== e.canvasRGBA ? (t.canvas.id = s.UniqueId(), t.canvas.style.display = "none", i.body.appendChild(t.canvas), e.canvasRGBA(t.canvas, n, r, o, a, this.blurRadius), i.body.removeChild(t.canvas)) : s.log("ERROR: StackBlur.js must be included for blur to work");
            };
          }, s.Element.feGaussianBlur.prototype = new s.Element.ElementBase(), s.Element.title = function () {}, s.Element.title.prototype = new s.Element.ElementBase(), s.Element.desc = function () {}, s.Element.desc.prototype = new s.Element.ElementBase(), s.Element.MISSING = function (t) {
            s.log("ERROR: Element '" + t.nodeName + "' not yet implemented.");
          }, s.Element.MISSING.prototype = new s.Element.ElementBase(), s.CreateElement = function (t) {
            var e = t.nodeName.replace(/^[^:]+:/, "");
            e = e.replace(/\-/g, "");
            var n = null;
            return (n = void 0 !== s.Element[e] ? new s.Element[e](t) : new s.Element.MISSING(t)).type = t.nodeName, n;
          }, s.load = function (t, e) {
            s.loadXml(t, s.ajax(e));
          }, s.loadXml = function (t, e) {
            s.loadXmlDoc(t, s.parseXml(e));
          }, s.loadXmlDoc = function (t, e) {
            s.init(t);

            var n = function n(e) {
              for (var n = t.canvas; n;) {
                e.x -= n.offsetLeft, e.y -= n.offsetTop, n = n.offsetParent;
              }

              return r.scrollX && (e.x += r.scrollX), r.scrollY && (e.y += r.scrollY), e;
            };

            1 != s.opts.ignoreMouse && (t.canvas.onclick = function (t) {
              var e = n(new s.Point(null != t ? t.clientX : event.clientX, null != t ? t.clientY : event.clientY));
              s.Mouse.onclick(e.x, e.y);
            }, t.canvas.onmousemove = function (t) {
              var e = n(new s.Point(null != t ? t.clientX : event.clientX, null != t ? t.clientY : event.clientY));
              s.Mouse.onmousemove(e.x, e.y);
            });
            var i = s.CreateElement(e.documentElement);
            i.root = !0, i.addStylesFromStyleDefinition();

            var o = !0,
                a = function a() {
              s.ViewPort.Clear(), t.canvas.parentNode ? s.ViewPort.SetCurrent(t.canvas.parentNode.clientWidth, t.canvas.parentNode.clientHeight) : s.ViewPort.SetCurrent(800, 600), 1 != s.opts.ignoreDimensions && (o || null == s.opts.scaleWidth && null == s.opts.scaleHeight) && (i.style("width").hasValue() && (t.canvas.width = i.style("width").toPixels("x"), t.canvas.style && (t.canvas.style.width = t.canvas.width + "px")), i.style("height").hasValue() && (t.canvas.height = i.style("height").toPixels("y"), t.canvas.style && (t.canvas.style.height = t.canvas.height + "px")));
              var n = t.canvas.clientWidth || t.canvas.width,
                  r = t.canvas.clientHeight || t.canvas.height;

              if (1 == s.opts.ignoreDimensions && i.style("width").hasValue() && i.style("height").hasValue() && (n = i.style("width").toPixels("x"), r = i.style("height").toPixels("y")), s.ViewPort.SetCurrent(n, r), null != s.opts.offsetX && (i.attribute("x", !0).value = s.opts.offsetX), null != s.opts.offsetY && (i.attribute("y", !0).value = s.opts.offsetY), null != s.opts.scaleWidth || null != s.opts.scaleHeight) {
                var a = null,
                    u = null,
                    l = s.ToNumberArray(i.attribute("viewBox").value);
                null != s.opts.scaleWidth && (i.attribute("width").hasValue() ? a = i.attribute("width").toPixels("x") / s.opts.scaleWidth : isNaN(l[2]) || (a = l[2] / s.opts.scaleWidth)), null != s.opts.scaleHeight && (i.attribute("height").hasValue() ? u = i.attribute("height").toPixels("y") / s.opts.scaleHeight : isNaN(l[3]) || (u = l[3] / s.opts.scaleHeight)), null == a && (a = u), null == u && (u = a), i.attribute("width", !0).value = s.opts.scaleWidth, i.attribute("height", !0).value = s.opts.scaleHeight, i.style("transform", !0, !0).value += " scale(" + 1 / a + "," + 1 / u + ")";
              }

              1 != s.opts.ignoreClear && t.clearRect(0, 0, n, r), i.render(t), o && (o = !1, "function" == typeof s.opts.renderCallback && s.opts.renderCallback(e));
            },
                u = !0;

            s.ImagesLoaded() && (u = !1, a()), s.intervalID = setInterval(function () {
              var t = !1;
              if (u && s.ImagesLoaded() && (t = !(u = !1)), 1 != s.opts.ignoreMouse && (t = t || s.Mouse.hasEvents()), 1 != s.opts.ignoreAnimation) for (var e = 0; e < s.Animations.length; e++) {
                var n = s.Animations[e].update(1e3 / s.FRAMERATE);
                t = t || n;
              }
              "function" == typeof s.opts.forceRedraw && 1 == s.opts.forceRedraw() && (t = !0), t && (a(), s.Mouse.runEvents());
            }, 1e3 / s.FRAMERATE);
          }, s.stop = function () {
            s.intervalID && clearInterval(s.intervalID);
          }, s.Mouse = new function () {
            this.events = [], this.hasEvents = function () {
              return 0 != this.events.length;
            }, this.onclick = function (t, e) {
              this.events.push({
                type: "onclick",
                x: t,
                y: e,
                run: function run(t) {
                  t.onclick && t.onclick();
                }
              });
            }, this.onmousemove = function (t, e) {
              this.events.push({
                type: "onmousemove",
                x: t,
                y: e,
                run: function run(t) {
                  t.onmousemove && t.onmousemove();
                }
              });
            }, this.eventElements = [], this.checkPath = function (t, e) {
              for (var n = 0; n < this.events.length; n++) {
                var r = this.events[n];
                e.isPointInPath && e.isPointInPath(r.x, r.y) && (this.eventElements[n] = t);
              }
            }, this.checkBoundingBox = function (t, e) {
              if (e) for (var n = 0; n < this.events.length; n++) {
                var r = this.events[n];
                e.isPointInBox(r.x, r.y) && (this.eventElements[n] = t);
              }
            }, this.runEvents = function () {
              s.ctx.canvas.style.cursor = "";

              for (var t = 0; t < this.events.length; t++) {
                for (var e = this.events[t], n = this.eventElements[t]; n;) {
                  e.run(n), n = n.parent;
                }
              }

              this.events = [], this.eventElements = [];
            };
          }(), s;
        }

        "undefined" != typeof CanvasRenderingContext2D && (CanvasRenderingContext2D.prototype.drawSvg = function (t, e, n, r, i, o) {
          var a = {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0,
            ignoreClear: !0,
            offsetX: e,
            offsetY: n,
            scaleWidth: r,
            scaleHeight: i
          };

          for (var u in o) {
            o.hasOwnProperty(u) && (a[u] = o[u]);
          }

          s(this.canvas, t, a);
        }), s._build = y, n.exports = s;
      }(n = {
        exports: {}
      }), n.exports;
    }(n(333), n(334));
  }, function (t, e) {
    t.exports = function (t) {
      this.ok = !1, this.alpha = 1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = (t = t.replace(/ /g, "")).toLowerCase();
      var e = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
      };
      t = e[t] || t;

      for (var n = [{
        re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
        example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
        process: function process(t) {
          return [parseInt(t[1]), parseInt(t[2]), parseInt(t[3]), parseFloat(t[4])];
        }
      }, {
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        process: function process(t) {
          return [parseInt(t[1]), parseInt(t[2]), parseInt(t[3])];
        }
      }, {
        re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        example: ["#00ff00", "336699"],
        process: function process(t) {
          return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)];
        }
      }, {
        re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        example: ["#fb0", "f0f"],
        process: function process(t) {
          return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16)];
        }
      }], r = 0; r < n.length; r++) {
        var i = n[r].re,
            o = n[r].process,
            a = i.exec(t);

        if (a) {
          var s = o(a);
          this.r = s[0], this.g = s[1], this.b = s[2], s.length > 3 && (this.alpha = s[3]), this.ok = !0;
        }
      }

      this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function () {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
      }, this.toRGBA = function () {
        return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
      }, this.toHex = function () {
        var t = this.r.toString(16),
            e = this.g.toString(16),
            n = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
      }, this.getHelpXML = function () {
        for (var t = new Array(), r = 0; r < n.length; r++) {
          for (var i = n[r].example, o = 0; o < i.length; o++) {
            t[t.length] = i[o];
          }
        }

        for (var a in e) {
          t[t.length] = a;
        }

        var s = document.createElement("ul");
        s.setAttribute("id", "rgbcolor-examples");

        for (r = 0; r < t.length; r++) {
          try {
            var u = document.createElement("li"),
                l = new RGBColor(t[r]),
                c = document.createElement("div");
            c.style.cssText = "margin: 3px; border: 1px solid black; background:" + l.toHex() + "; color:" + l.toHex(), c.appendChild(document.createTextNode("test"));
            var h = document.createTextNode(" " + t[r] + " -> " + l.toRGB() + " -> " + l.toHex());
            u.appendChild(c), u.appendChild(h), s.appendChild(u);
          } catch (t) {}
        }

        return s;
      };
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      "@babel/helpers - typeof";

      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    n.r(e), n.d(e, "BlurStack", function () {
      return f;
    }), n.d(e, "canvasRGB", function () {
      return c;
    }), n.d(e, "canvasRGBA", function () {
      return u;
    }), n.d(e, "image", function () {
      return a;
    }), n.d(e, "imageDataRGB", function () {
      return h;
    }), n.d(e, "imageDataRGBA", function () {
      return l;
    });
    var i = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259],
        o = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];

    function a(t, e, n, r) {
      if ("string" == typeof t && (t = document.getElementById(t)), t && "naturalWidth" in t) {
        var i = t.naturalWidth,
            o = t.naturalHeight;

        if ("string" == typeof e && (e = document.getElementById(e)), e && "getContext" in e) {
          e.style.width = i + "px", e.style.height = o + "px", e.width = i, e.height = o;
          var a = e.getContext("2d");
          a.clearRect(0, 0, i, o), a.drawImage(t, 0, 0), isNaN(n) || n < 1 || (r ? u(e, 0, 0, i, o, n) : c(e, 0, 0, i, o, n));
        }
      }
    }

    function s(t, e, n, i, o) {
      if ("string" == typeof t && (t = document.getElementById(t)), !(t && "object" === r(t) && "getContext" in t)) throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
      var a = t.getContext("2d");

      try {
        return a.getImageData(e, n, i, o);
      } catch (t) {
        throw new Error("unable to access image data: " + t);
      }
    }

    function u(t, e, n, r, i, o) {
      if (!(isNaN(o) || o < 1)) {
        o |= 0;
        var a = s(t, e, n, r, i);
        a = l(a, e, n, r, i, o), t.getContext("2d").putImageData(a, e, n);
      }
    }

    function l(t, e, n, r, a, s) {
      var u,
          l,
          c,
          h,
          p,
          d,
          v,
          y,
          m,
          g,
          _,
          b,
          L,
          x,
          w,
          M,
          k,
          C,
          E,
          I,
          A,
          P,
          O,
          T,
          S,
          D = t.data,
          j = 2 * s + 1,
          N = r - 1,
          z = a - 1,
          B = s + 1,
          R = B * (B + 1) / 2,
          G = new f(),
          Z = G;

      for (c = 1; c < j; c++) {
        Z = Z.next = new f(), c === B && (S = Z);
      }

      Z.next = G;
      var U = null,
          V = null;
      v = d = 0;
      var K = i[s],
          H = o[s];

      for (l = 0; l < a; l++) {
        for (M = k = C = E = y = m = g = _ = 0, b = B * (I = D[d]), L = B * (A = D[d + 1]), x = B * (P = D[d + 2]), w = B * (O = D[d + 3]), y += R * I, m += R * A, g += R * P, _ += R * O, Z = G, c = 0; c < B; c++) {
          Z.r = I, Z.g = A, Z.b = P, Z.a = O, Z = Z.next;
        }

        for (c = 1; c < B; c++) {
          h = d + ((N < c ? N : c) << 2), y += (Z.r = I = D[h]) * (T = B - c), m += (Z.g = A = D[h + 1]) * T, g += (Z.b = P = D[h + 2]) * T, _ += (Z.a = O = D[h + 3]) * T, M += I, k += A, C += P, E += O, Z = Z.next;
        }

        for (U = G, V = S, u = 0; u < r; u++) {
          D[d + 3] = O = _ * K >> H, 0 !== O ? (O = 255 / O, D[d] = (y * K >> H) * O, D[d + 1] = (m * K >> H) * O, D[d + 2] = (g * K >> H) * O) : D[d] = D[d + 1] = D[d + 2] = 0, y -= b, m -= L, g -= x, _ -= w, b -= U.r, L -= U.g, x -= U.b, w -= U.a, h = v + ((h = u + s + 1) < N ? h : N) << 2, y += M += U.r = D[h], m += k += U.g = D[h + 1], g += C += U.b = D[h + 2], _ += E += U.a = D[h + 3], U = U.next, b += I = V.r, L += A = V.g, x += P = V.b, w += O = V.a, M -= I, k -= A, C -= P, E -= O, V = V.next, d += 4;
        }

        v += r;
      }

      for (u = 0; u < r; u++) {
        for (k = C = E = M = m = g = _ = y = 0, b = B * (I = D[d = u << 2]), L = B * (A = D[d + 1]), x = B * (P = D[d + 2]), w = B * (O = D[d + 3]), y += R * I, m += R * A, g += R * P, _ += R * O, Z = G, c = 0; c < B; c++) {
          Z.r = I, Z.g = A, Z.b = P, Z.a = O, Z = Z.next;
        }

        for (p = r, c = 1; c <= s; c++) {
          d = p + u << 2, y += (Z.r = I = D[d]) * (T = B - c), m += (Z.g = A = D[d + 1]) * T, g += (Z.b = P = D[d + 2]) * T, _ += (Z.a = O = D[d + 3]) * T, M += I, k += A, C += P, E += O, Z = Z.next, c < z && (p += r);
        }

        for (d = u, U = G, V = S, l = 0; l < a; l++) {
          D[(h = d << 2) + 3] = O = _ * K >> H, O > 0 ? (O = 255 / O, D[h] = (y * K >> H) * O, D[h + 1] = (m * K >> H) * O, D[h + 2] = (g * K >> H) * O) : D[h] = D[h + 1] = D[h + 2] = 0, y -= b, m -= L, g -= x, _ -= w, b -= U.r, L -= U.g, x -= U.b, w -= U.a, h = u + ((h = l + B) < z ? h : z) * r << 2, y += M += U.r = D[h], m += k += U.g = D[h + 1], g += C += U.b = D[h + 2], _ += E += U.a = D[h + 3], U = U.next, b += I = V.r, L += A = V.g, x += P = V.b, w += O = V.a, M -= I, k -= A, C -= P, E -= O, V = V.next, d += r;
        }
      }

      return t;
    }

    function c(t, e, n, r, i, o) {
      if (!(isNaN(o) || o < 1)) {
        o |= 0;
        var a = s(t, e, n, r, i);
        a = h(a, e, n, r, i, o), t.getContext("2d").putImageData(a, e, n);
      }
    }

    function h(t, e, n, r, a, s) {
      var u,
          l,
          c,
          h,
          p,
          d,
          v,
          y,
          m,
          g,
          _,
          b,
          L,
          x,
          w,
          M,
          k,
          C,
          E,
          I,
          A,
          P = t.data,
          O = 2 * s + 1,
          T = r - 1,
          S = a - 1,
          D = s + 1,
          j = D * (D + 1) / 2,
          N = new f(),
          z = N;

      for (c = 1; c < O; c++) {
        z = z.next = new f(), c === D && (A = z);
      }

      z.next = N;
      var B = null,
          R = null;
      v = d = 0;
      var G = i[s],
          Z = o[s];

      for (l = 0; l < a; l++) {
        for (x = w = M = y = m = g = 0, _ = D * (k = P[d]), b = D * (C = P[d + 1]), L = D * (E = P[d + 2]), y += j * k, m += j * C, g += j * E, z = N, c = 0; c < D; c++) {
          z.r = k, z.g = C, z.b = E, z = z.next;
        }

        for (c = 1; c < D; c++) {
          h = d + ((T < c ? T : c) << 2), y += (z.r = k = P[h]) * (I = D - c), m += (z.g = C = P[h + 1]) * I, g += (z.b = E = P[h + 2]) * I, x += k, w += C, M += E, z = z.next;
        }

        for (B = N, R = A, u = 0; u < r; u++) {
          P[d] = y * G >> Z, P[d + 1] = m * G >> Z, P[d + 2] = g * G >> Z, y -= _, m -= b, g -= L, _ -= B.r, b -= B.g, L -= B.b, h = v + ((h = u + s + 1) < T ? h : T) << 2, y += x += B.r = P[h], m += w += B.g = P[h + 1], g += M += B.b = P[h + 2], B = B.next, _ += k = R.r, b += C = R.g, L += E = R.b, x -= k, w -= C, M -= E, R = R.next, d += 4;
        }

        v += r;
      }

      for (u = 0; u < r; u++) {
        for (w = M = x = m = g = y = 0, _ = D * (k = P[d = u << 2]), b = D * (C = P[d + 1]), L = D * (E = P[d + 2]), y += j * k, m += j * C, g += j * E, z = N, c = 0; c < D; c++) {
          z.r = k, z.g = C, z.b = E, z = z.next;
        }

        for (p = r, c = 1; c <= s; c++) {
          d = p + u << 2, y += (z.r = k = P[d]) * (I = D - c), m += (z.g = C = P[d + 1]) * I, g += (z.b = E = P[d + 2]) * I, x += k, w += C, M += E, z = z.next, c < S && (p += r);
        }

        for (d = u, B = N, R = A, l = 0; l < a; l++) {
          P[h = d << 2] = y * G >> Z, P[h + 1] = m * G >> Z, P[h + 2] = g * G >> Z, y -= _, m -= b, g -= L, _ -= B.r, b -= B.g, L -= B.b, h = u + ((h = l + D) < S ? h : S) * r << 2, y += x += B.r = P[h], m += w += B.g = P[h + 1], g += M += B.b = P[h + 2], B = B.next, _ += k = R.r, b += C = R.g, L += E = R.b, x -= k, w -= C, M -= E, R = R.next, d += r;
        }
      }

      return t;
    }

    var f = function t() {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
    };
  }, function (t, e) {
    /*!
    Copyright (C) 2015 by Andrea Giammarchi @WebReflection
    
    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:
    
    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.
    
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.
    
    */
    var n = function (t) {
      "use strict";

      var e = typeof e,
          n = typeof Symbol !== e,
          r = n && !!Symbol.hasInstance,
          i = 0,
          o = n ? Symbol : function (t) {
        return "@@:" + ++i + ":" + t + Math.random();
      },
          a = o("mixin:init"),
          s = t.hasOwnProperty,
          u = t.defineProperty || function (t, e, n) {
        t[e] = n.value;
      },
          l = t.getOwnPropertyNames || t.keys || function (t, e, n) {
        for (n in e = [], t) {
          s.call(t, n) && e.push(n);
        }

        return e;
      },
          c = t.getOwnPropertyDescriptor || function (t, e) {
        return {
          value: t[e]
        };
      },
          h = t.getOwnPropertySymbols || function () {
        return [];
      },
          f = typeof Reflect !== e && Reflect.ownKeys ? Reflect.ownKeys : function (t) {
        return l(t).concat(h(t));
      },
          p = r && {
        value: !0
      },
          d = {
        value: function value() {
          for (var t = this[a], e = 0, n = t.length; e < n; e++) {
            if (void 0 !== t[e].apply(this, arguments)) throw new Error("mixin.init() must not return a value");
          }
        }
      };

      return function (t, e) {
        var n = f(t),
            i = r && o("isa");

        function l(e) {
          for (var o, l, h = e.prototype || e, f = 0, v = n.length; f < v; f++) {
            "init" === (o = n[f]) ? (s.call(h, a) || (u(h, a, {
              value: a in h ? (h[a] || []).slice(0) : []
            }), u(h, o, d)), h[a].push(t[o])) : s.call(h, o) || ((l = c(t, o)).enumerable = !1, u(h, o, l));
          }

          return r && u(h, i, p), e;
        }

        e && function (t, e) {
          for (var n, r, i = f(e), o = 0, a = i.length; o < a; o++) {
            (r = c(e, n = i[o])).configurable = !1, s.call(r, "writable") && (r.writable = !1), u(t, n, r);
          }
        }(l, e), r && u(l, Symbol.hasInstance, {
          value: function value(t) {
            return !!t[i];
          }
        });

        for (var h, v, y = 0, m = n.length; y < m; y++) {
          h = n[y], v = c(t, h), s.call(v, "value") && "function" == typeof v.value && u(l, h, v);
        }

        return l;
      };
    }(Object);

    t.exports = n;
  }, function (t, e, n) {
    var r = n(337),
        i = n(155);

    t.exports = function (t, e) {
      return null != t && i(t, e, r);
    };
  }, function (t, e) {
    var n = Object.prototype.hasOwnProperty;

    t.exports = function (t, e) {
      return null != t && n.call(t, e);
    };
  }, function (t, e, n) {
    var r = n(171),
        i = n(178)(function (t, e, n) {
      r(t, e, n);
    });
    t.exports = i;
  }, function (t, e, n) {
    var r = n(172),
        i = n(340),
        o = n(341),
        a = n(343),
        s = n(344),
        u = n(64),
        l = n(8),
        c = n(175),
        h = n(65),
        f = n(91),
        p = n(17),
        d = n(346),
        v = n(67),
        y = n(176),
        m = n(347);

    t.exports = function (t, e, n, g, _, b, L) {
      var x = y(t, n),
          w = y(e, n),
          M = L.get(w);
      if (M) r(t, n, M);else {
        var k = b ? b(x, w, n + "", t, e, L) : void 0,
            C = void 0 === k;

        if (C) {
          var E = l(w),
              I = !E && h(w),
              A = !E && !I && v(w);
          k = w, E || I || A ? l(x) ? k = x : c(x) ? k = a(x) : I ? (C = !1, k = i(w, !0)) : A ? (C = !1, k = o(w, !0)) : k = [] : d(w) || u(w) ? (k = x, u(x) ? k = m(x) : p(x) && !f(x) || (k = s(w))) : C = !1;
        }

        C && (L.set(w, k), _(k, w, g, b, L), L.delete(w)), r(t, n, k);
      }
    };
  }, function (t, e, n) {
    (function (t) {
      var r = n(15),
          i = e && !e.nodeType && e,
          o = i && "object" == typeof t && t && !t.nodeType && t,
          a = o && o.exports === i ? r.Buffer : void 0,
          s = a ? a.allocUnsafe : void 0;

      t.exports = function (t, e) {
        if (e) return t.slice();
        var n = t.length,
            r = s ? s(n) : new t.constructor(n);
        return t.copy(r), r;
      };
    }).call(this, n(93)(t));
  }, function (t, e, n) {
    var r = n(342);

    t.exports = function (t, e) {
      var n = e ? r(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    };
  }, function (t, e, n) {
    var r = n(148);

    t.exports = function (t) {
      var e = new t.constructor(t.byteLength);
      return new r(e).set(new r(t)), e;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = -1,
          r = t.length;

      for (e || (e = Array(r)); ++n < r;) {
        e[n] = t[n];
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(345),
        i = n(174),
        o = n(68);

    t.exports = function (t) {
      return "function" != typeof t.constructor || o(t) ? {} : r(i(t));
    };
  }, function (t, e, n) {
    var r = n(17),
        i = Object.create,
        o = function () {
      function t() {}

      return function (e) {
        if (!r(e)) return {};
        if (i) return i(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();

    t.exports = o;
  }, function (t, e, n) {
    var r = n(27),
        i = n(174),
        o = n(23),
        a = "[object Object]",
        s = Function.prototype,
        u = Object.prototype,
        l = s.toString,
        c = u.hasOwnProperty,
        h = l.call(Object);

    t.exports = function (t) {
      if (!o(t) || r(t) != a) return !1;
      var e = i(t);
      if (null === e) return !0;
      var n = c.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && l.call(n) == h;
    };
  }, function (t, e, n) {
    var r = n(348),
        i = n(177);

    t.exports = function (t) {
      return r(t, i(t));
    };
  }, function (t, e, n) {
    var r = n(349),
        i = n(109);

    t.exports = function (t, e, n, o) {
      var a = !n;
      n || (n = {});

      for (var s = -1, u = e.length; ++s < u;) {
        var l = e[s],
            c = o ? o(n[l], t[l], l, n, t) : void 0;
        void 0 === c && (c = t[l]), a ? i(n, l, c) : r(n, l, c);
      }

      return n;
    };
  }, function (t, e, n) {
    var r = n(109),
        i = n(48),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t, e, n) {
      var a = t[e];
      o.call(t, e) && i(a, n) && (void 0 !== n || e in t) || r(t, e, n);
    };
  }, function (t, e, n) {
    var r = n(17),
        i = n(68),
        o = n(351),
        a = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!r(t)) return o(t);
      var e = i(t),
          n = [];

      for (var s in t) {
        ("constructor" != s || !e && a.call(t, s)) && n.push(s);
      }

      return n;
    };
  }, function (t, e) {
    t.exports = function (t) {
      var e = [];
      if (null != t) for (var n in Object(t)) {
        e.push(n);
      }
      return e;
    };
  }, function (t, e, n) {
    var r = n(353),
        i = Math.max;

    t.exports = function (t, e, n) {
      return e = i(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var o = arguments, a = -1, s = i(o.length - e, 0), u = Array(s); ++a < s;) {
          u[a] = o[e + a];
        }

        a = -1;

        for (var l = Array(e + 1); ++a < e;) {
          l[a] = o[a];
        }

        return l[e] = n(u), r(t, this, l);
      };
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);

        case 1:
          return t.call(e, n[0]);

        case 2:
          return t.call(e, n[0], n[1]);

        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }

      return t.apply(e, n);
    };
  }, function (t, e, n) {
    var r = n(355),
        i = n(357)(r);
    t.exports = i;
  }, function (t, e, n) {
    var r = n(356),
        i = n(173),
        o = n(73),
        a = i ? function (t, e) {
      return i(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: r(e),
        writable: !0
      });
    } : o;
    t.exports = a;
  }, function (t, e) {
    t.exports = function (t) {
      return function () {
        return t;
      };
    };
  }, function (t, e) {
    var n = 800,
        r = 16,
        i = Date.now;

    t.exports = function (t) {
      var e = 0,
          o = 0;
      return function () {
        var a = i(),
            s = r - (a - o);

        if (o = a, s > 0) {
          if (++e >= n) return arguments[0];
        } else e = 0;

        return t.apply(void 0, arguments);
      };
    };
  }, function (t, e, n) {
    var r = n(48),
        i = n(22),
        o = n(66),
        a = n(17);

    t.exports = function (t, e, n) {
      if (!a(n)) return !1;
      var s = typeof e;
      return !!("number" == s ? i(n) && o(e, n.length) : "string" == s && e in n) && r(n[e], t);
    };
  }, function (t, e, n) {
    var r = n(171),
        i = n(178)(function (t, e, n, i) {
      r(t, e, n, i);
    });
    t.exports = i;
  }, function (t, e, n) {
    var r = n(17),
        i = n(361),
        o = n(138),
        a = "Expected a function",
        s = Math.max,
        u = Math.min;

    t.exports = function (t, e, n) {
      var l,
          c,
          h,
          f,
          p,
          d,
          v = 0,
          y = !1,
          m = !1,
          g = !0;
      if ("function" != typeof t) throw new TypeError(a);

      function _(e) {
        var n = l,
            r = c;
        return l = c = void 0, v = e, f = t.apply(r, n);
      }

      function b(t) {
        var n = t - d;
        return void 0 === d || n >= e || n < 0 || m && t - v >= h;
      }

      function L() {
        var t = i();
        if (b(t)) return x(t);
        p = setTimeout(L, function (t) {
          var n = e - (t - d);
          return m ? u(n, h - (t - v)) : n;
        }(t));
      }

      function x(t) {
        return p = void 0, g && l ? _(t) : (l = c = void 0, f);
      }

      function w() {
        var t = i(),
            n = b(t);

        if (l = arguments, c = this, d = t, n) {
          if (void 0 === p) return function (t) {
            return v = t, p = setTimeout(L, e), y ? _(t) : f;
          }(d);
          if (m) return clearTimeout(p), p = setTimeout(L, e), _(d);
        }

        return void 0 === p && (p = setTimeout(L, e)), f;
      }

      return e = o(e) || 0, r(n) && (y = !!n.leading, h = (m = "maxWait" in n) ? s(o(n.maxWait) || 0, e) : h, g = "trailing" in n ? !!n.trailing : g), w.cancel = function () {
        void 0 !== p && clearTimeout(p), v = 0, l = d = c = p = void 0;
      }, w.flush = function () {
        return void 0 === p ? f : x(i());
      }, w;
    };
  }, function (t, e, n) {
    var r = n(15);

    t.exports = function () {
      return r.Date.now();
    };
  }, function (t, e, n) {
    var r = n(363)(n(110));
    t.exports = r;
  }, function (t, e, n) {
    var r = n(47),
        i = n(22),
        o = n(46);

    t.exports = function (t) {
      return function (e, n, a) {
        var s = Object(e);

        if (!i(e)) {
          var u = r(n, 3);
          e = o(e), n = function n(t) {
            return u(s[t], t, s);
          };
        }

        var l = t(e, n, a);
        return l > -1 ? s[u ? e[l] : l] : void 0;
      };
    };
  }, function (t, e, n) {
    n(365), t.exports = n(3).Object.getPrototypeOf;
  }, function (t, e, n) {
    var r = n(38),
        i = n(122);
    n(111)("getPrototypeOf", function () {
      return function (t) {
        return i(r(t));
      };
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(367),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(368);
    var r = n(3).Object;

    t.exports = function (t, e) {
      return r.getOwnPropertyDescriptor(t, e);
    };
  }, function (t, e, n) {
    var r = n(32),
        i = n(108).f;
    n(111)("getOwnPropertyDescriptor", function () {
      return function (t, e) {
        return i(r(t), e);
      };
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(370),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(371), t.exports = n(3).Object.setPrototypeOf;
  }, function (t, e, n) {
    var r = n(11);
    r(r.S, "Object", {
      setPrototypeOf: n(372).set
    });
  }, function (t, e, n) {
    var r = n(26),
        i = n(20),
        o = function o(t, e) {
      if (i(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
    };

    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
        try {
          (r = n(37)(Function.call, n(108).f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }

        return function (t, n) {
          return o(t, n), e ? t.__proto__ = n : r(t, n), t;
        };
      }({}, !1) : void 0),
      check: o
    };
  }, function (t, e, n) {
    var r = n(102),
        i = n(22);

    t.exports = function (t, e) {
      var n = -1,
          o = i(t) ? Array(t.length) : [];
      return r(t, function (t, r, i) {
        o[++n] = e(t, r, i);
      }), o;
    };
  }, function (t, e, n) {
    var r = n(154),
        i = n(375),
        o = n(376),
        a = n(377),
        s = n(378),
        u = n(153),
        l = /^\s+|\s+$/g;

    t.exports = function (t, e, n) {
      if ((t = u(t)) && (n || void 0 === e)) return t.replace(l, "");
      if (!t || !(e = r(e))) return t;
      var c = s(t),
          h = s(e),
          f = a(c, h),
          p = o(c, h) + 1;
      return i(c, f, p).join("");
    };
  }, function (t, e, n) {
    var r = n(156);

    t.exports = function (t, e, n) {
      var i = t.length;
      return n = void 0 === n ? i : n, !e && n >= i ? t : r(t, e, n);
    };
  }, function (t, e, n) {
    var r = n(60);

    t.exports = function (t, e) {
      for (var n = t.length; n-- && r(e, t[n], 0) > -1;) {
        ;
      }

      return n;
    };
  }, function (t, e, n) {
    var r = n(60);

    t.exports = function (t, e) {
      for (var n = -1, i = t.length; ++n < i && r(e, t[n], 0) > -1;) {
        ;
      }

      return n;
    };
  }, function (t, e, n) {
    var r = n(379),
        i = n(380),
        o = n(381);

    t.exports = function (t) {
      return i(t) ? o(t) : r(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t.split("");
    };
  }, function (t, e) {
    var n = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

    t.exports = function (t) {
      return n.test(t);
    };
  }, function (t, e) {
    var n = "[\\ud800-\\udfff]",
        r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        i = "\\ud83c[\\udffb-\\udfff]",
        o = "[^\\ud800-\\udfff]",
        a = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        s = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        u = "(?:" + r + "|" + i + ")" + "?",
        l = "[\\ufe0e\\ufe0f]?" + u + ("(?:\\u200d(?:" + [o, a, s].join("|") + ")[\\ufe0e\\ufe0f]?" + u + ")*"),
        c = "(?:" + [o + r + "?", r, a, s, n].join("|") + ")",
        h = RegExp(i + "(?=" + i + ")|" + c + l, "g");

    t.exports = function (t) {
      return t.match(h) || [];
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r,
        i = l(n(7)),
        o = l(n(0)),
        a = l(n(1)),
        s = l(n(52)),
        u = l(n(34));

    function l(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var c = (0, l(n(18)).default)(r = function () {
      function t(e, n, r) {
        (0, o.default)(this, t), this._props = r, this._tileProp = (0, i.default)({
          zIndex: 3,
          opacity: .5,
          tileSize: 256,
          visible: !0
        }, r, {
          source: n
        }), this._name = e;
      }

      return (0, a.default)(t, [{
        key: "setMap",
        value: function value(t) {
          null != t ? (this._layer = t.map.createTileLayer(this._tileProp, this._tileProp.source, this._name), this.setEventContext(this.layer)) : this.remove();
        }
      }, {
        key: "remove",
        value: function value() {
          this._layer.remove();
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._tileProp.visible = void 0 !== t ? t : !this._tileProp.visible, this._layer.toggle(this._tileProp.visible);
        }
      }, {
        key: "show",
        value: function value() {
          this.toggle(!0);
        }
      }, {
        key: "hide",
        value: function value() {
          this.toggle(!1);
        }
      }, {
        key: "receiveProps",
        value: function value(t) {
          var e = this,
              n = {
            opacity: this.setOpacity,
            zIndex: this.setZIndex,
            source: this.setSource,
            visible: this.toggle
          };
          (0, u.default)(t, function (r, i) {
            (0, s.default)(r, e._tileProp[i]) || n[i] && n[i].call(e, t[i]);
          });
        }
      }, {
        key: "setOpacity",
        value: function value(t) {
          this._layer && this._layer.setOpacity(t), this._tileProp.opacity = t;
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._layer && this._layer.setZIndex(t), this._tileProp.zIndex = t;
        }
      }, {
        key: "setSource",
        value: function value(t) {
          this._layer && this._layer.setSource(t), this._tileProp.source = t;
        }
      }, {
        key: "props",
        get: function get() {
          return this._tileProp;
        }
      }, {
        key: "name",
        get: function get() {
          return this._name;
        }
      }, {
        key: "tileSize",
        get: function get() {
          return this._tileProp.tileSize;
        }
      }, {
        key: "url",
        get: function get() {
          return this._tileProp.source;
        }
      }, {
        key: "layer",
        get: function get() {
          return this._layer;
        }
      }]), t;
    }()) || r;
    e.default = c;
  }, function (t, e, n) {
    var r = n(149),
        i = n(384),
        o = n(47),
        a = n(8),
        s = n(385);

    t.exports = function (t, e) {
      return (a(t) ? r : i)(t, s(o(e, 3)));
    };
  }, function (t, e, n) {
    var r = n(102);

    t.exports = function (t, e) {
      var n = [];
      return r(t, function (t, r, i) {
        e(t, r, i) && n.push(t);
      }), n;
    };
  }, function (t, e) {
    var n = "Expected a function";

    t.exports = function (t) {
      if ("function" != typeof t) throw new TypeError(n);
      return function () {
        var e = arguments;

        switch (e.length) {
          case 0:
            return !t.call(this);

          case 1:
            return !t.call(this, e[0]);

          case 2:
            return !t.call(this, e[0], e[1]);

          case 3:
            return !t.call(this, e[0], e[1], e[2]);
        }

        return !t.apply(this, e);
      };
    };
  }, function (t, e, n) {
    var r = n(387),
        i = n(179),
        o = n(175),
        a = i(function (t, e) {
      return o(t) ? r(t, e) : [];
    });
    t.exports = a;
  }, function (t, e, n) {
    var r = n(146),
        i = n(388),
        o = n(389),
        a = n(63),
        s = n(141),
        u = n(147),
        l = 200;

    t.exports = function (t, e, n, c) {
      var h = -1,
          f = i,
          p = !0,
          d = t.length,
          v = [],
          y = e.length;
      if (!d) return v;
      n && (e = a(e, s(n))), c ? (f = o, p = !1) : e.length >= l && (f = u, p = !1, e = new r(e));

      t: for (; ++h < d;) {
        var m = t[h],
            g = null == n ? m : n(m);

        if (m = c || 0 !== m ? m : 0, p && g == g) {
          for (var _ = y; _--;) {
            if (e[_] === g) continue t;
          }

          v.push(m);
        } else f(e, g, c) || v.push(m);
      }

      return v;
    };
  }, function (t, e, n) {
    var r = n(60);

    t.exports = function (t, e) {
      return !(null == t || !t.length) && r(t, e, 0) > -1;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      for (var r = -1, i = null == t ? 0 : t.length; ++r < i;) {
        if (n(e, t[r])) return !0;
      }

      return !1;
    };
  }, function (t, e) {
    t.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo4MGJlMjI1ZC0xYzFmLTRiNmQtYTE3MS1kMmM1ZjcxZmU0ZDIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzYzRURCRDE5Q0IzMTFFM0JGQTNGNzcwMEY0MTJCOTUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzYzRURCRDA5Q0IzMTFFM0JGQTNGNzcwMEY0MTJCOTUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZmFmNjUwY2QtMzc1ZS00YmNmLWIyY2QtZWJmOGFkY2NmYmRhIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjgwYmUyMjVkLTFjMWYtNGI2ZC1hMTcxLWQyYzVmNzFmZTRkMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Psq1hcAAAAh7SURBVHjazFp9TJVVGH/4Ri9gDQWBQAhMAQeYlGn1h5Ubc2TrD9tS09XyM63FptYy22wuP1qtNDTbcjOz0pUrUXFarJaSpQYo+MWXICAqmXzeiyI9v/fcc7lw73vfr1vr2c7u3fu+5zy/33ue8zzPec4bcPv2bfKHFBcXx/DPNG6PcBvPLYXbKG425yNd3K5zq+N2nttv3Ery8vKuWdEbHBys/AZYIcLgo/lnHrfZoaGhudHR0TRixAiKiIigYcOGEV+joKAg5dm+vj7q7e2lnp4e6uzspFu3blFbWxuuneTbu7ntZFJtlom8Olt/5xnzitP4Z0lISEhBQkICxcXFKQTMCAi1tLRQU1MTMZYtfGnrwZ15VXr7F+4xQYQJRPDPmrCwsBUpKSmUmJjoeuNSeh1EV6+wDbUSdXcSORzielgY0XDuPSqWaPR9RKFhg8fGjIFMTU0N93Fs4ktrmVCn34kwiQUBAQHbk5OTKS0tbRCBNrbyk8eIzp4maqwnutvne6xA7pqYTDThQaLcR4miYwYTqq6upvr6eurv71/EZLb7jQiTWD98+PBVOTk5FBUV5bp+4SzRke+JLrEh9PebW2cBAURjM4mmzyQaN2Hgent7O1VUVGA9bWIyKy0TYRKbY2JilmVlZbkW1tUmor07BAF/ytgMolkvsuklDMwOyLS2tm5hMst9EQnUMKdCXgfLJk6cqJDAWz+6n2jDm/4nAcGYGBs6oAvmCysABmDxaa4+SGxOSkpakpmZydMfQA470fb3iX74it/UHfrXBGNDx6e83KETuoEBWIBJ1Q2rkNgIc0pPTxeRrIN94kaihhp9YGLiiLJyiZLZSUfd67T5m0T11UQVHDWutWiPUVVGtHkd+3heHbZIImCx2+2YmR5va8ZjjfCDizigbZsyZYoytXCnGPBytbZyeJ9n5woSvgRk9u0S3k5LxvDLWP6WcNdYM6WlpXAAi5nMp6prBHGCp3Jbdna2QgJ2+vlH+khMmEj0xnptEhA8g2fRR0ugGxjkmgE2YGSskb7WyBrEichI8cyPRWKKtSQ9m+jlAg564frXAp5FH/TVY2ZwABBgA0aWt70SYYaZiNgIdpBWdrEH9mgribqHaP4yEeSMCvqgL8bQkoN7hduHACOwMuYJ3mZkSWpqqiti79kBm9RWkP8cpx429fuI8r4iPfpiDE1v1idiFwQYgRWYBxHhLHYkZ6qvIAGUU6knTiB3eugx7/fw9gp5HRTMFw3/5RsdKhgDY+mJM9LUgZUxLy0qKhrpPiNz4+PjXbOBtaFHMti+g7w48BucMH74Dm86Kng27oqG/7iGe0MFY2Rk69MpsQErMAO7BxGZAFaf0zdoYor364e+I+rp9ryOa7hnZKyhAmzSbWP7wDJHIYKdHU/RJJkMnjquPwG0qZhD3UX1Pmr3bBH6dAIbMEKwB+JFn8vmFY8ZeQI7OynnKvR7Hd7weRXeGKqK2j21sby643K3ICywTwORyXJ3d7tXpBF6paXR+/Xsh9X7qN1rrNOv93KNwKq4f2FJuSAyHntsCHIgIwmh2uw99TTR/Q94Xsc13PNmLpV/GkssZb5msym+fxx8ThpvmkQQbDYW0OCBYPMpQ0CHsPksX010vER4K8j4LKKp07x7uUp2qe1/G9MNV54wxkVkLIaNDXUaLrJco/LzYU8i0qU+Pl00Lfml2Ljerk655hTssTCtSLnzs9uND1h2wnts0G3vvCbPnzHez9EzqBwUGWh1I4Rgd3if+f4Hv7Wq/67i9ECk484dscLDw80N9scxoutXjferu8QOo9yczrBhA/t6cACR1l6nE7dFmnwrPFbRN8b77f/a/EzIAOrcGN4EkerubpFPxMabH7jsd2OxAK5bbyrkTWSlpaurS8knQeQ8arFyrx0UbG5gxIKiPf/NbADjqNGDiFwAkROov0r/n5xmXgHsXc9bPnOK6Eq9eT1jUgdKrijkIUUEkRJUxV3b1ixrXuTAXu1nDln0VO4Yndh/CszLy8NiP+VkRpOmijKmWak573tThlTEymwAG+rFcjYcDsep/Pz8ZhlHdjU3N7tKOmnp1t5YyQEf9w5ZGxvYZNHbiXm3+8ZKIeL0yfRkvjVlyJ28FeGaOVu+eNba2BIbsDqJ7HQRYfO6weZViPMJZQubIwrKZgUe7NcjntePHbVGApiADQKswMxmdWNoFWUrDlnkrKAqHhRkXunQnSb+ny614HKDBCY5G8AKzB7loIM7887ipAiHLDLgzJhlXnFHu9gAuacjXZ3mxwMWGQSBEViBWa3SuBYnRdKDYROUnm1euXtMqb1gwd1mD2zIgA0YWd5VLZnizK6/v39hWVkZIZGEq3vpNVFINiMtV7z/NxT80gQGYAGm8vJyHMktZKwdqkScZD7j3GsDToq4g1KjXbyCKCnVOAiUbZoui9Zm4jQdOqEbGIAFmDgl2QiMHvFF7ejNedCzLCNDuC8cuuz4WF9R2x8Cc8JMyMJ4VVUVNTQ0eBzBaR69oQN33FpZWemamUX8dmY+b82b6fFO0LF45cBMAAOwqJ0j+iTiJLO0sbFxi/uawaJbtd5anPEVJ1a+J3RAF9wsdAMDsPhMXf4Xx9NMYPozg4+nOzo6lIXtt+NpNzILAgMDlQ8G3I8fZFkIwQ4VQBQTtI4j0BXeCFksktSRsW41K+5cW1tLdXV12I+7jtj8RsRJBkebq8PDwwtASOsTDgRAh7MyA3u36fiEAyTsdvsHfGkdk/hLC5MpIm6ExvLPktDQ0NdRxUdzNzkjggCH5A+Nc6dPSHxUU6m3vwcRM4IDIv55gdscVPS9feYka2ZwFiqfOfF+kb7k9gWSV6MY/PK91hBSsHR8eDYZYYAGPjyTBwbItOSHZ0heTpD48KzVil5J5B8BBgCBNuloGO+NPwAAAABJRU5ErkJggg==";
  }, function (t, e) {
    t.exports = "data:image/png;base64,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";
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r,
        i = h(n(7)),
        o = h(n(0)),
        a = h(n(1)),
        s = h(n(52)),
        u = h(n(34)),
        l = h(n(168)),
        c = h(n(4));

    function h(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var f = (0, h(n(18)).default)(r = function () {
      function t(e, n, r) {
        if ((0, o.default)(this, t), !n) throw new Error("sources cannot be empty");
        this._tileProp = (0, i.default)({
          frameRate: 1e3,
          opacity: .5,
          tileSize: 256,
          visible: !0
        }, r, {
          zIndex: r.zIndex || 3
        }), this._name = e, this._sources = n, this._toggle = (0, c.default)(r, "visible", !0), this._autoPlay = (0, c.default)(r, "autoPlay", !1);
      }

      return (0, a.default)(t, [{
        key: "setMap",
        value: function value(t) {
          this._kmap = t, null != t ? (this._layer = t.map.createAnimatedTile(this._tileProp, this._sources, this._name), this.setEventContext(this._layer), this._autoPlay ? this._layer.play() : this._sources.length > 0 && this._layer.toggle(!0)) : this.remove();
        }
      }, {
        key: "remove",
        value: function value() {
          this.stop(), this._layer.remove();
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._toggle = void 0 !== t ? t : !this._toggle, this._layer.toggle(this._toggle);
        }
      }, {
        key: "show",
        value: function value() {
          this.toggle(!0);
        }
      }, {
        key: "hide",
        value: function value() {
          this.toggle(!1);
        }
      }, {
        key: "setOpacity",
        value: function value(t) {
          this._layer.setOpacity(t), this._tileProp.opacity = t;
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._layer.setZIndex(t), this._tileProp.zIndex = t;
        }
      }, {
        key: "setSources",
        value: function value(t) {
          this._sources = t, this._layer.setSources(this._sources);
        }
      }, {
        key: "setFrameRate",
        value: function value(t) {
          !(0, l.default)(t) || t < 1 || (this._tileProp.frameRate = t, this._layer.setFrameRate(t));
        }
      }, {
        key: "play",
        value: function value() {
          this._layer.play();
        }
      }, {
        key: "stop",
        value: function value() {
          this._layer.stop();
        }
      }, {
        key: "pause",
        value: function value() {
          this._layer.pause();
        }
      }, {
        key: "receiveProps",
        value: function value(t) {
          var e = this,
              n = {
            opacity: this.setOpacity,
            zIndex: this.setZIndex,
            sources: this.setSources,
            visible: this.toggle,
            frameRate: this.setFrameRate
          };
          (0, u.default)(t, function (r, i) {
            (!(0, s.default)(r, e._tileProp[i]) || "sources" === i && !(0, s.default)(r, e._sources) || "visible" === i && !(0, s.default)(r, e._toggle)) && n[i] && n[i].call(e, t[i]);
          });
        }
      }, {
        key: "name",
        get: function get() {
          return this._name;
        }
      }, {
        key: "sources",
        get: function get() {
          return this._sources;
        }
      }]), t;
    }()) || r;
    e.default = f;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = c(n(35)),
        i = c(n(0)),
        o = c(n(1)),
        a = c(n(39)),
        s = c(n(40)),
        u = c(n(16)),
        l = n(2);

    function c(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var h = function (t) {
      function e() {
        return (0, i.default)(this, e), (0, a.default)(this, (e.__proto__ || (0, r.default)(e)).apply(this, arguments));
      }

      return (0, s.default)(e, t), (0, o.default)(e, [{
        key: "setMap",
        value: function value(t) {
          this._kmap = t, this._layer = t.map.createGeoJsonLayer(this.name, this._props), this._props.zIndex && this._layer.setZIndex(this._props.zIndex), this._props.style && this._layer.setStyle(this._props.style), this._isIndexed ? this._kmap.on(l.KMapEvent.viewChange, this._loadData.bind(this)) : this._loadData();
        }
      }, {
        key: "processData",
        value: function value(t) {
          var e = this,
              n = this._props.layerShowMarker === l.LayerShowMarker.ALWAYS,
              r = this._props.layerShowShape === l.LayerShowShape.ALWAYS;

          function i(t) {
            return !(n || !function (t) {
              return t.match(/point|multipoint/i);
            }(t)) || !(r || !function (t) {
              return t.match(/Linestring|Polygon|MultiLinestring|MultiPolygon/i);
            }(t));
          }

          (n || r) && t && t.features && (0, u.default)(t.features, function (t) {
            t.geometry && (i(t.geometry.type) || function (t) {
              return t.match(/GeometricCollection/i);
            }(t.geometry.type) && ((0, u.default)(t.geometry.geometries, function (e, n) {
              return i(e.type) && t.geometry.geometries.splice(n, 1);
            }), 0 === t.geometry.geometries.length) || e._layer.addGeoJson(t));
          });
        }
      }]), e;
    }(c(n(74)).default);

    e.default = h;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = b(n(104)),
        i = b(n(105)),
        o = b(n(9)),
        a = b(n(35)),
        s = b(n(0)),
        u = b(n(1)),
        l = b(n(39)),
        c = b(n(75)),
        h = b(n(40)),
        f = b(n(5)),
        p = b(n(4)),
        d = b(n(25)),
        v = n(2),
        y = b(n(182)),
        m = b(n(181)),
        g = b(n(395)),
        _ = b(n(74));

    function b(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var L = function (t) {
      function e(t, n, r) {
        (0, s.default)(this, e);
        var i = (0, l.default)(this, (e.__proto__ || (0, a.default)(e)).call(this, t, [], r));
        if (i._isIndexed) throw new Error("Clustering is not available for indexed layers");
        return i._clusterSources = n, i._activeStyles = new y.default(), i._props.zoomOnClick = (0, p.default)(r, "zoomOnClick", !1), i._pointData = {}, i._timestamp = r.timestamp, i._worker = new g.default(), i._worker.onmessage = function (t) {
          switch (t.data.type) {
            case "LOADED":
              i.clear(), i._fetchDataFromWorker(i._kmap.getZoom());
              break;

            case "DATA":
              i._loadedSrc[t.data.tile] && i.processData(t.data.records);
          }
        }, i._worker.postMessage({
          action: "INITIALIZE",
          compress: (0, p.default)(r, "compress", !0),
          maxZoom: (0, p.default)(r, "maxZoom") || 20,
          minZoom: (0, p.default)(r, "minZoom") || 0,
          format: i._props.format,
          radius: (0, p.default)(r, "radius", 60),
          reduce: (0, p.default)(r, "reduce"),
          pagination: (0, p.default)(r, "pagination")
        }), i;
      }

      return (0, h.default)(e, t), (0, u.default)(e, [{
        key: "_fetchDataFromWorker",
        value: function value(t) {
          var e = this,
              n = this._kmap.getBBox();

          n && _.default.getTiles(n, t - 1).forEach(function (t) {
            e._loadedSrc[t.q] || (e._worker.postMessage({
              action: "GET_DATA",
              bbox: [n.west, n.south, n.east, n.north],
              zoom: e._kmap.getZoom(),
              tile: t.q
            }), e._loadedSrc[t.q] = 1);
          });
        }
      }, {
        key: "clear",
        value: function value() {
          (0, c.default)(e.prototype.__proto__ || (0, a.default)(e.prototype), "clear", this).call(this), this._activeStyles.clear();
        }
      }, {
        key: "_loadData",
        value: function value() {
          if (this._props.visible) {
            var t = this._kmap.getZoom();

            if (this._validZoom(t)) {
              if (this._cached.cluster && this._lastLoadedZoom !== this._kmap.getZoom()) return this.clear(), void this._fetchDataFromWorker(this._kmap.getZoom());
              this._cached.cluster = 1, this._worker.postMessage({
                action: "LOAD",
                sources: this._clusterSources,
                format: this._props.format
              });
            } else this.clear();
          }
        }
      }, {
        key: "setMap",
        value: function value(t) {
          var e = this;
          return this._kmap = t, this._layer = t.map.createVectorLayer(this._props), this.setEventContext(this._layer), this._props.zIndex && this._layer.setZIndex(this._props.zIndex), this._kmap.on(v.KMapEvent.VIEWCHANGED, function (t) {
            var n = t.zoom;
            e._props.visible && e._lastLoadedZoom !== n && (e.clear(), e._fetchDataFromWorker(n));
          }), setTimeout(this.loadData, 500), this;
        }
      }, {
        key: "processJsonData",
        value: function value(t) {
          var e = this,
              n = this._props.layerShowMarker === v.LayerShowMarker.ALWAYS,
              a = this._props.layerShowShape === v.LayerShowShape.ALWAYS;
          return o.default.all((0, f.default)(t, function () {
            var t = (0, i.default)(r.default.mark(function t(i) {
              var o;
              return r.default.wrap(function (t) {
                for (;;) {
                  switch (t.prev = t.next) {
                    case 0:
                      return t.next = 2, (0, d.default)(i.desc.cluster ? e._props.clusterStyle : e.props.style, i.desc, e._props.zIndex);

                    case 2:
                      o = t.sent, e._props.dynamic && void 0 !== (0, p.default)(o, "index") && (e._activeStyles.addItem(e._props.style.ranges[o.index], o.index, n, a), delete o.index), i.id && (i.desc.kid = i.id), n && e._layer.addPoints(i.geom, i.desc, o, i.id), a && (e._layer.addPolygons(i.geom, i.desc, o, i.id), e._layer.addPolylines(i.geom, i.desc, o, i.id));

                    case 7:
                    case "end":
                      return t.stop();
                  }
                }
              }, t, e);
            }));
            return function (e) {
              return t.apply(this, arguments);
            };
          }()));
        }
      }, {
        key: "processGeoJsonData",
        value: function value(t) {
          var e = this;
          if (!t) return o.default.resolve();
          var n = this._props.layerShowMarker === v.LayerShowMarker.ALWAYS,
              a = this._props.layerShowShape === v.LayerShowShape.ALWAYS;
          return o.default.all((0, f.default)(t, function () {
            var t = (0, i.default)(r.default.mark(function t(i) {
              var o, s;
              return r.default.wrap(function (t) {
                for (;;) {
                  switch (t.prev = t.next) {
                    case 0:
                      if (i.geometry) {
                        t.next = 2;
                        break;
                      }

                      return t.abrupt("return");

                    case 2:
                      return o = (0, m.default)(i.geometry), t.next = 5, (0, d.default)(i.properties.cluster ? e._props.clusterStyle : e._props.style, i.properties, e._props.zIndex);

                    case 5:
                      s = t.sent, e._props.dynamic && void 0 !== (0, p.default)(s, "index") && (e._activeStyles.addItem(e._props.style.ranges[s.index], s.index, n, a), delete s.index), n && o.points.length > 0 && e._layer.addPoints(o, i.properties, s, i.id), a && o.areas.length > 0 && e._layer.addPolygons(o, i.properties, s, i.id), a && o.lines.length > 0 && e._layer.addPolylines(o, i.properties, s, i.id);

                    case 10:
                    case "end":
                      return t.stop();
                  }
                }
              }, t, e);
            }));
            return function (e) {
              return t.apply(this, arguments);
            };
          }()));
        }
      }, {
        key: "processData",
        value: function value(t) {
          return this._props.format === v.KMapVectorFormat.GEOJSON ? this.processGeoJsonData(t) : this.processJsonData(t);
        }
      }, {
        key: "remove",
        value: function value() {
          (0, c.default)(e.prototype.__proto__ || (0, a.default)(e.prototype), "remove", this).call(this), this._worker.terminate();
        }
      }]), e;
    }(_.default);

    e.default = L;
  }, function (t, e, n) {
    t.exports = function () {
      return n(396)("!function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(t,\"__esModule\",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&\"object\"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,\"default\",{enumerable:!0,value:t}),2&e&&\"string\"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,\"a\",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p=\"\",n(n.s=99)}([function(t,e){var n=t.exports=\"undefined\"!=typeof window&&window.Math==Math?window:\"undefined\"!=typeof self&&self.Math==Math?self:Function(\"return this\")();\"number\"==typeof __g&&(__g=n)},function(t,e){var n=t.exports={version:\"2.6.11\"};\"number\"==typeof __e&&(__e=n)},function(t,e,n){var r=n(42)(\"wks\"),o=n(24),i=n(0).Symbol,u=\"function\"==typeof i;(t.exports=function(t){return r[t]||(r[t]=u&&i[t]||(u?i:o)(\"Symbol.\"+t))}).store=r},function(t,e,n){var r=n(0),o=n(1),i=n(15),u=n(9),a=n(11),c=function(t,e,n){var s,f,p,l=t&c.F,v=t&c.G,h=t&c.S,d=t&c.P,y=t&c.B,m=t&c.W,g=v?o:o[e]||(o[e]={}),x=g.prototype,_=v?r:h?r[e]:(r[e]||{}).prototype;for(s in v&&(n=e),n)(f=!l&&_&&void 0!==_[s])&&a(g,s)||(p=f?_[s]:n[s],g[s]=v&&\"function\"!=typeof _[s]?n[s]:y&&f?i(p,r):m&&_[s]==p?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(p):d&&\"function\"==typeof p?i(Function.call,p):p,d&&((g.virtual||(g.virtual={}))[s]=p,t&c.R&&x&&!x[s]&&u(x,s,p)))};c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,e,n){var r=n(8),o=n(61),i=n(38),u=Object.defineProperty;e.f=n(5)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return u(t,e,n)}catch(t){}if(\"get\"in n||\"set\"in n)throw TypeError(\"Accessors not supported!\");return\"value\"in n&&(t[e]=n.value),t}},function(t,e,n){t.exports=!n(16)(function(){return 7!=Object.defineProperty({},\"a\",{get:function(){return 7}}).a})},function(t,e){var n=Array.isArray;t.exports=n},function(t,e,n){var r=n(81),o=\"object\"==typeof self&&self&&self.Object===Object&&self,i=r||o||Function(\"return this\")();t.exports=i},function(t,e,n){var r=n(10);t.exports=function(t){if(!r(t))throw TypeError(t+\" is not an object!\");return t}},function(t,e,n){var r=n(4),o=n(17);t.exports=n(5)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){t.exports=function(t){return\"object\"==typeof t?null!==t:\"function\"==typeof t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(64),o=n(36);t.exports=function(t){return r(o(t))}},function(t,e,n){var r=n(157),o=n(160);t.exports=function(t,e){var n=o(t,e);return r(n)?n:void 0}},function(t,e){t.exports=!0},function(t,e,n){var r=n(22);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){t.exports={}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){var r=n(28),o=n(149),i=n(150),u=\"[object Null]\",a=\"[object Undefined]\",c=r?r.toStringTag:void 0;t.exports=function(t){return null==t?void 0===t?a:u:c&&c in Object(t)?o(t):i(t)}},function(t,e){t.exports=function(t){return null!=t&&\"object\"==typeof t}},function(t,e){t.exports=function(t){if(\"function\"!=typeof t)throw TypeError(t+\" is not a function!\");return t}},function(t,e,n){var r=n(63),o=n(43);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return\"Symbol(\".concat(void 0===t?\"\":t,\")_\",(++n+r).toString(36))}},function(t,e,n){var r=n(4).f,o=n(11),i=n(2)(\"toStringTag\");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(36);t.exports=function(t){return Object(r(t))}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(7).Symbol;t.exports=r},function(t,e,n){var r=n(13)(Object,\"create\");t.exports=r},function(t,e,n){var r=n(165),o=n(166),i=n(167),u=n(168),a=n(169);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=a,t.exports=c},function(t,e,n){var r=n(84);t.exports=function(t,e){for(var n=t.length;n--;)if(r(t[n][0],e))return n;return-1}},function(t,e,n){var r=n(171);t.exports=function(t,e){var n=t.__data__;return r(e)?n[\"string\"==typeof e?\"string\":\"hash\"]:n.map}},function(t,e,n){var r=n(51),o=1/0;t.exports=function(t){if(\"string\"==typeof t||r(t))return t;var e=t+\"\";return\"0\"==e&&1/t==-o?\"-0\":e}},function(t,e,n){\"use strict\";var r=n(101)(!0);n(60)(String,\"String\",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError(\"Can't call method on  \"+t);return t}},function(t,e,n){var r=n(10),o=n(0).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){var r=n(10);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&\"function\"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if(\"function\"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&\"function\"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError(\"Can't convert object to primitive value\")}},function(t,e,n){var r=n(8),o=n(103),i=n(43),u=n(41)(\"IE_PROTO\"),a=function(){},c=function(){var t,e=n(37)(\"iframe\"),r=i.length;for(e.style.display=\"none\",n(65).appendChild(e),e.src=\"javascript:\",(t=e.contentWindow.document).open(),t.write(\"<script>document.F=Object<\\/script>\"),t.close(),c=t.F;r--;)delete c.prototype[i[r]];return c()};t.exports=Object.create||function(t,e){var n;return null!==t?(a.prototype=r(t),n=new a,a.prototype=null,n[u]=t):n=c(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(35),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(42)(\"keys\"),o=n(24);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(1),o=n(0),i=o[\"__core-js_shared__\"]||(o[\"__core-js_shared__\"]={});(t.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})(\"versions\",[]).push({version:r.version,mode:n(14)?\"pure\":\"global\",copyright:\"\xA9 2019 Denis Pushkarev (zloirock.ru)\"})},function(t,e){t.exports=\"constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf\".split(\",\")},function(t,e,n){\"use strict\";var r=n(22);t.exports.f=function(t){return new function(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError(\"Bad Promise constructor\");e=t,n=r}),this.resolve=r(e),this.reject=r(n)}(t)}},function(t,e,n){e.f=n(2)},function(t,e,n){var r=n(0),o=n(1),i=n(14),u=n(45),a=n(4).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});\"_\"==t.charAt(0)||t in e||a(e,t,{value:u.f(t)})}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){\"use strict\";e.__esModule=!0;var r=function(t){return t&&t.__esModule?t:{default:t}}(n(138));e.default=function(t,e,n){return e in t?(0,r.default)(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e,n){t.exports={default:n(141),__esModule:!0}},function(t,e,n){var r=n(6),o=n(51),i=/\\.|\\[(?:[^[\\]]*|([\"'])(?:(?!\\1)[^\\\\]|\\\\.)*?\\1)\\]/,u=/^\\w*$/;t.exports=function(t,e){if(r(t))return!1;var n=typeof t;return!(\"number\"!=n&&\"symbol\"!=n&&\"boolean\"!=n&&null!=t&&!o(t))||u.test(t)||!i.test(t)||null!=e&&t in Object(e)}},function(t,e,n){var r=n(20),o=n(21),i=\"[object Symbol]\";t.exports=function(t){return\"symbol\"==typeof t||o(t)&&r(t)==i}},function(t,e,n){var r=n(154),o=n(170),i=n(172),u=n(173),a=n(174);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=a,t.exports=c},function(t,e){t.exports=function(t){var e=typeof t;return null!=t&&(\"object\"==e||\"function\"==e)}},function(t,e,n){var r=n(13)(n(7),\"Map\");t.exports=r},function(t,e,n){var r=n(216),o=n(223),i=n(57);t.exports=function(t){return i(t)?r(t):o(t)}},function(t,e){var n=9007199254740991;t.exports=function(t){return\"number\"==typeof t&&t>-1&&t%1==0&&t<=n}},function(t,e,n){var r=n(82),o=n(56);t.exports=function(t){return null!=t&&o(t.length)&&!r(t)}},function(t,e,n){t.exports={default:n(100),__esModule:!0}},function(t,e){},function(t,e,n){\"use strict\";var r=n(14),o=n(3),i=n(62),u=n(9),a=n(18),c=n(102),s=n(25),f=n(106),p=n(2)(\"iterator\"),l=!([].keys&&\"next\"in[].keys()),v=function(){return this};t.exports=function(t,e,n,h,d,y,m){c(n,e,h);var g,x,_,b=function(t){if(!l&&t in w)return w[t];switch(t){case\"keys\":case\"values\":return function(){return new n(this,t)}}return function(){return new n(this,t)}},O=e+\" Iterator\",j=\"values\"==d,E=!1,w=t.prototype,S=w[p]||w[\"@@iterator\"]||d&&w[d],A=S||b(d),M=d?j?b(\"entries\"):A:void 0,L=\"Array\"==e&&w.entries||S;if(L&&(_=f(L.call(new t)))!==Object.prototype&&_.next&&(s(_,O,!0),r||\"function\"==typeof _[p]||u(_,p,v)),j&&S&&\"values\"!==S.name&&(E=!0,A=function(){return S.call(this)}),r&&!m||!l&&!E&&w[p]||u(w,p,A),a[e]=A,a[O]=v,d)if(g={values:j?A:b(\"values\"),keys:y?A:b(\"keys\"),entries:M},m)for(x in g)x in w||i(w,x,g[x]);else o(o.P+o.F*(l||E),e,g);return g}},function(t,e,n){t.exports=!n(5)&&!n(16)(function(){return 7!=Object.defineProperty(n(37)(\"div\"),\"a\",{get:function(){return 7}}).a})},function(t,e,n){t.exports=n(9)},function(t,e,n){var r=n(11),o=n(12),i=n(104)(!1),u=n(41)(\"IE_PROTO\");t.exports=function(t,e){var n,a=o(t),c=0,s=[];for(n in a)n!=u&&r(a,n)&&s.push(n);for(;e.length>c;)r(a,n=e[c++])&&(~i(s,n)||s.push(n));return s}},function(t,e,n){var r=n(19);t.exports=Object(\"z\").propertyIsEnumerable(0)?Object:function(t){return\"String\"==r(t)?t.split(\"\"):Object(t)}},function(t,e,n){var r=n(0).document;t.exports=r&&r.documentElement},function(t,e,n){n(107);for(var r=n(0),o=n(9),i=n(18),u=n(2)(\"toStringTag\"),a=\"CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList\".split(\",\"),c=0;c<a.length;c++){var s=a[c],f=r[s],p=f&&f.prototype;p&&!p[u]&&o(p,u,s),i[s]=i.Array}},function(t,e,n){var r=n(19),o=n(2)(\"toStringTag\"),i=\"Arguments\"==r(function(){return arguments}());t.exports=function(t){var e,n,u;return void 0===t?\"Undefined\":null===t?\"Null\":\"string\"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),o))?n:i?r(e):\"Object\"==(u=r(e))&&\"function\"==typeof e.callee?\"Arguments\":u}},function(t,e,n){var r=n(8);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(18),o=n(2)(\"iterator\"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(67),o=n(2)(\"iterator\"),i=n(18);t.exports=n(1).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t[\"@@iterator\"]||i[r(t)]}},function(t,e,n){var r=n(8),o=n(22),i=n(2)(\"species\");t.exports=function(t,e){var n,u=r(t).constructor;return void 0===u||void 0==(n=r(u)[i])?e:o(n)}},function(t,e,n){var r,o,i,u=n(15),a=n(113),c=n(65),s=n(37),f=n(0),p=f.process,l=f.setImmediate,v=f.clearImmediate,h=f.MessageChannel,d=f.Dispatch,y=0,m={},g=function(){var t=+this;if(m.hasOwnProperty(t)){var e=m[t];delete m[t],e()}},x=function(t){g.call(t.data)};l&&v||(l=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return m[++y]=function(){a(\"function\"==typeof t?t:Function(t),e)},r(y),y},v=function(t){delete m[t]},\"process\"==n(19)(p)?r=function(t){p.nextTick(u(g,t,1))}:d&&d.now?r=function(t){d.now(u(g,t,1))}:h?(i=(o=new h).port2,o.port1.onmessage=x,r=u(i.postMessage,i,1)):f.addEventListener&&\"function\"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+\"\",\"*\")},f.addEventListener(\"message\",x,!1)):r=\"onreadystatechange\"in s(\"script\")?function(t){c.appendChild(s(\"script\")).onreadystatechange=function(){c.removeChild(this),g.call(t)}}:function(t){setTimeout(u(g,t,1),0)}),t.exports={set:l,clear:v}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var r=n(8),o=n(10),i=n(44);t.exports=function(t,e){if(r(t),o(e)&&e.constructor===t)return e;var n=i.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var r=n(2)(\"iterator\"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],u=i[r]();u.next=function(){return{done:n=!0}},i[r]=function(){return u},t(i)}catch(t){}return n}},function(t,e,n){var r=n(63),o=n(43).concat(\"length\",\"prototype\");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){\"use strict\";e.__esModule=!0;var r=function(t){return t&&t.__esModule?t:{default:t}}(n(134));e.default=function(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return(0,r.default)(t)}},function(t,e,n){var r=n(79);t.exports=function(t,e,n){var o=null==t?void 0:r(t,e);return void 0===o?n:o}},function(t,e,n){var r=n(80),o=n(33);t.exports=function(t,e){for(var n=0,i=(e=r(e,t)).length;null!=t&&n<i;)t=t[o(e[n++])];return n&&n==i?t:void 0}},function(t,e,n){var r=n(6),o=n(50),i=n(151),u=n(85);t.exports=function(t,e){return r(t)?t:o(t,e)?[t]:i(u(t))}},function(t,e,n){(function(e){var n=\"object\"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(this,n(148))},function(t,e,n){var r=n(20),o=n(53),i=\"[object AsyncFunction]\",u=\"[object Function]\",a=\"[object GeneratorFunction]\",c=\"[object Proxy]\";t.exports=function(t){if(!o(t))return!1;var e=r(t);return e==u||e==a||e==i||e==c}},function(t,e){var n=Function.prototype.toString;t.exports=function(t){if(null!=t){try{return n.call(t)}catch(t){}try{return t+\"\"}catch(t){}}return\"\"}},function(t,e){t.exports=function(t,e){return t===e||t!=t&&e!=e}},function(t,e,n){var r=n(86);t.exports=function(t){return null==t?\"\":r(t)}},function(t,e,n){var r=n(28),o=n(87),i=n(6),u=n(51),a=1/0,c=r?r.prototype:void 0,s=c?c.toString:void 0;t.exports=function t(e){if(\"string\"==typeof e)return e;if(i(e))return o(e,t)+\"\";if(u(e))return s?s.call(e):\"\";var n=e+\"\";return\"0\"==n&&1/e==-a?\"-0\":n}},function(t,e){t.exports=function(t,e){for(var n=-1,r=null==t?0:t.length,o=Array(r);++n<r;)o[n]=e(t[n],n,t);return o}},function(t,e,n){var r=n(179),o=n(180),i=n(181);t.exports=function(t,e,n){return e==e?i(t,e,n):r(t,o,n)}},function(t,e,n){var r=n(30),o=n(194),i=n(195),u=n(196),a=n(197),c=n(198);function s(t){var e=this.__data__=new r(t);this.size=e.size}s.prototype.clear=o,s.prototype.delete=i,s.prototype.get=u,s.prototype.has=a,s.prototype.set=c,t.exports=s},function(t,e,n){var r=n(199),o=n(21);t.exports=function t(e,n,i,u,a){return e===n||(null==e||null==n||!o(e)&&!o(n)?e!=e&&n!=n:r(e,n,i,u,t,a))}},function(t,e,n){var r=n(200),o=n(203),i=n(204),u=1,a=2;t.exports=function(t,e,n,c,s,f){var p=n&u,l=t.length,v=e.length;if(l!=v&&!(p&&v>l))return!1;var h=f.get(t);if(h&&f.get(e))return h==e;var d=-1,y=!0,m=n&a?new r:void 0;for(f.set(t,e),f.set(e,t);++d<l;){var g=t[d],x=e[d];if(c)var _=p?c(x,g,d,e,t,f):c(g,x,d,t,e,f);if(void 0!==_){if(_)continue;y=!1;break}if(m){if(!o(e,function(t,e){if(!i(m,e)&&(g===t||s(g,t,n,c,f)))return m.push(e)})){y=!1;break}}else if(g!==x&&!s(g,x,n,c,f)){y=!1;break}}return f.delete(t),f.delete(e),y}},function(t,e,n){var r=n(218),o=n(21),i=Object.prototype,u=i.hasOwnProperty,a=i.propertyIsEnumerable,c=r(function(){return arguments}())?r:function(t){return o(t)&&u.call(t,\"callee\")&&!a.call(t,\"callee\")};t.exports=c},function(t,e,n){(function(t){var r=n(7),o=n(219),i=e&&!e.nodeType&&e,u=i&&\"object\"==typeof t&&t&&!t.nodeType&&t,a=u&&u.exports===i?r.Buffer:void 0,c=(a?a.isBuffer:void 0)||o;t.exports=c}).call(this,n(94)(t))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,\"loaded\",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,\"id\",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e){var n=9007199254740991,r=/^(?:0|[1-9]\\d*)$/;t.exports=function(t,e){var o=typeof t;return!!(e=null==e?n:e)&&(\"number\"==o||\"symbol\"!=o&&r.test(t))&&t>-1&&t%1==0&&t<e}},function(t,e,n){var r=n(220),o=n(221),i=n(222),u=i&&i.isTypedArray,a=u?o(u):r;t.exports=a},function(t,e,n){var r=n(53);t.exports=function(t){return t==t&&!r(t)}},function(t,e){t.exports=function(t,e){return function(n){return null!=n&&n[t]===e&&(void 0!==e||t in Object(n))}}},function(t,e,n){\"use strict\";var r=c(n(58)),o=c(n(120)),i=c(n(133)),u=n(187),a=n(188);function c(t){return t&&t.__esModule?t:{default:t}}var s={},f=\"INITIALIZE\",p=\"LOAD\",l=\"GET_DATA\",v={FAILED:\"FAILED\",LOADED:\"LOADED\",EXPANSION_ZOOM:\"EXPANSION_ZOOM\",DATA:\"DATA\"},h=!1;function d(t){return\"object\"===(void 0===t?\"undefined\":(0,o.default)(t))?r.default.resolve(t):new r.default(function(e,n){var r=new XMLHttpRequest;r.open(\"GET\",t,!0),r.responseType=\"json\",r.setRequestHeader(\"Accept\",\"application/json\"),r.onload=function(){4===r.readyState&&r.status>=200&&r.status<300&&r.response?e(r.response):n()},r.send()})}self.onmessage=function(t){switch(t.data.action){case\"getClusterExpansionZoom\":postMessage({type:v.EXPANSION_ZOOM,expansionZoom:s.supercluster.getClusterExpansionZoom(t.data.getClusterExpansionZoom),center:t.data.center});break;case l:var e=t.data,n=e.bbox,o=e.zoom,c=e.format,y=e.tile;postMessage({records:h?s.supercluster.getClusters(n,o,c===u.KMapVectorFormat.JSON):[],type:v.DATA,tile:y});break;case f:var m=t.data,g=m.compress,x=m.maxZoom,_=m.radius,b=m.format,O=m.reduce,j=m.pagination,E=m.minZoom;s.supercluster=(0,i.default)({log:!1,radius:_,extent:256,maxZoom:x,minZoom:E,format:b,compress:g,reduce:(0,a.createClusterAggregator)(O),pagination:j});break;case p:var w=t.data,S=w.sources;switch(w.format){case u.KMapVectorFormat.GEOJSON:!function(t){var e=[];r.default.all(t.map(function(t){return d(t)})).then(function(t){t.forEach(function(t){t&&t.features&&(e=e.concat(t.features))}),h=e.length,s.supercluster.load(e),postMessage({type:v.LOADED})}).catch(function(){postMessage({type:v.FAILED})})}(S);break;default:!function(t){var e=[];r.default.all(t.map(function(t){return d(t)})).then(function(t){t.forEach(function(t){t&&t.file_data&&(e=e.concat(t.file_data))}),h=e.length,s.supercluster.load(e),postMessage({type:v.LOADED})}).catch(function(){postMessage({type:v.FAILED})})}(S)}}}},function(t,e,n){n(59),n(34),n(66),n(110),n(118),n(119),t.exports=n(1).Promise},function(t,e,n){var r=n(35),o=n(36);t.exports=function(t){return function(e,n){var i,u,a=String(o(e)),c=r(n),s=a.length;return c<0||c>=s?t?\"\":void 0:(i=a.charCodeAt(c))<55296||i>56319||c+1===s||(u=a.charCodeAt(c+1))<56320||u>57343?t?a.charAt(c):i:t?a.slice(c,c+2):u-56320+(i-55296<<10)+65536}}},function(t,e,n){\"use strict\";var r=n(39),o=n(17),i=n(25),u={};n(9)(u,n(2)(\"iterator\"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(u,{next:o(1,n)}),i(t,e+\" Iterator\")}},function(t,e,n){var r=n(4),o=n(8),i=n(23);t.exports=n(5)?Object.defineProperties:function(t,e){o(t);for(var n,u=i(e),a=u.length,c=0;a>c;)r.f(t,n=u[c++],e[n]);return t}},function(t,e,n){var r=n(12),o=n(40),i=n(105);t.exports=function(t){return function(e,n,u){var a,c=r(e),s=o(c.length),f=i(u,s);if(t&&n!=n){for(;s>f;)if((a=c[f++])!=a)return!0}else for(;s>f;f++)if((t||f in c)&&c[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(35),o=Math.max,i=Math.min;t.exports=function(t,e){return(t=r(t))<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(11),o=n(26),i=n(41)(\"IE_PROTO\"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:\"function\"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,e,n){\"use strict\";var r=n(108),o=n(109),i=n(18),u=n(12);t.exports=n(60)(Array,\"Array\",function(t,e){this._t=u(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):o(0,\"keys\"==e?n:\"values\"==e?t[n]:[n,t[n]])},\"values\"),i.Arguments=i.Array,r(\"keys\"),r(\"values\"),r(\"entries\")},function(t,e){t.exports=function(){}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){\"use strict\";var r,o,i,u,a=n(14),c=n(0),s=n(15),f=n(67),p=n(3),l=n(10),v=n(22),h=n(111),d=n(112),y=n(71),m=n(72).set,g=n(114)(),x=n(44),_=n(73),b=n(115),O=n(74),j=c.TypeError,E=c.process,w=E&&E.versions,S=w&&w.v8||\"\",A=c.Promise,M=\"process\"==f(E),L=function(){},P=o=x.f,T=!!function(){try{var t=A.resolve(1),e=(t.constructor={})[n(2)(\"species\")]=function(t){t(L,L)};return(M||\"function\"==typeof PromiseRejectionEvent)&&t.then(L)instanceof e&&0!==S.indexOf(\"6.6\")&&-1===b.indexOf(\"Chrome/66\")}catch(t){}}(),C=function(t){var e;return!(!l(t)||\"function\"!=typeof(e=t.then))&&e},I=function(t,e){if(!t._n){t._n=!0;var n=t._c;g(function(){for(var r=t._v,o=1==t._s,i=0,u=function(e){var n,i,u,a=o?e.ok:e.fail,c=e.resolve,s=e.reject,f=e.domain;try{a?(o||(2==t._h&&N(t),t._h=1),!0===a?n=r:(f&&f.enter(),n=a(r),f&&(f.exit(),u=!0)),n===e.promise?s(j(\"Promise-chain cycle\")):(i=C(n))?i.call(n,c,s):c(n)):s(r)}catch(t){f&&!u&&f.exit(),s(t)}};n.length>i;)u(n[i++]);t._c=[],t._n=!1,e&&!t._h&&k(t)})}},k=function(t){m.call(c,function(){var e,n,r,o=t._v,i=D(t);if(i&&(e=_(function(){M?E.emit(\"unhandledRejection\",o,t):(n=c.onunhandledrejection)?n({promise:t,reason:o}):(r=c.console)&&r.error&&r.error(\"Unhandled promise rejection\",o)}),t._h=M||D(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},D=function(t){return 1!==t._h&&0===(t._a||t._c).length},N=function(t){m.call(c,function(){var e;M?E.emit(\"rejectionHandled\",t):(e=c.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,(e=e._w||e)._v=t,e._s=2,e._a||(e._a=e._c.slice()),I(e,!0))},R=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw j(\"Promise can't be resolved itself\");(e=C(t))?g(function(){var r={_w:n,_d:!1};try{e.call(t,s(R,r,1),s(F,r,1))}catch(t){F.call(r,t)}}):(n._v=t,n._s=1,I(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};T||(A=function(t){h(this,A,\"Promise\",\"_h\"),v(t),r.call(this);try{t(s(R,this,1),s(F,this,1))}catch(t){F.call(this,t)}},(r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1}).prototype=n(116)(A.prototype,{then:function(t,e){var n=P(y(this,A));return n.ok=\"function\"!=typeof t||t,n.fail=\"function\"==typeof e&&e,n.domain=M?E.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&I(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new r;this.promise=t,this.resolve=s(R,t,1),this.reject=s(F,t,1)},x.f=P=function(t){return t===A||t===u?new i(t):o(t)}),p(p.G+p.W+p.F*!T,{Promise:A}),n(25)(A,\"Promise\"),n(117)(\"Promise\"),u=n(1).Promise,p(p.S+p.F*!T,\"Promise\",{reject:function(t){var e=P(this);return(0,e.reject)(t),e.promise}}),p(p.S+p.F*(a||!T),\"Promise\",{resolve:function(t){return O(a&&this===u?A:this,t)}}),p(p.S+p.F*!(T&&n(75)(function(t){A.all(t).catch(L)})),\"Promise\",{all:function(t){var e=this,n=P(e),r=n.resolve,o=n.reject,i=_(function(){var n=[],i=0,u=1;d(t,!1,function(t){var a=i++,c=!1;n.push(void 0),u++,e.resolve(t).then(function(t){c||(c=!0,n[a]=t,--u||r(n))},o)}),--u||r(n)});return i.e&&o(i.v),n.promise},race:function(t){var e=this,n=P(e),r=n.reject,o=_(function(){d(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return o.e&&r(o.v),n.promise}})},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+\": incorrect invocation!\");return t}},function(t,e,n){var r=n(15),o=n(68),i=n(69),u=n(8),a=n(40),c=n(70),s={},f={};(e=t.exports=function(t,e,n,p,l){var v,h,d,y,m=l?function(){return t}:c(t),g=r(n,p,e?2:1),x=0;if(\"function\"!=typeof m)throw TypeError(t+\" is not iterable!\");if(i(m)){for(v=a(t.length);v>x;x++)if((y=e?g(u(h=t[x])[0],h[1]):g(t[x]))===s||y===f)return y}else for(d=m.call(t);!(h=d.next()).done;)if((y=o(d,g,h.value,e))===s||y===f)return y}).BREAK=s,e.RETURN=f},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(0),o=n(72).set,i=r.MutationObserver||r.WebKitMutationObserver,u=r.process,a=r.Promise,c=\"process\"==n(19)(u);t.exports=function(){var t,e,n,s=function(){var r,o;for(c&&(r=u.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(c)n=function(){u.nextTick(s)};else if(!i||r.navigator&&r.navigator.standalone)if(a&&a.resolve){var f=a.resolve(void 0);n=function(){f.then(s)}}else n=function(){o.call(r,s)};else{var p=!0,l=document.createTextNode(\"\");new i(s).observe(l,{characterData:!0}),n=function(){l.data=p=!p}}return function(r){var o={fn:r,next:void 0};e&&(e.next=o),t||(t=o,n()),e=o}}},function(t,e,n){var r=n(0).navigator;t.exports=r&&r.userAgent||\"\"},function(t,e,n){var r=n(9);t.exports=function(t,e,n){for(var o in e)n&&t[o]?t[o]=e[o]:r(t,o,e[o]);return t}},function(t,e,n){\"use strict\";var r=n(0),o=n(1),i=n(4),u=n(5),a=n(2)(\"species\");t.exports=function(t){var e=\"function\"==typeof o[t]?o[t]:r[t];u&&e&&!e[a]&&i.f(e,a,{configurable:!0,get:function(){return this}})}},function(t,e,n){\"use strict\";var r=n(3),o=n(1),i=n(0),u=n(71),a=n(74);r(r.P+r.R,\"Promise\",{finally:function(t){var e=u(this,o.Promise||i.Promise),n=\"function\"==typeof t;return this.then(n?function(n){return a(e,t()).then(function(){return n})}:t,n?function(n){return a(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){\"use strict\";var r=n(3),o=n(44),i=n(73);r(r.S,\"Promise\",{try:function(t){var e=o.f(this),n=i(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){\"use strict\";e.__esModule=!0;var r=u(n(121)),o=u(n(123)),i=\"function\"==typeof o.default&&\"symbol\"==typeof r.default?function(t){return typeof t}:function(t){return t&&\"function\"==typeof o.default&&t.constructor===o.default&&t!==o.default.prototype?\"symbol\":typeof t};function u(t){return t&&t.__esModule?t:{default:t}}e.default=\"function\"==typeof o.default&&\"symbol\"===i(r.default)?function(t){return void 0===t?\"undefined\":i(t)}:function(t){return t&&\"function\"==typeof o.default&&t.constructor===o.default&&t!==o.default.prototype?\"symbol\":void 0===t?\"undefined\":i(t)}},function(t,e,n){t.exports={default:n(122),__esModule:!0}},function(t,e,n){n(34),n(66),t.exports=n(45).f(\"iterator\")},function(t,e,n){t.exports={default:n(124),__esModule:!0}},function(t,e,n){n(125),n(59),n(131),n(132),t.exports=n(1).Symbol},function(t,e,n){\"use strict\";var r=n(0),o=n(11),i=n(5),u=n(3),a=n(62),c=n(126).KEY,s=n(16),f=n(42),p=n(25),l=n(24),v=n(2),h=n(45),d=n(46),y=n(127),m=n(128),g=n(8),x=n(10),_=n(26),b=n(12),O=n(38),j=n(17),E=n(39),w=n(129),S=n(130),A=n(47),M=n(4),L=n(23),P=S.f,T=M.f,C=w.f,I=r.Symbol,k=r.JSON,D=k&&k.stringify,N=v(\"_hidden\"),F=v(\"toPrimitive\"),R={}.propertyIsEnumerable,K=f(\"symbol-registry\"),z=f(\"symbols\"),G=f(\"op-symbols\"),U=Object.prototype,Z=\"function\"==typeof I&&!!A.f,B=r.QObject,V=!B||!B.prototype||!B.prototype.findChild,Y=i&&s(function(){return 7!=E(T({},\"a\",{get:function(){return T(this,\"a\",{value:7}).a}})).a})?function(t,e,n){var r=P(U,e);r&&delete U[e],T(t,e,n),r&&t!==U&&T(U,e,r)}:T,H=function(t){var e=z[t]=E(I.prototype);return e._k=t,e},W=Z&&\"symbol\"==typeof I.iterator?function(t){return\"symbol\"==typeof t}:function(t){return t instanceof I},q=function(t,e,n){return t===U&&q(G,e,n),g(t),e=O(e,!0),g(n),o(z,e)?(n.enumerable?(o(t,N)&&t[N][e]&&(t[N][e]=!1),n=E(n,{enumerable:j(0,!1)})):(o(t,N)||T(t,N,j(1,{})),t[N][e]=!0),Y(t,e,n)):T(t,e,n)},$=function(t,e){g(t);for(var n,r=y(e=b(e)),o=0,i=r.length;i>o;)q(t,n=r[o++],e[n]);return t},J=function(t){var e=R.call(this,t=O(t,!0));return!(this===U&&o(z,t)&&!o(G,t))&&(!(e||!o(this,t)||!o(z,t)||o(this,N)&&this[N][t])||e)},X=function(t,e){if(t=b(t),e=O(e,!0),t!==U||!o(z,e)||o(G,e)){var n=P(t,e);return!n||!o(z,e)||o(t,N)&&t[N][e]||(n.enumerable=!0),n}},Q=function(t){for(var e,n=C(b(t)),r=[],i=0;n.length>i;)o(z,e=n[i++])||e==N||e==c||r.push(e);return r},tt=function(t){for(var e,n=t===U,r=C(n?G:b(t)),i=[],u=0;r.length>u;)!o(z,e=r[u++])||n&&!o(U,e)||i.push(z[e]);return i};Z||(a((I=function(){if(this instanceof I)throw TypeError(\"Symbol is not a constructor!\");var t=l(arguments.length>0?arguments[0]:void 0),e=function(n){this===U&&e.call(G,n),o(this,N)&&o(this[N],t)&&(this[N][t]=!1),Y(this,t,j(1,n))};return i&&V&&Y(U,t,{configurable:!0,set:e}),H(t)}).prototype,\"toString\",function(){return this._k}),S.f=X,M.f=q,n(76).f=w.f=Q,n(27).f=J,A.f=tt,i&&!n(14)&&a(U,\"propertyIsEnumerable\",J,!0),h.f=function(t){return H(v(t))}),u(u.G+u.W+u.F*!Z,{Symbol:I});for(var et=\"hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables\".split(\",\"),nt=0;et.length>nt;)v(et[nt++]);for(var rt=L(v.store),ot=0;rt.length>ot;)d(rt[ot++]);u(u.S+u.F*!Z,\"Symbol\",{for:function(t){return o(K,t+=\"\")?K[t]:K[t]=I(t)},keyFor:function(t){if(!W(t))throw TypeError(t+\" is not a symbol!\");for(var e in K)if(K[e]===t)return e},useSetter:function(){V=!0},useSimple:function(){V=!1}}),u(u.S+u.F*!Z,\"Object\",{create:function(t,e){return void 0===e?E(t):$(E(t),e)},defineProperty:q,defineProperties:$,getOwnPropertyDescriptor:X,getOwnPropertyNames:Q,getOwnPropertySymbols:tt});var it=s(function(){A.f(1)});u(u.S+u.F*it,\"Object\",{getOwnPropertySymbols:function(t){return A.f(_(t))}}),k&&u(u.S+u.F*(!Z||s(function(){var t=I();return\"[null]\"!=D([t])||\"{}\"!=D({a:t})||\"{}\"!=D(Object(t))})),\"JSON\",{stringify:function(t){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=e=r[1],(x(e)||void 0!==t)&&!W(t))return m(e)||(e=function(t,e){if(\"function\"==typeof n&&(e=n.call(this,t,e)),!W(e))return e}),r[1]=e,D.apply(k,r)}}),I.prototype[F]||n(9)(I.prototype,F,I.prototype.valueOf),p(I,\"Symbol\"),p(Math,\"Math\",!0),p(r.JSON,\"JSON\",!0)},function(t,e,n){var r=n(24)(\"meta\"),o=n(10),i=n(11),u=n(4).f,a=0,c=Object.isExtensible||function(){return!0},s=!n(16)(function(){return c(Object.preventExtensions({}))}),f=function(t){u(t,r,{value:{i:\"O\"+ ++a,w:{}}})},p=t.exports={KEY:r,NEED:!1,fastKey:function(t,e){if(!o(t))return\"symbol\"==typeof t?t:(\"string\"==typeof t?\"S\":\"P\")+t;if(!i(t,r)){if(!c(t))return\"F\";if(!e)return\"E\";f(t)}return t[r].i},getWeak:function(t,e){if(!i(t,r)){if(!c(t))return!0;if(!e)return!1;f(t)}return t[r].w},onFreeze:function(t){return s&&p.NEED&&c(t)&&!i(t,r)&&f(t),t}}},function(t,e,n){var r=n(23),o=n(47),i=n(27);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var u,a=n(t),c=i.f,s=0;a.length>s;)c.call(t,u=a[s++])&&e.push(u);return e}},function(t,e,n){var r=n(19);t.exports=Array.isArray||function(t){return\"Array\"==r(t)}},function(t,e,n){var r=n(12),o=n(76).f,i={}.toString,u=\"object\"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return u&&\"[object Window]\"==i.call(t)?function(t){try{return o(t)}catch(t){return u.slice()}}(t):o(r(t))}},function(t,e,n){var r=n(27),o=n(17),i=n(12),u=n(38),a=n(11),c=n(61),s=Object.getOwnPropertyDescriptor;e.f=n(5)?s:function(t,e){if(t=i(t),e=u(e,!0),c)try{return s(t,e)}catch(t){}if(a(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){n(46)(\"asyncIterator\")},function(t,e,n){n(46)(\"observable\")},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var r=s(n(77)),o=s(n(48)),i=s(n(49)),u=s(n(144));e.default=function(t){return new f(t)};var a=s(n(248)),c=n(147);function s(t){return t&&t.__esModule?t:{default:t}}function f(t){this.options=b((0,u.default)(this.options),t),this.trees=new Array(this.options.maxZoom+1)}function p(t,e,n,o){return e.numPoints?t=[].concat((0,r.default)(t),(0,r.default)(n?e.properties.records:e.properties.outages)):t.push(n?o[e.index].properties:o[e.index].desc),t}function l(t,e,n,r,o){return{x:t,y:e,zoom:1/0,id:n,parentId:-1,numPoints:r,properties:o}}function v(t,e){var n=t.geometry.coordinates;return{x:m(n[0]),y:g(n[1]),zoom:1/0,index:e,parentId:-1}}function h(t,e){return{x:m(t[1]),y:g(t[0]),zoom:1/0,index:e,parentId:-1}}function d(t,e){return\"geojson\"!==e?{geom:{points:[[[_(t.y),x(t.x)]]]},desc:y(t),id:t.id}:{type:\"Feature\",id:t.id,properties:y(t),geometry:{type:\"Point\",coordinates:[x(t.x),_(t.y)]}}}function y(t){var e=t.numPoints,n=e>=1e4?Math.round(e/1e3)+\"k\":e>=1e3?Math.round(e/100)/10+\"k\":e;return b(b({},t.properties),{cluster:!0,cluster_id:t.id,point_count:e,point_count_abbreviated:n})}function m(t){return t/360+.5}function g(t){var e=Math.sin(t*Math.PI/180),n=.5-.25*Math.log((1+e)/(1-e))/Math.PI;return n<0?0:n>1?1:n}function x(t){return 360*(t-.5)}function _(t){var e=(180-360*t)*Math.PI/180;return 360*Math.atan(Math.exp(e))/Math.PI-90}function b(t,e){for(var n in e)t[n]=e[n];return t}function O(t){return t.x}function j(t){return t.y}f.prototype={options:{minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1,compress:!1,format:\"geojson\",reduce:null,pagination:!1,initial:function(){return{}},map:function(t){return t}},load:function(t){var e=this.options.log;e&&console.time(\"total time\");var n=\"prepare \"+t.length+\" points\";e&&console.time(n),this.points=t;for(var r=[],o=0;o<t.length;o++)if(t[o].desc.cust_a=t[o].desc.cust_a.val,\"geojson\"!==this.options.format){var i=(0,c.processGeometries)(t[o],this.options.compress);if(!i||0===i.points.length)continue;t[o].geom=i,r.push(h(i.points[0][0],o))}else{if(!t[o].geometry)continue;r.push(v(t[o],o))}this.trees[this.options.maxZoom+1]=(0,a.default)(r,O,j,this.options.nodeSize,Float32Array),e&&console.timeEnd(n);for(var u=this.options.maxZoom;u>=this.options.minZoom;u--){var s=+Date.now();r=this._cluster(r,u),this.trees[u]=(0,a.default)(r,O,j,this.options.nodeSize,Float32Array),e&&console.log(\"z%d: %d clusters in %dms\",u,r.length,+Date.now()-s)}return e&&console.timeEnd(\"total time\"),this},getClusters:function(t,e){var n=((t[0]+180)%360+360)%360-180,r=Math.max(-90,Math.min(90,t[1])),o=180===t[2]?180:((t[2]+180)%360+360)%360-180,i=Math.max(-90,Math.min(90,t[3]));if(t[2]-t[0]>=360)n=-180,o=180;else if(n>o){var u=this.getClusters([n,r,180,i],e),a=this.getClusters([-180,r,o,i],e);return u.concat(a)}for(var c=this.trees[this._limitZoom(e)],s=c.range(m(n),g(i),m(o),g(r)),f=[],p=0;p<s.length;p++){var l=c.points[s[p]];f.push(l.numPoints?d(l,this.options.format):this.points[l.index])}return f},getChildren:function(t){var e=t>>5,n=t%32,r=\"No cluster with the specified id.\",o=this.trees[n];if(!o)throw new Error(r);var i=o.points[e];if(!i)throw new Error(r);for(var u=this.options.radius/(this.options.extent*Math.pow(2,n-1)),a=o.within(i.x,i.y,u),c=[],s=0;s<a.length;s++){var f=o.points[a[s]];f.parentId===t&&c.push(f.numPoints?d(f,this.options.format):this.points[f.index])}if(0===c.length)throw new Error(r);return c},getLeaves:function(t,e,n){e=e||10,n=n||0;var r=[];return this._appendLeaves(r,t,e,n,0),r},getTile:function(t,e,n){var r=this.trees[this._limitZoom(t)],o=Math.pow(2,t),i=this.options.extent,u=this.options.radius/i,a=(n-u)/o,c=(n+1+u)/o,s={features:[]};return this._addTileFeatures(r.range((e-u)/o,a,(e+1+u)/o,c),r.points,e,n,o,s),0===e&&this._addTileFeatures(r.range(1-u/o,a,1,c),r.points,o,n,o,s),e===o-1&&this._addTileFeatures(r.range(0,a,u/o,c),r.points,-1,n,o,s),s.features.length?s:null},getClusterExpansionZoom:function(t){for(var e=t%32-1;e<this.options.maxZoom;){var n=this.getChildren(t);if(e++,1!==n.length)break;t=n[0].properties.cluster_id}return e},_appendLeaves:function(t,e,n,r,o){for(var i=this.getChildren(e),u=0;u<i.length;u++){var a=i[u].properties;if(a&&a.cluster?o+a.point_count<=r?o+=a.point_count:o=this._appendLeaves(t,a.cluster_id,n,r,o):o<r?o++:t.push(i[u]),t.length===n)break}return o},_addTileFeatures:function(t,e,n,r,o,i){for(var u=0;u<t.length;u++){var a=e[t[u]],c={type:1,geometry:[[Math.round(this.options.extent*(a.x*o-n)),Math.round(this.options.extent*(a.y*o-r))]],tags:a.numPoints?y(a):this.points[a.index].properties},s=a.numPoints?a.id:this.points[a.index].id;void 0!==s&&(c.id=s),i.features.push(c)}},_limitZoom:function(t){return Math.max(this.options.minZoom,Math.min(t,this.options.maxZoom+1))},_cluster:function(t,e){for(var n=[],r=this.options.radius/(this.options.extent*Math.pow(2,e)),u=function(t,e){if(!t)return!1;if(!0===t)return!0;return(!t.startZoom||t.startZoom&&t.startZoom<e)&&(!t.endZoom||t.endZoom&&t.endZoom>e)}(this.options.pagination,e),a=\"geojson\"===this.options.format,c=0;c<t.length;c++){var s=t[c];if(!(s.zoom<=e)){s.zoom=e;var f=this.trees[e+1],v=f.within(s.x,s.y,r),h=s.numPoints||1,d=s.x*h,y=s.y*h,m=null,g=[];u?g=p(g,s,a,this.points):this.options.reduce&&(m=this.options.initial(),m=this._accumulate(m,s,h));for(var x=(c<<5)+(e+1),_=0;_<v.length;_++){var b=f.points[v[_]];if(!(b.zoom<=e)){b.zoom=e;var O=b.numPoints||1;d+=b.x*O,y+=b.y*O,h+=O,b.parentId=x,u?g=p(g,b,a,this.points):this.options.reduce&&(m=this._accumulate(m,b,h))}}1===h?n.push(s):(s.parentId=x,u&&(m=(0,i.default)({},m,(0,o.default)({},a?\"records\":\"outages\",g))),n.push(l(d/h,y/h,x,h,m)))}}return n},_accumulate:function(t,e,n){var r=e.numPoints?e.properties:\"geojson\"===this.options.format?this.options.map(this.points[e.index].properties):this.options.map(this.points[e.index].desc);return this.options.reduce(t,r,n)}}},function(t,e,n){t.exports={default:n(135),__esModule:!0}},function(t,e,n){n(34),n(136),t.exports=n(1).Array.from},function(t,e,n){\"use strict\";var r=n(15),o=n(3),i=n(26),u=n(68),a=n(69),c=n(40),s=n(137),f=n(70);o(o.S+o.F*!n(75)(function(t){Array.from(t)}),\"Array\",{from:function(t){var e,n,o,p,l=i(t),v=\"function\"==typeof this?this:Array,h=arguments.length,d=h>1?arguments[1]:void 0,y=void 0!==d,m=0,g=f(l);if(y&&(d=r(d,h>2?arguments[2]:void 0,2)),void 0==g||v==Array&&a(g))for(n=new v(e=c(l.length));e>m;m++)s(n,m,y?d(l[m],m):l[m]);else for(p=g.call(l),n=new v;!(o=p.next()).done;m++)s(n,m,y?u(p,d,[o.value,m],!0):o.value);return n.length=m,n}})},function(t,e,n){\"use strict\";var r=n(4),o=n(17);t.exports=function(t,e,n){e in t?r.f(t,e,o(0,n)):t[e]=n}},function(t,e,n){t.exports={default:n(139),__esModule:!0}},function(t,e,n){n(140);var r=n(1).Object;t.exports=function(t,e,n){return r.defineProperty(t,e,n)}},function(t,e,n){var r=n(3);r(r.S+r.F*!n(5),\"Object\",{defineProperty:n(4).f})},function(t,e,n){n(142),t.exports=n(1).Object.assign},function(t,e,n){var r=n(3);r(r.S+r.F,\"Object\",{assign:n(143)})},function(t,e,n){\"use strict\";var r=n(5),o=n(23),i=n(47),u=n(27),a=n(26),c=n(64),s=Object.assign;t.exports=!s||n(16)(function(){var t={},e={},n=Symbol(),r=\"abcdefghijklmnopqrst\";return t[n]=7,r.split(\"\").forEach(function(t){e[t]=t}),7!=s({},t)[n]||Object.keys(s({},e)).join(\"\")!=r})?function(t,e){for(var n=a(t),s=arguments.length,f=1,p=i.f,l=u.f;s>f;)for(var v,h=c(arguments[f++]),d=p?o(h).concat(p(h)):o(h),y=d.length,m=0;y>m;)v=d[m++],r&&!l.call(h,v)||(n[v]=h[v]);return n}:s},function(t,e,n){t.exports={default:n(145),__esModule:!0}},function(t,e,n){n(146);var r=n(1).Object;t.exports=function(t,e){return r.create(t,e)}},function(t,e,n){var r=n(3);r(r.S,\"Object\",{create:n(39)})},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.encodeCoords=e.processGeometries=e.decodeLine=e.loadAutoCompleteAPI=e.loadCss=void 0;var r=a(n(58)),o=a(n(49)),i=a(n(78)),u=a(n(175));function a(t){return t&&t.__esModule?t:{default:t}}e.tileXYToQuadKey=p,e.getTileUrlFunction=l;var c={},s=e.loadCss=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!c[t]){var n=document.createElement(\"link\");n.rel=\"stylesheet\",n.href=t,(0,o.default)(n,e),document.getElementsByTagName(\"head\")[0].appendChild(n),c[t]=1}},f=e.loadAutoCompleteAPI=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return c[t]?1===c[t]?c[t]:r.default.resolve():(c[t]=new r.default(function(n,r){var i=document.createElement(\"script\");i.type=\"text/javascript\",i.readyState?i.onreadystatechange=function(){\"loaded\"!==i.readyState&&\"complete\"!==i.readyState||(i.onreadystatechange=null,c[t]=\"loaded\",n())}:(i.onload=function(){c[t]=\"loaded\",n()},i.onerror=function(){c[t]=\"loaded\",r()}),(0,o.default)(i,e),i.src=t,document.getElementsByTagName(\"head\")[0].appendChild(i),c[t]=1}),c[t])};function p(t,e,n){for(var r=\"\",o=n;o>0;o-=1){var i=0,u=1<<o-1;0!=(t&u)&&(i+=1),0!=(e&u)&&(i+=1,i+=1),r+=i}return r}function l(t){return-1!==t.indexOf(\"{q}\")?function(e,n){var r=p(e.x,e.y,n);return t.replace(/{q}/,r)}:function(e,n){return t.replace(/{x}/,e.x).replace(/{y}/,e.y).replace(/{z}/,n)}}var v=e.decodeLine=function(t){var e=[];try{for(var n=t.length,r=0,o=null,i=0,u=0;r<n;){var a=void 0,c=0,s=0;do{a=t.charCodeAt(r)-63,r+=1,s|=(31&a)<<c,c+=5}while(a>=32);i+=1&s?~(s>>1):s>>1,c=0,s=0;do{a=t.charCodeAt(r)-63,r+=1,s|=(31&a)<<c,c+=5}while(a>=32);o=[i/1e5,(u+=1&s?~(s>>1):s>>1)/1e5],e.push(o)}}catch(t){}return e},h=function(t,e){return e?v(t):\"string\"==typeof t?function(t,e,n){try{if(t&&\"string\"==typeof t&&e&&n)return(0,u.default)(t).split(e).map(function(t){var e=t.split(n);return[parseFloat(e[0]),parseFloat(e[1])]})}catch(t){console.log(t)}return[]}(t,\"|\",\",\"):t?t.length>1&&!t[0]?[t]:t:[]},d=e.processGeometries=function(t,e,n,r){var o=function(t){if(!t)return null;for(var n=[],r=0;r<t.length;r+=1){var o=t[r],i=h(o,e);i&&i.length>0&&n.push(i)}return n},u={};return n||(u.areas=o((0,i.default)(t,\"geom.a\")),u.lines=o((0,i.default)(t,\"geom.l\"))),r||(u.points=o((0,i.default)(t,\"geom.p\"))),u},y=e.encodeCoords=function(t){for(var e=function(t){var e=t<<1;return t<0&&(e=~e),function(t){for(var e=t,n=\"\";e>=32;)n+=String.fromCharCode(63+(32|31&e)),e>>=5;return n+=String.fromCharCode(e+63)}(e)},n=0,r=0,o=\"\",i=0;i<t.length;i+=1){var u=t[i],a=u.lat,c=u.lng,s=Math.floor(1e5*a),f=Math.floor(1e5*c),p=s-n,l=f-r;n=s,r=f,o+=e(p)+e(l)}return o};e.default={loadCss:s,loadAutoCompleteAPI:f,getTileUrlFunction:l,processGeometries:d,decodeLine:v,encodeCoords:y,tileXYToQuadKey:p}},function(t,e){var n;n=function(){return this}();try{n=n||new Function(\"return this\")()}catch(t){\"object\"==typeof window&&(n=window)}t.exports=n},function(t,e,n){var r=n(28),o=Object.prototype,i=o.hasOwnProperty,u=o.toString,a=r?r.toStringTag:void 0;t.exports=function(t){var e=i.call(t,a),n=t[a];try{t[a]=void 0;var r=!0}catch(t){}var o=u.call(t);return r&&(e?t[a]=n:delete t[a]),o}},function(t,e){var n=Object.prototype.toString;t.exports=function(t){return n.call(t)}},function(t,e,n){var r=/[^.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))/g,o=/\\\\(\\\\)?/g,i=n(152)(function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(\"\"),t.replace(r,function(t,n,r,i){e.push(r?i.replace(o,\"$1\"):n||t)}),e});t.exports=i},function(t,e,n){var r=n(153),o=500;t.exports=function(t){var e=r(t,function(t){return n.size===o&&n.clear(),t}),n=e.cache;return e}},function(t,e,n){var r=n(52),o=\"Expected a function\";function i(t,e){if(\"function\"!=typeof t||null!=e&&\"function\"!=typeof e)throw new TypeError(o);var n=function(){var r=arguments,o=e?e.apply(this,r):r[0],i=n.cache;if(i.has(o))return i.get(o);var u=t.apply(this,r);return n.cache=i.set(o,u)||i,u};return n.cache=new(i.Cache||r),n}i.Cache=r,t.exports=i},function(t,e,n){var r=n(155),o=n(30),i=n(54);t.exports=function(){this.size=0,this.__data__={hash:new r,map:new(i||o),string:new r}}},function(t,e,n){var r=n(156),o=n(161),i=n(162),u=n(163),a=n(164);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=a,t.exports=c},function(t,e,n){var r=n(29);t.exports=function(){this.__data__=r?r(null):{},this.size=0}},function(t,e,n){var r=n(82),o=n(158),i=n(53),u=n(83),a=/^\\[object .+?Constructor\\]$/,c=Function.prototype,s=Object.prototype,f=c.toString,p=s.hasOwnProperty,l=RegExp(\"^\"+f.call(p).replace(/[\\\\^$.*+?()[\\]{}|]/g,\"\\\\$&\").replace(/hasOwnProperty|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,\"$1.*?\")+\"$\");t.exports=function(t){return!(!i(t)||o(t))&&(r(t)?l:a).test(u(t))}},function(t,e,n){var r=n(159),o=function(){var t=/[^.]+$/.exec(r&&r.keys&&r.keys.IE_PROTO||\"\");return t?\"Symbol(src)_1.\"+t:\"\"}();t.exports=function(t){return!!o&&o in t}},function(t,e,n){var r=n(7)[\"__core-js_shared__\"];t.exports=r},function(t,e){t.exports=function(t,e){return null==t?void 0:t[e]}},function(t,e){t.exports=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}},function(t,e,n){var r=n(29),o=\"__lodash_hash_undefined__\",i=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;if(r){var n=e[t];return n===o?void 0:n}return i.call(e,t)?e[t]:void 0}},function(t,e,n){var r=n(29),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;return r?void 0!==e[t]:o.call(e,t)}},function(t,e,n){var r=n(29),o=\"__lodash_hash_undefined__\";t.exports=function(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=r&&void 0===e?o:e,this}},function(t,e){t.exports=function(){this.__data__=[],this.size=0}},function(t,e,n){var r=n(31),o=Array.prototype.splice;t.exports=function(t){var e=this.__data__,n=r(e,t);return!(n<0||(n==e.length-1?e.pop():o.call(e,n,1),--this.size,0))}},function(t,e,n){var r=n(31);t.exports=function(t){var e=this.__data__,n=r(e,t);return n<0?void 0:e[n][1]}},function(t,e,n){var r=n(31);t.exports=function(t){return r(this.__data__,t)>-1}},function(t,e,n){var r=n(31);t.exports=function(t,e){var n=this.__data__,o=r(n,t);return o<0?(++this.size,n.push([t,e])):n[o][1]=e,this}},function(t,e,n){var r=n(32);t.exports=function(t){var e=r(this,t).delete(t);return this.size-=e?1:0,e}},function(t,e){t.exports=function(t){var e=typeof t;return\"string\"==e||\"number\"==e||\"symbol\"==e||\"boolean\"==e?\"__proto__\"!==t:null===t}},function(t,e,n){var r=n(32);t.exports=function(t){return r(this,t).get(t)}},function(t,e,n){var r=n(32);t.exports=function(t){return r(this,t).has(t)}},function(t,e,n){var r=n(32);t.exports=function(t,e){var n=r(this,t),o=n.size;return n.set(t,e),this.size+=n.size==o?0:1,this}},function(t,e,n){var r=n(86),o=n(176),i=n(178),u=n(182),a=n(183),c=n(85),s=/^\\s+|\\s+$/g;t.exports=function(t,e,n){if((t=c(t))&&(n||void 0===e))return t.replace(s,\"\");if(!t||!(e=r(e)))return t;var f=a(t),p=a(e),l=u(f,p),v=i(f,p)+1;return o(f,l,v).join(\"\")}},function(t,e,n){var r=n(177);t.exports=function(t,e,n){var o=t.length;return n=void 0===n?o:n,!e&&n>=o?t:r(t,e,n)}},function(t,e){t.exports=function(t,e,n){var r=-1,o=t.length;e<0&&(e=-e>o?0:o+e),(n=n>o?o:n)<0&&(n+=o),o=e>n?0:n-e>>>0,e>>>=0;for(var i=Array(o);++r<o;)i[r]=t[r+e];return i}},function(t,e,n){var r=n(88);t.exports=function(t,e){for(var n=t.length;n--&&r(e,t[n],0)>-1;);return n}},function(t,e){t.exports=function(t,e,n,r){for(var o=t.length,i=n+(r?1:-1);r?i--:++i<o;)if(e(t[i],i,t))return i;return-1}},function(t,e){t.exports=function(t){return t!=t}},function(t,e){t.exports=function(t,e,n){for(var r=n-1,o=t.length;++r<o;)if(t[r]===e)return r;return-1}},function(t,e,n){var r=n(88);t.exports=function(t,e){for(var n=-1,o=t.length;++n<o&&r(e,t[n],0)>-1;);return n}},function(t,e,n){var r=n(184),o=n(185),i=n(186);t.exports=function(t){return o(t)?i(t):r(t)}},function(t,e){t.exports=function(t){return t.split(\"\")}},function(t,e){var n=RegExp(\"[\\\\u200d\\\\ud800-\\\\udfff\\\\u0300-\\\\u036f\\\\ufe20-\\\\ufe2f\\\\u20d0-\\\\u20ff\\\\ufe0e\\\\ufe0f]\");t.exports=function(t){return n.test(t)}},function(t,e){var n=\"[\\\\ud800-\\\\udfff]\",r=\"[\\\\u0300-\\\\u036f\\\\ufe20-\\\\ufe2f\\\\u20d0-\\\\u20ff]\",o=\"\\\\ud83c[\\\\udffb-\\\\udfff]\",i=\"[^\\\\ud800-\\\\udfff]\",u=\"(?:\\\\ud83c[\\\\udde6-\\\\uddff]){2}\",a=\"[\\\\ud800-\\\\udbff][\\\\udc00-\\\\udfff]\",c=\"(?:\"+r+\"|\"+o+\")\"+\"?\",s=\"[\\\\ufe0e\\\\ufe0f]?\"+c+(\"(?:\\\\u200d(?:\"+[i,u,a].join(\"|\")+\")[\\\\ufe0e\\\\ufe0f]?\"+c+\")*\"),f=\"(?:\"+[i+r+\"?\",r,u,a,n].join(\"|\")+\")\",p=RegExp(o+\"(?=\"+o+\")|\"+f+s,\"g\");t.exports=function(t){return t.match(p)||[]}},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.KLayerEvents=e.KGeometryEvents=e.KGeometryType=e.LayerShowShape=e.LayerShowMarker=e.ErrorCodes=e.KMapVectorFormat=e.KMapLayerType=e.KMapSpecialMarker=e.KMapType=e.KMapApi=e.KMapEvent=void 0;var r,o=function(t){return t&&t.__esModule?t:{default:t}}(n(48));var i=e.KMapEvent={CLICK:\"click\",DOUBLECLICK:\"dblclick\",RIGHTCLICK:\"rightclick\",VIEWCHANGED:\"viewChanged\"},u=e.KMapApi={GOOGLE:\"google\",LEAFLET:\"leaflet\",BING:\"bing\"},a=e.KMapType=(r={},(0,o.default)(r,u.GOOGLE,{DEFAULT:\"roadmap\",ROAD:\"roadmap\",SATELLITE:\"satellite\",HYBRID:\"hybrid\",TERRAIN:\"terrain\"}),(0,o.default)(r,u.LEAFLET,{DEFAULT:\"osmmapnik\",ROAD:\"osmmapnik\",TOPO:\"opentopomap\",OPEN_CYCLE:\"cycle\",OSMDE:\"osmde\",MAP_QUEST:\"mapquest\",OSMHOT:\"osmhot\"}),(0,o.default)(r,u.BING,{DEFAULT:\"road\",SATELLITE:\"aerial\",CANVAS_DARK:\"canvasDark\",CANVAS_LIGHT:\"canvasLight\",BIRDSEYE:\"birdseye\",MERCURATOR:\"mercurator\",GRAYSCALE:\"grayscale\",ROAD:\"road\"}),r),c=e.KMapSpecialMarker={ADDRESS:\"address\",GPS:\"gps\",LOCATION:\"location\",BOOKMARK:\"bookmark\"},s=e.KMapLayerType={VECTOR:\"vector\",TILE:\"tile\",DRAW:\"draw\",ANIMATED_TILE:\"animated_tile\",CLUSTER:\"cluster\"},f=e.KMapVectorFormat={JSON:\"json\",GEOJSON:\"geojson\"},p=e.ErrorCodes={ADDRESS_NOT_FOUND:1,ADDRESS_NOT_IN_BOUNDS:2,ADDRESS_SEARCH_FAILED:3,OUT_OF_BOUNDS:4,LAT_LNG_NOT_FOUND:5},l=e.LayerShowMarker={NEVER:0,ALWAYS:1,ONLY_ON_SHAPE_SELECTION:2},v=e.LayerShowShape={NEVER:0,ALWAYS:1,ONLY_ON_MARKER_SELECTION:2},h=e.KGeometryType={POINT:\"POINT\",POLYGON:\"POLYGON\",POLYLINE:\"POLYLINE\"},d=e.KGeometryEvents={CLICK:\"click\",DOUBLECLICK:\"dblclick\",RIGHTCLICK:\"rightclick\"},y=e.KLayerEvents={CLICK:\"click\",DOUBLECLICK:\"dblclick\",RIGHTCLICK:\"rightclick\",DYNAMICSTYLES:\"dynamic-styles\",FRAMELOADED:\"step\",TILESLOADED:\"tilesloaded\",LOADED:\"LOADED\"};e.default={KMapEvent:i,KMapApi:u,KMapType:a,KMapSpecialMarker:c,KMapLayerType:s,KMapVectorFormat:f,ErrorCodes:p,LayerShowMarker:l,LayerShowShape:v,KGeometryType:h,KGeometryEvents:d,KLayerEvents:y}},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.unaryOperations=e.binaryOperations=void 0;var r=c(n(48)),o=c(n(189)),i=c(n(77));e.executeArguments=p,e.executeMember=l,e.execute=v,e.createClusterAggregator=h;var u=c(n(190)),a=c(n(247));function c(t){return t&&t.__esModule?t:{default:t}}var s=e.binaryOperations={\"||\":function(t,e){return t||e},\"&&\":function(t,e){return t&&e},\"===\":function(t,e){return t===e},\"==\":function(t,e){return t==e},\"!==\":function(t,e){return t!==e},\"!=\":function(t,e){return t!=e},\"<\":function(t,e){return t<e},\"<=\":function(t,e){return t<=e},\">\":function(t,e){return t>e},\">=\":function(t,e){return t>=e},\"%\":function(t,e){return t%e},\"+\":function(t,e){return t+e},\"-\":function(t,e){return t-e},\"*\":function(t,e){return t*e},\"/\":function(t,e){return t/e}},f=e.unaryOperations={\"+\":function(t){return t},\"-\":function(t){return-t},\"!\":function(t){return!t}};function p(t,e,n,r,o){return t.map(function(t){return v(t,e,n,r,o)})}function l(t,e,n,r,o){var i=v(t.object,e,n,r,o);return t.computed?[i,i[v(t.property,e,n,r,o)]]:[i,i[t.property.name]]}function v(t,e,n,r,o){switch(t.type){case\"BinaryExpression\":return s[t.operator](v(t.left,e,n,r,o),v(t.right,e,n,r,o));case\"CallExpression\":var u=r.cluster?r[e]:v(t.arguments[0],e,n,r,o);switch(t.callee.name.toUpperCase()){case\"SUM\":return(n[e]||0)+(u||0);case\"AVG\":return((n[e]||0)*(o-(r.point_count||1))+(u||0)*(r.point_count||1))/o;case\"COUNT\":return n[e]?(n[e]+=1,n[e]):1;case\"MIN\":return u?n[e]&&n[e]<u?n[e]:u:n[e];case\"MAX\":return u?n[e]&&n[e]>u?n[e]:u:n[e];case\"HAS_NULL\":return null===n[e]||null===u;default:return t.callee.name.apply(void 0,(0,i.default)(p(t.arguments,e,n,r,o)))}case\"ConditionalExpression\":return v(t.test,r)?v(t.consequent,e,n,r,o):v(t.alternate,e,n,r,o);case\"Literal\":return t.value;case\"UnaryExpression\":return f[t.operator](v(t,e,n,r,o));case\"Identifier\":return r[t.name];case\"ArrayExpression\":return p(t.elements,e,n,r,o);case\"MemberExpression\":return l(t,e,n,r,o)[1];default:return null}}function h(t){var e=(0,u.default)(t,function(t,e){return{treeNode:(0,a.default)(t),key:e}});return function(t,n,i){return e.reduce(function(e,u){return(0,o.default)({},e,(0,r.default)({},u.key,v(u.treeNode,u.key,t,n,i)))},{})}}e.default={createClusterAggregator:h}},function(t,e,n){\"use strict\";e.__esModule=!0;var r=function(t){return t&&t.__esModule?t:{default:t}}(n(49));e.default=r.default||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}},function(t,e,n){var r=n(87),o=n(191),i=n(241),u=n(6);t.exports=function(t,e){return(u(t)?r:i)(t,o(e,3))}},function(t,e,n){var r=n(192),o=n(233),i=n(237),u=n(6),a=n(238);t.exports=function(t){return\"function\"==typeof t?t:null==t?i:\"object\"==typeof t?u(t)?o(t[0],t[1]):r(t):a(t)}},function(t,e,n){var r=n(193),o=n(232),i=n(98);t.exports=function(t){var e=o(t);return 1==e.length&&e[0][2]?i(e[0][0],e[0][1]):function(n){return n===t||r(n,t,e)}}},function(t,e,n){var r=n(89),o=n(90),i=1,u=2;t.exports=function(t,e,n,a){var c=n.length,s=c,f=!a;if(null==t)return!s;for(t=Object(t);c--;){var p=n[c];if(f&&p[2]?p[1]!==t[p[0]]:!(p[0]in t))return!1}for(;++c<s;){var l=(p=n[c])[0],v=t[l],h=p[1];if(f&&p[2]){if(void 0===v&&!(l in t))return!1}else{var d=new r;if(a)var y=a(v,h,l,t,e,d);if(!(void 0===y?o(h,v,i|u,a,d):y))return!1}}return!0}},function(t,e,n){var r=n(30);t.exports=function(){this.__data__=new r,this.size=0}},function(t,e){t.exports=function(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n}},function(t,e){t.exports=function(t){return this.__data__.get(t)}},function(t,e){t.exports=function(t){return this.__data__.has(t)}},function(t,e,n){var r=n(30),o=n(54),i=n(52),u=200;t.exports=function(t,e){var n=this.__data__;if(n instanceof r){var a=n.__data__;if(!o||a.length<u-1)return a.push([t,e]),this.size=++n.size,this;n=this.__data__=new i(a)}return n.set(t,e),this.size=n.size,this}},function(t,e,n){var r=n(89),o=n(91),i=n(205),u=n(209),a=n(227),c=n(6),s=n(93),f=n(96),p=1,l=\"[object Arguments]\",v=\"[object Array]\",h=\"[object Object]\",d=Object.prototype.hasOwnProperty;t.exports=function(t,e,n,y,m,g){var x=c(t),_=c(e),b=x?v:a(t),O=_?v:a(e),j=(b=b==l?h:b)==h,E=(O=O==l?h:O)==h,w=b==O;if(w&&s(t)){if(!s(e))return!1;x=!0,j=!1}if(w&&!j)return g||(g=new r),x||f(t)?o(t,e,n,y,m,g):i(t,e,b,n,y,m,g);if(!(n&p)){var S=j&&d.call(t,\"__wrapped__\"),A=E&&d.call(e,\"__wrapped__\");if(S||A){var M=S?t.value():t,L=A?e.value():e;return g||(g=new r),m(M,L,n,y,g)}}return!!w&&(g||(g=new r),u(t,e,n,y,m,g))}},function(t,e,n){var r=n(52),o=n(201),i=n(202);function u(t){var e=-1,n=null==t?0:t.length;for(this.__data__=new r;++e<n;)this.add(t[e])}u.prototype.add=u.prototype.push=o,u.prototype.has=i,t.exports=u},function(t,e){var n=\"__lodash_hash_undefined__\";t.exports=function(t){return this.__data__.set(t,n),this}},function(t,e){t.exports=function(t){return this.__data__.has(t)}},function(t,e){t.exports=function(t,e){for(var n=-1,r=null==t?0:t.length;++n<r;)if(e(t[n],n,t))return!0;return!1}},function(t,e){t.exports=function(t,e){return t.has(e)}},function(t,e,n){var r=n(28),o=n(206),i=n(84),u=n(91),a=n(207),c=n(208),s=1,f=2,p=\"[object Boolean]\",l=\"[object Date]\",v=\"[object Error]\",h=\"[object Map]\",d=\"[object Number]\",y=\"[object RegExp]\",m=\"[object Set]\",g=\"[object String]\",x=\"[object Symbol]\",_=\"[object ArrayBuffer]\",b=\"[object DataView]\",O=r?r.prototype:void 0,j=O?O.valueOf:void 0;t.exports=function(t,e,n,r,O,E,w){switch(n){case b:if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case _:return!(t.byteLength!=e.byteLength||!E(new o(t),new o(e)));case p:case l:case d:return i(+t,+e);case v:return t.name==e.name&&t.message==e.message;case y:case g:return t==e+\"\";case h:var S=a;case m:var A=r&s;if(S||(S=c),t.size!=e.size&&!A)return!1;var M=w.get(t);if(M)return M==e;r|=f,w.set(t,e);var L=u(S(t),S(e),r,O,E,w);return w.delete(t),L;case x:if(j)return j.call(t)==j.call(e)}return!1}},function(t,e,n){var r=n(7).Uint8Array;t.exports=r},function(t,e){t.exports=function(t){var e=-1,n=Array(t.size);return t.forEach(function(t,r){n[++e]=[r,t]}),n}},function(t,e){t.exports=function(t){var e=-1,n=Array(t.size);return t.forEach(function(t){n[++e]=t}),n}},function(t,e,n){var r=n(210),o=1,i=Object.prototype.hasOwnProperty;t.exports=function(t,e,n,u,a,c){var s=n&o,f=r(t),p=f.length;if(p!=r(e).length&&!s)return!1;for(var l=p;l--;){var v=f[l];if(!(s?v in e:i.call(e,v)))return!1}var h=c.get(t);if(h&&c.get(e))return h==e;var d=!0;c.set(t,e),c.set(e,t);for(var y=s;++l<p;){var m=t[v=f[l]],g=e[v];if(u)var x=s?u(g,m,v,e,t,c):u(m,g,v,t,e,c);if(!(void 0===x?m===g||a(m,g,n,u,c):x)){d=!1;break}y||(y=\"constructor\"==v)}if(d&&!y){var _=t.constructor,b=e.constructor;_!=b&&\"constructor\"in t&&\"constructor\"in e&&!(\"function\"==typeof _&&_ instanceof _&&\"function\"==typeof b&&b instanceof b)&&(d=!1)}return c.delete(t),c.delete(e),d}},function(t,e,n){var r=n(211),o=n(213),i=n(55);t.exports=function(t){return r(t,i,o)}},function(t,e,n){var r=n(212),o=n(6);t.exports=function(t,e,n){var i=e(t);return o(t)?i:r(i,n(t))}},function(t,e){t.exports=function(t,e){for(var n=-1,r=e.length,o=t.length;++n<r;)t[o+n]=e[n];return t}},function(t,e,n){var r=n(214),o=n(215),i=Object.prototype.propertyIsEnumerable,u=Object.getOwnPropertySymbols,a=u?function(t){return null==t?[]:(t=Object(t),r(u(t),function(e){return i.call(t,e)}))}:o;t.exports=a},function(t,e){t.exports=function(t,e){for(var n=-1,r=null==t?0:t.length,o=0,i=[];++n<r;){var u=t[n];e(u,n,t)&&(i[o++]=u)}return i}},function(t,e){t.exports=function(){return[]}},function(t,e,n){var r=n(217),o=n(92),i=n(6),u=n(93),a=n(95),c=n(96),s=Object.prototype.hasOwnProperty;t.exports=function(t,e){var n=i(t),f=!n&&o(t),p=!n&&!f&&u(t),l=!n&&!f&&!p&&c(t),v=n||f||p||l,h=v?r(t.length,String):[],d=h.length;for(var y in t)!e&&!s.call(t,y)||v&&(\"length\"==y||p&&(\"offset\"==y||\"parent\"==y)||l&&(\"buffer\"==y||\"byteLength\"==y||\"byteOffset\"==y)||a(y,d))||h.push(y);return h}},function(t,e){t.exports=function(t,e){for(var n=-1,r=Array(t);++n<t;)r[n]=e(n);return r}},function(t,e,n){var r=n(20),o=n(21),i=\"[object Arguments]\";t.exports=function(t){return o(t)&&r(t)==i}},function(t,e){t.exports=function(){return!1}},function(t,e,n){var r=n(20),o=n(56),i=n(21),u={};u[\"[object Float32Array]\"]=u[\"[object Float64Array]\"]=u[\"[object Int8Array]\"]=u[\"[object Int16Array]\"]=u[\"[object Int32Array]\"]=u[\"[object Uint8Array]\"]=u[\"[object Uint8ClampedArray]\"]=u[\"[object Uint16Array]\"]=u[\"[object Uint32Array]\"]=!0,u[\"[object Arguments]\"]=u[\"[object Array]\"]=u[\"[object ArrayBuffer]\"]=u[\"[object Boolean]\"]=u[\"[object DataView]\"]=u[\"[object Date]\"]=u[\"[object Error]\"]=u[\"[object Function]\"]=u[\"[object Map]\"]=u[\"[object Number]\"]=u[\"[object Object]\"]=u[\"[object RegExp]\"]=u[\"[object Set]\"]=u[\"[object String]\"]=u[\"[object WeakMap]\"]=!1,t.exports=function(t){return i(t)&&o(t.length)&&!!u[r(t)]}},function(t,e){t.exports=function(t){return function(e){return t(e)}}},function(t,e,n){(function(t){var r=n(81),o=e&&!e.nodeType&&e,i=o&&\"object\"==typeof t&&t&&!t.nodeType&&t,u=i&&i.exports===o&&r.process,a=function(){try{var t=i&&i.require&&i.require(\"util\").types;return t||u&&u.binding&&u.binding(\"util\")}catch(t){}}();t.exports=a}).call(this,n(94)(t))},function(t,e,n){var r=n(224),o=n(225),i=Object.prototype.hasOwnProperty;t.exports=function(t){if(!r(t))return o(t);var e=[];for(var n in Object(t))i.call(t,n)&&\"constructor\"!=n&&e.push(n);return e}},function(t,e){var n=Object.prototype;t.exports=function(t){var e=t&&t.constructor;return t===(\"function\"==typeof e&&e.prototype||n)}},function(t,e,n){var r=n(226)(Object.keys,Object);t.exports=r},function(t,e){t.exports=function(t,e){return function(n){return t(e(n))}}},function(t,e,n){var r=n(228),o=n(54),i=n(229),u=n(230),a=n(231),c=n(20),s=n(83),f=s(r),p=s(o),l=s(i),v=s(u),h=s(a),d=c;(r&&\"[object DataView]\"!=d(new r(new ArrayBuffer(1)))||o&&\"[object Map]\"!=d(new o)||i&&\"[object Promise]\"!=d(i.resolve())||u&&\"[object Set]\"!=d(new u)||a&&\"[object WeakMap]\"!=d(new a))&&(d=function(t){var e=c(t),n=\"[object Object]\"==e?t.constructor:void 0,r=n?s(n):\"\";if(r)switch(r){case f:return\"[object DataView]\";case p:return\"[object Map]\";case l:return\"[object Promise]\";case v:return\"[object Set]\";case h:return\"[object WeakMap]\"}return e}),t.exports=d},function(t,e,n){var r=n(13)(n(7),\"DataView\");t.exports=r},function(t,e,n){var r=n(13)(n(7),\"Promise\");t.exports=r},function(t,e,n){var r=n(13)(n(7),\"Set\");t.exports=r},function(t,e,n){var r=n(13)(n(7),\"WeakMap\");t.exports=r},function(t,e,n){var r=n(97),o=n(55);t.exports=function(t){for(var e=o(t),n=e.length;n--;){var i=e[n],u=t[i];e[n]=[i,u,r(u)]}return e}},function(t,e,n){var r=n(90),o=n(78),i=n(234),u=n(50),a=n(97),c=n(98),s=n(33),f=1,p=2;t.exports=function(t,e){return u(t)&&a(e)?c(s(t),e):function(n){var u=o(n,t);return void 0===u&&u===e?i(n,t):r(e,u,f|p)}}},function(t,e,n){var r=n(235),o=n(236);t.exports=function(t,e){return null!=t&&o(t,e,r)}},function(t,e){t.exports=function(t,e){return null!=t&&e in Object(t)}},function(t,e,n){var r=n(80),o=n(92),i=n(6),u=n(95),a=n(56),c=n(33);t.exports=function(t,e,n){for(var s=-1,f=(e=r(e,t)).length,p=!1;++s<f;){var l=c(e[s]);if(!(p=null!=t&&n(t,l)))break;t=t[l]}return p||++s!=f?p:!!(f=null==t?0:t.length)&&a(f)&&u(l,f)&&(i(t)||o(t))}},function(t,e){t.exports=function(t){return t}},function(t,e,n){var r=n(239),o=n(240),i=n(50),u=n(33);t.exports=function(t){return i(t)?r(u(t)):o(t)}},function(t,e){t.exports=function(t){return function(e){return null==e?void 0:e[t]}}},function(t,e,n){var r=n(79);t.exports=function(t){return function(e){return r(e,t)}}},function(t,e,n){var r=n(242),o=n(57);t.exports=function(t,e){var n=-1,i=o(t)?Array(t.length):[];return r(t,function(t,r,o){i[++n]=e(t,r,o)}),i}},function(t,e,n){var r=n(243),o=n(246)(r);t.exports=o},function(t,e,n){var r=n(244),o=n(55);t.exports=function(t,e){return t&&r(t,e,o)}},function(t,e,n){var r=n(245)();t.exports=r},function(t,e){t.exports=function(t){return function(e,n,r){for(var o=-1,i=Object(e),u=r(e),a=u.length;a--;){var c=u[t?a:++o];if(!1===n(i[c],c,i))break}return e}}},function(t,e,n){var r=n(57);t.exports=function(t,e){return function(n,o){if(null==n)return n;if(!r(n))return t(n,o);for(var i=n.length,u=e?i:-1,a=Object(n);(e?u--:++u<i)&&!1!==o(a[u],u,a););return n}}},function(t,e,n){!function(n){\"use strict\";var r=function(t,e){var n=new Error(t+\" at character \"+e);throw n.index=e,n.description=t,n},o={\"-\":!0,\"!\":!0,\"~\":!0,\"+\":!0},i={\"||\":1,\"&&\":2,\"|\":3,\"^\":4,\"&\":5,\"==\":6,\"!=\":6,\"===\":6,\"!==\":6,\"<\":7,\">\":7,\"<=\":7,\">=\":7,\"<<\":8,\">>\":8,\">>>\":8,\"+\":9,\"-\":9,\"*\":10,\"/\":10,\"%\":10},u=function(t){var e,n=0;for(var r in t)(e=r.length)>n&&t.hasOwnProperty(r)&&(n=e);return n},a=u(o),c=u(i),s={true:!0,false:!1,null:null},f=function(t){return i[t]||0},p=function(t,e,n){return{type:\"||\"===t||\"&&\"===t?\"LogicalExpression\":\"BinaryExpression\",operator:t,left:e,right:n}},l=function(t){return t>=48&&t<=57},v=function(t){return 36===t||95===t||t>=65&&t<=90||t>=97&&t<=122||t>=128&&!i[String.fromCharCode(t)]},h=function(t){return 36===t||95===t||t>=65&&t<=90||t>=97&&t<=122||t>=48&&t<=57||t>=128&&!i[String.fromCharCode(t)]},d=function(t){for(var e,n,u=0,d=t.charAt,y=t.charCodeAt,m=function(e){return d.call(t,e)},g=function(e){return y.call(t,e)},x=t.length,_=function(){for(var t=g(u);32===t||9===t||10===t||13===t;)t=g(++u)},b=function(){var t,e,n=j();return _(),63!==g(u)?n:(u++,(t=b())||r(\"Expected expression\",u),_(),58===g(u)?(u++,(e=b())||r(\"Expected expression\",u),{type:\"ConditionalExpression\",test:n,consequent:t,alternate:e}):void r(\"Expected :\",u))},O=function(){_();for(var e=t.substr(u,c),n=e.length;n>0;){if(i.hasOwnProperty(e)&&(!v(g(u))||u+e.length<t.length&&!h(g(u+e.length))))return u+=n,e;e=e.substr(0,--n)}return!1},j=function(){var t,e,n,o,i,a,c,s;if(a=E(),!(e=O()))return a;for(i={value:e,prec:f(e)},(c=E())||r(\"Expected expression after \"+e,u),o=[a,i,c];(e=O())&&0!==(n=f(e));){for(i={value:e,prec:n};o.length>2&&n<=o[o.length-2].prec;)c=o.pop(),e=o.pop().value,a=o.pop(),t=p(e,a,c),o.push(t);(t=E())||r(\"Expected expression after \"+e,u),o.push(i,t)}for(t=o[s=o.length-1];s>1;)t=p(o[s-1].value,o[s-2],t),s-=2;return t},E=function(){var e,n,r;if(_(),e=g(u),l(e)||46===e)return w();if(39===e||34===e)return S();if(91===e)return T();for(r=(n=t.substr(u,a)).length;r>0;){if(o.hasOwnProperty(n)&&(!v(g(u))||u+n.length<t.length&&!h(g(u+n.length))))return u+=r,{type:\"UnaryExpression\",operator:n,argument:E(),prefix:!0};n=n.substr(0,--r)}return!(!v(e)&&40!==e)&&L()},w=function(){for(var t,e,n=\"\";l(g(u));)n+=m(u++);if(46===g(u))for(n+=m(u++);l(g(u));)n+=m(u++);if(\"e\"===(t=m(u))||\"E\"===t){for(n+=m(u++),\"+\"!==(t=m(u))&&\"-\"!==t||(n+=m(u++));l(g(u));)n+=m(u++);l(g(u-1))||r(\"Expected exponent (\"+n+m(u)+\")\",u)}return e=g(u),v(e)?r(\"Variable names cannot start with a number (\"+n+m(u)+\")\",u):46===e&&r(\"Unexpected period\",u),{type:\"Literal\",value:parseFloat(n),raw:n}},S=function(){for(var t,e=\"\",n=m(u++),o=!1;u<x;){if((t=m(u++))===n){o=!0;break}if(\"\\\\\"===t)switch(t=m(u++)){case\"n\":e+=\"\\n\";break;case\"r\":e+=\"\\r\";break;case\"t\":e+=\"\\t\";break;case\"b\":e+=\"\\b\";break;case\"f\":e+=\"\\f\";break;case\"v\":e+=\"\\v\";break;default:e+=t}else e+=t}return o||r('Unclosed quote after \"'+e+'\"',u),{type:\"Literal\",value:e,raw:n+e+n}},A=function(){var e,n=g(u),o=u;for(v(n)?u++:r(\"Unexpected \"+m(u),u);u<x&&(n=g(u),h(n));)u++;return e=t.slice(o,u),s.hasOwnProperty(e)?{type:\"Literal\",value:s[e],raw:e}:\"this\"===e?{type:\"ThisExpression\"}:{type:\"Identifier\",name:e}},M=function(t){for(var e,n,o=[],i=!1;u<x;){if(_(),(e=g(u))===t){i=!0,u++;break}44===e?u++:((n=b())&&\"Compound\"!==n.type||r(\"Expected comma\",u),o.push(n))}return i||r(\"Expected \"+String.fromCharCode(t),u),o},L=function(){var t,e;for(e=40===(t=g(u))?P():A(),_(),t=g(u);46===t||91===t||40===t;)u++,46===t?(_(),e={type:\"MemberExpression\",computed:!1,object:e,property:A()}):91===t?(e={type:\"MemberExpression\",computed:!0,object:e,property:b()},_(),93!==(t=g(u))&&r(\"Unclosed [\",u),u++):40===t&&(e={type:\"CallExpression\",arguments:M(41),callee:e}),_(),t=g(u);return e},P=function(){u++;var t=b();if(_(),41===g(u))return u++,t;r(\"Unclosed (\",u)},T=function(){return u++,{type:\"ArrayExpression\",elements:M(93)}},C=[];u<x;)59===(e=g(u))||44===e?u++:(n=b())?C.push(n):u<x&&r('Unexpected \"'+m(u)+'\"',u);return 1===C.length?C[0]:{type:\"Compound\",body:C}};d.version=\"0.3.4\",d.toString=function(){return\"JavaScript Expression Parser (JSEP) v\"+d.version},d.addUnaryOp=function(t){return a=Math.max(t.length,a),o[t]=!0,this},d.addBinaryOp=function(t,e){return c=Math.max(t.length,c),i[t]=e,this},d.addLiteral=function(t,e){return s[t]=e,this},d.removeUnaryOp=function(t){return delete o[t],t.length===a&&(a=u(o)),this},d.removeAllUnaryOps=function(){return o={},a=0,this},d.removeBinaryOp=function(t){return delete i[t],t.length===c&&(c=u(i)),this},d.removeAllBinaryOps=function(){return i={},c=0,this},d.removeLiteral=function(t){return delete s[t],this},d.removeAllLiterals=function(){return s={},this},t.exports?e=t.exports=d:e.parse=d}()},function(t,e,n){\"use strict\";function r(t,e,n,i,u,a){if(!(u-i<=n)){var c=Math.floor((i+u)/2);!function t(e,n,r,i,u,a){for(;u>i;){if(u-i>600){var c=u-i+1,s=r-i+1,f=Math.log(c),p=.5*Math.exp(2*f/3),l=.5*Math.sqrt(f*p*(c-p)/c)*(s-c/2<0?-1:1),v=Math.max(i,Math.floor(r-s*p/c+l)),h=Math.min(u,Math.floor(r+(c-s)*p/c+l));t(e,n,r,v,h,a)}var d=n[2*r+a],y=i,m=u;for(o(e,n,i,r),n[2*u+a]>d&&o(e,n,i,u);y<m;){for(o(e,n,y,m),y++,m--;n[2*y+a]<d;)y++;for(;n[2*m+a]>d;)m--}n[2*i+a]===d?o(e,n,i,m):o(e,n,++m,u),m<=r&&(i=m+1),r<=m&&(u=m-1)}}(t,e,c,i,u,a%2),r(t,e,n,i,c-1,a+1),r(t,e,n,c+1,u,a+1)}}function o(t,e,n,r){i(t,n,r),i(e,2*n,2*r),i(e,2*n+1,2*r+1)}function i(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function u(t,e,n,r){var o=t-n,i=e-r;return o*o+i*i}function a(t,e,n,r,o){return new c(t,e,n,r,o)}function c(t,e,n,o,i){e=e||s,n=n||f,i=i||Array,this.nodeSize=o||64,this.points=t,this.ids=new i(t.length),this.coords=new i(2*t.length);for(var u=0;u<t.length;u++)this.ids[u]=u,this.coords[2*u]=e(t[u]),this.coords[2*u+1]=n(t[u]);r(this.ids,this.coords,this.nodeSize,0,this.ids.length-1,0)}function s(t){return t[0]}function f(t){return t[1]}n.r(e),n.d(e,\"default\",function(){return a}),c.prototype={range:function(t,e,n,r){return function(t,e,n,r,o,i,u){for(var a,c,s=[0,t.length-1,0],f=[];s.length;){var p=s.pop(),l=s.pop(),v=s.pop();if(l-v<=u)for(var h=v;h<=l;h++)a=e[2*h],c=e[2*h+1],a>=n&&a<=o&&c>=r&&c<=i&&f.push(t[h]);else{var d=Math.floor((v+l)/2);a=e[2*d],c=e[2*d+1],a>=n&&a<=o&&c>=r&&c<=i&&f.push(t[d]);var y=(p+1)%2;(0===p?n<=a:r<=c)&&(s.push(v),s.push(d-1),s.push(y)),(0===p?o>=a:i>=c)&&(s.push(d+1),s.push(l),s.push(y))}}return f}(this.ids,this.coords,t,e,n,r,this.nodeSize)},within:function(t,e,n){return function(t,e,n,r,o,i){for(var a=[0,t.length-1,0],c=[],s=o*o;a.length;){var f=a.pop(),p=a.pop(),l=a.pop();if(p-l<=i)for(var v=l;v<=p;v++)u(e[2*v],e[2*v+1],n,r)<=s&&c.push(t[v]);else{var h=Math.floor((l+p)/2),d=e[2*h],y=e[2*h+1];u(d,y,n,r)<=s&&c.push(t[h]);var m=(f+1)%2;(0===f?n-o<=d:r-o<=y)&&(a.push(l),a.push(h-1),a.push(m)),(0===f?n+o>=d:r+o>=y)&&(a.push(h+1),a.push(p),a.push(m))}}return c}(this.ids,this.coords,t,e,n,this.nodeSize)}}}]);", n.p + "cluster.worker.js");
    };
  }, function (t, e, n) {
    "use strict";

    var r = window.URL || window.webkitURL;

    t.exports = function (t, e) {
      try {
        try {
          var n;

          try {
            (n = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)()).append(t), n = n.getBlob();
          } catch (e) {
            n = new Blob([t]);
          }

          return new Worker(r.createObjectURL(n));
        } catch (e) {
          return new Worker("data:application/javascript," + encodeURIComponent(t));
        }
      } catch (t) {
        if (!e) throw Error("Inline worker is not supported");
        return new Worker(e);
      }
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r,
        i = u(n(0)),
        o = u(n(1)),
        a = u(n(18)),
        s = n(2);

    function u(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var l = (0, a.default)(r = function () {
      function t(e, n, r, o) {
        (0, i.default)(this, t), this._options = r, this._geometry = e, this._type = n, this._desc = o;
      }

      return (0, o.default)(t, [{
        key: "setMap",
        value: function value(t) {
          switch (this._kmap = t, this._type) {
            case s.KGeometryType.POINT:
              this._vector = t.map.createPoint(this._geometry, this._options, this._desc);
              break;

            case s.KGeometryType.POLYGON:
              this._vector = t.map.createPolygon(this._geometry, this._options, this._desc);
              break;

            case s.KGeometryType.POLYLINE:
              this._vector = t.map.createPolyline(this._geometry, this._options, this._desc);
              break;

            default:
              this._vector = null;
          }

          this.setEventContext(this._vector), this._vector && this._vector.createVector && this._vector.createVector();
        }
      }, {
        key: "remove",
        value: function value() {
          this._vector && this._vector.remove();
        }
      }]), t;
    }()) || r;
    e.default = l;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = void 0;
      var r = g(n(9)),
          i = g(n(7)),
          o = g(n(0)),
          a = g(n(1)),
          s = n(28),
          u = n(2),
          l = g(n(399)),
          c = g(n(183)),
          h = g(n(405)),
          f = g(n(407)),
          p = g(n(408)),
          d = g(n(413)),
          v = g(n(414)),
          y = g(n(415)),
          m = g(n(416));

      function g(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      var _ = function () {
        function e() {
          (0, o.default)(this, e);
        }

        return (0, a.default)(e, [{
          key: "initialize",
          value: function value(t, e) {
            var n = this;
            this._mapOptions = (0, i.default)({
              zoomControl: !1,
              mapTypeControl: !1,
              streetViewControl: !1,
              rotateControl: !1,
              fullscreenControl: !1,
              scaleControl: e.showScalebar,
              mapTypeId: e.mapType,
              gestureHandling: "greedy"
            }, e), this._dom = t, this._map = new google.maps.Map(this._dom, this._mapOptions), this._mapOptions.allowedBBox && (this._mapOptions.allowedBounds = new google.maps.LatLngBounds({
              lat: this._mapOptions.allowedBBox.south,
              lng: this._mapOptions.allowedBBox.west
            }, {
              lat: this._mapOptions.allowedBBox.north,
              lng: this._mapOptions.allowedBBox.east
            }), this._map.addListener("drag", this._ensureWithinBounds.bind(this)), this._map.addListener("zoom_changed", this._ensureWithinBounds.bind(this))), google.maps.event.addListenerOnce(this._map, "tilesloaded", function () {
              n._mapInitialized = !0;
            });
          }
        }, {
          key: "_ensureWithinBounds",
          value: function value() {
            var t = this._map.getCenter();

            if (!this._mapOptions.allowedBounds.contains(t)) {
              var e = this._mapOptions.allowedBBox,
                  n = t.lat(),
                  r = t.lng();
              n < e.south && (n = e.south), n > e.north && (n = e.north), r < e.west && (r = e.west), r > e.east && (r = e.east), this._map.setCenter({
                lat: n,
                lng: r
              });
            }
          }
        }, {
          key: "createTileLayer",
          value: function value(t, e) {
            return new c.default(t, e, this._map);
          }
        }, {
          key: "createAnimatedTile",
          value: function value(t, e) {
            return new h.default(t, e, this._map);
          }
        }, {
          key: "createVectorLayer",
          value: function value(t, e) {
            return new l.default(t, this._map, e);
          }
        }, {
          key: "createDrawLayer",
          value: function value(t) {
            return new f.default(t, this._map);
          }
        }, {
          key: "createClusterLayer",
          value: function value(t) {
            return new p.default(t, this._map);
          }
        }, {
          key: "createGeoJsonLayer",
          value: function value(t) {
            return new d.default(t, this._map);
          }
        }, {
          key: "createPoint",
          value: function value(t, e, n) {
            return new v.default(t, this._map, e, n);
          }
        }, {
          key: "createPolygon",
          value: function value(t, e, n) {
            return new y.default(t, this._map, e, n);
          }
        }, {
          key: "createPolyline",
          value: function value(t, e, n) {
            return new m.default(t, this._map, e, n);
          }
        }, {
          key: "removeTileLayer",
          value: function value(t) {
            this._map.overlayMapTypes.setAt(t.name, null);
          }
        }, {
          key: "toggleTileLayer",
          value: function value(t, e, n) {
            e && this._map.overlayMapTypes.setAt(n, t), this._map.overlayMapTypes.removeAt(n);
          }
        }, {
          key: "getCenter",
          value: function value() {
            return this._map.getCenter().toJSON();
          }
        }, {
          key: "setCenter",
          value: function value(t) {
            this._map.setCenter(t);
          }
        }, {
          key: "getZoom",
          value: function value() {
            return this._map.getZoom();
          }
        }, {
          key: "setZoom",
          value: function value(t) {
            this._map.setZoom(t);
          }
        }, {
          key: "getView",
          value: function value() {
            return {
              center: this.getCenter(),
              zoom: this.getZoom()
            };
          }
        }, {
          key: "setView",
          value: function value(t) {
            t.zoom && this._map.setZoom(t.zoom), t.center.lat && t.center.lng && this._map.setCenter(t.center);
          }
        }, {
          key: "getBounds",
          value: function value() {
            var t = this._map.getBounds();

            return t ? t.toJSON() : t;
          }
        }, {
          key: "fitBounds",
          value: function value(t) {
            this._map.fitBounds(t);
          }
        }, {
          key: "setMapType",
          value: function value(t) {
            this._map.setMapTypeId(t);
          }
        }, {
          key: "panBy",
          value: function value(t, e) {
            this._map.panBy(t, e);
          }
        }, {
          key: "goToAddress",
          value: function value(t) {
            var e = this;
            return this.geocoder || (this.geocoder = new google.maps.Geocoder()), new r.default(function (n, r) {
              e.geocoder.geocode({
                address: t,
                bounds: e._mapOptions.allowedBounds
              }, function (t, i) {
                switch (i) {
                  case google.maps.places.PlacesServiceStatus.OK:
                    for (var o = void 0, a = 0; a < t.length; a += 1) {
                      if (e.contains(t[a].geometry.location)) {
                        o = t[a].geometry;
                        break;
                      }
                    }

                    if (!o) return void (t.length > 0 ? r({
                      error: u.ErrorCodes.ADDRESS_NOT_IN_BOUNDS
                    }) : r({
                      error: u.ErrorCodes.ADDRESS_NOT_FOUND
                    }));
                    var s = o.viewport ? o.viewport.toJSON() : void 0;
                    n({
                      location: o.location.toJSON(),
                      address: t[0].formatted_address,
                      bounds: s
                    });
                    break;

                  case google.maps.places.PlacesServiceStatus.ZERO_RESULTS:
                    r({
                      error: u.ErrorCodes.ADDRESS_NOT_FOUND
                    });
                    break;

                  default:
                    r({
                      error: u.ErrorCodes.ADDRESS_SEARCH_FAILED
                    });
                }
              }), e.removeSessionToken();
            });
          }
        }, {
          key: "removeSessionToken",
          value: function value() {
            this._sessionToken = null;
          }
        }, {
          key: "setSessionToken",
          value: function value() {
            this._sessionToken || (this._sessionToken = new google.maps.places.AutocompleteSessionToken());
          }
        }, {
          key: "searchAddress",
          value: function value(t) {
            var e = this;
            this._placesService || (this._placesService = new google.maps.places.AutocompleteService()), this.setSessionToken();
            var n = {
              input: t,
              bounds: this._mapOptions.allowedBounds,
              componentRestrictions: {
                country: this._mapOptions.country
              },
              sessionToken: this._sessionToken
            };
            return new r.default(function (t) {
              e._placesService.getPlacePredictions(n, function (e, n) {
                n === google.maps.places.PlacesServiceStatus.OK ? t({
                  results: e.map(function (t) {
                    return t.description;
                  })
                }) : t({});
              });
            });
          }
        }, {
          key: "contains",
          value: function value(t) {
            return !this._mapOptions.allowedBounds || this._mapOptions.allowedBounds.contains(t);
          }
        }, {
          key: "addEvent",
          value: function value(t, e) {
            var n = this;

            switch (e) {
              case u.KMapEvent.CLICK:
                return this._map.addListener("click", function (n) {
                  t.trigger(e, n.latLng.toJSON());
                });

              case "KMapEvent.boundsChange":
                return this._map.addListener("bounds_changed", function () {
                  t.trigger(e, n.getBounds());
                });

              case "KMapEvent.zoomChange":
                return this._map.addListener("zoom_changed", function () {
                  t.trigger(e, n.getZoom());
                });

              case u.KMapEvent.VIEWCHANGED:
                return this._map.addListener("idle", function () {
                  n._mapInitialized && t.trigger(e, n.getView());
                });

              case u.KMapEvent.DOUBLECLICK:
                return this._map.addListener("dblclick", function (n) {
                  t.trigger(e, n.latLng.toJSON());
                });

              case u.KMapEvent.RIGHTCLICK:
                return this._map.addListener("rightclick", function (n) {
                  t.trigger(e, n.latLng.toJSON());
                });

              default:
                return null;
            }
          }
        }, {
          key: "removeEvent",
          value: function value(t) {
            google.maps.event.removeListener(t);
          }
        }], [{
          key: "setUp",
          value: function value(e, n) {
            if (t.google && google.maps) return r.default.resolve();
            var i = "//maps.googleapis.com/maps/api/js?sensor=true&v=3" + (n ? "&libraries=" + n.join(",") : "") + "&" + e;
            return (0, s.loadAutoCompleteAPI)(i);
          }
        }]), e;
      }();

      e.default = _;
    }).call(this, n(10));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = d(n(14)),
          i = d(n(400)),
          o = d(n(0)),
          a = d(n(1)),
          s = d(n(5)),
          u = d(n(24)),
          l = d(n(34)),
          c = d(n(4)),
          h = n(28),
          f = n(2),
          p = n(77);

      function d(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      var v = function () {
        function e(t, n, r) {
          (0, o.default)(this, e), this._name = t, this._points = [], this._polygons = [], this._polylines = [], this._map = n, this._props = r, this._clickable = (0, c.default)(this._props, "clickable", !0), this._events = {}, this._listeners = {};
        }

        return (0, a.default)(e, [{
          key: "remove",
          value: function value() {
            var t = this;
            [].concat((0, i.default)(this._points), (0, i.default)(this._polygons), (0, i.default)(this._polylines)).forEach(function (t) {
              return t.setMap(null);
            }), this._points = [], this._polygons = [], this._polylines = [], (0, l.default)(this._listeners, function (e, n) {
              e.forEach(function (t) {
                return google.maps.event.removeListener(t);
              }), t._listeners[n] = [];
            });
          }
        }, {
          key: "clear",
          value: function value() {
            this.remove();
          }
        }, {
          key: "setZIndex",
          value: function value(t) {
            [].concat((0, i.default)(this._points), (0, i.default)(this._polygons), (0, i.default)(this._polylines)).forEach(function (e) {
              return e.setZIndex(t);
            });
          }
        }, {
          key: "toggle",
          value: function value(t) {
            [].concat((0, i.default)(this._points), (0, i.default)(this._polygons), (0, i.default)(this._polylines)).forEach(function (e) {
              return e.setVisible(t);
            });
          }
        }, {
          key: "addPoints",
          value: function value(t, e, n, r) {
            var i = this;
            return (0, u.default)(t.points) ? null : (0, s.default)(t.points, function (o) {
              var a = new google.maps.Marker({
                position: {
                  lat: o[0][0],
                  lng: o[0][1]
                },
                desc: e,
                geom: t,
                kStyle: n,
                id: r,
                clickable: i._clickable,
                optimized: !1,
                icon: (0, p.convertKIconToGoogleIcon)(n.icon),
                opacity: n.icon.opacity,
                zIndex: n.zIndex
              });
              return i._clusterLayer ? i._clusterLayer.addMarker(a) : a.setMap(i._map), i._points.push(a), i._addVectorEvents(a), a;
            });
          }
        }, {
          key: "addPolygons",
          value: function value(t, e, n, i) {
            if ((0, u.default)(t.areas)) return null;
            var o = (0, s.default)(t.areas, function (t) {
              return (0, s.default)(t, function (t) {
                return {
                  lat: t[0],
                  lng: t[1]
                };
              });
            }),
                a = new google.maps.Polygon((0, r.default)({
              paths: o,
              desc: e,
              geom: t,
              id: i,
              kStyle: n,
              clickable: this._clickable
            }, (0, p.convertKShapeToPolygonOption)(n)));
            return a.setMap(this._map), this._polygons.push(a), this._addVectorEvents(a), a;
          }
        }, {
          key: "addPolylines",
          value: function value(t, e, n, i) {
            if ((0, u.default)(t.lines)) return null;
            var o = (0, s.default)(t.lines, function (t) {
              return (0, s.default)(t, function (t) {
                return {
                  lat: t[0],
                  lng: t[1]
                };
              });
            }),
                a = new google.maps.Polyline((0, r.default)({
              path: o[0],
              desc: e,
              geom: t,
              id: i,
              clickable: this._clickable,
              kStyle: n
            }, (0, p.convertKShapeToPolylineOption)(n)));
            return a.setMap(this._map), this._polylines.push(a), this._addVectorEvents(a), a;
          }
        }, {
          key: "_addVectorEvents",
          value: function value(t) {
            var e = this;
            (0, l.default)(this._events, function (n, r) {
              e._listeners[r].push(google.maps.event.addListener(t, r, n));
            });
          }
        }, {
          key: "addEvent",
          value: function value(t, e) {
            var n = this;

            function r(r) {
              var i = function i(n) {
                var r = f.KGeometryType.POLYLINE;
                this instanceof google.maps.Marker ? r = f.KGeometryType.POINT : this instanceof google.maps.Polygon && (r = f.KGeometryType.POLYGON), t.trigger(e, {
                  type: r,
                  desc: this.desc,
                  geom: this.geom,
                  kStyle: this.kStyle,
                  clickedLatLng: n.latLng.toJSON(),
                  id: this.id
                });
              };

              return n._listeners[e] || (n._listeners[e] = []), n._points.forEach(function (t) {
                return n._listeners[e].push(t.addListener(r, i));
              }), n._polygons.forEach(function (t) {
                return n._listeners[e].push(t.addListener(r, i));
              }), n._polylines.forEach(function (t) {
                return n._listeners[e].push(t.addListener(r, i));
              }), n._events[r] = i, i;
            }

            switch (e) {
              case f.KLayerEvents.DOUBLECLICK:
                return r("dblclick");

              case f.KLayerEvents.RIGHTCLICK:
                return r("rightclick");

              case f.KLayerEvents.CLICK:
                return r("click");

              default:
                return null;
            }
          }
        }, {
          key: "removeEvent",
          value: function value(t, e) {
            this._listeners[e] && (this._listeners[e].forEach(function (t) {
              return google.maps.event.removeListener(t);
            }), this._listeners[e] = []);
          }
        }, {
          key: "setClustering",
          value: function value(e) {
            var n = this;
            e && !this._clusterLayer ? (0, h.loadAutoCompleteAPI)("https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js").then(function () {
              n._clusterLayer = new t.MarkerClusterer(n._map, n._points, {
                imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"
              });
            }) : this._clusterLayer && (this._clusterLayer.setMap(null), this._clusterLayer = null);
          }
        }, {
          key: "map",
          get: function get() {
            return this._map;
          },
          set: function set(t) {
            this._map = t;
          }
        }]), e;
      }();

      e.default = v;
    }).call(this, n(10));
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(401));

    e.default = function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }

      return (0, r.default)(t);
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(402),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(88), n(403), t.exports = n(3).Array.from;
  }, function (t, e, n) {
    "use strict";

    var r = n(37),
        i = n(11),
        o = n(38),
        a = n(125),
        s = n(126),
        u = n(82),
        l = n(404),
        c = n(127);
    i(i.S + i.F * !n(132)(function (t) {
      Array.from(t);
    }), "Array", {
      from: function from(t) {
        var e,
            n,
            i,
            h,
            f = o(t),
            p = "function" == typeof this ? this : Array,
            d = arguments.length,
            v = d > 1 ? arguments[1] : void 0,
            y = void 0 !== v,
            m = 0,
            g = c(f);
        if (y && (v = r(v, d > 2 ? arguments[2] : void 0, 2)), void 0 == g || p == Array && s(g)) for (n = new p(e = u(f.length)); e > m; m++) {
          l(n, m, y ? v(f[m], m) : f[m]);
        } else for (h = g.call(f), n = new p(); !(i = h.next()).done; m++) {
          l(n, m, y ? a(h, v, [i.value, m], !0) : i.value);
        }
        return n.length = m, n;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(19),
        i = n(41);

    t.exports = function (t, e, n) {
      e in t ? r.f(t, e, i(0, n)) : t[e] = n;
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = c(n(35)),
          i = c(n(0)),
          o = c(n(1)),
          a = c(n(39)),
          s = c(n(75)),
          u = c(n(40)),
          l = c(n(183));

      function c(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      var h = function (e) {
        function n(t, e, o) {
          (0, i.default)(this, n);
          var s = (0, a.default)(this, (n.__proto__ || (0, r.default)(n)).call(this, t, e, o));
          return s._layers = e.map(function (t) {
            return new l.default(s._tileProp, t, o);
          }), s._listeners = s._layers.map(function (t, e) {
            return t.tile.addListener("tilesloaded", function () {
              return s.loadedTile(e);
            });
          }), s;
        }

        return (0, u.default)(n, e), (0, o.default)(n, [{
          key: "setSources",
          value: function value() {
            var e = this,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            (0, s.default)(n.prototype.__proto__ || (0, r.default)(n.prototype), "setSources", this).call(this, i), this._listeners.forEach(function (e) {
              return t.google.maps.event.removeListener(e);
            }), i.forEach(function (t, n) {
              var r = e._layers[n];
              r || (r = new l.default(e._tileProp, t, e._map), e._layers[n] = r, e._interval && r.enable()), e._listeners[n] = r.tile.addListener("tilesloaded", function () {
                return e.loadedTile(n);
              });
            }), this._toggle && !this._interval && (this._layers[this._step].enable(), this._layers[this._step].toggle(!0));
          }
        }]), n;
      }(c(n(184)).default);

      e.default = h;
    }).call(this, n(10));
  }, function (t, e) {
    t.exports = function (t) {
      for (var e = -1, n = null == t ? 0 : t.length, r = 0, i = []; ++e < n;) {
        var o = t[e];
        o && (i[r++] = o);
      }

      return i;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r,
        i = p(n(9)),
        o = p(n(7)),
        a = p(n(0)),
        s = p(n(1)),
        u = p(n(5)),
        l = p(n(16)),
        c = p(n(18)),
        h = n(77),
        f = n(76);

    function p(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function d(t) {
      return t.getPaths().getArray().map(function (t) {
        return t.getArray().map(function (t) {
          return t.toJSON();
        });
      });
    }

    function v(t) {
      return [t.getPath().getArray().map(function (t) {
        return t.toJSON();
      })];
    }

    function y(t) {
      return [t.getPosition().toJSON()];
    }

    var m = (0, c.default)(r = function () {
      function t(e, n) {
        (0, a.default)(this, t), this._map = n, this._prop = (0, o.default)({
          drawingControl: !1,
          drawingControlOptions: {
            position: google.maps.ControlPosition.BOTTOM_CENTER,
            drawingModes: ["marker", "polygon", "polyline"]
          }
        }), this._vectors = [], this.setEventContext(this);
      }

      return (0, s.default)(t, [{
        key: "initialize",
        value: function value() {
          return this._drawManager = new google.maps.drawing.DrawingManager(this._prop), this._drawManager.setMap(this._map), i.default.resolve();
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case f.KDrawEvents.POINT_COMPLETE:
              return this._drawManager.addListener("markercomplete", function (r) {
                n.setDrawingMode(null), t.trigger(e, {
                  points: [y(r)]
                }), r.setMap(null);
              });

            case f.KDrawEvents.POLYGON_COMPLETE:
              return this._drawManager.addListener("polygoncomplete", function (r) {
                n.setDrawingMode(null), t.trigger(e, {
                  areas: d(r)
                }), r.setMap(null);
              });

            case f.KDrawEvents.POLYLINE_COMPLETE:
              return this._drawManager.addListener("polylinecomplete", function (r) {
                n.setDrawingMode(null), t.trigger(e, {
                  lines: v(r)
                }), r.setMap(null);
              });

            case f.KDrawEvents.RECTANGLE_COMPLETE:
              return this._drawManager.addListener("rectanglecomplete", function (r) {
                n.setDrawingMode(null), t.trigger(e, r.getBounds().toJSON());
              });

            case f.KDrawEvents.CIRCLE_COMPLETE:
              return this._drawManager.addListener("circlecomplete", function (r) {
                n.setDrawingMode(null), t.trigger(e, {
                  center: r.getCenter().toJSON(),
                  radius: r.getRadius()
                });
              });

            default:
              return null;
          }
        }
      }, {
        key: "startEdit",
        value: function value(t) {
          this._vectors.forEach(function (e) {
            e.setDraggable(!0), e instanceof google.maps.Marker ? e.setIcon((0, h.convertKIconToGoogleIcon)(t.icon)) : e.setEditable(!0);
          });
        }
      }, {
        key: "stopEdit",
        value: function value() {
          this._vectors.forEach(function (t) {
            t.setDraggable(!1), t instanceof google.maps.Marker || t.setEditable(!1), t.setMap(null);
          }), this._vectors = [];
        }
      }, {
        key: "deleteVector",
        value: function value() {
          this._vectors.forEach(function (t) {
            return t.setMap(null);
          }), this._vectors = [];
        }
      }, {
        key: "getSelectedGeometry",
        value: function value() {
          var t = {
            points: [],
            areas: [],
            lines: []
          };
          return this._vectors.forEach(function (e) {
            e instanceof google.maps.Marker && t.points.push(y(e)), e instanceof google.maps.Polygon && (t.areas = d(e)), e instanceof google.maps.Polyline && (t.lines = v(e));
          }), t;
        }
      }, {
        key: "addPoints",
        value: function value(t, e) {
          var n = this;
          (0, l.default)(t.points, function (r) {
            var i = new google.maps.Marker({
              position: {
                lat: r[0][0],
                lng: r[0][1]
              },
              geom: t,
              icon: (0, h.convertKIconToGoogleIcon)(e.icon),
              map: n._map,
              opacity: e.icon.opacity,
              zIndex: e.zIndex
            });

            n._vectors.push(i);
          });
        }
      }, {
        key: "addPolygons",
        value: function value(t, e) {
          var n = (0, u.default)(t.areas, function (t) {
            return (0, u.default)(t, function (t) {
              return {
                lat: t[0],
                lng: t[1]
              };
            });
          }),
              r = new google.maps.Polygon({
            paths: n,
            geom: t,
            map: this._map,
            strokeWeight: e.shape.borderWeight,
            strokeColor: e.shape.borderColor,
            strokeOpacity: e.shape.borderOpacity,
            fillColor: e.shape.fillColor,
            fillOpacity: e.shape.opacity,
            zIndex: e.zIndex
          });

          this._vectors.push(r);
        }
      }, {
        key: "addPolylines",
        value: function value(t, e) {
          var n = (0, u.default)(t.lines, function (t) {
            return (0, u.default)(t, function (t) {
              return {
                lat: t[0],
                lng: t[1]
              };
            });
          }),
              r = new google.maps.Polyline({
            path: n[0],
            geom: t,
            map: this._map,
            kStyle: e,
            strokeWeight: e.shape.borderWeight,
            strokeColor: e.shape.borderColor,
            strokeOpacity: e.shape.borderOpacity,
            zIndex: e.zIndex
          });

          this._vectors.push(r);
        }
      }, {
        key: "clear",
        value: function value() {
          this._vectors.forEach(function (t) {
            t.setMap(null);
          }), this._vectors = [];
        }
      }, {
        key: "remove",
        value: function value() {
          this._drawManager.setMap(null), this._vectors = [];
        }
      }, {
        key: "setActiveDrawingOptions",
        value: function value(t) {
          if (t) {
            if (t.shape) {
              var e = {
                strokeWeight: t.shape.borderWeight,
                strokeColor: t.shape.borderColor,
                strokeOpacity: t.shape.borderOpacity,
                fillColor: t.shape.fillColor,
                fillOpacity: t.shape.opacity
              };

              this._drawManager.setOptions({
                polygonOptions: e,
                polylineOptions: e,
                circleOptions: e,
                rectangleOptions: e
              });
            }

            t.icon && this._drawManager.setOptions({
              markerOptions: {
                icon: (0, h.convertKIconToGoogleIcon)(t.icon),
                opacity: t.icon.opacity
              }
            });
          }
        }
      }, {
        key: "setDrawingMode",
        value: function value(t, e) {
          switch (this.setActiveDrawingOptions(e), t) {
            case f.DrawingMode.POINT:
              return this._drawManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);

            case f.DrawingMode.POLYGON:
              return this._drawManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);

            case f.DrawingMode.POLYLINE:
              return this._drawManager.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE);

            case f.DrawingMode.RECTANGLE:
              return this._drawManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);

            case f.DrawingMode.CIRCLE:
              return this._drawManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);

            default:
              return this._drawManager.setDrawingMode(null);
          }
        }
      }, {
        key: "addCircle",
        value: function value() {}
      }, {
        key: "addRectange",
        value: function value() {}
      }, {
        key: "removeEvent",
        value: function value(t) {
          google.maps.event.removeListener(t);
        }
      }]), t;
    }()) || r;
    e.default = m;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = d(n(9)),
        i = d(n(0)),
        o = d(n(1)),
        a = d(n(52)),
        s = d(n(5)),
        u = d(n(24)),
        l = d(n(34)),
        c = d(n(4)),
        h = d(n(25)),
        f = n(2),
        p = n(77);

    function d(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var v = n(409),
        y = v.MarkerClusterer,
        m = v.Cluster,
        g = function () {
      function t(e, n) {
        (0, i.default)(this, t), this._points = [], this._map = n, this._props = e, this._events = {}, this._listeners = {}, this._clickable = (0, c.default)(this._props, "clickable", !0), this.loadMarkerClusterer();
      }

      return (0, o.default)(t, [{
        key: "loadMarkerClusterer",
        value: function value() {
          return this._layer = new y(this._map, this._points, {
            styles: (0, c.default)(this._props, "clusterStyle.ranges", []).map(function (t) {
              return {
                width: (0, c.default)(t, "rangeStyles.icon.size[0]"),
                height: (0, c.default)(t, "rangeStyles.icon.size[1]"),
                textColor: "#000",
                textSize: "12px",
                url: (0, c.default)(t, "rangeStyles.icon.url")
              };
            }),
            zoomOnClick: this._props.zoomOnClick,
            averageCenter: !0
          }), this._layer.setCalculator(this.getClusterStyle.bind(this)), this._events.click && this._listeners.click.push(google.maps.event.addListener(this._layer, "clusterclick", this._events.click)), r.default.resolve();
        }
      }, {
        key: "getClusterStyle",
        value: function value(t) {
          var e = (0, h.default)(this._props.clusterStyle, {
            CLUSTERSIZE: t.length
          }, this._props.zIndex);
          return {
            index: e.index,
            text: e.icon.labelValue
          };
        }
      }, {
        key: "remove",
        value: function value() {
          var t = this;
          this._points.forEach(function (t) {
            return t.setMap(null);
          }), this._layer.clearMarkers(), this._points = [], (0, l.default)(this._listeners, function (e, n) {
            e.forEach(function (t) {
              return google.maps.event.removeListener(t);
            }), t._listeners[n] = [];
          });
        }
      }, {
        key: "clear",
        value: function value() {
          this._layer.clearMarkers();
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._points.forEach(function (e) {
            return e.setZIndex(t);
          });
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._points.forEach(function (e) {
            return e.setVisible(t);
          }), this._layer && (t ? this._layer.addMarkers(this._points) : this._layer.clearMarkers()), this._toggle = t;
        }
      }, {
        key: "addPoints",
        value: function value(t, e, n, r) {
          var i = this;
          if ((0, u.default)(t.points)) return null;
          var o = (0, s.default)(t.points, function (o) {
            var a = new google.maps.Marker({
              position: {
                lat: o[0][0],
                lng: o[0][1]
              },
              desc: e,
              geom: t,
              clusterIndex: r,
              kStyle: n,
              label: n.icon.labelValue && {
                color: "#000",
                fontFamily: "roboto",
                fontSize: "12px",
                fontWeight: "600",
                text: n.icon.labelValue
              },
              icon: (0, p.convertKIconToGoogleIcon)(n.icon),
              opacity: n.icon.opacity,
              zIndex: n.zIndex,
              clickable: i._clickable
            });
            return i._points.push(a), i._addVectorEvents(a), a;
          });
          return this._layer && this._toggle && this._layer.addMarkers(o, !0), o;
        }
      }, {
        key: "removePoints",
        value: function value(t) {
          var e = this;
          t.forEach(function (t) {
            t.setMap(null), e._layer.removeMarker(t, !0);
          });
        }
      }, {
        key: "updatePoints",
        value: function value(t, e, n) {
          (0, a.default)(t[0].desc, e) || t.forEach(function (t) {
            t.setIcon((0, p.convertKIconToGoogleIcon)(n.icon)), t.desc = e;
          });
        }
      }, {
        key: "_addVectorEvents",
        value: function value(t) {
          var e = this;
          (0, l.default)(this._events, function (n, r) {
            e._listeners[r].push(google.maps.event.addListener(t, r, n));
          });
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case f.KLayerEvents.DOUBLECLICK:
            case f.KLayerEvents.RIGHTCLICK:
            case f.KLayerEvents.CLICK:
              var r = function r(n) {
                var r = f.KGeometryType.POINT,
                    i = void 0;
                i = n instanceof m ? {
                  type: r,
                  clickedLatLng: n.getCenter().toJSON(),
                  desc: {
                    CLUSTERSIZE: n.getMarkers().length,
                    cluster: !0
                  },
                  geom: {
                    points: [[n.getCenter().toJSON()]]
                  }
                } : {
                  type: r,
                  clickedLatLng: n.latLng.toJSON(),
                  desc: this.desc,
                  geom: this.geom,
                  kStyle: this.kStyle
                }, t.trigger(e, i);
              };

              return this._listeners[e] || (this._listeners[e] = []), this._points.forEach(function (t) {
                return n._listeners[e].push(t.addListener(e, r));
              }), this._layer && f.KLayerEvents.CLICK === e && this._layer.addListener("clusterclick", r), this._events.click = r, r;

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          this._listeners[e] && (this._listeners[e].forEach(function (t) {
            return google.maps.event.removeListener(t);
          }), this._listeners[e] = []);
        }
      }, {
        key: "redraw",
        value: function value() {
          this._layer.repaint();
        }
      }, {
        key: "map",
        get: function get() {
          return this._map;
        },
        set: function set(t) {
          this._map = t;
        }
      }]), t;
    }();

    e.default = g;
  }, function (t, e, n) {
    "use strict";

    var r = o(n(50)),
        i = o(n(410));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function a(t, e, n) {
      this.extend(a, google.maps.OverlayView), this.map_ = t, this.markers_ = [], this.clusters_ = [], this.sizes = [53, 56, 66, 78, 90], this.styles_ = [], this.ready_ = !1;
      var r = n || {};
      this.gridSize_ = r.gridSize || 60, this.minClusterSize_ = r.minimumClusterSize || 2, this.maxZoom_ = r.maxZoom || null, this.styles_ = r.styles || [], this.imagePath_ = r.imagePath || this.MARKER_CLUSTER_IMAGE_PATH_, this.imageExtension_ = r.imageExtension || this.MARKER_CLUSTER_IMAGE_EXTENSION_, this.zoomOnClick_ = !0, void 0 != r.zoomOnClick && (this.zoomOnClick_ = r.zoomOnClick), this.averageCenter_ = !1, void 0 != r.averageCenter && (this.averageCenter_ = r.averageCenter), this.setupStyles_(), this.setMap(t), this.prevZoom_ = this.map_.getZoom();
      var o = this;
      google.maps.event.addListener(this.map_, "zoom_changed", function () {
        var t = o.map_.getZoom(),
            e = o.map_.minZoom || 0,
            n = Math.min(o.map_.maxZoom || 100, o.map_.mapTypes[o.map_.getMapTypeId()].maxZoom);
        t = Math.min(Math.max(t, e), n), o.prevZoom_ != t && (o.prevZoom_ = t, o.resetViewport());
      }), google.maps.event.addListener(this.map_, "idle", function () {
        o.redraw();
      }), e && (e.length || (0, i.default)(e).length) && this.addMarkers(e, !1);
    }

    function s(t) {
      this.markerClusterer_ = t, this.map_ = t.getMap(), this.gridSize_ = t.getGridSize(), this.minClusterSize_ = t.getMinClusterSize(), this.averageCenter_ = t.isAverageCenter(), this.center_ = null, this.markers_ = [], this.bounds_ = null, this.clusterIcon_ = new u(this, t.getStyles(), t.getGridSize());
    }

    function u(t, e, n) {
      t.getMarkerClusterer().extend(u, google.maps.OverlayView), this.styles_ = e, this.padding_ = n || 0, this.cluster_ = t, this.center_ = null, this.map_ = t.getMap(), this.div_ = null, this.sums_ = null, this.visible_ = !1, this.setMap(this.map_);
    }

    a.prototype.MARKER_CLUSTER_IMAGE_PATH_ = "../images/m", a.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = "png", a.prototype.extend = function (t, e) {
      return function (t) {
        for (var e in t.prototype) {
          this.prototype[e] = t.prototype[e];
        }

        return this;
      }.apply(t, [e]);
    }, a.prototype.onAdd = function () {
      this.setReady_(!0);
    }, a.prototype.draw = function () {}, a.prototype.setupStyles_ = function () {
      if (!this.styles_.length) for (var t, e = 0; t = this.sizes[e]; e++) {
        this.styles_.push({
          url: this.imagePath_ + (e + 1) + "." + this.imageExtension_,
          height: t,
          width: t
        });
      }
    }, a.prototype.fitMapToMarkers = function () {
      for (var t, e = this.getMarkers(), n = new google.maps.LatLngBounds(), r = 0; t = e[r]; r++) {
        n.extend(t.getPosition());
      }

      this.map_.fitBounds(n);
    }, a.prototype.setStyles = function (t) {
      this.styles_ = t;
    }, a.prototype.getStyles = function () {
      return this.styles_;
    }, a.prototype.isZoomOnClick = function () {
      return this.zoomOnClick_;
    }, a.prototype.isAverageCenter = function () {
      return this.averageCenter_;
    }, a.prototype.getMarkers = function () {
      return this.markers_;
    }, a.prototype.getTotalMarkers = function () {
      return this.markers_.length;
    }, a.prototype.setMaxZoom = function (t) {
      this.maxZoom_ = t;
    }, a.prototype.getMaxZoom = function () {
      return this.maxZoom_;
    }, a.prototype.calculator_ = function (t, e) {
      for (var n = 0, r = t.length, i = r; 0 !== i;) {
        i = parseInt(i / 10, 10), n++;
      }

      return {
        text: r,
        index: n = Math.min(n, e)
      };
    }, a.prototype.setCalculator = function (t) {
      this.calculator_ = t;
    }, a.prototype.getCalculator = function () {
      return this.calculator_;
    }, a.prototype.addMarkers = function (t, e) {
      if (t.length) for (var n = 0; r = t[n]; n++) {
        this.pushMarkerTo_(r);
      } else if ((0, i.default)(t).length) for (var r in t) {
        this.pushMarkerTo_(t[r]);
      }
      e || this.redraw();
    }, a.prototype.pushMarkerTo_ = function (t) {
      if (t.isAdded = !1, t.draggable) {
        var e = this;
        google.maps.event.addListener(t, "dragend", function () {
          t.isAdded = !1, e.repaint();
        });
      }

      this.markers_.push(t);
    }, a.prototype.addMarker = function (t, e) {
      this.pushMarkerTo_(t), e || this.redraw();
    }, a.prototype.removeMarker_ = function (t) {
      var e = -1;
      if (this.markers_.indexOf) e = this.markers_.indexOf(t);else for (var n, r = 0; n = this.markers_[r]; r++) {
        if (n == t) {
          e = r;
          break;
        }
      }
      return -1 != e && (t.setMap(null), this.markers_.splice(e, 1), !0);
    }, a.prototype.removeMarker = function (t, e) {
      var n = this.removeMarker_(t);
      return !(e || !n) && (this.resetViewport(), this.redraw(), !0);
    }, a.prototype.removeMarkers = function (t, e) {
      for (var n, r = !1, i = 0; n = t[i]; i++) {
        var o = this.removeMarker_(n);
        r = r || o;
      }

      if (!e && r) return this.resetViewport(), this.redraw(), !0;
    }, a.prototype.setReady_ = function (t) {
      this.ready_ || (this.ready_ = t, this.createClusters_());
    }, a.prototype.getTotalClusters = function () {
      return this.clusters_.length;
    }, a.prototype.getMap = function () {
      return this.map_;
    }, a.prototype.setMap = function (t) {
      this.map_ = t;
    }, a.prototype.getGridSize = function () {
      return this.gridSize_;
    }, a.prototype.setGridSize = function (t) {
      this.gridSize_ = t;
    }, a.prototype.getMinClusterSize = function () {
      return this.minClusterSize_;
    }, a.prototype.setMinClusterSize = function (t) {
      this.minClusterSize_ = t;
    }, a.prototype.getExtendedBounds = function (t) {
      var e = this.getProjection(),
          n = new google.maps.LatLng(t.getNorthEast().lat(), t.getNorthEast().lng()),
          r = new google.maps.LatLng(t.getSouthWest().lat(), t.getSouthWest().lng()),
          i = e.fromLatLngToDivPixel(n);
      i.x += this.gridSize_, i.y -= this.gridSize_;
      var o = e.fromLatLngToDivPixel(r);
      o.x -= this.gridSize_, o.y += this.gridSize_;
      var a = e.fromDivPixelToLatLng(i),
          s = e.fromDivPixelToLatLng(o);
      return t.extend(a), t.extend(s), t;
    }, a.prototype.isMarkerInBounds_ = function (t, e) {
      return e.contains(t.getPosition());
    }, a.prototype.clearMarkers = function () {
      this.resetViewport(!0), this.markers_ = [];
    }, a.prototype.resetViewport = function (t) {
      for (var e, n = 0; e = this.clusters_[n]; n++) {
        e.remove();
      }

      var r;

      for (n = 0; r = this.markers_[n]; n++) {
        r.isAdded = !1, t && r.setMap(null);
      }

      this.clusters_ = [];
    }, a.prototype.repaint = function () {
      var t = this.clusters_.slice();
      this.clusters_.length = 0, this.resetViewport(), this.redraw(), window.setTimeout(function () {
        for (var e, n = 0; e = t[n]; n++) {
          e.remove();
        }
      }, 0);
    }, a.prototype.redraw = function () {
      this.createClusters_();
    }, a.prototype.distanceBetweenPoints_ = function (t, e) {
      if (!t || !e) return 0;
      var n = (e.lat() - t.lat()) * Math.PI / 180,
          r = (e.lng() - t.lng()) * Math.PI / 180,
          i = Math.sin(n / 2) * Math.sin(n / 2) + Math.cos(t.lat() * Math.PI / 180) * Math.cos(e.lat() * Math.PI / 180) * Math.sin(r / 2) * Math.sin(r / 2);
      return 6371 * (2 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i)));
    }, a.prototype.addToClosestCluster_ = function (t) {
      for (var e, n = 4e4, r = null, i = (t.getPosition(), 0); e = this.clusters_[i]; i++) {
        var o = e.getCenter();

        if (o) {
          var a = this.distanceBetweenPoints_(o, t.getPosition());
          a < n && (n = a, r = e);
        }
      }

      r && r.isMarkerInClusterBounds(t) ? r.addMarker(t) : ((e = new s(this)).addMarker(t), this.clusters_.push(e));
    }, a.prototype.createClusters_ = function () {
      if (this.ready_) for (var t, e = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(), this.map_.getBounds().getNorthEast()), n = this.getExtendedBounds(e), r = 0; t = this.markers_[r]; r++) {
        !t.isAdded && this.isMarkerInBounds_(t, n) && this.addToClosestCluster_(t);
      }
    }, s.prototype.isMarkerAlreadyAdded = function (t) {
      if (this.markers_.indexOf) return -1 != this.markers_.indexOf(t);

      for (var e, n = 0; e = this.markers_[n]; n++) {
        if (e == t) return !0;
      }

      return !1;
    }, s.prototype.addMarker = function (t) {
      if (this.isMarkerAlreadyAdded(t)) return !1;

      if (this.center_) {
        if (this.averageCenter_) {
          var e = this.markers_.length + 1,
              n = (this.center_.lat() * (e - 1) + t.getPosition().lat()) / e,
              r = (this.center_.lng() * (e - 1) + t.getPosition().lng()) / e;
          this.center_ = new google.maps.LatLng(n, r), this.calculateBounds_();
        }
      } else this.center_ = t.getPosition(), this.calculateBounds_();

      t.isAdded = !0, this.markers_.push(t);
      var i = this.markers_.length;
      if (i < this.minClusterSize_ && t.getMap() != this.map_ && t.setMap(this.map_), i == this.minClusterSize_) for (var o = 0; o < i; o++) {
        this.markers_[o].setMap(null);
      }
      return i >= this.minClusterSize_ && t.setMap(null), this.updateIcon(), !0;
    }, s.prototype.getMarkerClusterer = function () {
      return this.markerClusterer_;
    }, s.prototype.getBounds = function () {
      for (var t, e = new google.maps.LatLngBounds(this.center_, this.center_), n = this.getMarkers(), r = 0; t = n[r]; r++) {
        e.extend(t.getPosition());
      }

      return e;
    }, s.prototype.remove = function () {
      this.clusterIcon_.remove(), this.markers_.length = 0, delete this.markers_;
    }, s.prototype.getSize = function () {
      return this.markers_.length;
    }, s.prototype.getMarkers = function () {
      return this.markers_;
    }, s.prototype.getCenter = function () {
      return this.center_;
    }, s.prototype.calculateBounds_ = function () {
      var t = new google.maps.LatLngBounds(this.center_, this.center_);
      this.bounds_ = this.markerClusterer_.getExtendedBounds(t);
    }, s.prototype.isMarkerInClusterBounds = function (t) {
      return this.bounds_.contains(t.getPosition());
    }, s.prototype.getMap = function () {
      return this.map_;
    }, s.prototype.updateIcon = function () {
      var t = this.map_.getZoom(),
          e = this.markerClusterer_.getMaxZoom();
      if (e && t > e) for (var n, r = 0; n = this.markers_[r]; r++) {
        n.setMap(this.map_);
      } else if (this.markers_.length < this.minClusterSize_) this.clusterIcon_.hide();else {
        var i = this.markerClusterer_.getStyles().length,
            o = this.markerClusterer_.getCalculator()(this.markers_, i);
        this.clusterIcon_.setCenter(this.center_), this.clusterIcon_.setSums(o), this.clusterIcon_.show();
      }
    }, u.prototype.triggerClusterClick = function () {
      var t = this.cluster_.getMarkerClusterer();
      google.maps.event.trigger(t, "clusterclick", this.cluster_), t.isZoomOnClick() && this.map_.fitBounds(this.cluster_.getBounds());
    }, u.prototype.onAdd = function () {
      if (this.div_ = document.createElement("DIV"), this.visible_) {
        var t = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(t), this.div_.innerHTML = this.sums_.text;
      }

      this.getPanes().overlayMouseTarget.appendChild(this.div_);
      var e = this;
      google.maps.event.addDomListener(this.div_, "click", function (t) {
        t.stopPropagation(), e.triggerClusterClick();
      });
    }, u.prototype.getPosFromLatLng_ = function (t) {
      var e = this.getProjection().fromLatLngToDivPixel(t);
      return e.x -= parseInt(this.width_ / 2, 10), e.y -= parseInt(this.height_ / 2, 10), e;
    }, u.prototype.draw = function () {
      if (this.visible_) {
        var t = this.getPosFromLatLng_(this.center_);
        this.div_.style.top = t.y + "px", this.div_.style.left = t.x + "px";
      }
    }, u.prototype.hide = function () {
      this.div_ && (this.div_.style.display = "none"), this.visible_ = !1;
    }, u.prototype.show = function () {
      if (this.div_) {
        var t = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(t), this.div_.style.display = "";
      }

      this.visible_ = !0;
    }, u.prototype.remove = function () {
      this.setMap(null);
    }, u.prototype.onRemove = function () {
      this.div_ && this.div_.parentNode && (this.hide(), this.div_.parentNode.removeChild(this.div_), this.div_ = null);
    }, u.prototype.setSums = function (t) {
      this.sums_ = t, this.text_ = t.text, this.index_ = t.index, this.div_ && (this.div_.innerHTML = t.text), this.useStyle();
    }, u.prototype.useStyle = function () {
      var t = Math.max(0, this.sums_.index - 1);
      t = Math.min(this.styles_.length - 1, t);
      var e = this.styles_[t];
      this.url_ = e.url, this.height_ = e.height, this.width_ = e.width, this.textColor_ = e.textColor, this.anchor_ = e.anchor, this.textSize_ = e.textSize, this.backgroundPosition_ = e.backgroundPosition;
    }, u.prototype.setCenter = function (t) {
      this.center_ = t;
    }, u.prototype.createCss = function (t) {
      var e = [];
      e.push("background-image:url(" + this.url_ + ");");
      var n = this.backgroundPosition_ ? this.backgroundPosition_ : "0 0";
      e.push("background-position:" + n + ";"), "object" === (0, r.default)(this.anchor_) ? ("number" == typeof this.anchor_[0] && this.anchor_[0] > 0 && this.anchor_[0] < this.height_ ? e.push("height:" + (this.height_ - this.anchor_[0]) + "px; padding-top:" + this.anchor_[0] + "px;") : e.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px;"), "number" == typeof this.anchor_[1] && this.anchor_[1] > 0 && this.anchor_[1] < this.width_ ? e.push("width:" + (this.width_ - this.anchor_[1]) + "px; padding-left:" + this.anchor_[1] + "px;") : e.push("width:" + this.width_ + "px; text-align:center;")) : e.push("height:" + this.height_ + "px; line-height:" + this.height_ + "px; width:" + this.width_ + "px; text-align:center;");
      var i = this.textColor_ ? this.textColor_ : "black",
          o = this.textSize_ ? this.textSize_ : 11;
      return e.push("cursor:pointer; top:" + t.y + "px; left:" + t.x + "px; color:" + i + "; position:absolute; font-size:" + o + "px; font-family:Arial,sans-serif; font-weight:bold"), e.join("");
    }, e.MarkerClusterer = a, e.ClusterIcon = u, e.Cluster = s, e.default = {
      ClusterIcon: u,
      MarkerClusterer: a,
      Cluster: s
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(411),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(412), t.exports = n(3).Object.keys;
  }, function (t, e, n) {
    var r = n(38),
        i = n(42);
    n(111)("keys", function () {
      return function (t) {
        return i(r(t));
      };
    });
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = s(n(0)),
        i = s(n(1)),
        o = s(n(25)),
        a = n(77);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function () {
      function t(e, n) {
        (0, r.default)(this, t), this._name = e, this._map = n, this._layer = new google.maps.Data({
          map: this._map,
          name: e
        });
      }

      return (0, i.default)(t, [{
        key: "clear",
        value: function value() {
          this._layer.setGeoJson({
            type: "FeatureCollection",
            features: []
          });
        }
      }, {
        key: "remove",
        value: function value() {
          this._layer.setMap(null), delete this._layer;
        }
      }, {
        key: "setStyle",
        value: function value(t) {
          this._styles = t, this._layer.setStyle(this._getStyleOptions.bind(this));
        }
      }, {
        key: "_getStyleOptions",
        value: function value(t) {
          var e = (0, o.default)(this._styles, t, this._zIndex, function (e, n, r) {
            return t.getProperty(n) || r;
          });
          return "Polyline" === t.geometry.type || "MultiPolyline" === t.geometry.type ? {
            strokeOpacity: e.icon.borderOpacity,
            strokeColor: e.shape.borderColor,
            strokeWeight: e.shape.borderWeight,
            zIndex: e.zIndex
          } : "Polygon" === t.geometry.type || "MultiPolygon" === t.geometry.type ? {
            strokeOpacity: e.icon.borderOpacity,
            strokeColor: e.shape.borderColor,
            strokeWeight: e.shape.borderWeight,
            zIndex: e.zIndex,
            fillColor: e.shape.fillColor,
            fillOpacity: e.shape.opacity
          } : "Point" === t.geometry.type || "MultiPoint" === t.geometry.type ? {
            icon: (0, a.convertKIconToGoogleIcon)(e.icon),
            title: e.icon.text,
            zIndex: e.zIndex,
            opacity: e.icon.opacity
          } : null;
        }
      }, {
        key: "addGeoJson",
        value: function value(t) {
          this._layer.addGeoJson(t);
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          return this._layer.addListener(e, function (n) {
            t.trigger(e, n.feature);
          });
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          google.maps.event.removeListener(t);
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          var e = this;
          this._layer.forEach(function (n) {
            e._layer.overrideStyle(n, {
              zIndex: t
            });
          }), this._zIndex = t;
        }
      }, {
        key: "toggle",
        value: function value(t) {
          return t ? this._layer.setMap(this._map) : this._layer.setMap(null);
        }
      }]), t;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = s(n(14)),
        i = s(n(0)),
        o = s(n(1)),
        a = n(2);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function () {
      function t(e, n, o, a) {
        (0, i.default)(this, t), this._map = n, this._desc = a, this._listeners = [];
        var s = {
          icon: {
            anchor: o.anchor ? new google.maps.Point(o.anchor[0], o.anchor[1]) : void 0,
            scaledSize: o.size ? new google.maps.Size(o.size[0], o.size[1]) : void 0,
            labelClass: "kmap-marker-label",
            labelStyle: {
              opacity: o.opacity
            },
            labelOrigin: o.labelAnchor ? new google.maps.Point(o.labelAnchor[0], o.labelAnchor[1]) : void 0,
            url: o.url
          },
          optimized: !1,
          opacity: o.opacity,
          zIndex: o.zIndex,
          label: o.labelValue && {
            color: "#000",
            fontFamily: "roboto",
            fontSize: "12px",
            fontWeight: "600",
            text: o.labelValue
          }
        };
        e.lat || e.lng || (s.position = {
          lat: e[0],
          lng: e[1]
        }), this._vector = new google.maps.Marker((0, r.default)({
          position: e
        }, s)), this._vector.setMap(this._map);
      }

      return (0, o.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case a.KGeometryEvents.DOUBLECLICK:
            case a.KGeometryEvents.RIGHTCLICK:
            case a.KGeometryEvents.CLICK:
              var r = this._vector.addListener(e, function (r) {
                t.trigger(e, {
                  type: a.KGeometryType.POINT,
                  desc: n._desc,
                  clickedLatLng: r.latLng.toJSON(),
                  geom: r.latLng.toJSON()
                });
              });

              return this._listeners.push(r), r;

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          return google.maps.event.removeListener(t);
        }
      }, {
        key: "remove",
        value: function value() {
          this._vector.setMap(null), this._listeners.forEach(function (t) {
            return google.maps.event.removeListener(t);
          });
        }
      }]), t;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = s(n(0)),
        i = s(n(1)),
        o = s(n(5)),
        a = n(2);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function () {
      function t(e, n, i, a) {
        (0, r.default)(this, t), this._map = n, this._events = {}, this._desc = a, this._areas = e, this._listeners = [];
        var s = (0, o.default)(e, function (t) {
          return (0, o.default)(t, function (t) {
            return {
              lat: t[0],
              lng: t[1]
            };
          });
        });
        this._vector = new google.maps.Polygon({
          paths: s,
          strokeWeight: i.borderWeight,
          strokeColor: i.borderColor,
          strokeOpacity: i.borderOpacity,
          fillColor: i.fillColor,
          fillOpacity: i.opacity,
          zIndex: i.zIndex
        }), this._vector.setMap(this._map);
      }

      return (0, i.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case a.KGeometryEvents.RIGHTCLICK:
            case a.KGeometryEvents.DOUBLECLICK:
            case a.KGeometryEvents.CLICK:
              var r = this._vector.addListener(e, function (r) {
                t.trigger(e, {
                  type: a.KGeometryType.POLYGON,
                  clickedLatLng: r.latLng.toJSON(),
                  desc: n._desc,
                  geom: n._areas
                });
              });

              return this._listeners.push(r), r;

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          return google.maps.event.removeListener(t);
        }
      }, {
        key: "remove",
        value: function value() {
          this._vector.setMap(null), this._listeners.forEach(function (t) {
            return google.maps.event.removeListener(t);
          });
        }
      }]), t;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = s(n(0)),
        i = s(n(1)),
        o = s(n(5)),
        a = n(2);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function () {
      function t(e, n, i, a) {
        (0, r.default)(this, t), this._map = n, this._events = {}, this._desc = a, this._line = e, this._listeners = [];
        var s = (0, o.default)(e, function (t) {
          return {
            lat: t[0],
            lng: t[1]
          };
        });
        this._vector = new google.maps.Polyline({
          paths: s,
          strokeWeight: i.borderWeight,
          strokeColor: i.borderColor,
          strokeOpacity: i.borderOpacity,
          zIndex: i.zIndex
        }), this._vector.setMap(this._map);
      }

      return (0, i.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case a.KGeometryEvents.RIGHTCLICK:
            case a.KGeometryEvents.DOUBLECLICK:
            case a.KGeometryEvents.CLICK:
              var r = this._vector.addListener(e, function (r) {
                t.trigger(e, {
                  type: a.KGeometryType.POLYLINE,
                  clickedLatLng: r.latLng.toJSON(),
                  desc: n._desc,
                  geom: n._line
                });
              });

              return this._listeners.push(r), r;

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          return google.maps.event.removeListener(t);
        }
      }, {
        key: "remove",
        value: function value() {
          this._vector.setMap(null), this._listeners.forEach(function (t) {
            return google.maps.event.removeListener(t);
          });
        }
      }]), t;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = void 0;

      var r = b(n(9)),
          i = b(n(7)),
          o = b(n(0)),
          a = b(n(1)),
          s = b(n(4)),
          u = n(28),
          l = n(2),
          c = b(n(418)),
          h = b(n(419)),
          f = b(n(420)),
          p = b(n(421)),
          d = b(n(422)),
          v = b(n(423)),
          y = b(n(424)),
          m = b(n(425)),
          g = b(n(426)),
          _ = n(36);

      function b(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      function L(t, e, n, r, i) {
        var o = {
          where: e,
          bounds: n,
          callback: function callback(t) {
            if (t && t.results && t.results.length > 0) {
              var e = (0, s.default)(t, ["results", 0, "bestView", "bounds"]),
                  n = void 0;
              e && (n = {
                south: e[0],
                east: e[1],
                north: e[2],
                west: e[3]
              }), r({
                location: (0, _.transformBingLatLngToCoord)(t.results[0].location),
                bounds: n,
                address: (0, s.default)(t.results[0], ["address", "formattedAddress"])
              });
            } else i({
              error: l.ErrorCodes.ADDRESS_NOT_FOUND
            });
          },
          errorCallback: function errorCallback() {
            i({
              error: l.ErrorCodes.ADDRESS_SEARCH_FAILED
            });
          }
        };
        t.geocode(o);
      }

      var x = function () {
        function e() {
          (0, o.default)(this, e);
        }

        return (0, a.default)(e, [{
          key: "initialize",
          value: function value(t, e) {
            if (this._mapOptions = (0, i.default)({
              disableStreetside: !0,
              credentials: e.apiKey,
              showZoomButtons: !1,
              showTermsLink: !1,
              showTrafficButton: !1,
              showScalebar: e.showScalebar,
              showMapTypeSelector: !1,
              showLocateMeButton: !1,
              showDashboard: !1,
              center: {
                latitude: (0, s.default)(e, "center.lat"),
                longitude: (0, s.default)(e, "center.lng")
              },
              mapTypeId: Microsoft.Maps.MapTypeId[e.mapType],
              zoom: e.zoom
            }), this._dom = t, e.allowedBBox) {
              var n = e.allowedBBox;
              this._mapOptions.maxBounds = Microsoft.Maps.LocationRect.fromEdges(n.north, n.west, n.south, n.east);
            }

            this._map = new Microsoft.Maps.Map(this._dom, this._mapOptions);
          }
        }, {
          key: "createTileLayer",
          value: function value(t, e) {
            return new h.default(t, e, this._map);
          }
        }, {
          key: "createAnimatedTile",
          value: function value(t, e) {
            return new f.default(t, e, this._map);
          }
        }, {
          key: "createVectorLayer",
          value: function value(t, e) {
            return new c.default(t, this._map, e);
          }
        }, {
          key: "createDrawLayer",
          value: function value(t) {
            return new p.default(t, this._map);
          }
        }, {
          key: "createClusterLayer",
          value: function value(t) {
            return new d.default(t, this._map);
          }
        }, {
          key: "createGeoJsonLayer",
          value: function value(t) {
            return new v.default(t, this._map);
          }
        }, {
          key: "createPoint",
          value: function value(t, e, n) {
            return new y.default(t, this._map, e, n);
          }
        }, {
          key: "createPolygon",
          value: function value(t, e, n) {
            return new m.default(t, this._map, e, n);
          }
        }, {
          key: "createPolyline",
          value: function value(t, e, n) {
            return new g.default(t, this._map, e, n);
          }
        }, {
          key: "getCenter",
          value: function value() {
            return (0, _.transformBingLatLngToCoord)(this._map.getCenter());
          }
        }, {
          key: "setCenter",
          value: function value(t) {
            this._map.setView({
              center: (0, _.transformCoordToBingLatLng)(t)
            });
          }
        }, {
          key: "getZoom",
          value: function value() {
            return this._map.getZoom();
          }
        }, {
          key: "setZoom",
          value: function value(t) {
            this._map.setView({
              zoom: t
            });
          }
        }, {
          key: "getView",
          value: function value() {
            return {
              center: this.getCenter(),
              zoom: this.getZoom()
            };
          }
        }, {
          key: "setView",
          value: function value(t) {
            this._map.setView({
              center: t.center && (0, _.transformCoordToBingLatLng)(t.center),
              zoom: t.zoom
            });
          }
        }, {
          key: "fitBounds",
          value: function value(t) {
            this._map.setView({
              bounds: Microsoft.Maps.LocationRect.fromEdges(t.north, t.west, t.south, t.east)
            });
          }
        }, {
          key: "getBounds",
          value: function value() {
            var t = this._map.getBounds();

            return {
              north: t.getNorth(),
              east: t.getEast(),
              south: t.getSouth(),
              west: t.getWest()
            };
          }
        }, {
          key: "setMapType",
          value: function value(t) {
            this._map.setMapType(Microsoft.Maps.MapTypeId[t]);
          }
        }, {
          key: "goToAddress",
          value: function value(t) {
            var e = this;
            return new r.default(function (n, r) {
              e.geocoder ? L(e.geocoder, t, e._mapOptions.maxBounds, n, r) : Microsoft.Maps.loadModule("Microsoft.Maps.Search", function () {
                e.geocoder = new Microsoft.Maps.Search.SearchManager(e._map), L(e.geocoder, t, e._mapOptions.maxBounds, n, r);
              });
            });
          }
        }, {
          key: "searchAddress",
          value: function value(t) {
            var e = this;
            return new r.default(function (n) {
              var r = function r(t) {
                return n({
                  results: t.map(function (t) {
                    return t.formattedSuggestion;
                  })
                });
              };

              e.searchManager ? e.searchManager.getSuggestions(t, r) : Microsoft.Maps.loadModule("Microsoft.Maps.AutoSuggest", function () {
                var n = {
                  maxResults: 5,
                  map: e._map,
                  bounds: e._mapOptions.maxBounds,
                  country: e._mapOptions.country
                };
                e.searchManager = new Microsoft.Maps.AutosuggestManager(n), e.searchManager.getSuggestions(t, r);
              });
            });
          }
        }, {
          key: "panBy",
          value: function value(t, e) {
            var n = this._map.tryPixelToLocation(new Microsoft.Maps.Point(this._map.getWidth() / 2 + t, this._map.getHeight() / 2 - e), Microsoft.Maps.PixelReference.control);

            this._map.setView({
              center: n
            });
          }
        }, {
          key: "contains",
          value: function value(t) {
            return !this._mapOptions.maxBounds || this._mapOptions.maxBounds.contains((0, _.transformCoordToBingLatLng)(t));
          }
        }, {
          key: "addEvent",
          value: function value(t, e) {
            var n = this;

            switch (e) {
              case l.KMapEvent.CLICK:
                return Microsoft.Maps.Events.addHandler(this._map, "click", function (n) {
                  t.trigger(e, (0, _.transformBingLatLngToCoord)(n.location));
                });

              case "KMapEvent.boundsChange":
                return Microsoft.Maps.Events.addHandler(this._map, "viewchangeend", function () {
                  t.trigger(e, n.getBounds());
                });

              case "KMapEvent.zoomChange":
                return Microsoft.Maps.Events.addHandler(this._map, "viewchangeend", function () {
                  t.trigger(e, n.getZoom());
                });

              case l.KMapEvent.VIEWCHANGED:
                return Microsoft.Maps.Events.addHandler(this._map, "viewchangeend", function () {
                  t.trigger(e, n.getView());
                });

              case l.KMapEvent.DOUBLECLICK:
                return Microsoft.Maps.Events.addHandler(this._map, "dblclick", function (n) {
                  t.trigger(e, (0, _.transformBingLatLngToCoord)(n.location));
                });

              case l.KMapEvent.RIGHTCLICK:
                return Microsoft.Maps.Events.addHandler(this._map, "rightclick", function (n) {
                  t.trigger(e, (0, _.transformBingLatLngToCoord)(n.location));
                });

              default:
                return null;
            }
          }
        }, {
          key: "removeEvent",
          value: function value(t) {
            Microsoft.Maps.Events.removeHandler(t);
          }
        }], [{
          key: "setUp",
          value: function value() {
            if (t.Microsoft && Microsoft.Maps) return r.default.resolve();
            return new r.default(function (e) {
              t.window.onBingLoad = function () {
                e();
              }, (0, u.loadAutoCompleteAPI)("https://www.bing.com/api/maps/mapcontrol?callback=onBingLoad");
            });
          }
        }]), e;
      }();

      e.default = x;
    }).call(this, n(10));
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = f(n(7)),
        i = f(n(0)),
        o = f(n(1)),
        a = f(n(34)),
        s = f(n(5)),
        u = f(n(24)),
        l = f(n(4)),
        c = n(36),
        h = n(2);

    function f(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var p = function () {
      function t(e, n, r) {
        (0, i.default)(this, t), this._name = e, this._map = n, this._props = r, this._clickCursor = (0, l.default)(r, "clickable", !0) ? "pointer" : "default", this._layer = new Microsoft.Maps.Layer(e), this._map.layers.insert(this._layer), this._points = [], this._events = {};
      }

      return (0, o.default)(t, [{
        key: "clear",
        value: function value() {
          this._layer.clear();
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._layer.setZIndex(t);
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._layer.setVisible(t);
        }
      }, {
        key: "remove",
        value: function value() {
          this._layer.clear(), this._map.layers.remove(this._layer), this._layer.dispose();
        }
      }, {
        key: "addPoints",
        value: function value(t, e, n, r) {
          if (!(0, u.default)(t.points)) {
            var i = {
              geom: t,
              desc: e,
              kStyle: n,
              type: h.KGeometryType.POINT,
              id: r
            },
                o = {
              icon: n.icon.url,
              anchor: n.icon.anchor ? new Microsoft.Maps.Point(n.icon.anchor[0], n.icon.anchor[1]) : void 0,
              opacity: n.icon.opacity,
              zIndex: n.zIndex,
              cursor: this._clickCursor
            },
                a = (0, s.default)(t.points, function (t) {
              var e = new Microsoft.Maps.Pushpin({
                latitude: t[0][0],
                longitude: t[0][1]
              }, o);
              return e.metadata = i, e;
            });
            this._clusterLayer ? (this._points = this._points.concat(a), this._clusterLayer.setPushpins(this._points)) : this._layer.add(a);
          }
        }
      }, {
        key: "addPolygons",
        value: function value(t, e, n, r) {
          if (!(0, u.default)(t.areas)) {
            var i = {
              geom: t,
              desc: e,
              kStyle: n,
              type: h.KGeometryType.POLYGON,
              id: r
            },
                o = new Microsoft.Maps.Color.fromHex(n.shape.fillColor),
                a = new Microsoft.Maps.Color.fromHex(n.shape.borderColor);
            o.a = n.shape.opacity, a.a = n.shape.borderOpacity;
            var l = {
              fillColor: o,
              strokeColor: a,
              strokeThickness: n.shape.borderWeight,
              cursor: this._clickCursor
            },
                c = (0, s.default)(t.areas, function (t) {
              return (0, s.default)(t, function (t) {
                return {
                  latitude: t[0],
                  longitude: t[1]
                };
              });
            }),
                f = new Microsoft.Maps.Polygon(c, l);
            f.metadata = i, this._layer.add(f);
          }
        }
      }, {
        key: "addPolylines",
        value: function value(t, e, n, r) {
          if (!(0, u.default)(t.lines)) {
            var i = new Microsoft.Maps.Color.fromHex(n.shape.borderColor);
            i.a = n.shape.borderOpacity;
            var o = {
              geom: t,
              desc: e,
              kStyle: n,
              type: h.KGeometryType.POLYLINE,
              id: r
            },
                a = {
              strokeColor: i,
              strokeThickness: n.shape.borderWeight,
              cursor: this._clickCursor
            },
                l = (0, s.default)(t.lines, function (t) {
              return (0, s.default)(t, function (t) {
                return {
                  latitude: t[0],
                  longitude: t[1]
                };
              });
            }),
                c = new Microsoft.Maps.Polyline(l, a);
            c.metadata = o, this._layer.add(c);
          }
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          function i(i) {
            var o = function o(n) {
              t.trigger(e, (0, r.default)(n.target.metadata, {
                clickedLatLng: (0, c.transformBingLatLngToCoord)(n.location)
              }));
            };

            return n._events[i] = o, n._clusterLayer && Microsoft.Maps.Events.addHandler(n._clusterLayer, i, o), Microsoft.Maps.Events.addHandler(n._layer, i, o);
          }

          switch (e) {
            case h.KLayerEvents.DOUBLECLICK:
              return i("dblclick");

            case h.KLayerEvents.RIGHTCLICK:
              return i("rightclick");

            case h.KLayerEvents.CLICK:
              return i("click");

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }, {
        key: "setClustering",
        value: function value(t) {
          var e = this;
          t && !this._clusterLayer ? Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function () {
            e._clusterLayer = new Microsoft.Maps.ClusterLayer([]), e._map.layers.insert(e._clusterLayer), (0, a.default)(e._events, function (t, n) {
              return Microsoft.Maps.Events.addHandler(e._clusterLayer, n, t);
            });
          }) : this._clusterLayer && (this._map.layers.remove(this._clusterLayer), this._clusterLayer = null);
        }
      }]), t;
    }();

    e.default = p;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = a(n(0)),
        i = a(n(1)),
        o = n(2);

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var s = function () {
      function t(e, n, i) {
        (0, r.default)(this, t);
        var o = n.replace("{z}", "{zoom}");
        o = o.replace("{q}", "{quadkey}");
        var a = {
          minZoom: e.minZoom,
          maxZoom: e.maxZoom,
          uriConstructor: o
        };

        if (e.bounds) {
          var s = e.bounds;
          a.bounds = Microsoft.Maps.LocationRect.fromEdges(s.north, s.west, s.south, s.east);
        }

        var u = new Microsoft.Maps.TileSource(a);
        this._map = i, this._props = e, this._tile = new Microsoft.Maps.TileLayer({
          mercator: u,
          opacity: e.opacity,
          visible: e.visible,
          zIndex: e.zIndex
        }), this._map.layers.insert(this._tile);
      }

      return (0, i.default)(t, [{
        key: "remove",
        value: function value() {
          this._map.layers.remove(this._tile), this._tile.dispose();
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._tile.setVisible(t);
        }
      }, {
        key: "setOpacity",
        value: function value(t) {
          this._tile.setOpacity(t);
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._tile.setZIndex(t);
        }
      }, {
        key: "setSource",
        value: function value(t) {
          var e = t.replace("{z}", "{zoom}"),
              n = new Microsoft.Maps.TileSource({
            uriConstructor: e
          }),
              r = this._baseTile.getVisible();

          this._map.layers.remove(this._tile), this._tile.dispose(), this._tile = new Microsoft.Maps.TileLayer({
            mercator: n,
            opacity: this._props.opacity,
            visible: r,
            zIndex: this._props.zIndex
          }), this._map.layers.insert(this._tile);
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          switch (e) {
            case o.KLayerEvents.TILESLOADED:
              return Microsoft.Maps.Events.addHandler(this._tile, "tiledownloadcomplete", function () {
                t.trigger(e);
              });

            default:
              return Microsoft.Maps.Events.addHandler(this._tile, e, function () {
                t.trigger(e, {});
              });
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }]), t;
    }();

    e.default = s;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = s(n(14)),
        i = s(n(0)),
        o = s(n(1)),
        a = n(2);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = void 0;

    var l = function () {
      function t(e, n, o) {
        (0, i.default)(this, t);
        var a = {
          minZoom: e.minZoom,
          maxZoom: e.maxZoom
        };

        if (this._sources = n, e.bounds) {
          var s = e.bounds;
          a.bounds = Microsoft.Maps.LocationRect.fromEdges(s.north, s.west, s.south, s.east);
        }

        var l = n.map(function (t) {
          var e = t.replace("{z}", "{zoom}");
          return new Microsoft.Maps.TileSource((0, r.default)({}, a, {
            uriConstructor: e
          }));
        });
        this._map = o, this._props = e, this._tile = new Microsoft.Maps.AnimatedTileLayer({
          mercator: l,
          opacity: e.opacity,
          visible: e.visible,
          zIndex: e.zIndex,
          frameRate: e.frameRate,
          loadingScreen: function () {
            if (u) return u;

            function t() {}

            return t.prototype = new Microsoft.Maps.CustomOverlay(), t.prototype.onAdd = function () {
              var t = document.createElement("div");
              t.style.display = "none", this.setHtmlElement(t);
            }, u = new t();
          }(),
          autoPlay: !1
        }), this._baseTile = new Microsoft.Maps.TileLayer({
          mercator: l[l.length - 1],
          opacity: e.opacity,
          visible: !e.autoPlay && e.visible,
          zIndex: e.zIndex
        }), this._map.layers.insert(this._baseTile);
      }

      return (0, o.default)(t, [{
        key: "remove",
        value: function value() {
          this._map.layers.remove(this._tile), this._map.layers.remove(this._baseTile);
        }
      }, {
        key: "toggle",
        value: function value(t) {
          t || this._map.layers.remove(this._tile), this._baseTile.setVisible(t);
        }
      }, {
        key: "setOpacity",
        value: function value(t) {
          this._tile.setOptions({
            opacity: t
          }), this._props.opacity = t, this._tile._htmlElement && this._tile._htmlElement.style.opacity !== t && (this._tile._htmlElement.style.opacity = t), this._baseTile.setOpacity(t);
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._tile.setOptions({
            zIndex: t
          }), this._baseTile.setZIndex(t);
        }
      }, {
        key: "play",
        value: function value() {
          this._map.layers.insert(this._tile), this._tile.play(), this._baseTile.setVisible(!1);
        }
      }, {
        key: "pause",
        value: function value() {
          this._tile.pause();
        }
      }, {
        key: "stop",
        value: function value() {
          this._tile.stop(), this._map.layers.remove(this._tile), this._baseTile.setVisible(!0);
        }
      }, {
        key: "setSources",
        value: function value(t) {
          var e = this,
              n = t.map(function (t) {
            var n = t.replace("{z}", "{zoom}");
            return new Microsoft.Maps.TileSource({
              minZoom: e._props.minZoom,
              maxZoom: e._props.maxZoom,
              uriConstructor: n
            });
          });

          this._tile.setOptions({
            mercator: n
          });

          var r = this._baseTile.getVisible();

          this._map.layers.remove(this._baseTile), this._baseTile.dispose(), this._baseTile = new Microsoft.Maps.TileLayer({
            mercator: n[n.length - 1],
            opacity: this._props.opacity,
            visible: r,
            zIndex: this._props.zIndex
          }), this._map.layers.insert(this._baseTile);
        }
      }, {
        key: "setFrameRate",
        value: function value(t) {
          this._tile.setOptions({
            frameRate: t
          });
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          switch (e) {
            case a.KLayerEvents.FRAMELOADED:
              return Microsoft.Maps.Events.addHandler(this._tile, "onFrameLoaded", function (n) {
                t.trigger(e, n.index);
              });

            case a.KLayerEvents.TILESLOADED:
              return Microsoft.Maps.Events.addHandler(this._baseTile, "tiledownloadcomplete", function () {
                t.trigger(e);
              });

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }]), t;
    }();

    e.default = l;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r,
        i = d(n(14)),
        o = d(n(9)),
        a = d(n(0)),
        s = d(n(1)),
        u = d(n(5)),
        l = d(n(16)),
        c = d(n(24)),
        h = d(n(18)),
        f = n(36),
        p = n(76);

    function d(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function v(t) {
      return t.getRings().map(function (t) {
        return t.map(function (t) {
          return (0, f.transformBingLatLngToCoord)(t);
        });
      });
    }

    function y(t) {
      return [t.getLocations().map(function (t) {
        return (0, f.transformBingLatLngToCoord)(t);
      })];
    }

    function m(t) {
      return [(0, f.transformBingLatLngToCoord)(t.getLocation())];
    }

    function g(t, e, n) {
      return {
        icon: t,
        anchor: e.anchor ? new Microsoft.Maps.Point(e.anchor[0], e.anchor[1]) : void 0,
        opacity: e.opacity,
        zIndex: n
      };
    }

    var _ = (0, h.default)(r = function () {
      function t(e, n) {
        (0, a.default)(this, t), this._map = n, this._prop = e, this._vectors = [], this.setEventContext(this);
      }

      return (0, s.default)(t, [{
        key: "initialize",
        value: function value() {
          var t = this;
          return new o.default(function (e) {
            Microsoft.Maps.loadModule("Microsoft.Maps.DrawingTools", function () {
              t._tools = new Microsoft.Maps.DrawingTools(t._map), t._tools.showDrawingManager(function (n) {
                t._drawManager = n, e();
              });
            });
          });
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case p.KDrawEvents.POINT_COMPLETE:
              return Microsoft.Maps.Events.addHandler(this._drawManager, "drawingEnded", function (n) {
                n instanceof Microsoft.Maps.Pushpin && t.trigger(e, {
                  points: [m(n)]
                });
              });

            case p.KDrawEvents.POLYGON_COMPLETE:
              return Microsoft.Maps.Events.addHandler(this._drawManager, "drawingEnded", function (r) {
                r instanceof Microsoft.Maps.Polygon && (n._tools.finish(), t.trigger(e, {
                  areas: v(r)
                }));
              });

            case p.KDrawEvents.POLYLINE_COMPLETE:
              return Microsoft.Maps.Events.addHandler(this._drawManager, "drawingEnded", function (r) {
                r instanceof Microsoft.Maps.Polyline && (n._tools.finish(), t.trigger(e, {
                  lines: y(r)
                }));
              });

            default:
              return null;
          }
        }
      }, {
        key: "addPoints",
        value: function value(t, e) {
          var n = this;
          return (0, c.default)(t.points) ? null : (0, f.createPushpinWithText)(e.icon.url, null, e.icon.size, e.icon.labelAnchor).then(function (r) {
            var i = g(r, e.icon, e.zIndex);
            (0, l.default)(t.points, function (t) {
              var e = new Microsoft.Maps.Pushpin({
                latitude: t[0][0],
                longitude: t[0][1]
              }, i);
              return n._vectors.push(e), n._drawManager.add(e), e;
            });
          });
        }
      }, {
        key: "addPolygons",
        value: function value(t, e) {
          if (!(0, c.default)(t.areas)) {
            var n = new Microsoft.Maps.Color.fromHex(e.shape.fillColor),
                r = new Microsoft.Maps.Color.fromHex(e.shape.borderColor);
            n.a = e.shape.opacity, r.a = e.shape.borderOpacity;
            var i = {
              fillColor: n,
              strokeColor: r,
              strokeThickness: e.shape.borderWeight
            },
                o = (0, u.default)(t.areas, function (t) {
              return (0, u.default)(t, function (t) {
                return {
                  latitude: t[0],
                  longitude: t[1]
                };
              });
            }),
                a = new Microsoft.Maps.Polygon(o, i);
            this._vectors.push(a), this._drawManager.add(a);
          }
        }
      }, {
        key: "addPolylines",
        value: function value(t, e) {
          if (!(0, c.default)(t.lines)) {
            var n = new Microsoft.Maps.Color.fromHex(e.shape.borderColor);
            n.a = e.shape.borderOpacity;
            var r = {
              strokeColor: n,
              strokeThickness: e.shape.borderWeight
            },
                i = (0, u.default)(t.lines, function (t) {
              return (0, u.default)(t, function (t) {
                return {
                  latitude: t[0],
                  longitude: t[1]
                };
              });
            }),
                o = new Microsoft.Maps.Polyline(i, r);
            this._vectors.push(o), this._drawManager.add(o);
          }
        }
      }, {
        key: "startEdit",
        value: function value(t) {
          var e = this;
          this._tools.finish(), this._vectors.forEach(function (n) {
            return (n instanceof Microsoft.Maps.Polygon || n instanceof Microsoft.Maps.Polyline) && (e._drawManager.remove(n), e._tools.edit(n)), n instanceof Microsoft.Maps.Pushpin ? (0, f.createPushpinWithText)(t.icon.url, null, t.icon.size, t.icon.labelAnchor).then(function (r) {
              var o = g(r, t.icon, t.zIndex);
              e._drawManager.remove(n), n.setOptions((0, i.default)({}, o, {
                draggable: !0
              })), e._map.entities.add(n);
            }) : null;
          });
        }
      }, {
        key: "stopEdit",
        value: function value() {
          var t = this;
          this._vectors.forEach(function (e) {
            e instanceof Microsoft.Maps.Pushpin ? t._map.entities.remove(e) : t._tools.finish();
          }), this._drawManager.clear(), this._vectors = [];
        }
      }, {
        key: "deleteVector",
        value: function value() {
          var t = this;
          this._mode = "delete", this._tools.finish(), this._vectors.forEach(function (e) {
            e instanceof Microsoft.Maps.Pushpin && t._map.entities.remove(e);
          }), this._drawManager.clear(), this._vectors = [];
        }
      }, {
        key: "getSelectedGeometry",
        value: function value() {
          var t = {
            points: [],
            areas: [],
            lines: []
          };
          return this._vectors.forEach(function (e) {
            e instanceof Microsoft.Maps.Pushpin && t.points.push(m(e)), e instanceof Microsoft.Maps.Polygon && (t.areas = v(e)), e instanceof Microsoft.Maps.Polyline && (t.lines = y(e));
          }), t;
        }
      }, {
        key: "setDrawingMode",
        value: function value(t, e) {
          switch (e && e.shape && this._drawManager.setOptions({
            fillColor: new Microsoft.Maps.Color.fromHex(e.shape.fillColor),
            strokeColor: new Microsoft.Maps.Color.fromHex(e.shape.borderColor)
          }), t) {
            case p.DrawingMode.POINT:
              return this._drawManager.setDrawingMode(Microsoft.Maps.DrawingTools.DrawingMode.pushpin);

            case p.DrawingMode.POLYGON:
              return this._drawManager.setDrawingMode(Microsoft.Maps.DrawingTools.DrawingMode.polygon);

            case p.DrawingMode.POLYLINE:
              return this._drawManager.setDrawingMode(Microsoft.Maps.DrawingTools.DrawingMode.polyline);

            case p.DrawingMode.RECTANGLE:
            case p.DrawingMode.CIRCLE:
            default:
              return this._drawManager.setDrawingMode(Microsoft.Maps.DrawingTools.DrawingMode.none);
          }
        }
      }, {
        key: "clear",
        value: function value() {
          var t = this;
          this._vectors.forEach(function (e) {
            e instanceof Microsoft.Maps.Pushpin && t._map.entities.remove(e);
          }), this._vectors = [], this._tools.finish(), this._drawManager.clear();
        }
      }, {
        key: "remove",
        value: function value() {
          var t = this;
          this._vectors.forEach(function (e) {
            e instanceof Microsoft.Maps.Pushpin && t._map.entities.remove(e);
          }), this._vectors = null, this._drawManager.dispose(), this._tools.dispose();
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }]), t;
    }()) || r;

    e.default = _;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = p(n(14)),
        i = p(n(9)),
        o = p(n(0)),
        a = p(n(1)),
        s = p(n(5)),
        u = p(n(24)),
        l = p(n(4)),
        c = n(36),
        h = p(n(25)),
        f = n(2);

    function p(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var d = function () {
      function t(e, n) {
        var a = this;
        (0, o.default)(this, t), this._map = n, this._points = [], this._props = e, this._clickCursor = (0, l.default)(this._props, "clickable", !0) ? "pointer" : "default", this._layerPromise = new i.default(function (t) {
          Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function () {
            a._layer = new Microsoft.Maps.ClusterLayer(a._points, (0, r.default)({
              clusteredPinCallback: a.getClusterStyle.bind(a)
            }, a._props)), a._map.layers.insert(a._layer), t();
          });
        }), this._events = {};
      }

      return (0, a.default)(t, [{
        key: "getClusterStyle",
        value: function value(t) {
          var e = (0, h.default)(this._props.clusterStyle, {
            CLUSTERSIZE: t.containedPushpins.length
          }, this._props.zIndex);
          (0, c.createPushpinWithText)(e.icon.url, e.icon.labelValue, e.icon.size).then(function (n) {
            t.setOptions({
              icon: n,
              anchor: e.icon.anchor ? new Microsoft.Maps.Point(e.icon.anchor[0], e.icon.anchor[1]) : void 0,
              text: "",
              opacity: e.icon.opacity,
              zIndex: e.zIndex
            });
          });
        }
      }, {
        key: "clear",
        value: function value() {
          this._layer.clear();
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._layer && this._layer.setZIndex(t), this._props.zIndex = t;
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._layer && this._layer.setVisible(t), this._props.visible = t;
        }
      }, {
        key: "remove",
        value: function value() {
          this._layer.clear(), this._map.layers.remove(this._layer);
        }
      }, {
        key: "addPoints",
        value: function value(t, e, n) {
          var r = this;
          if ((0, u.default)(t.points)) return i.default.resolve();

          var o = {
            geom: t,
            desc: e,
            kStyle: n
          },
              a = function a(e) {
            var i = {
              icon: e,
              anchor: n.icon.anchor ? new Microsoft.Maps.Point(n.icon.anchor[0], n.icon.anchor[1]) : void 0,
              opacity: n.icon.opacity,
              zIndex: n.zIndex,
              cursor: r._clickCursor
            },
                a = (0, s.default)(t.points, function (t) {
              var e = new Microsoft.Maps.Pushpin({
                latitude: t[0][0],
                longitude: t[0][1]
              }, i);
              return e.metadata = o, e;
            });
            r._points = r._points.concat(a), clearTimeout(r._setClusterTimeout), r._setClusterTimeout = setTimeout(function () {
              r._layer && r._layer.setPushpins(r._points);
            }, 100);
          };

          return n.icon.labelValue ? (0, c.createPushpinWithText)(n.icon.url, n.icon.labelValue, n.icon.size).then(a) : i.default.resolve(a(n.icon.url));
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case f.KLayerEvents.DOUBLECLICK:
            case f.KLayerEvents.RIGHTCLICK:
            case f.KLayerEvents.CLICK:
              var o = function o(n) {
                var i = (0, r.default)({
                  clickedLatLng: (0, c.transformBingLatLngToCoord)(n.location)
                }, n.target.metadata, {
                  type: f.KGeometryType.POINT
                });
                n.target.containedPushpins && (i.desc = {
                  CLUSTERSIZE: n.target.containedPushpins.length,
                  cluster: !0
                }, i.geom = {
                  points: [[(0, c.transformBingLatLngToCoord)(n.target.getLocation())]]
                }), t.trigger(e, i);
              };

              return this._events[e] = o, i.default.resolve(this._layerPromise).then(function () {
                return Microsoft.Maps.Events.addHandler(n._layer, e, o);
              });

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }]), t;
    }();

    e.default = d;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = s(n(0)),
        i = s(n(1)),
        o = s(n(16)),
        a = s(n(25));

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function () {
      function t(e, n) {
        (0, r.default)(this, t), this._name = e, this._map = n, this._layer = new Microsoft.Maps.Layer(e), this._map.layers.insert(this._layer);
      }

      return (0, i.default)(t, [{
        key: "clear",
        value: function value() {
          this._layer.clear();
        }
      }, {
        key: "remove",
        value: function value() {
          this._layer.clear(), this._map.layers.remove(this._layer), delete this._layer;
        }
      }, {
        key: "setStyle",
        value: function value(t) {
          this._styles = t;
        }
      }, {
        key: "_getStyleOptions",
        value: function value(t) {
          var e = (0, a.default)(this._styles, t, this._zIndex, function (e, n, r) {
            return t.properties && t.properties[n] || r;
          }),
              n = new Microsoft.Maps.Color.fromHex(e.shape.fillColor),
              r = new Microsoft.Maps.Color.fromHex(e.shape.borderColor);
          return n.a = e.shape.opacity, r.a = e.shape.borderOpacity, {
            polygonOptions: {
              fillColor: n,
              strokeColor: r,
              strokeThickness: e.shape.borderWeight,
              zIndex: e.zIndex
            },
            pushpinOptions: {
              icon: e.icon.url,
              anchor: e.icon.anchor ? new Microsoft.Maps.Point(e.icon.anchor[0], e.icon.anchor[1]) : void 0,
              opacity: e.icon.opacity,
              zIndex: e.zIndex
            },
            polylineOptions: {
              strokeColor: r,
              strokeThickness: e.shape.borderWeight,
              zIndex: e.zIndex
            }
          };
        }
      }, {
        key: "addGeoJson",
        value: function value(t) {
          var e = this;

          function n(t) {
            Microsoft.Maps.loadModule("Microsoft.Maps.GeoJson", function () {
              var n = Microsoft.Maps.GeoJson.read(t, e._getStyleOptions(t));

              e._layer.add(n);
            });
          }

          t.feature ? (0, o.default)(t.feature, function (t) {
            return n(t);
          }) : n(t);
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          return Microsoft.Maps.Events.addHandler(this._layer, e, function (n) {
            t.trigger(e, n.feature);
          });
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._zIndex = t, this._layer.setZIndex(t);
        }
      }, {
        key: "toggle",
        value: function value(t) {
          this._layer.setVisible(t);
        }
      }]), t;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = l(n(9)),
        i = l(n(0)),
        o = l(n(1)),
        a = n(36),
        s = n(2),
        u = n(170);

    function l(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var c = 0,
        h = function () {
      function t(e, n, r, o) {
        (0, i.default)(this, t), this._map = n, this._events = {};
        var a = e;
        a.lat || a.lng || (a = {
          lat: a[0],
          lng: a[1]
        }), this._position = a, this._options = r, this._desc = o, c += 1, this._layer = new Microsoft.Maps.Layer("pointLayer" + c), r.zIndex && this._layer.setZIndex(r.zIndex), this._map.layers.insert(this._layer);
      }

      return (0, o.default)(t, [{
        key: "createVector",
        value: function value() {
          var t = this,
              e = this._options;
          return this._pushpinPromise = (0, u.createImageWithText)(e.url, e.labelValue, e.size, e.labelAnchor).then(function (n) {
            var r = {
              icon: n,
              anchor: e.anchor ? new Microsoft.Maps.Point(e.anchor[0], e.anchor[1]) : void 0,
              opacity: e.opacity,
              zIndex: e.zIndex
            };
            t._vector = new Microsoft.Maps.Pushpin((0, a.transformCoordToBingLatLng)(t._position), r), t._layer.add(t._vector);
          }), this._pushpinPromise;
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case s.KGeometryEvents.DOUBLECLICK:
            case s.KGeometryEvents.RIGHTCLICK:
            case s.KGeometryEvents.CLICK:
              var i = function i(r) {
                t.trigger(e, {
                  type: s.KGeometryType.POINT,
                  clickedLatLng: (0, a.transformBingLatLngToCoord)(r.location),
                  desc: n._desc,
                  geom: n._position
                });
              };

              return this._events[e] = i, this._vector ? Microsoft.Maps.Events.addHandler(this._vector, e, i) : r.default.resolve(this._pushpinPromise).then(function () {
                return Microsoft.Maps.Events.addHandler(n._vector, e, i);
              });

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.layers.remove(this._layer), this._layer.dispose();
        }
      }]), t;
    }();

    e.default = h;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = u(n(0)),
        i = u(n(1)),
        o = u(n(5)),
        a = n(2),
        s = n(36);

    function u(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var l = function () {
      function t(e, n, i, a) {
        (0, r.default)(this, t), this._map = n, this._events = {}, this._desc = a, this._areas = e;
        var s = new Microsoft.Maps.Color.fromHex(i.fillColor),
            u = new Microsoft.Maps.Color.fromHex(i.borderColor);
        s.a = i.opacity, u.a = i.borderOpacity;
        var l = {
          fillColor: s,
          strokeColor: u,
          strokeThickness: i.borderWeight
        },
            c = (0, o.default)(e, function (t) {
          return (0, o.default)(t, function (t) {
            return {
              latitude: t[0],
              longitude: t[1]
            };
          });
        });
        this._vector = new Microsoft.Maps.Polygon(c, l), this._map.entities.push(this._vector);
      }

      return (0, i.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case a.KGeometryEvents.RIGHTCLICK:
            case a.KGeometryEvents.DOUBLECLICK:
            case a.KGeometryEvents.CLICK:
              var r = function r(_r) {
                t.trigger(e, {
                  type: a.KGeometryType.POLYGON,
                  clickedLatLng: (0, s.transformBingLatLngToCoord)(_r.location),
                  desc: n._desc,
                  geom: n._areas
                });
              };

              return this._events[e] = r, Microsoft.Maps.Events.addHandler(this._vector, e, r);

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.entities.remove(this._vector);
        }
      }]), t;
    }();

    e.default = l;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = u(n(0)),
        i = u(n(1)),
        o = u(n(5)),
        a = n(2),
        s = n(36);

    function u(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var l = function () {
      function t(e, n, i, a) {
        (0, r.default)(this, t), this._map = n, this._events = {}, this._desc = a, this._line = e;
        var s = new Microsoft.Maps.Color.fromHex(i.borderColor);
        s.a = i.borderOpacity;
        var u = {
          strokeColor: s,
          strokeThickness: i.borderWeight
        },
            l = (0, o.default)(e, function (t) {
          return {
            latitude: t[0],
            longitude: t[1]
          };
        });
        this._vector = new Microsoft.Maps.Polyline(l, u), this._map.entities.push(this._vector);
      }

      return (0, i.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case a.KGeometryEvents.RIGHTCLICK:
            case a.KGeometryEvents.DOUBLECLICK:
            case a.KGeometryEvents.CLICK:
              var r = function r(_r2) {
                t.trigger(e, {
                  type: a.KGeometryType.POLYLINE,
                  clickedLatLng: (0, s.transformBingLatLngToCoord)(_r2.location),
                  desc: n._desc,
                  geom: n._line
                });
              };

              return this._events[e] = r, Microsoft.Maps.Events.addHandler(this._vector, e, r);

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t) {
          Microsoft.Maps.Events.removeHandler(t);
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.entities.remove(this._vector);
        }
      }]), t;
    }();

    e.default = l;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = e.LBaseLayerUrl = void 0;

      var r,
          i = x(n(9)),
          o = x(n(7)),
          a = x(n(0)),
          s = x(n(1)),
          u = x(n(90)),
          l = x(n(428)),
          c = x(n(441)),
          h = x(n(187)),
          f = x(n(442)),
          p = x(n(443)),
          d = x(n(450)),
          v = x(n(451)),
          y = n(2),
          m = x(n(452)),
          g = x(n(453)),
          _ = x(n(454)),
          b = n(28);

      function x(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      var w = e.LBaseLayerUrl = (r = {}, (0, u.default)(r, y.KMapType.leaflet.ROAD, {
        url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        options: {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          detectRetina: !0
        }
      }), (0, u.default)(r, y.KMapType.leaflet.TOPO, {
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
        options: {
          attribution: 'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
          detectRetina: !0
        }
      }), (0, u.default)(r, "mq-old-satellite", {
        url: "http://oatile{s}.mqcdn.com/tiles/1.0.0/sat/{z}/{x}/{y}.jpg",
        options: {
          attribution: 'Tiles Courtesy of <a href="http://www.mapquest.com/">MapQuest</a> &mdash; Portions Courtesy NASA/JPL-Caltech and U.S. Depart. of Agriculture, Farm Service Agency',
          subdomains: "1234",
          detectRetina: !0
        }
      }), (0, u.default)(r, y.KMapType.leaflet.HYBRID, {
        url: "https://{s}.{base}.maps.cit.api.here.com/maptile/2.1/{type}/{mapID}/hybrid.day/{z}/{x}/{y}/{size}/{format}?app_id={app_id}&app_code={app_code}&lg={language}",
        options: {
          attribution: 'Tiles Courtesy of <a href="http://www.mapquest.com/">MapQuest</a> &mdash; Portions Courtesy NASA/JPL-Caltech and U.S. Depart. of Agriculture, Farm Service Agency',
          subdomains: "1234",
          detectRetina: !0
        }
      }), (0, u.default)(r, y.KMapType.leaflet.OPEN_CYCLE, {
        url: "http://{s}.tile.opencyclemap.org/cycle/{z}/{x}/{y}.png",
        options: {
          attribution: '&copy; <a href="http://www.opencyclemap.org">OpenCycleMap</a>, {attribution.OpenStreetMap}',
          detectRetina: !0
        }
      }), (0, u.default)(r, y.KMapType.leaflet.OSMDE, {
        url: "https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png",
        options: {
          attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
          detectRetina: !0
        }
      }), (0, u.default)(r, y.KMapType.leaflet.MAP_QUEST, {
        url: "http://otile{s}.mqcdn.com/tiles/1.0.0/map/{z}/{x}/{y}.jpeg",
        options: {
          attribution: 'Tiles Courtesy of <a href="http://www.mapquest.com/">MapQuest</a> &mdash; Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
          subdomains: "1234",
          detectRetina: !0
        }
      }), (0, u.default)(r, y.KMapType.leaflet.OSMHOT, {
        url: "http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
        options: {
          attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>',
          detectRetina: !0
        }
      }), r),
          M = function () {
        function e() {
          (0, a.default)(this, e);
        }

        return (0, s.default)(e, [{
          key: "initialize",
          value: function value(t, e) {
            this._mapOptions = (0, o.default)({
              zoomControl: !1,
              attributionControl: e.showScalebar,
              mapType: y.KMapType.leaflet.ROAD
            }, e), e.allowedBBox && (this._mapOptions.maxBounds = L.latLngBounds([[e.allowedBBox.south, e.allowedBBox.west], [e.allowedBBox.north, e.allowedBBox.east]])), this._dom = t, this._map = new L.map(this._dom, this._mapOptions).setView([this._mapOptions.center.lat, this._mapOptions.center.lng], this._mapOptions.zoom), this._baseLayer = this.createTileLayer((0, o.default)({
              zIndex: 1,
              crossorigin: ""
            }, w[this._mapOptions.mapType].options), w[this._mapOptions.mapType].url);
          }
        }, {
          key: "createTileLayer",
          value: function value(t, e) {
            return new h.default(t, e, this._map);
          }
        }, {
          key: "createAnimatedTile",
          value: function value(t, e) {
            return new f.default(t, e, this._map);
          }
        }, {
          key: "createVectorLayer",
          value: function value(t, e) {
            return new c.default(t, this._map, e);
          }
        }, {
          key: "createDrawLayer",
          value: function value(t) {
            return new p.default(t, this._map);
          }
        }, {
          key: "createClusterLayer",
          value: function value(t) {
            return new d.default(t, this._map);
          }
        }, {
          key: "createGeoJsonLayer",
          value: function value(t) {
            return new v.default(t, this._map);
          }
        }, {
          key: "createPoint",
          value: function value(t, e, n) {
            return new m.default(t, this._map, e, n);
          }
        }, {
          key: "createPolygon",
          value: function value(t, e, n) {
            return new g.default(t, this._map, e, n);
          }
        }, {
          key: "createPolyline",
          value: function value(t, e, n) {
            return new _.default(t, this._map, e, n);
          }
        }, {
          key: "getCenter",
          value: function value() {
            return this._map.getCenter();
          }
        }, {
          key: "setCenter",
          value: function value(t) {
            this._map.panTo(t);
          }
        }, {
          key: "getZoom",
          value: function value() {
            return this._map.getZoom();
          }
        }, {
          key: "setZoom",
          value: function value(t) {
            this._map.setZoom(t);
          }
        }, {
          key: "getView",
          value: function value() {
            return {
              center: this.getCenter(),
              zoom: this.getZoom()
            };
          }
        }, {
          key: "setView",
          value: function value(t) {
            t.center && t.zoom ? this._map.setView(t.center, t.zoom, {
              animate: !1
            }) : t.center ? this.setCenter(t.center) : t.zoom && this.setZoom(t.zoom);
          }
        }, {
          key: "fitBounds",
          value: function value(t) {
            this._map.fitBounds([[t.south, t.west], [t.north, t.east]]);
          }
        }, {
          key: "getBounds",
          value: function value() {
            var t = this._map.getBounds();

            return {
              north: t.getNorthWest().wrap().lat,
              south: t.getSouthEast().wrap().lat,
              west: t.getNorthWest().wrap().lng,
              east: t.getSouthEast().wrap().lng
            };
          }
        }, {
          key: "setMapType",
          value: function value(t) {
            this._baseLayer.remove(), this._baseLayer = this.createTileLayer((0, o.default)({
              zIndex: 1,
              crossorigin: ""
            }, w[t].options), w[t].url);
          }
        }, {
          key: "goToAddress",
          value: function value(t) {
            var e = this;
            this.geocoder || (this.geocoder = new l.default({
              countrycodes: this._mapOptions.country
            }));
            var n = void 0;

            if (this._mapOptions.allowedBBox) {
              var r = this._mapOptions.allowedBBox;
              n = [r.west, r.south, r.east, r.north];
            }

            return new i.default(function (r, i) {
              e.geocoder.search({
                query: t,
                bounds: n
              }).then(function (t) {
                t && 0 !== t.length || i({
                  error: y.ErrorCodes.ADDRESS_NOT_FOUND
                });
                var e = t[0],
                    n = void 0;
                e.bounds && e.bounds.length > 0 && (n = {
                  south: e.bounds[0][0],
                  west: e.bounds[0][1],
                  north: e.bounds[1][0],
                  east: e.bounds[1][1]
                }), r({
                  location: {
                    lat: e.y,
                    lng: e.x
                  },
                  bounds: n,
                  address: e.label
                });
              }).catch(function (t) {
                return i(t);
              });
            });
          }
        }, {
          key: "searchAddress",
          value: function value(t) {
            var e = this;
            this.geocoder || (this.geocoder = new l.default({
              countrycodes: this._mapOptions.country
            }));
            var n = {
              query: t,
              addressdetails: !0,
              limit: 5
            };

            if (this._mapOptions.allowedBBox) {
              var r = this._mapOptions.allowedBBox,
                  o = [r.west, r.south, r.east, r.north];
              n.bounds = o;
            }

            return new i.default(function (t) {
              e.geocoder.search(n).then(function (e) {
                t({
                  results: e.map(function (t) {
                    return t.label;
                  })
                });
              });
            });
          }
        }, {
          key: "panBy",
          value: function value(t, e) {
            this._map.panBy([t, e], {
              animate: !1
            });
          }
        }, {
          key: "contains",
          value: function value(t) {
            return !this._mapOptions.maxBounds || this._mapOptions.maxBounds.contains(t);
          }
        }, {
          key: "addEvent",
          value: function value(t, e) {
            var n = this;

            switch (e) {
              case y.KMapEvent.CLICK:
                var r = function r(n) {
                  t.trigger(e, n.latlng);
                };

                return this._map.on("click", r), r;

              case "KMapEvent.boundsChange":
                return this._map.on("bounds_changed", function () {
                  t.trigger(e, n.getBounds());
                });

              case "KMapEvent.zoomChange":
                return this._map.on("zoomend", function () {
                  t.trigger(e, n.getZoom());
                });

              case y.KMapEvent.VIEWCHANGED:
                var i = function i() {
                  t.trigger(e, n.getView());
                };

                return this._map.on("moveend", i), i;

              case y.KMapEvent.DOUBLECLICK:
                var o = function o(n) {
                  t.trigger(e, n.latlng);
                };

                return this._map.on("dblclick", o), o;

              case y.KMapEvent.RIGHTCLICK:
                var a = function a(n) {
                  t.trigger(e, n.latlng);
                };

                return this._map.on("contextmenu", a), a;

              default:
                return null;
            }
          }
        }, {
          key: "removeEvent",
          value: function value(t, e) {
            this._map.off(e, t);
          }
        }], [{
          key: "setUp",
          value: function value() {
            if (t.L && L.map) return i.default.resolve();
            return (0, b.loadAutoCompleteAPI)("https://unpkg.com/leaflet@1.3.1/dist/leaflet.js").then(function () {
              (0, b.loadCss)("https://unpkg.com/leaflet@1.3.1/dist/leaflet.css"), n(455);
            });
          }
        }]), e;
      }();

      e.default = M;
    }).call(this, n(10));
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = l(n(14)),
        i = l(n(35)),
        o = l(n(0)),
        a = l(n(1)),
        s = l(n(39)),
        u = l(n(40));

    function l(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var c = function (t) {
      function e() {
        return (0, o.default)(this, e), (0, s.default)(this, (e.__proto__ || (0, i.default)(e)).apply(this, arguments));
      }

      return (0, u.default)(e, t), (0, a.default)(e, [{
        key: "endpoint",
        value: function value() {
          var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).query,
              e = this.options.params;
          return "https://nominatim.openstreetmap.org/search?" + this.getParamString((0, r.default)({}, e, {
            format: "json",
            q: t
          }));
        }
      }]), e;
    }(n(429).OpenStreetMapProvider);

    e.default = c;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(430);
    Object.defineProperty(e, "GeoSearchControl", {
      enumerable: !0,
      get: function get() {
        return c(r).default;
      }
    });
    var i = n(185);
    Object.defineProperty(e, "SearchElement", {
      enumerable: !0,
      get: function get() {
        return c(i).default;
      }
    });
    var o = n(437);
    Object.defineProperty(e, "BingProvider", {
      enumerable: !0,
      get: function get() {
        return c(o).default;
      }
    });
    var a = n(438);
    Object.defineProperty(e, "EsriProvider", {
      enumerable: !0,
      get: function get() {
        return c(a).default;
      }
    });
    var s = n(439);
    Object.defineProperty(e, "GoogleProvider", {
      enumerable: !0,
      get: function get() {
        return c(s).default;
      }
    });
    var u = n(440);
    Object.defineProperty(e, "OpenStreetMapProvider", {
      enumerable: !0,
      get: function get() {
        return c(u).default;
      }
    });
    var l = n(54);

    function c(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "Provider", {
      enumerable: !0,
      get: function get() {
        return c(l).default;
      }
    });
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    l(n(53));

    var r = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    };

    e.default = function () {
      if (!L || !L.Control || !L.Control.extend) throw new Error("Leaflet must be loaded before instantiating the GeoSearch control");

      for (var t = L.Control.extend(f), e = arguments.length, n = Array(e), r = 0; r < e; r++) {
        n[r] = arguments[r];
      }

      return new (Function.prototype.bind.apply(t, [null].concat(n)))();
    };

    var i = l(n(435)),
        o = l(n(185)),
        a = l(n(436)),
        s = n(78),
        u = n(186);

    function l(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var c = {},
        h = ["dragging", "touchZoom", "doubleClickZoom", "scrollWheelZoom", "boxZoom", "keyboard"],
        f = {
      initialize: function initialize(t) {
        var e = this;
        this.markers = new L.FeatureGroup(), this.handlersDisabled = !1, this.options = r({}, {
          position: "topleft",
          style: "button",
          showMarker: !0,
          showPopup: !1,
          popupFormat: function popupFormat(t) {
            return "" + t.result.label;
          },
          marker: {
            icon: new L.Icon.Default(),
            draggable: !1
          },
          maxMarkers: 1,
          retainZoomLevel: !1,
          animateZoom: !0,
          searchLabel: "Enter address",
          notFoundMessage: "Sorry, that address could not be found.",
          messageHideDelay: 3e3,
          zoomLevel: 18,
          classNames: {
            container: "leaflet-bar leaflet-control leaflet-control-geosearch",
            button: "leaflet-bar-part leaflet-bar-part-single",
            resetButton: "reset",
            msgbox: "leaflet-bar message",
            form: "",
            input: ""
          },
          autoComplete: !0,
          autoCompleteDelay: 250,
          autoClose: !1,
          keepResult: !1
        }, t);
        var n = this.options,
            u = n.style,
            l = n.classNames,
            c = n.searchLabel,
            h = n.autoComplete,
            f = n.autoCompleteDelay;
        "button" !== u && (this.options.classNames.container += " " + t.style), this.searchElement = new o.default(r({}, this.options, {
          handleSubmit: function handleSubmit(t) {
            return e.onSubmit(t);
          }
        }));
        var p = this.searchElement.elements,
            d = p.container,
            v = p.form,
            y = p.input,
            m = (0, s.createElement)("a", l.button, d);
        m.title = c, m.href = "#", m.addEventListener("click", function (t) {
          e.onClick(t);
        }, !1);
        var g = (0, s.createElement)("a", l.resetButton, v);
        g.innerHTML = "X", m.href = "#", g.addEventListener("click", function () {
          e.clearResults(null, !0);
        }, !1), h && (this.resultList = new a.default({
          handleClick: function handleClick(t) {
            var n = t.result;
            y.value = n.label, e.onSubmit({
              query: n.label,
              data: n
            });
          }
        }), v.appendChild(this.resultList.elements.container), y.addEventListener("keyup", (0, i.default)(function (t) {
          return e.autoSearch(t);
        }, f), !0), y.addEventListener("keydown", function (t) {
          return e.selectResult(t);
        }, !0), y.addEventListener("keydown", function (t) {
          return e.clearResults(t, !0);
        }, !0)), v.addEventListener("mouseenter", function (t) {
          return e.disableHandlers(t);
        }, !0), v.addEventListener("mouseleave", function (t) {
          return e.restoreHandlers(t);
        }, !0), this.elements = {
          button: m,
          resetButton: g
        };
      },
      onAdd: function onAdd(t) {
        var e = this.options,
            n = e.showMarker,
            r = e.style;

        if (this.map = t, n && this.markers.addTo(t), "bar" === r) {
          var i = this.searchElement.elements.form,
              o = t.getContainer().querySelector(".leaflet-control-container"),
              a = (0, s.createElement)("div", "leaflet-control-geosearch bar");
          a.appendChild(i), o.appendChild(a), this.elements.container = a;
        }

        return this.searchElement.elements.container;
      },
      onRemove: function onRemove() {
        var t = this.elements.container;
        return t && t.remove(), this;
      },
      onClick: function onClick(t) {
        t.preventDefault();
        var e = this.searchElement.elements,
            n = e.container,
            r = e.input;
        n.classList.contains("active") ? ((0, s.removeClassName)(n, "active"), this.clearResults()) : ((0, s.addClassName)(n, "active"), r.focus());
      },
      disableHandlers: function disableHandlers(t) {
        var e = this,
            n = this.searchElement.elements.form;
        this.handlersDisabled || t && t.target !== n || (this.handlersDisabled = !0, h.forEach(function (t) {
          e.map[t] && (c[t] = e.map[t].enabled(), e.map[t].disable());
        }));
      },
      restoreHandlers: function restoreHandlers(t) {
        var e = this,
            n = this.searchElement.elements.form;
        !this.handlersDisabled || t && t.target !== n || (this.handlersDisabled = !1, h.forEach(function (t) {
          c[t] && e.map[t].enable();
        }));
      },
      selectResult: function selectResult(t) {
        if ([u.ENTER_KEY, u.ARROW_DOWN_KEY, u.ARROW_UP_KEY].includes(t.keyCode)) {
          t.preventDefault();
          var e = this.searchElement.elements.input,
              n = this.resultList;

          if (t.keyCode !== u.ENTER_KEY) {
            var r = n.count() - 1;

            if (!(r < 0)) {
              var i = "ArrowDown" === t.code ? 1 + ~~n.selected : ~~n.selected - 1,
                  o = i < 0 ? r : i > r ? 0 : i,
                  a = n.select(o);
              e.value = a.label;
            }
          } else {
            var s = n.select(n.selected);
            this.onSubmit({
              query: e.value,
              data: s
            });
          }
        }
      },
      clearResults: function clearResults(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

        if (!t || t.keyCode === u.ESCAPE_KEY) {
          var n = this.searchElement.elements.input,
              r = this.options,
              i = r.keepResult,
              o = r.autoComplete;
          !e && i || (n.value = "", this.markers.clearLayers()), o && this.resultList.clear();
        }
      },
      autoSearch: function autoSearch(t) {
        return new Promise(function (e, n) {
          var r, i, o;
          return u.SPECIAL_KEYS.includes(t.keyCode) ? e() : (r = t.target.value, i = this.options.provider, r.length ? i.search({
            query: r
          }).then(function (t) {
            return o = t, this.resultList.render(o), a.call(this);
          }.$asyncbind(this, n), n) : (this.resultList.clear(), a.call(this)));

          function a() {
            return e();
          }
        }.$asyncbind(this));
      },
      onSubmit: function onSubmit(t) {
        return new Promise(function (e, n) {
          var r;
          return this.options.provider.search(t).then(function (n) {
            return (r = n) && r.length > 0 && this.showResult(r[0], t), e();
          }.$asyncbind(this, n), n);
        }.$asyncbind(this));
      },
      showResult: function showResult(t, e) {
        var n = e.query,
            r = this.options.autoClose,
            i = Object.keys(this.markers._layers);
        i.length >= this.options.maxMarkers && this.markers.removeLayer(i[0]);
        var o = this.addMarker(t, n);
        this.centerMap(t), this.map.fireEvent("geosearch/showlocation", {
          location: t,
          marker: o
        }), r && this.closeResults();
      },
      closeResults: function closeResults() {
        var t = this.searchElement.elements.container;
        t.classList.contains("active") && (0, s.removeClassName)(t, "active"), this.restoreHandlers(), this.clearResults();
      },
      addMarker: function addMarker(t, e) {
        var n = this,
            r = this.options,
            i = r.marker,
            o = r.showPopup,
            a = r.popupFormat,
            s = new L.Marker([t.y, t.x], i),
            u = t.label;
        return "function" == typeof a && (u = a({
          query: e,
          result: t
        })), s.bindPopup(u), this.markers.addLayer(s), o && s.openPopup(), i.draggable && s.on("dragend", function (t) {
          n.map.fireEvent("geosearch/marker/dragend", {
            location: s.getLatLng(),
            event: t
          });
        }), s;
      },
      centerMap: function centerMap(t) {
        var e = this.options,
            n = e.retainZoomLevel,
            r = e.animateZoom,
            i = new L.LatLngBounds(t.bounds),
            o = i.isValid() ? i : this.markers.getBounds();
        !n && i.isValid() ? this.map.fitBounds(o, {
          animate: r
        }) : this.map.setView(o.getCenter(), this.getZoom(), {
          animate: r
        });
      },
      getZoom: function getZoom() {
        var t = this.options,
            e = t.retainZoomLevel,
            n = t.zoomLevel;
        return e ? this.map.getZoom() : n;
      }
    };
  }, function (t, e, n) {
    "use strict";

    (function (e, n) {
      t.exports = function (t) {
        t = t || "object" == typeof e && e.nextTick || "function" == typeof n && n || function (t) {
          setTimeout(t, 0);
        };

        var r = function () {
          var e = [],
              n = 0,
              r = 1024;

          function i() {
            for (; e.length - n;) {
              try {
                e[n]();
              } catch (t) {}

              e[n++] = void 0, n === r && (e.splice(0, r), n = 0);
            }
          }

          return function (r) {
            e.push(r), e.length - n == 1 && t(i);
          };
        }();

        function i(t) {
          if (t) {
            var e = this;
            t(function (t) {
              e.resolve(t);
            }, function (t) {
              e.reject(t);
            });
          }
        }

        function o(t, e) {
          if ("function" == typeof t.y) try {
            var n = t.y.call(void 0, e);
            t.p.resolve(n);
          } catch (e) {
            t.p.reject(e);
          } else t.p.resolve(e);
        }

        function a(t, e) {
          if ("function" == typeof t.n) try {
            var n = t.n.call(void 0, e);
            t.p.resolve(n);
          } catch (e) {
            t.p.reject(e);
          } else t.p.reject(e);
        }

        return i.prototype = {
          resolve: function resolve(t) {
            if (void 0 === this.state) {
              if (t === this) return this.reject(new TypeError("Attempt to resolve promise with self"));
              var e = this;
              if (t && ("function" == typeof t || "object" == typeof t)) try {
                var n = 0,
                    i = t.then;
                if ("function" == typeof i) return void i.call(t, function (t) {
                  n++ || e.resolve(t);
                }, function (t) {
                  n++ || e.reject(t);
                });
              } catch (t) {
                return void (n || this.reject(t));
              }
              this.state = o, this.v = t, e.c && r(function () {
                for (var n = 0, r = e.c.length; n < r; n++) {
                  o(e.c[n], t);
                }
              });
            }
          },
          reject: function reject(t) {
            if (void 0 === this.state) {
              this.state = a, this.v = t;
              var e = this.c;
              e && r(function () {
                for (var n = 0, r = e.length; n < r; n++) {
                  a(e[n], t);
                }
              });
            }
          },
          then: function then(t, e) {
            var n = new i(),
                o = {
              y: t,
              n: e,
              p: n
            };
            if (void 0 === this.state) this.c ? this.c.push(o) : this.c = [o];else {
              var a = this.state,
                  s = this.v;
              r(function () {
                a(o, s);
              });
            }
            return n;
          }
        }, i.resolve = function (t) {
          if (t && t instanceof i) return t;
          var e = new i();
          return e.resolve(t), e;
        }, i.reject = function (t) {
          if (t && t instanceof i) return t;
          var e = new i();
          return e.reject(t), e;
        }, i.version = "2.3.3-nodent", i;
      };
    }).call(this, n(103), n(432).setImmediate);
  }, function (t, e, n) {
    (function (t) {
      var r = void 0 !== t && t || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(t, e) {
        this._id = t, this._clearFn = e;
      }

      e.setTimeout = function () {
        return new o(i.call(setTimeout, r, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new o(i.call(setInterval, r, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, n(433), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, n(10));
  }, function (t, e, n) {
    (function (t, e) {
      !function (t, n) {
        "use strict";

        if (!t.setImmediate) {
          var r,
              i = 1,
              o = {},
              a = !1,
              s = t.document,
              u = Object.getPrototypeOf && Object.getPrototypeOf(t);
          u = u && u.setTimeout ? u : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
            e.nextTick(function () {
              c(t);
            });
          } : function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  n = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = n, e;
            }
          }() ? function () {
            var e = "setImmediate$" + Math.random() + "$",
                n = function n(_n2) {
              _n2.source === t && "string" == typeof _n2.data && 0 === _n2.data.indexOf(e) && c(+_n2.data.slice(e.length));
            };

            t.addEventListener ? t.addEventListener("message", n, !1) : t.attachEvent("onmessage", n), r = function r(n) {
              t.postMessage(e + n, "*");
            };
          }() : t.MessageChannel ? function () {
            var t = new MessageChannel();
            t.port1.onmessage = function (t) {
              c(t.data);
            }, r = function r(e) {
              t.port2.postMessage(e);
            };
          }() : s && "onreadystatechange" in s.createElement("script") ? function () {
            var t = s.documentElement;

            r = function r(e) {
              var n = s.createElement("script");
              n.onreadystatechange = function () {
                c(e), n.onreadystatechange = null, t.removeChild(n), n = null;
              }, t.appendChild(n);
            };
          }() : r = function r(t) {
            setTimeout(c, 0, t);
          }, u.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));

            for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
              e[n] = arguments[n + 1];
            }

            var a = {
              callback: t,
              args: e
            };
            return o[i] = a, r(i), i++;
          }, u.clearImmediate = l;
        }

        function l(t) {
          delete o[t];
        }

        function c(t) {
          if (a) setTimeout(c, 0, t);else {
            var e = o[t];

            if (e) {
              a = !0;

              try {
                !function (t) {
                  var e = t.callback,
                      r = t.args;

                  switch (r.length) {
                    case 0:
                      e();
                      break;

                    case 1:
                      e(r[0]);
                      break;

                    case 2:
                      e(r[0], r[1]);
                      break;

                    case 3:
                      e(r[0], r[1], r[2]);
                      break;

                    default:
                      e.apply(n, r);
                  }
                }(e);
              } finally {
                l(t), a = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, n(10), n(103));
  }, function (t, e) {
    t.exports = function () {
      function t(t) {
        return t && t instanceof Object && "function" == typeof t.then;
      }

      function e(n, r, i) {
        try {
          var o = i ? i(r) : r;
          if (n === o) return n.reject(new TypeError("Promise resolution loop"));
          t(o) ? o.then(function (t) {
            e(n, t);
          }, function (t) {
            n.reject(t);
          }) : n.resolve(o);
        } catch (t) {
          n.reject(t);
        }
      }

      function n(t) {}

      function r() {}

      function i(n, i) {
        var o = new r();

        try {
          this._resolver(function (r) {
            return t(r) ? r.then(n, i) : e(o, r, n);
          }, function (t) {
            e(o, t, i);
          });
        } catch (t) {
          e(o, t, i);
        }

        return o;
      }

      function o(t) {
        this._resolver = t, this.then = i;
      }

      return r.prototype = {
        resolve: n,
        reject: n,
        then: function then(t, e) {
          this.resolve = t, this.reject = e;
        }
      }, o.resolve = function (t) {
        return o.isThenable(t) ? t : {
          then: function then(e) {
            return e(t);
          }
        };
      }, o.isThenable = t, o;
    };
  }, function (t, e, n) {
    (function (e) {
      var n = "Expected a function",
          r = NaN,
          i = "[object Symbol]",
          o = /^\s+|\s+$/g,
          a = /^[-+]0x[0-9a-f]+$/i,
          s = /^0b[01]+$/i,
          u = /^0o[0-7]+$/i,
          l = parseInt,
          c = "object" == typeof e && e && e.Object === Object && e,
          h = "object" == typeof self && self && self.Object === Object && self,
          f = c || h || Function("return this")(),
          p = Object.prototype.toString,
          d = Math.max,
          v = Math.min,
          y = function y() {
        return f.Date.now();
      };

      function m(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
      }

      function g(t) {
        if ("number" == typeof t) return t;
        if (function (t) {
          return "symbol" == typeof t || function (t) {
            return !!t && "object" == typeof t;
          }(t) && p.call(t) == i;
        }(t)) return r;

        if (m(t)) {
          var e = "function" == typeof t.valueOf ? t.valueOf() : t;
          t = m(e) ? e + "" : e;
        }

        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(o, "");
        var n = s.test(t);
        return n || u.test(t) ? l(t.slice(2), n ? 2 : 8) : a.test(t) ? r : +t;
      }

      t.exports = function (t, e, r) {
        var i,
            o,
            a,
            s,
            u,
            l,
            c = 0,
            h = !1,
            f = !1,
            p = !0;
        if ("function" != typeof t) throw new TypeError(n);

        function _(e) {
          var n = i,
              r = o;
          return i = o = void 0, c = e, s = t.apply(r, n);
        }

        function b(t) {
          var n = t - l;
          return void 0 === l || n >= e || n < 0 || f && t - c >= a;
        }

        function L() {
          var t = y();
          if (b(t)) return x(t);
          u = setTimeout(L, function (t) {
            var n = e - (t - l);
            return f ? v(n, a - (t - c)) : n;
          }(t));
        }

        function x(t) {
          return u = void 0, p && i ? _(t) : (i = o = void 0, s);
        }

        function w() {
          var t = y(),
              n = b(t);

          if (i = arguments, o = this, l = t, n) {
            if (void 0 === u) return function (t) {
              return c = t, u = setTimeout(L, e), h ? _(t) : s;
            }(l);
            if (f) return u = setTimeout(L, e), _(l);
          }

          return void 0 === u && (u = setTimeout(L, e)), s;
        }

        return e = g(e) || 0, m(r) && (h = !!r.leading, a = (f = "maxWait" in r) ? d(g(r.maxWait) || 0, e) : a, p = "trailing" in r ? !!r.trailing : p), w.cancel = function () {
          void 0 !== u && clearTimeout(u), c = 0, i = l = o = u = void 0;
        }, w.flush = function () {
          return void 0 === u ? s : x(y());
        }, w;
      };
    }).call(this, n(10));
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        i = n(78);

    var o = function o() {
      for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) {
        e[n] = arguments[n];
      }

      return e.join(" ").trim();
    },
        a = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = e.handleClick,
            r = void 0 === n ? function () {} : n,
            a = e.classNames,
            u = void 0 === a ? {} : a;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), s.call(this), this.props = {
          handleClick: r,
          classNames: u
        }, this.selected = -1;
        var l = (0, i.createElement)("div", o("results", u.container)),
            c = (0, i.createElement)("div", o(u.item));
        l.addEventListener("click", this.onClick, !0), this.elements = {
          container: l,
          resultItem: c
        };
      }

      return r(t, [{
        key: "render",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              e = this.elements,
              n = e.container,
              r = e.resultItem;
          this.clear(), t.forEach(function (t, e) {
            var i = r.cloneNode(!0);
            i.setAttribute("data-key", e), i.innerHTML = t.label, n.appendChild(i);
          }), t.length > 0 && (0, i.addClassName)(n, "active"), this.results = t;
        }
      }, {
        key: "select",
        value: function value(t) {
          var e = this.elements.container;
          return Array.from(e.children).forEach(function (e, n) {
            return n === t ? (0, i.addClassName)(e, "active") : (0, i.removeClassName)(e, "active");
          }), this.selected = t, this.results[t];
        }
      }, {
        key: "count",
        value: function value() {
          return this.results ? this.results.length : 0;
        }
      }, {
        key: "clear",
        value: function value() {
          var t = this.elements.container;

          for (this.selected = -1; t.lastChild;) {
            t.removeChild(t.lastChild);
          }

          (0, i.removeClassName)(t, "active");
        }
      }]), t;
    }(),
        s = function s() {
      var t = this;

      this.onClick = function () {
        var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).target,
            n = t.props.handleClick,
            r = t.elements.container;

        if (e.parentNode === r && e.hasAttribute("data-key")) {
          var i = e.getAttribute("data-key");
          n({
            result: t.results[i]
          });
        }
      };
    };

    e.default = a;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    s(n(53));

    var r = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    },
        i = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        o = s(n(54)),
        a = n(78);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (t, e) {
          if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e || "object" != typeof e && "function" != typeof e ? t : e;
        }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
      }(e, o.default), i(e, [{
        key: "endpoint",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.query,
              n = t.protocol,
              i = t.jsonp,
              o = this.options.params;
          return n + "//dev.virtualearth.net/REST/v1/Locations?" + this.getParamString(r({}, o, {
            query: e,
            jsonp: i
          }));
        }
      }, {
        key: "parse",
        value: function value(t) {
          var e = t.data;
          return 0 === e.resourceSets.length ? [] : e.resourceSets[0].resources.map(function (t) {
            return {
              x: t.point.coordinates[1],
              y: t.point.coordinates[0],
              label: t.address.formattedAddress,
              bounds: [[t.bbox[0], t.bbox[1]], [t.bbox[2], t.bbox[3]]],
              raw: t
            };
          });
        }
      }, {
        key: "search",
        value: function value(t) {
          return new Promise(function (e, n) {
            var r, i, o, s, u;
            return r = t.query, i = ~location.protocol.indexOf("http") ? location.protocol : "https:", o = "BING_JSONP_CB_" + Date.now(), s = this.endpoint({
              query: r,
              protocol: i,
              jsonp: o
            }), (0, a.createScriptElement)(s, o).then(function (t) {
              return u = t, e(this.parse({
                data: u
              }));
            }.$asyncbind(this, n), n);
          }.$asyncbind(this));
        }
      }]), e;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    },
        i = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        o = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(54));

    var a = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (t, e) {
          if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e || "object" != typeof e && "function" != typeof e ? t : e;
        }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
      }(e, o.default), i(e, [{
        key: "endpoint",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.query,
              n = t.protocol,
              i = this.options.params;
          return n + "//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/find?" + this.getParamString(r({}, i, {
            f: "json",
            text: e
          }));
        }
      }, {
        key: "parse",
        value: function value(t) {
          return t.data.locations.map(function (t) {
            return {
              x: t.feature.geometry.x,
              y: t.feature.geometry.y,
              label: t.name,
              bounds: [[t.extent.ymin, t.extent.xmin], [t.extent.ymax, t.extent.xmax]],
              raw: t
            };
          });
        }
      }]), e;
    }();

    e.default = a;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    },
        i = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        o = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }(n(54));

    var a = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (t, e) {
          if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e || "object" != typeof e && "function" != typeof e ? t : e;
        }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
      }(e, o.default), i(e, [{
        key: "endpoint",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.query,
              n = t.protocol,
              i = this.options.params,
              o = this.getParamString(r({}, i, {
            address: e
          }));
          return (i && i.key ? "https:" : n) + "//maps.googleapis.com/maps/api/geocode/json?" + o;
        }
      }, {
        key: "parse",
        value: function value(t) {
          return t.data.results.map(function (t) {
            return {
              x: t.geometry.location.lng,
              y: t.geometry.location.lat,
              label: t.formatted_address,
              bounds: [[t.geometry.viewport.southwest.lat, t.geometry.viewport.southwest.lng], [t.geometry.viewport.northeast.lat, t.geometry.viewport.northeast.lng]],
              raw: t
            };
          });
        }
      }]), e;
    }();

    e.default = a;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    a(n(53));

    var r = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    },
        i = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        o = a(n(54));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var s = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (t, e) {
          if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e || "object" != typeof e && "function" != typeof e ? t : e;
        }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
      }(e, o.default), i(e, [{
        key: "endpoint",
        value: function value() {
          var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).query,
              e = this.options.params;
          return "https://nominatim.openstreetmap.org/search?" + this.getParamString(r({}, e, {
            format: "json",
            q: t
          }));
        }
      }, {
        key: "endpointReverse",
        value: function value() {
          var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).data,
              e = this.options.params;
          return "https://nominatim.openstreetmap.org/reverse?" + this.getParamString(r({}, e, {
            format: "json",
            osm_id: t.raw.osm_id,
            osm_type: this.translateOsmType(t.raw.osm_type)
          }));
        }
      }, {
        key: "parse",
        value: function value(t) {
          return t.data.map(function (t) {
            return {
              x: t.lon,
              y: t.lat,
              label: t.display_name,
              bounds: [[parseFloat(t.boundingbox[0]), parseFloat(t.boundingbox[2])], [parseFloat(t.boundingbox[1]), parseFloat(t.boundingbox[3])]],
              raw: t
            };
          });
        }
      }, {
        key: "search",
        value: function value(t) {
          return new Promise(function (e, n) {
            var r, i, o, a, s;
            return r = t.query, i = t.data, o = ~location.protocol.indexOf("http") ? location.protocol : "https:", a = i ? this.endpointReverse({
              data: i,
              protocol: o
            }) : this.endpoint({
              query: r,
              protocol: o
            }), fetch(a).then(function (t) {
              return t.json().then(function (t) {
                return s = t, e(this.parse({
                  data: i ? [s] : s
                }));
              }.$asyncbind(this, n), n);
            }.$asyncbind(this, n), n);
          }.$asyncbind(this));
        }
      }, {
        key: "translateOsmType",
        value: function value(t) {
          return "node" === t ? "N" : "way" === t ? "W" : "relation" === t ? "R" : "";
        }
      }]), e;
    }();

    e.default = s;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = c(n(0)),
        i = c(n(1)),
        o = c(n(5)),
        a = c(n(16)),
        s = c(n(24)),
        u = c(n(4)),
        l = n(2);

    function c(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var h = function () {
      function t(e, n, i) {
        (0, r.default)(this, t), this._name = e, this._map = n, this._layer = L.featureGroup().addTo(this._map), this._noClick = (0, u.default)(i, "clickable", !0) ? "" : "kmap-no-click";
      }

      return (0, i.default)(t, [{
        key: "setZIndex",
        value: function value(t) {
          this._layer.setZIndex(t);
        }
      }, {
        key: "toggle",
        value: function value(t) {
          return t ? this._map.addLayer(this._layer) : this._map.removeLayer(this._layer);
        }
      }, {
        key: "clear",
        value: function value() {
          this._layer.clearLayers();
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.removeLayer(this._layer);
        }
      }, {
        key: "addPoints",
        value: function value(t, e, n, r) {
          var i = this;

          if (!(0, s.default)(t.points)) {
            var o = {
              record: {
                geom: t,
                desc: e,
                kStyle: n,
                type: l.KGeometryType.POINT,
                id: r
              },
              icon: new L.icon({
                iconAnchor: n.icon.anchor,
                iconSize: n.icon.size,
                iconUrl: n.icon.url
              }),
              opacity: n.icon.opacity,
              zIndexOffset: n.zIndex
            },
                u = {
              permanent: !0,
              noHide: !0,
              direction: "center",
              className: "kmap-marker-label " + this._noClick
            };
            n.icon.labelAnchor && (u.offset = [n.icon.size[0] / 2 - n.icon.labelAnchor[0], n.icon.size[1] / 2 - n.icon.labelAnchor[1]]), (0, a.default)(t.points, function (t) {
              var e = L.marker({
                lat: t[0][0],
                lng: t[0][1]
              }, o).bindTooltip(n.icon.labelValue, u);
              i._clusterLayer ? i._clusterLayer.addLayer(e) : i._layer.addLayer(e);
            });
          }
        }
      }, {
        key: "addPolygons",
        value: function value(t, e, n, r) {
          if (!(0, s.default)(t.areas)) {
            var i = {
              record: {
                geom: t,
                desc: e,
                kStyle: n,
                type: l.KGeometryType.POLYGON,
                id: r
              },
              color: n.shape.borderColor,
              opacity: n.shape.borderOpacity,
              weight: n.shape.borderWeight,
              fillColor: n.shape.fillColor,
              fillOpacity: n.shape.opacity,
              zIndex: n.zIndex,
              className: this._noClick
            },
                a = (0, o.default)(t.areas, function (t) {
              return (0, o.default)(t, function (t) {
                return {
                  lat: t[0],
                  lng: t[1]
                };
              });
            }),
                u = L.polygon(a, i);

            this._layer.addLayer(u);
          }
        }
      }, {
        key: "addPolylines",
        value: function value(t, e, n, r) {
          if (!(0, s.default)(t.lines)) {
            var i = {
              fill: !1,
              stroke: !0,
              record: {
                geom: t,
                desc: e,
                kStyle: n,
                type: l.KGeometryType.POLYLINE,
                id: r
              },
              color: n.shape.borderColor,
              opacity: n.shape.borderOpacity,
              weight: n.shape.borderWeight,
              zIndex: n.zIndex,
              className: this._noClick
            },
                a = (0, o.default)(t.lines, function (t) {
              return (0, o.default)(t, function (t) {
                return {
                  lat: t[0],
                  lng: t[1]
                };
              });
            }),
                u = L.polyline(a[0], i);

            this._layer.addLayer(u);
          }
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          function r(r) {
            var i = function i(n) {
              L.DomEvent.stop(n), t.trigger(e, {
                desc: n.layer.options.record.desc,
                geom: n.layer.options.record.geom,
                kStyle: n.layer.options.record.kStyle,
                type: n.layer.options.record.type,
                clickedLatLng: n.latlng
              });
            };

            return n._layer.on(r, i), n._clusterLayer && n._clusterLayer.on(r, i), i;
          }

          switch (e) {
            case l.KLayerEvents.DOUBLECLICK:
              return r("dblclick");

            case l.KLayerEvents.RIGHTCLICK:
              return r("contextmenu");

            case l.KLayerEvents.CLICK:
              return r("click");

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          this._layer.off(e, t);
        }
      }, {
        key: "setClustering",
        value: function value(t) {
          t ? (this._clusterLayer = L.markerClusterGroup(), this._map.addLayer(this._clusterLayer)) : this._clusterLayer && (this._clusterLayer.remove(), this._clusterLayer = null);
        }
      }]), t;
    }();

    e.default = h;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = c(n(35)),
        i = c(n(0)),
        o = c(n(1)),
        a = c(n(39)),
        s = c(n(75)),
        u = c(n(40)),
        l = c(n(187));

    function c(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var h = function (t) {
      function e(t, n, o) {
        (0, i.default)(this, e);
        var s = (0, a.default)(this, (e.__proto__ || (0, r.default)(e)).call(this, t, n, o));
        return s._layers = n.map(function (t) {
          return new l.default(s._tileProp, t, o);
        }), s._layers.forEach(function (t, e) {
          return t.tile.on("load", function () {
            return s.loadedTile(e);
          });
        }), s;
      }

      return (0, u.default)(e, t), (0, o.default)(e, [{
        key: "setSources",
        value: function value(t) {
          var n = this;
          (0, s.default)(e.prototype.__proto__ || (0, r.default)(e.prototype), "setSources", this).call(this, t), t.forEach(function (t, e) {
            var r = n._layers[e];
            r || (r = new l.default(n._tileProp, t, n._map), n._layers[e] = r), r.tile.off("load"), r.tile.on("load", function () {
              return n.loadedTile(e);
            }), n._interval && r.enable();
          }), this._toggle && !this._interval && (this._layers[this._step].enable(), this._layers[this._step].toggle(!0));
        }
      }]), e;
    }(c(n(184)).default);

    e.default = h;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r,
        i = h(n(0)),
        o = h(n(1)),
        a = h(n(5)),
        s = h(n(16)),
        u = h(n(24)),
        l = h(n(18)),
        c = n(76);

    function h(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function f(t) {
      return t.getLatLngs();
    }

    function p(t) {
      return t.getLatLngs();
    }

    function d(t) {
      return [t.getLatLng()];
    }

    function v(t, e) {
      return {
        icon: new L.Icon({
          iconAnchor: t.anchor,
          iconSize: t.size,
          iconUrl: t.url
        }),
        opacity: t.opacity,
        zIndexOffset: e
      };
    }

    var y = (0, l.default)(r = function () {
      function t(e, n) {
        (0, i.default)(this, t), this._drawnItems = new L.FeatureGroup(), this._prop = e, this._map = n, this._map.addLayer(this._drawnItems);
      }

      return (0, o.default)(t, [{
        key: "initialize",
        value: function value() {
          return this.setEventContext(this), n(444), n(449);
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          switch (e) {
            case c.KDrawEvents.POINT_COMPLETE:
              return this._map.on(L.Draw.Event.CREATED, function (r) {
                n.setDrawingMode(null), "marker" === r.layerType && t.trigger(e, {
                  points: [d(r.layer)]
                });
              });

            case c.KDrawEvents.POLYGON_COMPLETE:
              return this._map.on(L.Draw.Event.CREATED, function (r) {
                n.setDrawingMode(null), "polygon" === r.layerType && t.trigger(e, {
                  areas: f(r.layer)
                });
              });

            case c.KDrawEvents.POLYLINE_COMPLETE:
              return this._map.on(L.Draw.Event.CREATED, function (r) {
                n.setDrawingMode(null), "polyline" === r.layerType && t.trigger(e, {
                  lines: p(r.layer)
                });
              });

            case c.KDrawEvents.RECTANGLE_COMPLETE:
              return this._map.on(L.Draw.Event.CREATED, function (r) {
                n.setDrawingMode(null), "rectangle" === r.layerType && t.trigger(e, r.layer.getLatLngs());
              });

            case c.KDrawEvents.CIRCLE_COMPLETE:
              return this._map.on(L.Draw.Event.CREATED, function (r) {
                n.setDrawingMode(null), "circle" === r.layerType && t.trigger(e, r.layer.getLatLng());
              });

            default:
              return null;
          }
        }
      }, {
        key: "startEdit",
        value: function value(t) {
          var e = v(t.icon);

          this._drawnItems.getLayers().forEach(function (t) {
            t instanceof L.Marker && t.setIcon(e.icon), t.options.editing || (t.options.editing = {}), t.editing.enable();
          });
        }
      }, {
        key: "stopEdit",
        value: function value() {
          this._drawnItems.clearLayers();
        }
      }, {
        key: "deleteVector",
        value: function value() {
          var t = this;

          this._drawnItems.getLayers().forEach(function (e) {
            t._drawnItems.removeLayer(e);
          });
        }
      }, {
        key: "getSelectedGeometry",
        value: function value() {
          var t = {
            points: [],
            areas: [],
            lines: []
          };
          return this._drawnItems.getLayers().forEach(function (e) {
            e instanceof L.Marker && t.points.push(d(e)), e instanceof L.Polygon && (t.areas = f(e)), e instanceof L.Polyline && (t.lines = p(e));
          }), t;
        }
      }, {
        key: "setActiveDrawingOptions",
        value: function value(t) {
          if (this._activeItem instanceof L.Draw.Marker && t && t.icon) {
            var e = v(t.icon, t.zIndex);

            this._activeItem.setOptions(e);
          } else if (this._activeItem && t && t.shape) {
            var n = {
              shapeOptions: {
                color: t.shape.borderColor,
                opacity: t.shape.borderOpacity,
                weight: t.shape.borderWeight || 1,
                fillColor: t.shape.fillColor,
                fillOpacity: t.shape.opacity,
                zIndex: t.zIndex
              }
            };

            this._activeItem.setOptions(n);
          }
        }
      }, {
        key: "addPoints",
        value: function value(t, e) {
          var n = this;

          if (!(0, u.default)(t.points)) {
            var r = v(e.icon, e.zIndex);
            (0, s.default)(t.points, function (t) {
              var e = L.marker({
                lat: t[0][0],
                lng: t[0][1]
              }, r);

              n._drawnItems.addLayer(e);
            });
          }
        }
      }, {
        key: "addPolygons",
        value: function value(t, e) {
          if (!(0, u.default)(t.areas)) {
            var n = {
              color: e.shape.borderColor,
              opacity: e.shape.borderOpacity,
              weight: e.shape.borderWeight,
              fillColor: e.shape.fillColor,
              fillOpacity: e.shape.opacity,
              zIndex: e.zIndex
            },
                r = (0, a.default)(t.areas, function (t) {
              return (0, a.default)(t, function (t) {
                return {
                  lat: t[0],
                  lng: t[1]
                };
              });
            }),
                i = L.polygon(r, n);

            this._drawnItems.addLayer(i);
          }
        }
      }, {
        key: "addPolylines",
        value: function value(t, e) {
          if (!(0, u.default)(t.lines)) {
            var n = {
              fill: !1,
              stroke: !0,
              color: e.shape.borderColor,
              opacity: e.shape.borderOpacity,
              weight: e.shape.borderWeight,
              zIndex: e.zIndex
            },
                r = (0, a.default)(t.lines, function (t) {
              return (0, a.default)(t, function (t) {
                return {
                  lat: t[0],
                  lng: t[1]
                };
              });
            }),
                i = L.polyline(r[0], n);

            this._drawnItems.addLayer(i);
          }
        }
      }, {
        key: "setDrawingMode",
        value: function value(t, e) {
          var n = void 0;

          switch (t) {
            case c.DrawingMode.POINT:
              n = new L.Draw.Marker(this._map);
              break;

            case c.DrawingMode.POLYGON:
              n = new L.Draw.Polygon(this._map);
              break;

            case c.DrawingMode.POLYLINE:
              n = new L.Draw.Polyline(this._map);
              break;

            case c.DrawingMode.RECTANGLE:
              n = new L.Draw.Rectangle(this._map);
              break;

            case c.DrawingMode.CIRCLE:
              n = new L.Draw.Circle(this._map);
          }

          this._activeItem = n, n && (this.setActiveDrawingOptions(e), n.enable());
        }
      }, {
        key: "clear",
        value: function value() {
          this._drawnItems.clearLayers();
        }
      }, {
        key: "remove",
        value: function value() {
          this._drawnItems.remove();
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          this._layer.off(e, t);
        }
      }]), t;
    }()) || r;
    e.default = y;
  }, function (t, e, n) {
    var r = n(445);
    "string" == typeof r && (r = [[t.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(113)(r, i);
    r.locals && (t.exports = r.locals);
  }, function (t, e, n) {
    var r = n(446);
    (t.exports = n(112)(!1)).push([t.i, ".leaflet-draw-section{position:relative}.leaflet-draw-toolbar{margin-top:12px}.leaflet-draw-toolbar-top{margin-top:0}.leaflet-draw-toolbar-notop a:first-child{border-top-right-radius:0}.leaflet-draw-toolbar-nobottom a:last-child{border-bottom-right-radius:0}.leaflet-draw-toolbar a{background-image:url(" + r(n(447)) + ");background-image:linear-gradient(transparent, transparent),url(" + r(n(188)) + ");background-repeat:no-repeat;background-size:300px 30px;background-clip:padding-box}.leaflet-retina .leaflet-draw-toolbar a{background-image:url(" + r(n(448)) + ");background-image:linear-gradient(transparent, transparent),url(" + r(n(188)) + ')}.leaflet-draw a{display:block;text-align:center;text-decoration:none}.leaflet-draw a .sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.leaflet-draw-actions{display:none;list-style:none;margin:0;padding:0;position:absolute;left:26px;top:0;white-space:nowrap}.leaflet-touch .leaflet-draw-actions{left:32px}.leaflet-right .leaflet-draw-actions{right:26px;left:auto}.leaflet-touch .leaflet-right .leaflet-draw-actions{right:32px;left:auto}.leaflet-draw-actions li{display:inline-block}.leaflet-draw-actions li:first-child a{border-left:0}.leaflet-draw-actions li:last-child a{-webkit-border-radius:0 4px 4px 0;border-radius:0 4px 4px 0}.leaflet-right .leaflet-draw-actions li:last-child a{-webkit-border-radius:0;border-radius:0}.leaflet-right .leaflet-draw-actions li:first-child a{-webkit-border-radius:4px 0 0 4px;border-radius:4px 0 0 4px}.leaflet-draw-actions a{background-color:#919187;border-left:1px solid #AAA;color:#FFF;font:11px/19px "Helvetica Neue",Arial,Helvetica,sans-serif;line-height:28px;text-decoration:none;padding-left:10px;padding-right:10px;height:28px}.leaflet-touch .leaflet-draw-actions a{font-size:12px;line-height:30px;height:30px}.leaflet-draw-actions-bottom{margin-top:0}.leaflet-draw-actions-top{margin-top:1px}.leaflet-draw-actions-top a,.leaflet-draw-actions-bottom a{height:27px;line-height:27px}.leaflet-draw-actions a:hover{background-color:#a0a098}.leaflet-draw-actions-top.leaflet-draw-actions-bottom a{height:26px;line-height:26px}.leaflet-draw-toolbar .leaflet-draw-draw-polyline{background-position:-2px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-polyline{background-position:0 -1px}.leaflet-draw-toolbar .leaflet-draw-draw-polygon{background-position:-31px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-polygon{background-position:-29px -1px}.leaflet-draw-toolbar .leaflet-draw-draw-rectangle{background-position:-62px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-rectangle{background-position:-60px -1px}.leaflet-draw-toolbar .leaflet-draw-draw-circle{background-position:-92px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-circle{background-position:-90px -1px}.leaflet-draw-toolbar .leaflet-draw-draw-marker{background-position:-122px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-marker{background-position:-120px -1px}.leaflet-draw-toolbar .leaflet-draw-draw-circlemarker{background-position:-273px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-circlemarker{background-position:-271px -1px}.leaflet-draw-toolbar .leaflet-draw-edit-edit{background-position:-152px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-edit{background-position:-150px -1px}.leaflet-draw-toolbar .leaflet-draw-edit-remove{background-position:-182px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-remove{background-position:-180px -1px}.leaflet-draw-toolbar .leaflet-draw-edit-edit.leaflet-disabled{background-position:-212px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-edit.leaflet-disabled{background-position:-210px -1px}.leaflet-draw-toolbar .leaflet-draw-edit-remove.leaflet-disabled{background-position:-242px -2px}.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-remove.leaflet-disabled{background-position:-240px -2px}.leaflet-mouse-marker{background-color:#fff;cursor:crosshair}.leaflet-draw-tooltip{background:#363636;background:rgba(0,0,0,0.5);border:1px solid transparent;-webkit-border-radius:4px;border-radius:4px;color:#fff;font:12px/18px "Helvetica Neue",Arial,Helvetica,sans-serif;margin-left:20px;margin-top:-21px;padding:4px 8px;position:absolute;visibility:hidden;white-space:nowrap;z-index:6}.leaflet-draw-tooltip:before{border-right:6px solid black;border-right-color:rgba(0,0,0,0.5);border-top:6px solid transparent;border-bottom:6px solid transparent;content:"";position:absolute;top:7px;left:-7px}.leaflet-error-draw-tooltip{background-color:#f2dede;border:1px solid #e6b6bd;color:#b94a48}.leaflet-error-draw-tooltip:before{border-right-color:#e6b6bd}.leaflet-draw-tooltip-single{margin-top:-12px}.leaflet-draw-tooltip-subtext{color:#f8d5e4}.leaflet-draw-guide-dash{font-size:1%;opacity:.6;position:absolute;width:5px;height:5px}.leaflet-edit-marker-selected{background-color:rgba(254,87,161,0.1);border:4px dashed rgba(254,87,161,0.6);-webkit-border-radius:4px;border-radius:4px;box-sizing:content-box}.leaflet-edit-move{cursor:move}.leaflet-edit-resize{cursor:pointer}.leaflet-oldie .leaflet-draw-toolbar{border:1px solid #999}\n', ""]);
  }, function (t, e) {
    t.exports = function (t) {
      return "string" != typeof t ? t : (/^['"].*['"]$/.test(t) && (t = t.slice(1, -1)), /["'() \t\n]/.test(t) ? '"' + t.replace(/"/g, '\\"').replace(/\n/g, "\\n") + '"' : t);
    };
  }, function (t, e) {
    t.exports = "data:image/png;base64,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";
  }, function (t, e) {
    t.exports = "data:image/png;base64,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";
  }, function (t, e) {
    !function (t, e, n) {
      L.drawVersion = "0.4.14", L.Draw = {}, L.drawLocal = {
        draw: {
          toolbar: {
            actions: {
              title: "Cancel drawing",
              text: "Cancel"
            },
            finish: {
              title: "Finish drawing",
              text: "Finish"
            },
            undo: {
              title: "Delete last point drawn",
              text: "Delete last point"
            },
            buttons: {
              polyline: "Draw a polyline",
              polygon: "Draw a polygon",
              rectangle: "Draw a rectangle",
              circle: "Draw a circle",
              marker: "Draw a marker",
              circlemarker: "Draw a circlemarker"
            }
          },
          handlers: {
            circle: {
              tooltip: {
                start: "Click and drag to draw circle."
              },
              radius: "Radius"
            },
            circlemarker: {
              tooltip: {
                start: "Click map to place circle marker."
              }
            },
            marker: {
              tooltip: {
                start: "Click map to place marker."
              }
            },
            polygon: {
              tooltip: {
                start: "Click to start drawing shape.",
                cont: "Click to continue drawing shape.",
                end: "Click first point to close this shape."
              }
            },
            polyline: {
              error: "<strong>Error:</strong> shape edges cannot cross!",
              tooltip: {
                start: "Click to start drawing line.",
                cont: "Click to continue drawing line.",
                end: "Click last point to finish line."
              }
            },
            rectangle: {
              tooltip: {
                start: "Click and drag to draw rectangle."
              }
            },
            simpleshape: {
              tooltip: {
                end: "Release mouse to finish drawing."
              }
            }
          }
        },
        edit: {
          toolbar: {
            actions: {
              save: {
                title: "Save changes",
                text: "Save"
              },
              cancel: {
                title: "Cancel editing, discards all changes",
                text: "Cancel"
              },
              clearAll: {
                title: "Clear all layers",
                text: "Clear All"
              }
            },
            buttons: {
              edit: "Edit layers",
              editDisabled: "No layers to edit",
              remove: "Delete layers",
              removeDisabled: "No layers to delete"
            }
          },
          handlers: {
            edit: {
              tooltip: {
                text: "Drag handles or markers to edit features.",
                subtext: "Click cancel to undo changes."
              }
            },
            remove: {
              tooltip: {
                text: "Click on a feature to remove."
              }
            }
          }
        }
      }, L.Draw.Event = {}, L.Draw.Event.CREATED = "draw:created", L.Draw.Event.EDITED = "draw:edited", L.Draw.Event.DELETED = "draw:deleted", L.Draw.Event.DRAWSTART = "draw:drawstart", L.Draw.Event.DRAWSTOP = "draw:drawstop", L.Draw.Event.DRAWVERTEX = "draw:drawvertex", L.Draw.Event.EDITSTART = "draw:editstart", L.Draw.Event.EDITMOVE = "draw:editmove", L.Draw.Event.EDITRESIZE = "draw:editresize", L.Draw.Event.EDITVERTEX = "draw:editvertex", L.Draw.Event.EDITSTOP = "draw:editstop", L.Draw.Event.DELETESTART = "draw:deletestart", L.Draw.Event.DELETESTOP = "draw:deletestop", L.Draw.Event.TOOLBAROPENED = "draw:toolbaropened", L.Draw.Event.TOOLBARCLOSED = "draw:toolbarclosed", L.Draw.Event.MARKERCONTEXT = "draw:markercontext", L.Draw = L.Draw || {}, L.Draw.Feature = L.Handler.extend({
        initialize: function initialize(t, e) {
          this._map = t, this._container = t._container, this._overlayPane = t._panes.overlayPane, this._popupPane = t._panes.popupPane, e && e.shapeOptions && (e.shapeOptions = L.Util.extend({}, this.options.shapeOptions, e.shapeOptions)), L.setOptions(this, e);
          var n = L.version.split(".");
          1 === parseInt(n[0], 10) && parseInt(n[1], 10) >= 2 ? L.Draw.Feature.include(L.Evented.prototype) : L.Draw.Feature.include(L.Mixin.Events);
        },
        enable: function enable() {
          this._enabled || (L.Handler.prototype.enable.call(this), this.fire("enabled", {
            handler: this.type
          }), this._map.fire(L.Draw.Event.DRAWSTART, {
            layerType: this.type
          }));
        },
        disable: function disable() {
          this._enabled && (L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DRAWSTOP, {
            layerType: this.type
          }), this.fire("disabled", {
            handler: this.type
          }));
        },
        addHooks: function addHooks() {
          var t = this._map;
          t && (L.DomUtil.disableTextSelection(), t.getContainer().focus(), this._tooltip = new L.Draw.Tooltip(this._map), L.DomEvent.on(this._container, "keyup", this._cancelDrawing, this));
        },
        removeHooks: function removeHooks() {
          this._map && (L.DomUtil.enableTextSelection(), this._tooltip.dispose(), this._tooltip = null, L.DomEvent.off(this._container, "keyup", this._cancelDrawing, this));
        },
        setOptions: function setOptions(t) {
          L.setOptions(this, t);
        },
        _fireCreatedEvent: function _fireCreatedEvent(t) {
          this._map.fire(L.Draw.Event.CREATED, {
            layer: t,
            layerType: this.type
          });
        },
        _cancelDrawing: function _cancelDrawing(t) {
          27 === t.keyCode && (this._map.fire("draw:canceled", {
            layerType: this.type
          }), this.disable());
        }
      }), L.Draw.Polyline = L.Draw.Feature.extend({
        statics: {
          TYPE: "polyline"
        },
        Poly: L.Polyline,
        options: {
          allowIntersection: !0,
          repeatMode: !1,
          drawError: {
            color: "#b00b00",
            timeout: 2500
          },
          icon: new L.DivIcon({
            iconSize: new L.Point(8, 8),
            className: "leaflet-div-icon leaflet-editing-icon"
          }),
          touchIcon: new L.DivIcon({
            iconSize: new L.Point(20, 20),
            className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
          }),
          guidelineDistance: 20,
          maxGuideLineLength: 4e3,
          shapeOptions: {
            stroke: !0,
            color: "#3388ff",
            weight: 4,
            opacity: .5,
            fill: !1,
            clickable: !0
          },
          metric: !0,
          feet: !0,
          nautic: !1,
          showLength: !0,
          zIndexOffset: 2e3,
          factor: 1,
          maxPoints: 0
        },
        initialize: function initialize(t, e) {
          L.Browser.touch && (this.options.icon = this.options.touchIcon), this.options.drawError.message = L.drawLocal.draw.handlers.polyline.error, e && e.drawError && (e.drawError = L.Util.extend({}, this.options.drawError, e.drawError)), this.type = L.Draw.Polyline.TYPE, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function addHooks() {
          L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._markers = [], this._markerGroup = new L.LayerGroup(), this._map.addLayer(this._markerGroup), this._poly = new L.Polyline([], this.options.shapeOptions), this._tooltip.updateContent(this._getTooltipText()), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
            icon: L.divIcon({
              className: "leaflet-mouse-marker",
              iconAnchor: [20, 20],
              iconSize: [40, 40]
            }),
            opacity: 0,
            zIndexOffset: this.options.zIndexOffset
          })), this._mouseMarker.on("mouseout", this._onMouseOut, this).on("mousemove", this._onMouseMove, this).on("mousedown", this._onMouseDown, this).on("mouseup", this._onMouseUp, this).addTo(this._map), this._map.on("mouseup", this._onMouseUp, this).on("mousemove", this._onMouseMove, this).on("zoomlevelschange", this._onZoomEnd, this).on("touchstart", this._onTouch, this).on("zoomend", this._onZoomEnd, this));
        },
        removeHooks: function removeHooks() {
          L.Draw.Feature.prototype.removeHooks.call(this), this._clearHideErrorTimeout(), this._cleanUpShape(), this._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers, this._map.removeLayer(this._poly), delete this._poly, this._mouseMarker.off("mousedown", this._onMouseDown, this).off("mouseout", this._onMouseOut, this).off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._clearGuides(), this._map.off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this).off("zoomlevelschange", this._onZoomEnd, this).off("zoomend", this._onZoomEnd, this).off("touchstart", this._onTouch, this).off("click", this._onTouch, this);
        },
        deleteLastVertex: function deleteLastVertex() {
          if (!(this._markers.length <= 1)) {
            var t = this._markers.pop(),
                e = this._poly,
                n = e.getLatLngs(),
                r = n.splice(-1, 1)[0];

            this._poly.setLatLngs(n), this._markerGroup.removeLayer(t), e.getLatLngs().length < 2 && this._map.removeLayer(e), this._vertexChanged(r, !1);
          }
        },
        addVertex: function addVertex(t) {
          this._markers.length >= 2 && !this.options.allowIntersection && this._poly.newLatLngIntersects(t) ? this._showErrorTooltip() : (this._errorShown && this._hideErrorTooltip(), this._markers.push(this._createMarker(t)), this._poly.addLatLng(t), 2 === this._poly.getLatLngs().length && this._map.addLayer(this._poly), this._vertexChanged(t, !0));
        },
        completeShape: function completeShape() {
          this._markers.length <= 1 || (this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable());
        },
        _finishShape: function _finishShape() {
          var t = this._poly._defaultShape ? this._poly._defaultShape() : this._poly.getLatLngs(),
              e = this._poly.newLatLngIntersects(t[t.length - 1]);

          !this.options.allowIntersection && e || !this._shapeIsValid() ? this._showErrorTooltip() : (this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable());
        },
        _shapeIsValid: function _shapeIsValid() {
          return !0;
        },
        _onZoomEnd: function _onZoomEnd() {
          null !== this._markers && this._updateGuide();
        },
        _onMouseMove: function _onMouseMove(t) {
          var e = this._map.mouseEventToLayerPoint(t.originalEvent),
              n = this._map.layerPointToLatLng(e);

          this._currentLatLng = n, this._updateTooltip(n), this._updateGuide(e), this._mouseMarker.setLatLng(n), L.DomEvent.preventDefault(t.originalEvent);
        },
        _vertexChanged: function _vertexChanged(t, e) {
          this._map.fire(L.Draw.Event.DRAWVERTEX, {
            layers: this._markerGroup
          }), this._updateFinishHandler(), this._updateRunningMeasure(t, e), this._clearGuides(), this._updateTooltip();
        },
        _onMouseDown: function _onMouseDown(t) {
          if (!this._clickHandled && !this._touchHandled && !this._disableMarkers) {
            this._onMouseMove(t), this._clickHandled = !0, this._disableNewMarkers();
            var e = t.originalEvent,
                n = e.clientX,
                r = e.clientY;

            this._startPoint.call(this, n, r);
          }
        },
        _startPoint: function _startPoint(t, e) {
          this._mouseDownOrigin = L.point(t, e);
        },
        _onMouseUp: function _onMouseUp(t) {
          var e = t.originalEvent,
              n = e.clientX,
              r = e.clientY;
          this._endPoint.call(this, n, r, t), this._clickHandled = null;
        },
        _endPoint: function _endPoint(e, n, r) {
          if (this._mouseDownOrigin) {
            var i = L.point(e, n).distanceTo(this._mouseDownOrigin),
                o = this._calculateFinishDistance(r.latlng);

            this.options.maxPoints > 1 && this.options.maxPoints == this._markers.length + 1 ? (this.addVertex(r.latlng), this._finishShape()) : o < 10 && L.Browser.touch ? this._finishShape() : Math.abs(i) < 9 * (t.devicePixelRatio || 1) && this.addVertex(r.latlng), this._enableNewMarkers();
          }

          this._mouseDownOrigin = null;
        },
        _onTouch: function _onTouch(t) {
          var e,
              n,
              r = t.originalEvent;
          !r.touches || !r.touches[0] || this._clickHandled || this._touchHandled || this._disableMarkers || (e = r.touches[0].clientX, n = r.touches[0].clientY, this._disableNewMarkers(), this._touchHandled = !0, this._startPoint.call(this, e, n), this._endPoint.call(this, e, n, t), this._touchHandled = null), this._clickHandled = null;
        },
        _onMouseOut: function _onMouseOut() {
          this._tooltip && this._tooltip._onMouseOut.call(this._tooltip);
        },
        _calculateFinishDistance: function _calculateFinishDistance(t) {
          var e;

          if (this._markers.length > 0) {
            var n;
            if (this.type === L.Draw.Polyline.TYPE) n = this._markers[this._markers.length - 1];else {
              if (this.type !== L.Draw.Polygon.TYPE) return 1 / 0;
              n = this._markers[0];
            }

            var r = this._map.latLngToContainerPoint(n.getLatLng()),
                i = new L.Marker(t, {
              icon: this.options.icon,
              zIndexOffset: 2 * this.options.zIndexOffset
            }),
                o = this._map.latLngToContainerPoint(i.getLatLng());

            e = r.distanceTo(o);
          } else e = 1 / 0;

          return e;
        },
        _updateFinishHandler: function _updateFinishHandler() {
          var t = this._markers.length;
          t > 1 && this._markers[t - 1].on("click", this._finishShape, this), t > 2 && this._markers[t - 2].off("click", this._finishShape, this);
        },
        _createMarker: function _createMarker(t) {
          var e = new L.Marker(t, {
            icon: this.options.icon,
            zIndexOffset: 2 * this.options.zIndexOffset
          });
          return this._markerGroup.addLayer(e), e;
        },
        _updateGuide: function _updateGuide(t) {
          var e = this._markers ? this._markers.length : 0;
          e > 0 && (t = t || this._map.latLngToLayerPoint(this._currentLatLng), this._clearGuides(), this._drawGuide(this._map.latLngToLayerPoint(this._markers[e - 1].getLatLng()), t));
        },
        _updateTooltip: function _updateTooltip(t) {
          var e = this._getTooltipText();

          t && this._tooltip.updatePosition(t), this._errorShown || this._tooltip.updateContent(e);
        },
        _drawGuide: function _drawGuide(t, e) {
          var n,
              r,
              i,
              o = Math.floor(Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))),
              a = this.options.guidelineDistance,
              s = this.options.maxGuideLineLength,
              u = o > s ? o - s : a;

          for (this._guidesContainer || (this._guidesContainer = L.DomUtil.create("div", "leaflet-draw-guides", this._overlayPane)); u < o; u += this.options.guidelineDistance) {
            n = u / o, r = {
              x: Math.floor(t.x * (1 - n) + n * e.x),
              y: Math.floor(t.y * (1 - n) + n * e.y)
            }, (i = L.DomUtil.create("div", "leaflet-draw-guide-dash", this._guidesContainer)).style.backgroundColor = this._errorShown ? this.options.drawError.color : this.options.shapeOptions.color, L.DomUtil.setPosition(i, r);
          }
        },
        _updateGuideColor: function _updateGuideColor(t) {
          if (this._guidesContainer) for (var e = 0, n = this._guidesContainer.childNodes.length; e < n; e++) {
            this._guidesContainer.childNodes[e].style.backgroundColor = t;
          }
        },
        _clearGuides: function _clearGuides() {
          if (this._guidesContainer) for (; this._guidesContainer.firstChild;) {
            this._guidesContainer.removeChild(this._guidesContainer.firstChild);
          }
        },
        _getTooltipText: function _getTooltipText() {
          var t,
              e,
              n = this.options.showLength;
          return 0 === this._markers.length ? t = {
            text: L.drawLocal.draw.handlers.polyline.tooltip.start
          } : (e = n ? this._getMeasurementString() : "", t = 1 === this._markers.length ? {
            text: L.drawLocal.draw.handlers.polyline.tooltip.cont,
            subtext: e
          } : {
            text: L.drawLocal.draw.handlers.polyline.tooltip.end,
            subtext: e
          }), t;
        },
        _updateRunningMeasure: function _updateRunningMeasure(t, e) {
          var n,
              r,
              i = this._markers.length;
          1 === this._markers.length ? this._measurementRunningTotal = 0 : (n = i - (e ? 2 : 1), r = L.GeometryUtil.isVersion07x() ? t.distanceTo(this._markers[n].getLatLng()) * (this.options.factor || 1) : this._map.distance(t, this._markers[n].getLatLng()) * (this.options.factor || 1), this._measurementRunningTotal += r * (e ? 1 : -1));
        },
        _getMeasurementString: function _getMeasurementString() {
          var t,
              e = this._currentLatLng,
              n = this._markers[this._markers.length - 1].getLatLng();

          return t = L.GeometryUtil.isVersion07x() ? n && e && e.distanceTo ? this._measurementRunningTotal + e.distanceTo(n) * (this.options.factor || 1) : this._measurementRunningTotal || 0 : n && e ? this._measurementRunningTotal + this._map.distance(e, n) * (this.options.factor || 1) : this._measurementRunningTotal || 0, L.GeometryUtil.readableDistance(t, this.options.metric, this.options.feet, this.options.nautic, this.options.precision);
        },
        _showErrorTooltip: function _showErrorTooltip() {
          this._errorShown = !0, this._tooltip.showAsError().updateContent({
            text: this.options.drawError.message
          }), this._updateGuideColor(this.options.drawError.color), this._poly.setStyle({
            color: this.options.drawError.color
          }), this._clearHideErrorTimeout(), this._hideErrorTimeout = setTimeout(L.Util.bind(this._hideErrorTooltip, this), this.options.drawError.timeout);
        },
        _hideErrorTooltip: function _hideErrorTooltip() {
          this._errorShown = !1, this._clearHideErrorTimeout(), this._tooltip.removeError().updateContent(this._getTooltipText()), this._updateGuideColor(this.options.shapeOptions.color), this._poly.setStyle({
            color: this.options.shapeOptions.color
          });
        },
        _clearHideErrorTimeout: function _clearHideErrorTimeout() {
          this._hideErrorTimeout && (clearTimeout(this._hideErrorTimeout), this._hideErrorTimeout = null);
        },
        _disableNewMarkers: function _disableNewMarkers() {
          this._disableMarkers = !0;
        },
        _enableNewMarkers: function _enableNewMarkers() {
          setTimeout(function () {
            this._disableMarkers = !1;
          }.bind(this), 50);
        },
        _cleanUpShape: function _cleanUpShape() {
          this._markers.length > 1 && this._markers[this._markers.length - 1].off("click", this._finishShape, this);
        },
        _fireCreatedEvent: function _fireCreatedEvent() {
          var t = new this.Poly(this._poly.getLatLngs(), this.options.shapeOptions);

          L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
      }), L.Draw.Polygon = L.Draw.Polyline.extend({
        statics: {
          TYPE: "polygon"
        },
        Poly: L.Polygon,
        options: {
          showArea: !1,
          showLength: !1,
          shapeOptions: {
            stroke: !0,
            color: "#3388ff",
            weight: 4,
            opacity: .5,
            fill: !0,
            fillColor: null,
            fillOpacity: .2,
            clickable: !0
          },
          metric: !0,
          feet: !0,
          nautic: !1,
          precision: {}
        },
        initialize: function initialize(t, e) {
          L.Draw.Polyline.prototype.initialize.call(this, t, e), this.type = L.Draw.Polygon.TYPE;
        },
        _updateFinishHandler: function _updateFinishHandler() {
          var t = this._markers.length;
          1 === t && this._markers[0].on("click", this._finishShape, this), t > 2 && (this._markers[t - 1].on("dblclick", this._finishShape, this), t > 3 && this._markers[t - 2].off("dblclick", this._finishShape, this));
        },
        _getTooltipText: function _getTooltipText() {
          var t, e;
          return 0 === this._markers.length ? t = L.drawLocal.draw.handlers.polygon.tooltip.start : this._markers.length < 3 ? (t = L.drawLocal.draw.handlers.polygon.tooltip.cont, e = this._getMeasurementString()) : (t = L.drawLocal.draw.handlers.polygon.tooltip.end, e = this._getMeasurementString()), {
            text: t,
            subtext: e
          };
        },
        _getMeasurementString: function _getMeasurementString() {
          var t = this._area,
              e = "";
          return t || this.options.showLength ? (this.options.showLength && (e = L.Draw.Polyline.prototype._getMeasurementString.call(this)), t && (e += "<br>" + L.GeometryUtil.readableArea(t, this.options.metric, this.options.precision)), e) : null;
        },
        _shapeIsValid: function _shapeIsValid() {
          return this._markers.length >= 3;
        },
        _vertexChanged: function _vertexChanged(t, e) {
          var n;
          !this.options.allowIntersection && this.options.showArea && (n = this._poly.getLatLngs(), this._area = L.GeometryUtil.geodesicArea(n)), L.Draw.Polyline.prototype._vertexChanged.call(this, t, e);
        },
        _cleanUpShape: function _cleanUpShape() {
          var t = this._markers.length;
          t > 0 && (this._markers[0].off("click", this._finishShape, this), t > 2 && this._markers[t - 1].off("dblclick", this._finishShape, this));
        }
      }), L.SimpleShape = {}, L.Draw.SimpleShape = L.Draw.Feature.extend({
        options: {
          repeatMode: !1
        },
        initialize: function initialize(t, e) {
          this._endLabelText = L.drawLocal.draw.handlers.simpleshape.tooltip.end, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function addHooks() {
          L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._mapDraggable = this._map.dragging.enabled(), this._mapDraggable && this._map.dragging.disable(), this._container.style.cursor = "crosshair", this._tooltip.updateContent({
            text: this._initialLabelText
          }), this._map.on("mousedown", this._onMouseDown, this).on("mousemove", this._onMouseMove, this).on("touchstart", this._onMouseDown, this).on("touchmove", this._onMouseMove, this), e.addEventListener("touchstart", L.DomEvent.preventDefault, {
            passive: !1
          }));
        },
        removeHooks: function removeHooks() {
          L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._mapDraggable && this._map.dragging.enable(), this._container.style.cursor = "", this._map.off("mousedown", this._onMouseDown, this).off("mousemove", this._onMouseMove, this).off("touchstart", this._onMouseDown, this).off("touchmove", this._onMouseMove, this), L.DomEvent.off(e, "mouseup", this._onMouseUp, this), L.DomEvent.off(e, "touchend", this._onMouseUp, this), e.removeEventListener("touchstart", L.DomEvent.preventDefault), this._shape && (this._map.removeLayer(this._shape), delete this._shape)), this._isDrawing = !1;
        },
        _getTooltipText: function _getTooltipText() {
          return {
            text: this._endLabelText
          };
        },
        _onMouseDown: function _onMouseDown(t) {
          this._isDrawing = !0, this._startLatLng = t.latlng, L.DomEvent.on(e, "mouseup", this._onMouseUp, this).on(e, "touchend", this._onMouseUp, this).preventDefault(t.originalEvent);
        },
        _onMouseMove: function _onMouseMove(t) {
          var e = t.latlng;
          this._tooltip.updatePosition(e), this._isDrawing && (this._tooltip.updateContent(this._getTooltipText()), this._drawShape(e));
        },
        _onMouseUp: function _onMouseUp() {
          this._shape && this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        }
      }), L.Draw.Rectangle = L.Draw.SimpleShape.extend({
        statics: {
          TYPE: "rectangle"
        },
        options: {
          shapeOptions: {
            stroke: !0,
            color: "#3388ff",
            weight: 4,
            opacity: .5,
            fill: !0,
            fillColor: null,
            fillOpacity: .2,
            showArea: !0,
            clickable: !0
          },
          metric: !0
        },
        initialize: function initialize(t, e) {
          this.type = L.Draw.Rectangle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.rectangle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        disable: function disable() {
          this._enabled && (this._isCurrentlyTwoClickDrawing = !1, L.Draw.SimpleShape.prototype.disable.call(this));
        },
        _onMouseUp: function _onMouseUp(t) {
          this._shape || this._isCurrentlyTwoClickDrawing ? this._isCurrentlyTwoClickDrawing && !function (t, e) {
            for (; (t = t.parentElement) && !t.classList.contains(e);) {
              ;
            }

            return t;
          }(t.target, "leaflet-pane") || L.Draw.SimpleShape.prototype._onMouseUp.call(this) : this._isCurrentlyTwoClickDrawing = !0;
        },
        _drawShape: function _drawShape(t) {
          this._shape ? this._shape.setBounds(new L.LatLngBounds(this._startLatLng, t)) : (this._shape = new L.Rectangle(new L.LatLngBounds(this._startLatLng, t), this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function _fireCreatedEvent() {
          var t = new L.Rectangle(this._shape.getBounds(), this.options.shapeOptions);

          L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _getTooltipText: function _getTooltipText() {
          var t,
              e,
              n,
              r = L.Draw.SimpleShape.prototype._getTooltipText.call(this),
              i = this._shape,
              o = this.options.showArea;

          return i && (t = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), e = L.GeometryUtil.geodesicArea(t), n = o ? L.GeometryUtil.readableArea(e, this.options.metric) : ""), {
            text: r.text,
            subtext: n
          };
        }
      }), L.Draw.Marker = L.Draw.Feature.extend({
        statics: {
          TYPE: "marker"
        },
        options: {
          icon: new L.Icon.Default(),
          repeatMode: !1,
          zIndexOffset: 2e3
        },
        initialize: function initialize(t, e) {
          this.type = L.Draw.Marker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.marker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function addHooks() {
          L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._tooltip.updateContent({
            text: this._initialLabelText
          }), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
            icon: L.divIcon({
              className: "leaflet-mouse-marker",
              iconAnchor: [20, 20],
              iconSize: [40, 40]
            }),
            opacity: 0,
            zIndexOffset: this.options.zIndexOffset
          })), this._mouseMarker.on("click", this._onClick, this).addTo(this._map), this._map.on("mousemove", this._onMouseMove, this), this._map.on("click", this._onTouch, this));
        },
        removeHooks: function removeHooks() {
          L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._map.off("click", this._onClick, this).off("click", this._onTouch, this), this._marker && (this._marker.off("click", this._onClick, this), this._map.removeLayer(this._marker), delete this._marker), this._mouseMarker.off("click", this._onClick, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._map.off("mousemove", this._onMouseMove, this));
        },
        _onMouseMove: function _onMouseMove(t) {
          var e = t.latlng;
          this._tooltip.updatePosition(e), this._mouseMarker.setLatLng(e), this._marker ? (e = this._mouseMarker.getLatLng(), this._marker.setLatLng(e)) : (this._marker = this._createMarker(e), this._marker.on("click", this._onClick, this), this._map.on("click", this._onClick, this).addLayer(this._marker));
        },
        _createMarker: function _createMarker(t) {
          return new L.Marker(t, {
            icon: this.options.icon,
            zIndexOffset: this.options.zIndexOffset
          });
        },
        _onClick: function _onClick() {
          this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        },
        _onTouch: function _onTouch(t) {
          this._onMouseMove(t), this._onClick();
        },
        _fireCreatedEvent: function _fireCreatedEvent() {
          var t = new L.Marker.Touch(this._marker.getLatLng(), {
            icon: this.options.icon
          });

          L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
      }), L.Draw.CircleMarker = L.Draw.Marker.extend({
        statics: {
          TYPE: "circlemarker"
        },
        options: {
          stroke: !0,
          color: "#3388ff",
          weight: 4,
          opacity: .5,
          fill: !0,
          fillColor: null,
          fillOpacity: .2,
          clickable: !0,
          zIndexOffset: 2e3
        },
        initialize: function initialize(t, e) {
          this.type = L.Draw.CircleMarker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circlemarker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        _fireCreatedEvent: function _fireCreatedEvent() {
          var t = new L.CircleMarker(this._marker.getLatLng(), this.options);

          L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        },
        _createMarker: function _createMarker(t) {
          return new L.CircleMarker(t, this.options);
        }
      }), L.Draw.Circle = L.Draw.SimpleShape.extend({
        statics: {
          TYPE: "circle"
        },
        options: {
          shapeOptions: {
            stroke: !0,
            color: "#3388ff",
            weight: 4,
            opacity: .5,
            fill: !0,
            fillColor: null,
            fillOpacity: .2,
            clickable: !0
          },
          showRadius: !0,
          metric: !0,
          feet: !0,
          nautic: !1
        },
        initialize: function initialize(t, e) {
          this.type = L.Draw.Circle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        _drawShape: function _drawShape(t) {
          if (L.GeometryUtil.isVersion07x()) var e = this._startLatLng.distanceTo(t);else e = this._map.distance(this._startLatLng, t);
          this._shape ? this._shape.setRadius(e) : (this._shape = new L.Circle(this._startLatLng, e, this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function _fireCreatedEvent() {
          var t = new L.Circle(this._startLatLng, this._shape.getRadius(), this.options.shapeOptions);

          L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _onMouseMove: function _onMouseMove(t) {
          var e,
              n = t.latlng,
              r = this.options.showRadius,
              i = this.options.metric;

          if (this._tooltip.updatePosition(n), this._isDrawing) {
            this._drawShape(n), e = this._shape.getRadius().toFixed(1);
            var o = "";
            r && (o = L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(e, i, this.options.feet, this.options.nautic)), this._tooltip.updateContent({
              text: this._endLabelText,
              subtext: o
            });
          }
        }
      }), L.Edit = L.Edit || {}, L.Edit.Marker = L.Handler.extend({
        initialize: function initialize(t, e) {
          this._marker = t, L.setOptions(this, e);
        },
        addHooks: function addHooks() {
          var t = this._marker;
          t.dragging.enable(), t.on("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        removeHooks: function removeHooks() {
          var t = this._marker;
          t.dragging.disable(), t.off("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        _onDragEnd: function _onDragEnd(t) {
          var e = t.target;
          e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
            layer: e
          });
        },
        _toggleMarkerHighlight: function _toggleMarkerHighlight() {
          var t = this._marker._icon;
          t && (t.style.display = "none", L.DomUtil.hasClass(t, "leaflet-edit-marker-selected") ? (L.DomUtil.removeClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, -4)) : (L.DomUtil.addClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, 4)), t.style.display = "");
        },
        _offsetMarker: function _offsetMarker(t, e) {
          var n = parseInt(t.style.marginTop, 10) - e,
              r = parseInt(t.style.marginLeft, 10) - e;
          t.style.marginTop = n + "px", t.style.marginLeft = r + "px";
        }
      }), L.Marker.addInitHook(function () {
        L.Edit.Marker && (this.editing = new L.Edit.Marker(this), this.options.editable && this.editing.enable());
      }), L.Edit = L.Edit || {}, L.Edit.Poly = L.Handler.extend({
        initialize: function initialize(t) {
          this.latlngs = [t._latlngs], t._holes && (this.latlngs = this.latlngs.concat(t._holes)), this._poly = t, this._poly.on("revert-edited", this._updateLatLngs, this);
        },
        _defaultShape: function _defaultShape() {
          return L.Polyline._flat ? L.Polyline._flat(this._poly._latlngs) ? this._poly._latlngs : this._poly._latlngs[0] : this._poly._latlngs;
        },
        _eachVertexHandler: function _eachVertexHandler(t) {
          for (var e = 0; e < this._verticesHandlers.length; e++) {
            t(this._verticesHandlers[e]);
          }
        },
        addHooks: function addHooks() {
          this._initHandlers(), this._eachVertexHandler(function (t) {
            t.addHooks();
          });
        },
        removeHooks: function removeHooks() {
          this._eachVertexHandler(function (t) {
            t.removeHooks();
          });
        },
        updateMarkers: function updateMarkers() {
          this._eachVertexHandler(function (t) {
            t.updateMarkers();
          });
        },
        _initHandlers: function _initHandlers() {
          this._verticesHandlers = [];

          for (var t = 0; t < this.latlngs.length; t++) {
            this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly, this.latlngs[t], this._poly.options.poly));
          }
        },
        _updateLatLngs: function _updateLatLngs(t) {
          this.latlngs = [t.layer._latlngs], t.layer._holes && (this.latlngs = this.latlngs.concat(t.layer._holes));
        }
      }), L.Edit.PolyVerticesEdit = L.Handler.extend({
        options: {
          icon: new L.DivIcon({
            iconSize: new L.Point(8, 8),
            className: "leaflet-div-icon leaflet-editing-icon"
          }),
          touchIcon: new L.DivIcon({
            iconSize: new L.Point(20, 20),
            className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
          }),
          drawError: {
            color: "#b00b00",
            timeout: 1e3
          }
        },
        initialize: function initialize(t, e, n) {
          L.Browser.touch && (this.options.icon = this.options.touchIcon), this._poly = t, n && n.drawError && (n.drawError = L.Util.extend({}, this.options.drawError, n.drawError)), this._latlngs = e, L.setOptions(this, n);
        },
        _defaultShape: function _defaultShape() {
          return L.Polyline._flat ? L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0] : this._latlngs;
        },
        addHooks: function addHooks() {
          var t = this._poly,
              e = t._path;
          t instanceof L.Polygon || (t.options.fill = !1, t.options.editing && (t.options.editing.fill = !1)), e && t.options.editing.className && (t.options.original.className && t.options.original.className.split(" ").forEach(function (t) {
            L.DomUtil.removeClass(e, t);
          }), t.options.editing.className.split(" ").forEach(function (t) {
            L.DomUtil.addClass(e, t);
          })), t.setStyle(t.options.editing), this._poly._map && (this._map = this._poly._map, this._markerGroup || this._initMarkers(), this._poly._map.addLayer(this._markerGroup));
        },
        removeHooks: function removeHooks() {
          var t = this._poly,
              e = t._path;
          e && t.options.editing.className && (t.options.editing.className.split(" ").forEach(function (t) {
            L.DomUtil.removeClass(e, t);
          }), t.options.original.className && t.options.original.className.split(" ").forEach(function (t) {
            L.DomUtil.addClass(e, t);
          })), t.setStyle(t.options.original), t._map && (t._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers);
        },
        updateMarkers: function updateMarkers() {
          this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function _initMarkers() {
          this._markerGroup || (this._markerGroup = new L.LayerGroup()), this._markers = [];

          var t,
              e,
              n,
              r,
              i,
              o,
              a = this._defaultShape();

          for (t = 0, n = a.length; t < n; t++) {
            (r = this._createMarker(a[t], t)).on("click", this._onMarkerClick, this), r.on("contextmenu", this._onContextMenu, this), this._markers.push(r);
          }

          for (t = 0, e = n - 1; t < n; e = t++) {
            (0 !== t || L.Polygon && this._poly instanceof L.Polygon) && (i = this._markers[e], o = this._markers[t], this._createMiddleMarker(i, o), this._updatePrevNext(i, o));
          }
        },
        _createMarker: function _createMarker(t, e) {
          var n = new L.Marker.Touch(t, {
            draggable: !0,
            icon: this.options.icon
          });
          return n._origLatLng = t, n._index = e, n.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._fireEdit, this).on("touchmove", this._onTouchMove, this).on("touchend", this._fireEdit, this).on("MSPointerMove", this._onTouchMove, this).on("MSPointerUp", this._fireEdit, this), this._markerGroup.addLayer(n), n;
        },
        _onMarkerDragStart: function _onMarkerDragStart() {
          this._poly.fire("editstart");
        },
        _spliceLatLngs: function _spliceLatLngs() {
          var t = this._defaultShape(),
              e = [].splice.apply(t, arguments);

          return this._poly._convertLatLngs(t, !0), this._poly.redraw(), e;
        },
        _removeMarker: function _removeMarker(t) {
          var e = t._index;
          this._markerGroup.removeLayer(t), this._markers.splice(e, 1), this._spliceLatLngs(e, 1), this._updateIndexes(e, -1), t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._fireEdit, this).off("touchmove", this._onMarkerDrag, this).off("touchend", this._fireEdit, this).off("click", this._onMarkerClick, this).off("MSPointerMove", this._onTouchMove, this).off("MSPointerUp", this._fireEdit, this);
        },
        _fireEdit: function _fireEdit() {
          this._poly.edited = !0, this._poly.fire("edit"), this._poly._map.fire(L.Draw.Event.EDITVERTEX, {
            layers: this._markerGroup,
            poly: this._poly
          });
        },
        _onMarkerDrag: function _onMarkerDrag(t) {
          var e = t.target,
              n = this._poly;

          if (L.extend(e._origLatLng, e._latlng), e._middleLeft && e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev, e)), e._middleRight && e._middleRight.setLatLng(this._getMiddleLatLng(e, e._next)), n.options.poly) {
            var r = n._map._editTooltip;

            if (!n.options.poly.allowIntersection && n.intersects()) {
              var i = n.options.color;
              n.setStyle({
                color: this.options.drawError.color
              }), 0 !== L.version.indexOf("0.7") && e.dragging._draggable._onUp(t), this._onMarkerClick(t), r && r.updateContent({
                text: L.drawLocal.draw.handlers.polyline.error
              }), setTimeout(function () {
                n.setStyle({
                  color: i
                }), r && r.updateContent({
                  text: L.drawLocal.edit.handlers.edit.tooltip.text,
                  subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
                });
              }, 1e3);
            }
          }

          this._poly._bounds._southWest = L.latLng(1 / 0, 1 / 0), this._poly._bounds._northEast = L.latLng(-1 / 0, -1 / 0);

          var o = this._poly.getLatLngs();

          this._poly._convertLatLngs(o, !0), this._poly.redraw(), this._poly.fire("editdrag");
        },
        _onMarkerClick: function _onMarkerClick(t) {
          var e = L.Polygon && this._poly instanceof L.Polygon ? 4 : 3,
              n = t.target;
          this._defaultShape().length < e || (this._removeMarker(n), this._updatePrevNext(n._prev, n._next), n._middleLeft && this._markerGroup.removeLayer(n._middleLeft), n._middleRight && this._markerGroup.removeLayer(n._middleRight), n._prev && n._next ? this._createMiddleMarker(n._prev, n._next) : n._prev ? n._next || (n._prev._middleRight = null) : n._next._middleLeft = null, this._fireEdit());
        },
        _onContextMenu: function _onContextMenu(t) {
          var e = t.target;
          this._poly, this._poly._map.fire(L.Draw.Event.MARKERCONTEXT, {
            marker: e,
            layers: this._markerGroup,
            poly: this._poly
          }), L.DomEvent.stopPropagation;
        },
        _onTouchMove: function _onTouchMove(t) {
          var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),
              n = this._map.layerPointToLatLng(e),
              r = t.target;

          L.extend(r._origLatLng, n), r._middleLeft && r._middleLeft.setLatLng(this._getMiddleLatLng(r._prev, r)), r._middleRight && r._middleRight.setLatLng(this._getMiddleLatLng(r, r._next)), this._poly.redraw(), this.updateMarkers();
        },
        _updateIndexes: function _updateIndexes(t, e) {
          this._markerGroup.eachLayer(function (n) {
            n._index > t && (n._index += e);
          });
        },
        _createMiddleMarker: function _createMiddleMarker(t, e) {
          var n,
              _r3,
              _i,
              o = this._getMiddleLatLng(t, e),
              a = this._createMarker(o);

          a.setOpacity(.6), t._middleRight = e._middleLeft = a, _r3 = function r() {
            a.off("touchmove", _r3, this);
            var i = e._index;
            a._index = i, a.off("click", n, this).on("click", this._onMarkerClick, this), o.lat = a.getLatLng().lat, o.lng = a.getLatLng().lng, this._spliceLatLngs(i, 0, o), this._markers.splice(i, 0, a), a.setOpacity(1), this._updateIndexes(i, 1), e._index++, this._updatePrevNext(t, a), this._updatePrevNext(a, e), this._poly.fire("editstart");
          }, _i = function i() {
            a.off("dragstart", _r3, this), a.off("dragend", _i, this), a.off("touchmove", _r3, this), this._createMiddleMarker(t, a), this._createMiddleMarker(a, e);
          }, n = function n() {
            _r3.call(this), _i.call(this), this._fireEdit();
          }, a.on("click", n, this).on("dragstart", _r3, this).on("dragend", _i, this).on("touchmove", _r3, this), this._markerGroup.addLayer(a);
        },
        _updatePrevNext: function _updatePrevNext(t, e) {
          t && (t._next = e), e && (e._prev = t);
        },
        _getMiddleLatLng: function _getMiddleLatLng(t, e) {
          var n = this._poly._map,
              r = n.project(t.getLatLng()),
              i = n.project(e.getLatLng());
          return n.unproject(r._add(i)._divideBy(2));
        }
      }), L.Polyline.addInitHook(function () {
        this.editing || (L.Edit.Poly && (this.editing = new L.Edit.Poly(this), this.options.editable && this.editing.enable()), this.on("add", function () {
          this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function () {
          this.editing && this.editing.enabled() && this.editing.removeHooks();
        }));
      }), L.Edit = L.Edit || {}, L.Edit.SimpleShape = L.Handler.extend({
        options: {
          moveIcon: new L.DivIcon({
            iconSize: new L.Point(8, 8),
            className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move"
          }),
          resizeIcon: new L.DivIcon({
            iconSize: new L.Point(8, 8),
            className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"
          }),
          touchMoveIcon: new L.DivIcon({
            iconSize: new L.Point(20, 20),
            className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"
          }),
          touchResizeIcon: new L.DivIcon({
            iconSize: new L.Point(20, 20),
            className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"
          })
        },
        initialize: function initialize(t, e) {
          L.Browser.touch && (this.options.moveIcon = this.options.touchMoveIcon, this.options.resizeIcon = this.options.touchResizeIcon), this._shape = t, L.Util.setOptions(this, e);
        },
        addHooks: function addHooks() {
          var t = this._shape;
          this._shape._map && (this._map = this._shape._map, t.setStyle(t.options.editing), t._map && (this._map = t._map, this._markerGroup || this._initMarkers(), this._map.addLayer(this._markerGroup)));
        },
        removeHooks: function removeHooks() {
          var t = this._shape;

          if (t.setStyle(t.options.original), t._map) {
            this._unbindMarker(this._moveMarker);

            for (var e = 0, n = this._resizeMarkers.length; e < n; e++) {
              this._unbindMarker(this._resizeMarkers[e]);
            }

            this._resizeMarkers = null, this._map.removeLayer(this._markerGroup), delete this._markerGroup;
          }

          this._map = null;
        },
        updateMarkers: function updateMarkers() {
          this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function _initMarkers() {
          this._markerGroup || (this._markerGroup = new L.LayerGroup()), this._createMoveMarker(), this._createResizeMarker();
        },
        _createMoveMarker: function _createMoveMarker() {},
        _createResizeMarker: function _createResizeMarker() {},
        _createMarker: function _createMarker(t, e) {
          var n = new L.Marker.Touch(t, {
            draggable: !0,
            icon: e,
            zIndexOffset: 10
          });
          return this._bindMarker(n), this._markerGroup.addLayer(n), n;
        },
        _bindMarker: function _bindMarker(t) {
          t.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._onMarkerDragEnd, this).on("touchstart", this._onTouchStart, this).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onTouchEnd, this).on("MSPointerUp", this._onTouchEnd, this);
        },
        _unbindMarker: function _unbindMarker(t) {
          t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._onMarkerDragEnd, this).off("touchstart", this._onTouchStart, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onTouchEnd, this).off("MSPointerUp", this._onTouchEnd, this);
        },
        _onMarkerDragStart: function _onMarkerDragStart(t) {
          t.target.setOpacity(0), this._shape.fire("editstart");
        },
        _fireEdit: function _fireEdit() {
          this._shape.edited = !0, this._shape.fire("edit");
        },
        _onMarkerDrag: function _onMarkerDrag(t) {
          var e = t.target,
              n = e.getLatLng();
          e === this._moveMarker ? this._move(n) : this._resize(n), this._shape.redraw(), this._shape.fire("editdrag");
        },
        _onMarkerDragEnd: function _onMarkerDragEnd(t) {
          t.target.setOpacity(1), this._fireEdit();
        },
        _onTouchStart: function _onTouchStart(t) {
          if (L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t), "function" == typeof this._getCorners) {
            var e = this._getCorners(),
                n = t.target,
                r = n._cornerIndex;

            n.setOpacity(0), this._oppositeCorner = e[(r + 2) % 4], this._toggleCornerMarkers(0, r);
          }

          this._shape.fire("editstart");
        },
        _onTouchMove: function _onTouchMove(t) {
          var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),
              n = this._map.layerPointToLatLng(e);

          return t.target === this._moveMarker ? this._move(n) : this._resize(n), this._shape.redraw(), !1;
        },
        _onTouchEnd: function _onTouchEnd(t) {
          t.target.setOpacity(1), this.updateMarkers(), this._fireEdit();
        },
        _move: function _move() {},
        _resize: function _resize() {}
      }), L.Edit = L.Edit || {}, L.Edit.Rectangle = L.Edit.SimpleShape.extend({
        _createMoveMarker: function _createMoveMarker() {
          var t = this._shape.getBounds().getCenter();

          this._moveMarker = this._createMarker(t, this.options.moveIcon);
        },
        _createResizeMarker: function _createResizeMarker() {
          var t = this._getCorners();

          this._resizeMarkers = [];

          for (var e = 0, n = t.length; e < n; e++) {
            this._resizeMarkers.push(this._createMarker(t[e], this.options.resizeIcon)), this._resizeMarkers[e]._cornerIndex = e;
          }
        },
        _onMarkerDragStart: function _onMarkerDragStart(t) {
          L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t);

          var e = this._getCorners(),
              n = t.target._cornerIndex;

          this._oppositeCorner = e[(n + 2) % 4], this._toggleCornerMarkers(0, n);
        },
        _onMarkerDragEnd: function _onMarkerDragEnd(t) {
          var e,
              n = t.target;
          n === this._moveMarker && (e = this._shape.getBounds().getCenter(), n.setLatLng(e)), this._toggleCornerMarkers(1), this._repositionCornerMarkers(), L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this, t);
        },
        _move: function _move(t) {
          for (var e, n = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), r = this._shape.getBounds().getCenter(), i = [], o = 0, a = n.length; o < a; o++) {
            e = [n[o].lat - r.lat, n[o].lng - r.lng], i.push([t.lat + e[0], t.lng + e[1]]);
          }

          this._shape.setLatLngs(i), this._repositionCornerMarkers(), this._map.fire(L.Draw.Event.EDITMOVE, {
            layer: this._shape
          });
        },
        _resize: function _resize(t) {
          var e;
          this._shape.setBounds(L.latLngBounds(t, this._oppositeCorner)), e = this._shape.getBounds(), this._moveMarker.setLatLng(e.getCenter()), this._map.fire(L.Draw.Event.EDITRESIZE, {
            layer: this._shape
          });
        },
        _getCorners: function _getCorners() {
          var t = this._shape.getBounds();

          return [t.getNorthWest(), t.getNorthEast(), t.getSouthEast(), t.getSouthWest()];
        },
        _toggleCornerMarkers: function _toggleCornerMarkers(t) {
          for (var e = 0, n = this._resizeMarkers.length; e < n; e++) {
            this._resizeMarkers[e].setOpacity(t);
          }
        },
        _repositionCornerMarkers: function _repositionCornerMarkers() {
          for (var t = this._getCorners(), e = 0, n = this._resizeMarkers.length; e < n; e++) {
            this._resizeMarkers[e].setLatLng(t[e]);
          }
        }
      }), L.Rectangle.addInitHook(function () {
        L.Edit.Rectangle && (this.editing = new L.Edit.Rectangle(this), this.options.editable && this.editing.enable());
      }), L.Edit = L.Edit || {}, L.Edit.CircleMarker = L.Edit.SimpleShape.extend({
        _createMoveMarker: function _createMoveMarker() {
          var t = this._shape.getLatLng();

          this._moveMarker = this._createMarker(t, this.options.moveIcon);
        },
        _createResizeMarker: function _createResizeMarker() {
          this._resizeMarkers = [];
        },
        _move: function _move(t) {
          if (this._resizeMarkers.length) {
            var e = this._getResizeMarkerPoint(t);

            this._resizeMarkers[0].setLatLng(e);
          }

          this._shape.setLatLng(t), this._map.fire(L.Draw.Event.EDITMOVE, {
            layer: this._shape
          });
        }
      }), L.CircleMarker.addInitHook(function () {
        L.Edit.CircleMarker && (this.editing = new L.Edit.CircleMarker(this), this.options.editable && this.editing.enable()), this.on("add", function () {
          this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function () {
          this.editing && this.editing.enabled() && this.editing.removeHooks();
        });
      }), L.Edit = L.Edit || {}, L.Edit.Circle = L.Edit.CircleMarker.extend({
        _createResizeMarker: function _createResizeMarker() {
          var t = this._shape.getLatLng(),
              e = this._getResizeMarkerPoint(t);

          this._resizeMarkers = [], this._resizeMarkers.push(this._createMarker(e, this.options.resizeIcon));
        },
        _getResizeMarkerPoint: function _getResizeMarkerPoint(t) {
          var e = this._shape._radius * Math.cos(Math.PI / 4),
              n = this._map.project(t);

          return this._map.unproject([n.x + e, n.y - e]);
        },
        _resize: function _resize(t) {
          var e = this._moveMarker.getLatLng();

          L.GeometryUtil.isVersion07x() ? radius = e.distanceTo(t) : radius = this._map.distance(e, t), this._shape.setRadius(radius), this._map._editTooltip.updateContent({
            text: L.drawLocal.edit.handlers.edit.tooltip.subtext + "<br />" + L.drawLocal.edit.handlers.edit.tooltip.text,
            subtext: L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(radius, !0, this.options.feet, this.options.nautic)
          }), this._shape.setRadius(radius), this._map.fire(L.Draw.Event.EDITRESIZE, {
            layer: this._shape
          });
        }
      }), L.Circle.addInitHook(function () {
        L.Edit.Circle && (this.editing = new L.Edit.Circle(this), this.options.editable && this.editing.enable()), this.on("add", function () {
          this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function () {
          this.editing && this.editing.enabled() && this.editing.removeHooks();
        });
      }), L.Map.mergeOptions({
        touchExtend: !0
      }), L.Map.TouchExtend = L.Handler.extend({
        initialize: function initialize(t) {
          this._map = t, this._container = t._container, this._pane = t._panes.overlayPane;
        },
        addHooks: function addHooks() {
          L.DomEvent.on(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.on(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.on(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.on(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.on(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.on(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.on(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.on(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.on(this._container, "touchleave", this._onTouchLeave, this));
        },
        removeHooks: function removeHooks() {
          L.DomEvent.off(this._container, "touchstart", this._onTouchStart), L.DomEvent.off(this._container, "touchend", this._onTouchEnd), L.DomEvent.off(this._container, "touchmove", this._onTouchMove), this._detectIE() ? (L.DomEvent.off(this._container, "MSPointerDowm", this._onTouchStart), L.DomEvent.off(this._container, "MSPointerUp", this._onTouchEnd), L.DomEvent.off(this._container, "MSPointerMove", this._onTouchMove), L.DomEvent.off(this._container, "MSPointerCancel", this._onTouchCancel)) : (L.DomEvent.off(this._container, "touchcancel", this._onTouchCancel), L.DomEvent.off(this._container, "touchleave", this._onTouchLeave));
        },
        _touchEvent: function _touchEvent(t, e) {
          var n = {};

          if (void 0 !== t.touches) {
            if (!t.touches.length) return;
            n = t.touches[0];
          } else {
            if ("touch" !== t.pointerType) return;
            if (n = t, !this._filterClick(t)) return;
          }

          var r = this._map.mouseEventToContainerPoint(n),
              i = this._map.mouseEventToLayerPoint(n),
              o = this._map.layerPointToLatLng(i);

          this._map.fire(e, {
            latlng: o,
            layerPoint: i,
            containerPoint: r,
            pageX: n.pageX,
            pageY: n.pageY,
            originalEvent: t
          });
        },
        _filterClick: function _filterClick(t) {
          var e = t.timeStamp || t.originalEvent.timeStamp,
              n = L.DomEvent._lastClick && e - L.DomEvent._lastClick;
          return n && n > 100 && n < 500 || t.target._simulatedClick && !t._simulated ? (L.DomEvent.stop(t), !1) : (L.DomEvent._lastClick = e, !0);
        },
        _onTouchStart: function _onTouchStart(t) {
          this._map._loaded && this._touchEvent(t, "touchstart");
        },
        _onTouchEnd: function _onTouchEnd(t) {
          this._map._loaded && this._touchEvent(t, "touchend");
        },
        _onTouchCancel: function _onTouchCancel(t) {
          if (this._map._loaded) {
            var e = "touchcancel";
            this._detectIE() && (e = "pointercancel"), this._touchEvent(t, e);
          }
        },
        _onTouchLeave: function _onTouchLeave(t) {
          this._map._loaded && this._touchEvent(t, "touchleave");
        },
        _onTouchMove: function _onTouchMove(t) {
          this._map._loaded && this._touchEvent(t, "touchmove");
        },
        _detectIE: function _detectIE() {
          var e = t.navigator.userAgent,
              n = e.indexOf("MSIE ");
          if (n > 0) return parseInt(e.substring(n + 5, e.indexOf(".", n)), 10);

          if (e.indexOf("Trident/") > 0) {
            var r = e.indexOf("rv:");
            return parseInt(e.substring(r + 3, e.indexOf(".", r)), 10);
          }

          var i = e.indexOf("Edge/");
          return i > 0 && parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
        }
      }), L.Map.addInitHook("addHandler", "touchExtend", L.Map.TouchExtend), L.Marker.Touch = L.Marker.extend({
        _initInteraction: function _initInteraction() {
          return this.addInteractiveTarget ? L.Marker.prototype._initInteraction.apply(this) : this._initInteractionLegacy();
        },
        _initInteractionLegacy: function _initInteractionLegacy() {
          if (this.options.clickable) {
            var t = this._icon,
                e = ["dblclick", "mousedown", "mouseover", "mouseout", "contextmenu", "touchstart", "touchend", "touchmove"];
            this._detectIE ? e.concat(["MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel"]) : e.concat(["touchcancel"]), L.DomUtil.addClass(t, "leaflet-clickable"), L.DomEvent.on(t, "click", this._onMouseClick, this), L.DomEvent.on(t, "keypress", this._onKeyPress, this);

            for (var n = 0; n < e.length; n++) {
              L.DomEvent.on(t, e[n], this._fireMouseEvent, this);
            }

            L.Handler.MarkerDrag && (this.dragging = new L.Handler.MarkerDrag(this), this.options.draggable && this.dragging.enable());
          }
        },
        _detectIE: function _detectIE() {
          var e = t.navigator.userAgent,
              n = e.indexOf("MSIE ");
          if (n > 0) return parseInt(e.substring(n + 5, e.indexOf(".", n)), 10);

          if (e.indexOf("Trident/") > 0) {
            var r = e.indexOf("rv:");
            return parseInt(e.substring(r + 3, e.indexOf(".", r)), 10);
          }

          var i = e.indexOf("Edge/");
          return i > 0 && parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
        }
      }), L.LatLngUtil = {
        cloneLatLngs: function cloneLatLngs(t) {
          for (var e = [], n = 0, r = t.length; n < r; n++) {
            Array.isArray(t[n]) ? e.push(L.LatLngUtil.cloneLatLngs(t[n])) : e.push(this.cloneLatLng(t[n]));
          }

          return e;
        },
        cloneLatLng: function cloneLatLng(t) {
          return L.latLng(t.lat, t.lng);
        }
      }, function () {
        var t = {
          km: 2,
          ha: 2,
          m: 0,
          mi: 2,
          ac: 2,
          yd: 0,
          ft: 0,
          nm: 2
        };
        L.GeometryUtil = L.extend(L.GeometryUtil || {}, {
          geodesicArea: function geodesicArea(t) {
            var e,
                n,
                r = t.length,
                i = 0,
                o = Math.PI / 180;

            if (r > 2) {
              for (var a = 0; a < r; a++) {
                e = t[a], i += ((n = t[(a + 1) % r]).lng - e.lng) * o * (2 + Math.sin(e.lat * o) + Math.sin(n.lat * o));
              }

              i = 6378137 * i * 6378137 / 2;
            }

            return Math.abs(i);
          },
          formattedNumber: function formattedNumber(t, e) {
            var n = parseFloat(t).toFixed(e),
                r = L.drawLocal.format && L.drawLocal.format.numeric,
                i = r && r.delimiters,
                o = i && i.thousands,
                a = i && i.decimal;

            if (o || a) {
              var s = n.split(".");
              n = o ? s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + o) : s[0], a = a || ".", s.length > 1 && (n = n + a + s[1]);
            }

            return n;
          },
          readableArea: function readableArea(e, n, r) {
            var i, o;
            r = L.Util.extend({}, t, r);
            return n ? (o = ["ha", "m"], type = typeof n, "string" === type ? o = [n] : "boolean" !== type && (o = n), i = e >= 1e6 && -1 !== o.indexOf("km") ? L.GeometryUtil.formattedNumber(1e-6 * e, r.km) + " km²" : e >= 1e4 && -1 !== o.indexOf("ha") ? L.GeometryUtil.formattedNumber(1e-4 * e, r.ha) + " ha" : L.GeometryUtil.formattedNumber(e, r.m) + " m²") : i = (e /= .836127) >= 3097600 ? L.GeometryUtil.formattedNumber(e / 3097600, r.mi) + " mi²" : e >= 4840 ? L.GeometryUtil.formattedNumber(e / 4840, r.ac) + " acres" : L.GeometryUtil.formattedNumber(e, r.yd) + " yd²", i;
          },
          readableDistance: function readableDistance(e, n, r, i, o) {
            var a;
            o = L.Util.extend({}, t, o);

            switch (n ? "string" == typeof n ? n : "metric" : r ? "feet" : i ? "nauticalMile" : "yards") {
              case "metric":
                a = e > 1e3 ? L.GeometryUtil.formattedNumber(e / 1e3, o.km) + " km" : L.GeometryUtil.formattedNumber(e, o.m) + " m";
                break;

              case "feet":
                e *= 3.28083, a = L.GeometryUtil.formattedNumber(e, o.ft) + " ft";
                break;

              case "nauticalMile":
                e *= .53996, a = L.GeometryUtil.formattedNumber(e / 1e3, o.nm) + " nm";
                break;

              case "yards":
              default:
                a = (e *= 1.09361) > 1760 ? L.GeometryUtil.formattedNumber(e / 1760, o.mi) + " miles" : L.GeometryUtil.formattedNumber(e, o.yd) + " yd";
            }

            return a;
          },
          isVersion07x: function isVersion07x() {
            var t = L.version.split(".");
            return 0 === parseInt(t[0], 10) && 7 === parseInt(t[1], 10);
          }
        });
      }(), L.Util.extend(L.LineUtil, {
        segmentsIntersect: function segmentsIntersect(t, e, n, r) {
          return this._checkCounterclockwise(t, n, r) !== this._checkCounterclockwise(e, n, r) && this._checkCounterclockwise(t, e, n) !== this._checkCounterclockwise(t, e, r);
        },
        _checkCounterclockwise: function _checkCounterclockwise(t, e, n) {
          return (n.y - t.y) * (e.x - t.x) > (e.y - t.y) * (n.x - t.x);
        }
      }), L.Polyline.include({
        intersects: function intersects() {
          var t,
              e,
              n,
              r = this._getProjectedPoints(),
              i = r ? r.length : 0;

          if (this._tooFewPointsForIntersection()) return !1;

          for (t = i - 1; t >= 3; t--) {
            if (e = r[t - 1], n = r[t], this._lineSegmentsIntersectsRange(e, n, t - 2)) return !0;
          }

          return !1;
        },
        newLatLngIntersects: function newLatLngIntersects(t, e) {
          return !!this._map && this.newPointIntersects(this._map.latLngToLayerPoint(t), e);
        },
        newPointIntersects: function newPointIntersects(t, e) {
          var n = this._getProjectedPoints(),
              r = n ? n.length : 0,
              i = n ? n[r - 1] : null,
              o = r - 2;

          return !this._tooFewPointsForIntersection(1) && this._lineSegmentsIntersectsRange(i, t, o, e ? 1 : 0);
        },
        _tooFewPointsForIntersection: function _tooFewPointsForIntersection(t) {
          var e = this._getProjectedPoints(),
              n = e ? e.length : 0;

          return !e || (n += t || 0) <= 3;
        },
        _lineSegmentsIntersectsRange: function _lineSegmentsIntersectsRange(t, e, n, r) {
          var i,
              o,
              a = this._getProjectedPoints();

          r = r || 0;

          for (var s = n; s > r; s--) {
            if (i = a[s - 1], o = a[s], L.LineUtil.segmentsIntersect(t, e, i, o)) return !0;
          }

          return !1;
        },
        _getProjectedPoints: function _getProjectedPoints() {
          if (!this._defaultShape) return this._originalPoints;

          for (var t = [], e = this._defaultShape(), n = 0; n < e.length; n++) {
            t.push(this._map.latLngToLayerPoint(e[n]));
          }

          return t;
        }
      }), L.Polygon.include({
        intersects: function intersects() {
          var t,
              e,
              n,
              r,
              i = this._getProjectedPoints();

          return !this._tooFewPointsForIntersection() && (!!L.Polyline.prototype.intersects.call(this) || (t = i.length, e = i[0], n = i[t - 1], r = t - 2, this._lineSegmentsIntersectsRange(n, e, r, 1)));
        }
      }), L.Control.Draw = L.Control.extend({
        options: {
          position: "topleft",
          draw: {},
          edit: !1
        },
        initialize: function initialize(t) {
          if (L.version < "0.7") throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");
          var e;
          L.Control.prototype.initialize.call(this, t), this._toolbars = {}, L.DrawToolbar && this.options.draw && (e = new L.DrawToolbar(this.options.draw), this._toolbars[L.DrawToolbar.TYPE] = e, this._toolbars[L.DrawToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.EditToolbar && this.options.edit && (e = new L.EditToolbar(this.options.edit), this._toolbars[L.EditToolbar.TYPE] = e, this._toolbars[L.EditToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.toolbar = this;
        },
        onAdd: function onAdd(t) {
          var e,
              n = L.DomUtil.create("div", "leaflet-draw"),
              r = !1;

          for (var i in this._toolbars) {
            this._toolbars.hasOwnProperty(i) && (e = this._toolbars[i].addToolbar(t)) && (r || (L.DomUtil.hasClass(e, "leaflet-draw-toolbar-top") || L.DomUtil.addClass(e.childNodes[0], "leaflet-draw-toolbar-top"), r = !0), n.appendChild(e));
          }

          return n;
        },
        onRemove: function onRemove() {
          for (var t in this._toolbars) {
            this._toolbars.hasOwnProperty(t) && this._toolbars[t].removeToolbar();
          }
        },
        setDrawingOptions: function setDrawingOptions(t) {
          for (var e in this._toolbars) {
            this._toolbars[e] instanceof L.DrawToolbar && this._toolbars[e].setOptions(t);
          }
        },
        _toolbarEnabled: function _toolbarEnabled(t) {
          var e = t.target;

          for (var n in this._toolbars) {
            this._toolbars[n] !== e && this._toolbars[n].disable();
          }
        }
      }), L.Map.mergeOptions({
        drawControlTooltips: !0,
        drawControl: !1
      }), L.Map.addInitHook(function () {
        this.options.drawControl && (this.drawControl = new L.Control.Draw(), this.addControl(this.drawControl));
      }), L.Toolbar = L.Class.extend({
        initialize: function initialize(t) {
          L.setOptions(this, t), this._modes = {}, this._actionButtons = [], this._activeMode = null;
          var e = L.version.split(".");
          1 === parseInt(e[0], 10) && parseInt(e[1], 10) >= 2 ? L.Toolbar.include(L.Evented.prototype) : L.Toolbar.include(L.Mixin.Events);
        },
        enabled: function enabled() {
          return null !== this._activeMode;
        },
        disable: function disable() {
          this.enabled() && this._activeMode.handler.disable();
        },
        addToolbar: function addToolbar(t) {
          var e,
              n = L.DomUtil.create("div", "leaflet-draw-section"),
              r = 0,
              i = this._toolbarClass || "",
              o = this.getModeHandlers(t);

          for (this._toolbarContainer = L.DomUtil.create("div", "leaflet-draw-toolbar leaflet-bar"), this._map = t, e = 0; e < o.length; e++) {
            o[e].enabled && this._initModeHandler(o[e].handler, this._toolbarContainer, r++, i, o[e].title);
          }

          if (r) return this._lastButtonIndex = --r, this._actionsContainer = L.DomUtil.create("ul", "leaflet-draw-actions"), n.appendChild(this._toolbarContainer), n.appendChild(this._actionsContainer), n;
        },
        removeToolbar: function removeToolbar() {
          for (var t in this._modes) {
            this._modes.hasOwnProperty(t) && (this._disposeButton(this._modes[t].button, this._modes[t].handler.enable, this._modes[t].handler), this._modes[t].handler.disable(), this._modes[t].handler.off("enabled", this._handlerActivated, this).off("disabled", this._handlerDeactivated, this));
          }

          this._modes = {};

          for (var e = 0, n = this._actionButtons.length; e < n; e++) {
            this._disposeButton(this._actionButtons[e].button, this._actionButtons[e].callback, this);
          }

          this._actionButtons = [], this._actionsContainer = null;
        },
        _initModeHandler: function _initModeHandler(t, e, n, r, i) {
          var o = t.type;
          this._modes[o] = {}, this._modes[o].handler = t, this._modes[o].button = this._createButton({
            type: o,
            title: i,
            className: r + "-" + o,
            container: e,
            callback: this._modes[o].handler.enable,
            context: this._modes[o].handler
          }), this._modes[o].buttonIndex = n, this._modes[o].handler.on("enabled", this._handlerActivated, this).on("disabled", this._handlerDeactivated, this);
        },
        _detectIOS: function _detectIOS() {
          return /iPad|iPhone|iPod/.test(navigator.userAgent) && !t.MSStream;
        },
        _createButton: function _createButton(t) {
          var e = L.DomUtil.create("a", t.className || "", t.container),
              n = L.DomUtil.create("span", "sr-only", t.container);
          e.href = "#", e.appendChild(n), t.title && (e.title = t.title, n.innerHTML = t.title), t.text && (e.innerHTML = t.text, n.innerHTML = t.text);
          var r = this._detectIOS() ? "touchstart" : "click";
          return L.DomEvent.on(e, "click", L.DomEvent.stopPropagation).on(e, "mousedown", L.DomEvent.stopPropagation).on(e, "dblclick", L.DomEvent.stopPropagation).on(e, "touchstart", L.DomEvent.stopPropagation).on(e, "click", L.DomEvent.preventDefault).on(e, r, t.callback, t.context), e;
        },
        _disposeButton: function _disposeButton(t, e) {
          var n = this._detectIOS() ? "touchstart" : "click";
          L.DomEvent.off(t, "click", L.DomEvent.stopPropagation).off(t, "mousedown", L.DomEvent.stopPropagation).off(t, "dblclick", L.DomEvent.stopPropagation).off(t, "touchstart", L.DomEvent.stopPropagation).off(t, "click", L.DomEvent.preventDefault).off(t, n, e);
        },
        _handlerActivated: function _handlerActivated(t) {
          this.disable(), this._activeMode = this._modes[t.handler], L.DomUtil.addClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._showActionsToolbar(), this.fire("enable");
        },
        _handlerDeactivated: function _handlerDeactivated() {
          this._hideActionsToolbar(), L.DomUtil.removeClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._activeMode = null, this.fire("disable");
        },
        _createActions: function _createActions(t) {
          var e,
              n,
              r,
              i,
              o = this._actionsContainer,
              a = this.getActions(t),
              s = a.length;

          for (n = 0, r = this._actionButtons.length; n < r; n++) {
            this._disposeButton(this._actionButtons[n].button, this._actionButtons[n].callback);
          }

          for (this._actionButtons = []; o.firstChild;) {
            o.removeChild(o.firstChild);
          }

          for (var u = 0; u < s; u++) {
            "enabled" in a[u] && !a[u].enabled || (e = L.DomUtil.create("li", "", o), i = this._createButton({
              title: a[u].title,
              text: a[u].text,
              container: e,
              callback: a[u].callback,
              context: a[u].context
            }), this._actionButtons.push({
              button: i,
              callback: a[u].callback
            }));
          }
        },
        _showActionsToolbar: function _showActionsToolbar() {
          var t = this._activeMode.buttonIndex,
              e = this._lastButtonIndex,
              n = this._activeMode.button.offsetTop - 1;
          this._createActions(this._activeMode.handler), this._actionsContainer.style.top = n + "px", 0 === t && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-top")), t === e && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-bottom")), this._actionsContainer.style.display = "block", this._map.fire(L.Draw.Event.TOOLBAROPENED);
        },
        _hideActionsToolbar: function _hideActionsToolbar() {
          this._actionsContainer.style.display = "none", L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-top"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-bottom"), this._map.fire(L.Draw.Event.TOOLBARCLOSED);
        }
      }), L.Draw = L.Draw || {}, L.Draw.Tooltip = L.Class.extend({
        initialize: function initialize(t) {
          this._map = t, this._popupPane = t._panes.popupPane, this._visible = !1, this._container = t.options.drawControlTooltips ? L.DomUtil.create("div", "leaflet-draw-tooltip", this._popupPane) : null, this._singleLineLabel = !1, this._map.on("mouseout", this._onMouseOut, this);
        },
        dispose: function dispose() {
          this._map.off("mouseout", this._onMouseOut, this), this._container && (this._popupPane.removeChild(this._container), this._container = null);
        },
        updateContent: function updateContent(t) {
          return this._container ? (t.subtext = t.subtext || "", 0 !== t.subtext.length || this._singleLineLabel ? t.subtext.length > 0 && this._singleLineLabel && (L.DomUtil.removeClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !1) : (L.DomUtil.addClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !0), this._container.innerHTML = (t.subtext.length > 0 ? '<span class="leaflet-draw-tooltip-subtext">' + t.subtext + "</span><br />" : "") + "<span>" + t.text + "</span>", t.text || t.subtext ? (this._visible = !0, this._container.style.visibility = "inherit") : (this._visible = !1, this._container.style.visibility = "hidden"), this) : this;
        },
        updatePosition: function updatePosition(t) {
          var e = this._map.latLngToLayerPoint(t),
              n = this._container;

          return this._container && (this._visible && (n.style.visibility = "inherit"), L.DomUtil.setPosition(n, e)), this;
        },
        showAsError: function showAsError() {
          return this._container && L.DomUtil.addClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        removeError: function removeError() {
          return this._container && L.DomUtil.removeClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        _onMouseOut: function _onMouseOut() {
          this._container && (this._container.style.visibility = "hidden");
        }
      }), L.DrawToolbar = L.Toolbar.extend({
        statics: {
          TYPE: "draw"
        },
        options: {
          polyline: {},
          polygon: {},
          rectangle: {},
          circle: {},
          marker: {},
          circlemarker: {}
        },
        initialize: function initialize(t) {
          for (var e in this.options) {
            this.options.hasOwnProperty(e) && t[e] && (t[e] = L.extend({}, this.options[e], t[e]));
          }

          this._toolbarClass = "leaflet-draw-draw", L.Toolbar.prototype.initialize.call(this, t);
        },
        getModeHandlers: function getModeHandlers(t) {
          return [{
            enabled: this.options.polyline,
            handler: new L.Draw.Polyline(t, this.options.polyline),
            title: L.drawLocal.draw.toolbar.buttons.polyline
          }, {
            enabled: this.options.polygon,
            handler: new L.Draw.Polygon(t, this.options.polygon),
            title: L.drawLocal.draw.toolbar.buttons.polygon
          }, {
            enabled: this.options.rectangle,
            handler: new L.Draw.Rectangle(t, this.options.rectangle),
            title: L.drawLocal.draw.toolbar.buttons.rectangle
          }, {
            enabled: this.options.circle,
            handler: new L.Draw.Circle(t, this.options.circle),
            title: L.drawLocal.draw.toolbar.buttons.circle
          }, {
            enabled: this.options.marker,
            handler: new L.Draw.Marker(t, this.options.marker),
            title: L.drawLocal.draw.toolbar.buttons.marker
          }, {
            enabled: this.options.circlemarker,
            handler: new L.Draw.CircleMarker(t, this.options.circlemarker),
            title: L.drawLocal.draw.toolbar.buttons.circlemarker
          }];
        },
        getActions: function getActions(t) {
          return [{
            enabled: t.completeShape,
            title: L.drawLocal.draw.toolbar.finish.title,
            text: L.drawLocal.draw.toolbar.finish.text,
            callback: t.completeShape,
            context: t
          }, {
            enabled: t.deleteLastVertex,
            title: L.drawLocal.draw.toolbar.undo.title,
            text: L.drawLocal.draw.toolbar.undo.text,
            callback: t.deleteLastVertex,
            context: t
          }, {
            title: L.drawLocal.draw.toolbar.actions.title,
            text: L.drawLocal.draw.toolbar.actions.text,
            callback: this.disable,
            context: this
          }];
        },
        setOptions: function setOptions(t) {
          for (var e in L.setOptions(this, t), this._modes) {
            this._modes.hasOwnProperty(e) && t.hasOwnProperty(e) && this._modes[e].handler.setOptions(t[e]);
          }
        }
      }), L.EditToolbar = L.Toolbar.extend({
        statics: {
          TYPE: "edit"
        },
        options: {
          edit: {
            selectedPathOptions: {
              dashArray: "10, 10",
              fill: !0,
              fillColor: "#fe57a1",
              fillOpacity: .1,
              maintainColor: !1
            }
          },
          remove: {},
          poly: null,
          featureGroup: null
        },
        initialize: function initialize(t) {
          t.edit && (void 0 === t.edit.selectedPathOptions && (t.edit.selectedPathOptions = this.options.edit.selectedPathOptions), t.edit.selectedPathOptions = L.extend({}, this.options.edit.selectedPathOptions, t.edit.selectedPathOptions)), t.remove && (t.remove = L.extend({}, this.options.remove, t.remove)), t.poly && (t.poly = L.extend({}, this.options.poly, t.poly)), this._toolbarClass = "leaflet-draw-edit", L.Toolbar.prototype.initialize.call(this, t), this._selectedFeatureCount = 0;
        },
        getModeHandlers: function getModeHandlers(t) {
          var e = this.options.featureGroup;
          return [{
            enabled: this.options.edit,
            handler: new L.EditToolbar.Edit(t, {
              featureGroup: e,
              selectedPathOptions: this.options.edit.selectedPathOptions,
              poly: this.options.poly
            }),
            title: L.drawLocal.edit.toolbar.buttons.edit
          }, {
            enabled: this.options.remove,
            handler: new L.EditToolbar.Delete(t, {
              featureGroup: e
            }),
            title: L.drawLocal.edit.toolbar.buttons.remove
          }];
        },
        getActions: function getActions(t) {
          var e = [{
            title: L.drawLocal.edit.toolbar.actions.save.title,
            text: L.drawLocal.edit.toolbar.actions.save.text,
            callback: this._save,
            context: this
          }, {
            title: L.drawLocal.edit.toolbar.actions.cancel.title,
            text: L.drawLocal.edit.toolbar.actions.cancel.text,
            callback: this.disable,
            context: this
          }];
          return t.removeAllLayers && e.push({
            title: L.drawLocal.edit.toolbar.actions.clearAll.title,
            text: L.drawLocal.edit.toolbar.actions.clearAll.text,
            callback: this._clearAllLayers,
            context: this
          }), e;
        },
        addToolbar: function addToolbar(t) {
          var e = L.Toolbar.prototype.addToolbar.call(this, t);
          return this._checkDisabled(), this.options.featureGroup.on("layeradd layerremove", this._checkDisabled, this), e;
        },
        removeToolbar: function removeToolbar() {
          this.options.featureGroup.off("layeradd layerremove", this._checkDisabled, this), L.Toolbar.prototype.removeToolbar.call(this);
        },
        disable: function disable() {
          this.enabled() && (this._activeMode.handler.revertLayers(), L.Toolbar.prototype.disable.call(this));
        },
        _save: function _save() {
          this._activeMode.handler.save(), this._activeMode && this._activeMode.handler.disable();
        },
        _clearAllLayers: function _clearAllLayers() {
          this._activeMode.handler.removeAllLayers(), this._activeMode && this._activeMode.handler.disable();
        },
        _checkDisabled: function _checkDisabled() {
          var t,
              e = 0 !== this.options.featureGroup.getLayers().length;
          this.options.edit && (t = this._modes[L.EditToolbar.Edit.TYPE].button, e ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", e ? L.drawLocal.edit.toolbar.buttons.edit : L.drawLocal.edit.toolbar.buttons.editDisabled)), this.options.remove && (t = this._modes[L.EditToolbar.Delete.TYPE].button, e ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", e ? L.drawLocal.edit.toolbar.buttons.remove : L.drawLocal.edit.toolbar.buttons.removeDisabled));
        }
      }), L.EditToolbar.Edit = L.Handler.extend({
        statics: {
          TYPE: "edit"
        },
        initialize: function initialize(t, e) {
          if (L.Handler.prototype.initialize.call(this, t), L.setOptions(this, e), this._featureGroup = e.featureGroup, !(this._featureGroup instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
          this._uneditedLayerProps = {}, this.type = L.EditToolbar.Edit.TYPE;
          var n = L.version.split(".");
          1 === parseInt(n[0], 10) && parseInt(n[1], 10) >= 2 ? L.EditToolbar.Edit.include(L.Evented.prototype) : L.EditToolbar.Edit.include(L.Mixin.Events);
        },
        enable: function enable() {
          !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
            handler: this.type
          }), this._map.fire(L.Draw.Event.EDITSTART, {
            handler: this.type
          }), L.Handler.prototype.enable.call(this), this._featureGroup.on("layeradd", this._enableLayerEdit, this).on("layerremove", this._disableLayerEdit, this));
        },
        disable: function disable() {
          this._enabled && (this._featureGroup.off("layeradd", this._enableLayerEdit, this).off("layerremove", this._disableLayerEdit, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.EDITSTOP, {
            handler: this.type
          }), this.fire("disabled", {
            handler: this.type
          }));
        },
        addHooks: function addHooks() {
          var t = this._map;
          t && (t.getContainer().focus(), this._featureGroup.eachLayer(this._enableLayerEdit, this), this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
            text: L.drawLocal.edit.handlers.edit.tooltip.text,
            subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
          }), t._editTooltip = this._tooltip, this._updateTooltip(), this._map.on("mousemove", this._onMouseMove, this).on("touchmove", this._onMouseMove, this).on("MSPointerMove", this._onMouseMove, this).on(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        removeHooks: function removeHooks() {
          this._map && (this._featureGroup.eachLayer(this._disableLayerEdit, this), this._uneditedLayerProps = {}, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this).off("touchmove", this._onMouseMove, this).off("MSPointerMove", this._onMouseMove, this).off(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        revertLayers: function revertLayers() {
          this._featureGroup.eachLayer(function (t) {
            this._revertLayer(t);
          }, this);
        },
        save: function save() {
          var t = new L.LayerGroup();
          this._featureGroup.eachLayer(function (e) {
            e.edited && (t.addLayer(e), e.edited = !1);
          }), this._map.fire(L.Draw.Event.EDITED, {
            layers: t
          });
        },
        _backupLayer: function _backupLayer(t) {
          var e = L.Util.stamp(t);
          this._uneditedLayerProps[e] || (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? this._uneditedLayerProps[e] = {
            latlngs: L.LatLngUtil.cloneLatLngs(t.getLatLngs())
          } : t instanceof L.Circle ? this._uneditedLayerProps[e] = {
            latlng: L.LatLngUtil.cloneLatLng(t.getLatLng()),
            radius: t.getRadius()
          } : (t instanceof L.Marker || t instanceof L.CircleMarker) && (this._uneditedLayerProps[e] = {
            latlng: L.LatLngUtil.cloneLatLng(t.getLatLng())
          }));
        },
        _getTooltipText: function _getTooltipText() {
          return {
            text: L.drawLocal.edit.handlers.edit.tooltip.text,
            subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
          };
        },
        _updateTooltip: function _updateTooltip() {
          this._tooltip.updateContent(this._getTooltipText());
        },
        _revertLayer: function _revertLayer(t) {
          var e = L.Util.stamp(t);
          t.edited = !1, this._uneditedLayerProps.hasOwnProperty(e) && (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? t.setLatLngs(this._uneditedLayerProps[e].latlngs) : t instanceof L.Circle ? (t.setLatLng(this._uneditedLayerProps[e].latlng), t.setRadius(this._uneditedLayerProps[e].radius)) : (t instanceof L.Marker || t instanceof L.CircleMarker) && t.setLatLng(this._uneditedLayerProps[e].latlng), t.fire("revert-edited", {
            layer: t
          }));
        },
        _enableLayerEdit: function _enableLayerEdit(t) {
          var e,
              n,
              r = t.layer || t.target || t;
          this._backupLayer(r), this.options.poly && (n = L.Util.extend({}, this.options.poly), r.options.poly = n), this.options.selectedPathOptions && ((e = L.Util.extend({}, this.options.selectedPathOptions)).maintainColor && (e.color = r.options.color, e.fillColor = r.options.fillColor), r.options.original = L.extend({}, r.options), r.options.editing = e), r instanceof L.Marker ? (r.editing && r.editing.enable(), r.dragging.enable(), r.on("dragend", this._onMarkerDragEnd).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onMarkerDragEnd, this).on("MSPointerUp", this._onMarkerDragEnd, this)) : r.editing.enable();
        },
        _disableLayerEdit: function _disableLayerEdit(t) {
          var e = t.layer || t.target || t;
          e.edited = !1, e.editing && e.editing.disable(), delete e.options.editing, delete e.options.original, this._selectedPathOptions && (e instanceof L.Marker ? this._toggleMarkerHighlight(e) : (e.setStyle(e.options.previousOptions), delete e.options.previousOptions)), e instanceof L.Marker ? (e.dragging.disable(), e.off("dragend", this._onMarkerDragEnd, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onMarkerDragEnd, this).off("MSPointerUp", this._onMarkerDragEnd, this)) : e.editing.disable();
        },
        _onMouseMove: function _onMouseMove(t) {
          this._tooltip.updatePosition(t.latlng);
        },
        _onMarkerDragEnd: function _onMarkerDragEnd(t) {
          var e = t.target;
          e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
            layer: e
          });
        },
        _onTouchMove: function _onTouchMove(t) {
          var e = t.originalEvent.changedTouches[0],
              n = this._map.mouseEventToLayerPoint(e),
              r = this._map.layerPointToLatLng(n);

          t.target.setLatLng(r);
        },
        _hasAvailableLayers: function _hasAvailableLayers() {
          return 0 !== this._featureGroup.getLayers().length;
        }
      }), L.EditToolbar.Delete = L.Handler.extend({
        statics: {
          TYPE: "remove"
        },
        initialize: function initialize(t, e) {
          if (L.Handler.prototype.initialize.call(this, t), L.Util.setOptions(this, e), this._deletableLayers = this.options.featureGroup, !(this._deletableLayers instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
          this.type = L.EditToolbar.Delete.TYPE;
          var n = L.version.split(".");
          1 === parseInt(n[0], 10) && parseInt(n[1], 10) >= 2 ? L.EditToolbar.Delete.include(L.Evented.prototype) : L.EditToolbar.Delete.include(L.Mixin.Events);
        },
        enable: function enable() {
          !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
            handler: this.type
          }), this._map.fire(L.Draw.Event.DELETESTART, {
            handler: this.type
          }), L.Handler.prototype.enable.call(this), this._deletableLayers.on("layeradd", this._enableLayerDelete, this).on("layerremove", this._disableLayerDelete, this));
        },
        disable: function disable() {
          this._enabled && (this._deletableLayers.off("layeradd", this._enableLayerDelete, this).off("layerremove", this._disableLayerDelete, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DELETESTOP, {
            handler: this.type
          }), this.fire("disabled", {
            handler: this.type
          }));
        },
        addHooks: function addHooks() {
          var t = this._map;
          t && (t.getContainer().focus(), this._deletableLayers.eachLayer(this._enableLayerDelete, this), this._deletedLayers = new L.LayerGroup(), this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
            text: L.drawLocal.edit.handlers.remove.tooltip.text
          }), this._map.on("mousemove", this._onMouseMove, this));
        },
        removeHooks: function removeHooks() {
          this._map && (this._deletableLayers.eachLayer(this._disableLayerDelete, this), this._deletedLayers = null, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this));
        },
        revertLayers: function revertLayers() {
          this._deletedLayers.eachLayer(function (t) {
            this._deletableLayers.addLayer(t), t.fire("revert-deleted", {
              layer: t
            });
          }, this);
        },
        save: function save() {
          this._map.fire(L.Draw.Event.DELETED, {
            layers: this._deletedLayers
          });
        },
        removeAllLayers: function removeAllLayers() {
          this._deletableLayers.eachLayer(function (t) {
            this._removeLayer({
              layer: t
            });
          }, this), this.save();
        },
        _enableLayerDelete: function _enableLayerDelete(t) {
          (t.layer || t.target || t).on("click", this._removeLayer, this);
        },
        _disableLayerDelete: function _disableLayerDelete(t) {
          var e = t.layer || t.target || t;
          e.off("click", this._removeLayer, this), this._deletedLayers.removeLayer(e);
        },
        _removeLayer: function _removeLayer(t) {
          var e = t.layer || t.target || t;
          this._deletableLayers.removeLayer(e), this._deletedLayers.addLayer(e), e.fire("deleted");
        },
        _onMouseMove: function _onMouseMove(t) {
          this._tooltip.updatePosition(t.latlng);
        },
        _hasAvailableLayers: function _hasAvailableLayers() {
          return 0 !== this._deletableLayers.getLayers().length;
        }
      });
    }(window, document);
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = h(n(14)),
        i = h(n(0)),
        o = h(n(1)),
        a = h(n(5)),
        s = h(n(24)),
        u = h(n(4)),
        l = h(n(25)),
        c = n(2);

    function h(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var f = function () {
      function t(e, n) {
        (0, i.default)(this, t), this._props = (0, r.default)({}, e, {
          spiderfyOnMaxZoom: e.zoomOnClick,
          showCoverageOnHover: !1
        }), this._map = n, this._noClick = (0, u.default)(e, "clickable", !0) ? "" : "kmap-no-click", this._layer = L.markerClusterGroup({
          iconCreateFunction: this.getClusterStyle.bind(this),
          zoomToBoundsOnClick: e.zoomOnClick
        }), this._map.addLayer(this._layer);
      }

      return (0, o.default)(t, [{
        key: "getClusterStyle",
        value: function value(t) {
          var e = (0, l.default)(this._props.clusterStyle, {
            CLUSTERSIZE: t.getAllChildMarkers().length
          }, this._props.zIndex),
              n = e.icon.size[0] + "px " + e.icon.size[1] + "px",
              r = "<div style=\"background-image: url('" + e.icon.url + "'); background-size: " + n + '">' + e.icon.labelValue + "</div>";
          return L.divIcon({
            iconAnchor: e.icon.anchor,
            iconSize: e.icon.size,
            iconUrl: e.icon.url,
            html: r,
            className: "kmap-marker-label kmap-cluster-label " + this._noClick
          });
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._layer.setZIndex(t);
        }
      }, {
        key: "toggle",
        value: function value(t) {
          return t ? this._map.addLayer(this._layer) : this._map.removeLayer(this._layer);
        }
      }, {
        key: "clear",
        value: function value() {
          this._layer.clearLayers();
        }
      }, {
        key: "remove",
        value: function value() {
          this._layer.remove();
        }
      }, {
        key: "addPoints",
        value: function value(t, e, n) {
          if (!(0, s.default)(t.points)) {
            var r = {
              record: {
                geom: t,
                desc: e,
                kStyle: n,
                type: c.KGeometryType.POINT
              },
              icon: new L.icon({
                iconAnchor: n.icon.anchor,
                iconSize: n.icon.size,
                iconUrl: n.icon.url
              }),
              opacity: n.icon.opacity,
              zIndex: n.zIndex
            },
                i = (0, a.default)(t.points, function (t) {
              return L.marker({
                lat: t[0][0],
                lng: t[0][1]
              }, r).bindTooltip(n.icon.labelValue, {
                permanent: !0,
                noHide: !0,
                direction: "center",
                className: "kmap-marker-label"
              });
            });
            this._layer && this._layer.addLayers(i);
          }
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          function r(r) {
            var i = function i(n) {
              t.trigger(e, {
                desc: n.layer.options.record.desc,
                geom: n.layer.options.record.geom,
                kStyle: n.layer.options.record.kStyle,
                clickedLatLng: n.latlng,
                type: c.KGeometryType.POINT
              });
            };

            if (n._layer.on(r, i), "click" === r && !n._layer.zoomToBoundsOnClick) {
              n._layer.on("clusterclick", function (n) {
                t.trigger(e, {
                  type: c.KGeometryType.POINT,
                  clickedLatLng: n.latlng,
                  desc: {
                    CLUSTERSIZE: n.layer.getAllChildMarkers().length,
                    cluster: !0
                  },
                  geom: {
                    points: [[n.layer.getLatLng()]]
                  }
                });
              });
            }

            return i;
          }

          switch (e) {
            case c.KLayerEvents.DOUBLECLICK:
              return r("dblclick");

            case c.KLayerEvents.RIGHTCLICK:
              return r("contextmenu");

            case c.KLayerEvents.CLICK:
              return r("click");

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          this._layer.off(e, t);
        }
      }]), t;
    }();

    e.default = f;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = s(n(0)),
        i = s(n(1)),
        o = s(n(25)),
        a = n(2);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function () {
      function t(e, n) {
        var i = this;
        (0, r.default)(this, t), this._name = e, this._map = n, this._layer = L.geoJSON({
          type: "FeatureCollection",
          features: []
        }, {
          pointToLayer: function pointToLayer(t, e) {
            var n = (0, o.default)(i._styles, t, i._zIndex, function (e, n, r) {
              return t.properties[n] || r;
            }),
                r = {
              icon: new L.icon({
                iconAnchor: n.icon.anchor,
                iconSize: n.icon.size,
                iconUrl: n.icon.url
              }),
              opacity: n.icon.opacity,
              zIndex: n.zIndex
            },
                a = {
              permanent: !0,
              noHide: !0,
              direction: "center",
              className: "kmap-marker-label"
            };
            return n.icon.labelAnchor && (a.offset = [n.icon.size[0] / 2 - n.icon.labelAnchor[0], n.icon.size[1] / 2 - n.icon.labelAnchor[1]]), L.marker(e, r).bindTooltip(n.icon.text, a);
          }
        }), this._layer.addTo(n);
      }

      return (0, i.default)(t, [{
        key: "clear",
        value: function value() {
          this._layer.clearLayers();
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.removeLayer(this._layer);
        }
      }, {
        key: "setStyle",
        value: function value(t) {
          this._styles = t, this._layer.setStyle(this._getStyleOptions.bind(this));
        }
      }, {
        key: "_getStyleOptions",
        value: function value(t) {
          var e = (0, o.default)(this._styles, t, this._zIndex, function (e, n, r) {
            return t.properties[n] || r;
          });
          return "Polyline" === t.geometry.type || "MultiPolyline" === t.geometry.type ? {
            color: e.shape.borderColor,
            opacity: e.shape.borderOpacity,
            weight: e.shape.borderWeight,
            zIndex: e.zIndex
          } : {
            opacity: e.shape.borderOpacity,
            color: e.shape.borderColor,
            weight: e.shape.borderWeight,
            zIndex: e.zIndex,
            fillColor: e.shape.fillColor,
            fillOpacity: e.shape.opacity
          };
        }
      }, {
        key: "addGeoJson",
        value: function value(t) {
          this._layer.addData(t);
        }
      }, {
        key: "addEvent",
        value: function value(t, e) {
          var n = e;
          e === a.KLayerEvents.RIGHTCLICK && (n = "contextmenu");

          var r = function r(n) {
            t.trigger(e, n.feature);
          };

          return this._layer.on(n, r), r;
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          this._layer.off(e, t);
        }
      }, {
        key: "setZIndex",
        value: function value(t) {
          this._layer.setZIndex(t), this._zIndex = t;
        }
      }, {
        key: "toggle",
        value: function value(t) {
          return t ? this._map.addLayer(this._layer) : this._map.removeLayer(this._layer);
        }
      }]), t;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = a(n(0)),
        i = a(n(1)),
        o = n(2);

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var s = function () {
      function t(e, n, i, o) {
        (0, r.default)(this, t), this._map = n, this._events = {}, this._desc = o;
        var a = {
          icon: new L.icon({
            iconAnchor: i.anchor,
            iconSize: i.size,
            iconUrl: i.url
          }),
          opacity: i.opacity,
          zIndexOffset: i.zIndex
        },
            s = {
          permanent: !0,
          noHide: !0,
          direction: "center",
          className: "kmap-marker-label"
        };
        i.labelAnchor && (s.offset = [i.size[0] / 2 - i.labelAnchor[0], i.size[1] / 2 - i.labelAnchor[1]]), this._vector = new L.marker(e, a).bindTooltip(i.labelValue, s), this._map.addLayer(this._vector);
      }

      return (0, i.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          function r(r) {
            var i = function i(r) {
              t.trigger(e, {
                type: o.KGeometryType.POINT,
                clickedLatLng: r.latlng,
                desc: n._desc,
                geom: r.latlng
              });
            };

            return n._events[r] = i, n._vector.on(r, i), i;
          }

          switch (e) {
            case o.KGeometryEvents.RIGHTCLICK:
              return r("contextmenu");

            case o.KGeometryEvents.CLICK:
              return r("click");

            case o.KGeometryEvents.DOUBLECLICK:
              return r("dblclick");

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          switch (e) {
            case o.KGeometryEvents.click:
              this._vector.off("click", t);

          }
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.removeLayer(this._vector);
        }
      }]), t;
    }();

    e.default = s;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = s(n(0)),
        i = s(n(1)),
        o = s(n(5)),
        a = n(2);

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var u = function () {
      function t(e, n, i, a) {
        (0, r.default)(this, t), this._map = n, this._events = {}, this._desc = a, this._areas = e;
        var s = (0, o.default)(e, function (t) {
          return (0, o.default)(t, function (t) {
            return {
              lat: t[0],
              lng: t[1]
            };
          });
        });
        this._vector = new L.polygon(s, {
          color: i.borderColor,
          opacity: i.borderOpacity,
          weight: i.borderWeight,
          fillColor: i.fillColor,
          fillOpacity: i.opacity,
          zIndex: i.zIndex
        }), this._map.addLayer(this._vector);
      }

      return (0, i.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          function r(r) {
            var i = function i(r) {
              L.DomEvent.stop(r), t.trigger(e, {
                type: a.KGeometryType.POLYGON,
                clickedLatLng: r.latlng,
                desc: n._desc,
                geom: n._areas
              });
            };

            return n._events[r] = i, n._vector.on(r, i), i;
          }

          switch (e) {
            case a.KGeometryEvents.RIGHTCLICK:
              return r("contextmenu");

            case a.KGeometryEvents.CLICK:
              return r("click");

            case a.KGeometryEvents.DOUBLECLICK:
              return r("dblclick");

            default:
              return null;
          }
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.removeLayer(this._vector);
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          switch (e) {
            case a.KGeometryEvents.click:
              this._vector.off("click", t);

          }
        }
      }]), t;
    }();

    e.default = u;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = a(n(0)),
        i = a(n(1)),
        o = n(2);

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var s = function () {
      function t(e, n, i, o) {
        (0, r.default)(this, t), this._map = n, this._events = {}, this._desc = o, this._line = e, this._vector = new L.polyline(e, {
          color: i.borderColor,
          opacity: i.borderOpacity,
          weight: i.borderWeight
        }), this._map.addLayer(this._vector);
      }

      return (0, i.default)(t, [{
        key: "addEvent",
        value: function value(t, e) {
          var n = this;

          function r(r) {
            var i = function i(r) {
              L.DomEvent.stop(r), t.trigger(e, {
                type: o.KGeometryType.POLYLINE,
                clickedLatLng: r.latlng,
                desc: n._desc,
                geom: n._line
              });
            };

            return n._events[r] = i, n._vector.on(r, i), i;
          }

          switch (e) {
            case o.KGeometryEvents.RIGHTCLICK:
              return r("contextmenu");

            case o.KGeometryEvents.CLICK:
              return r("click");

            case o.KGeometryEvents.DOUBLECLICK:
              return r("dblclick");

            default:
              return null;
          }
        }
      }, {
        key: "removeEvent",
        value: function value(t, e) {
          switch (e) {
            case o.KGeometryEvents.click:
              this._vector.off("click", t);

          }
        }
      }, {
        key: "remove",
        value: function value() {
          this._map.removeLayer(this._vector);
        }
      }]), t;
    }();

    e.default = s;
  }, function (t, e, n) {
    !function (t) {
      "use strict";

      var e = L.MarkerClusterGroup = L.FeatureGroup.extend({
        options: {
          maxClusterRadius: 80,
          iconCreateFunction: null,
          clusterPane: L.Marker.prototype.options.pane,
          spiderfyOnMaxZoom: !0,
          showCoverageOnHover: !0,
          zoomToBoundsOnClick: !0,
          singleMarkerMode: !1,
          disableClusteringAtZoom: null,
          removeOutsideVisibleBounds: !0,
          animate: !0,
          animateAddingMarkers: !1,
          spiderfyDistanceMultiplier: 1,
          spiderLegPolylineOptions: {
            weight: 1.5,
            color: "#222",
            opacity: .5
          },
          chunkedLoading: !1,
          chunkInterval: 200,
          chunkDelay: 50,
          chunkProgress: null,
          polygonOptions: {}
        },
        initialize: function initialize(t) {
          L.Util.setOptions(this, t), this.options.iconCreateFunction || (this.options.iconCreateFunction = this._defaultIconCreateFunction), this._featureGroup = L.featureGroup(), this._featureGroup.addEventParent(this), this._nonPointGroup = L.featureGroup(), this._nonPointGroup.addEventParent(this), this._inZoomAnimation = 0, this._needsClustering = [], this._needsRemoving = [], this._currentShownBounds = null, this._queue = [], this._childMarkerEventHandlers = {
            dragstart: this._childMarkerDragStart,
            move: this._childMarkerMoved,
            dragend: this._childMarkerDragEnd
          };
          var e = L.DomUtil.TRANSITION && this.options.animate;
          L.extend(this, e ? this._withAnimation : this._noAnimation), this._markerCluster = e ? L.MarkerCluster : L.MarkerClusterNonAnimated;
        },
        addLayer: function addLayer(t) {
          if (t instanceof L.LayerGroup) return this.addLayers([t]);
          if (!t.getLatLng) return this._nonPointGroup.addLayer(t), this.fire("layeradd", {
            layer: t
          }), this;
          if (!this._map) return this._needsClustering.push(t), this.fire("layeradd", {
            layer: t
          }), this;
          if (this.hasLayer(t)) return this;
          this._unspiderfy && this._unspiderfy(), this._addLayer(t, this._maxZoom), this.fire("layeradd", {
            layer: t
          }), this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons();
          var e = t,
              n = this._zoom;
          if (t.__parent) for (; e.__parent._zoom >= n;) {
            e = e.__parent;
          }
          return this._currentShownBounds.contains(e.getLatLng()) && (this.options.animateAddingMarkers ? this._animationAddLayer(t, e) : this._animationAddLayerNonAnimated(t, e)), this;
        },
        removeLayer: function removeLayer(t) {
          return t instanceof L.LayerGroup ? this.removeLayers([t]) : t.getLatLng ? this._map ? t.__parent ? (this._unspiderfy && (this._unspiderfy(), this._unspiderfyLayer(t)), this._removeLayer(t, !0), this.fire("layerremove", {
            layer: t
          }), this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons(), t.off(this._childMarkerEventHandlers, this), this._featureGroup.hasLayer(t) && (this._featureGroup.removeLayer(t), t.clusterShow && t.clusterShow()), this) : this : (!this._arraySplice(this._needsClustering, t) && this.hasLayer(t) && this._needsRemoving.push({
            layer: t,
            latlng: t._latlng
          }), this.fire("layerremove", {
            layer: t
          }), this) : (this._nonPointGroup.removeLayer(t), this.fire("layerremove", {
            layer: t
          }), this);
        },
        addLayers: function addLayers(t, e) {
          if (!L.Util.isArray(t)) return this.addLayer(t);
          var n,
              r = this._featureGroup,
              i = this._nonPointGroup,
              o = this.options.chunkedLoading,
              a = this.options.chunkInterval,
              s = this.options.chunkProgress,
              u = t.length,
              l = 0,
              c = !0;

          if (this._map) {
            var h = new Date().getTime(),
                f = L.bind(function () {
              for (var p = new Date().getTime(); l < u; l++) {
                if (o && l % 200 == 0) {
                  var d = new Date().getTime() - p;
                  if (d > a) break;
                }

                if ((n = t[l]) instanceof L.LayerGroup) c && (t = t.slice(), c = !1), this._extractNonGroupLayers(n, t), u = t.length;else if (n.getLatLng) {
                  if (!this.hasLayer(n) && (this._addLayer(n, this._maxZoom), e || this.fire("layeradd", {
                    layer: n
                  }), n.__parent && 2 === n.__parent.getChildCount())) {
                    var v = n.__parent.getAllChildMarkers(),
                        y = v[0] === n ? v[1] : v[0];

                    r.removeLayer(y);
                  }
                } else i.addLayer(n), e || this.fire("layeradd", {
                  layer: n
                });
              }

              s && s(l, u, new Date().getTime() - h), l === u ? (this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons(), this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds)) : setTimeout(f, this.options.chunkDelay);
            }, this);
            f();
          } else for (var p = this._needsClustering; l < u; l++) {
            (n = t[l]) instanceof L.LayerGroup ? (c && (t = t.slice(), c = !1), this._extractNonGroupLayers(n, t), u = t.length) : n.getLatLng ? this.hasLayer(n) || p.push(n) : i.addLayer(n);
          }

          return this;
        },
        removeLayers: function removeLayers(t) {
          var e,
              n,
              r = t.length,
              i = this._featureGroup,
              o = this._nonPointGroup,
              a = !0;

          if (!this._map) {
            for (e = 0; e < r; e++) {
              (n = t[e]) instanceof L.LayerGroup ? (a && (t = t.slice(), a = !1), this._extractNonGroupLayers(n, t), r = t.length) : (this._arraySplice(this._needsClustering, n), o.removeLayer(n), this.hasLayer(n) && this._needsRemoving.push({
                layer: n,
                latlng: n._latlng
              }), this.fire("layerremove", {
                layer: n
              }));
            }

            return this;
          }

          if (this._unspiderfy) {
            this._unspiderfy();

            var s = t.slice(),
                u = r;

            for (e = 0; e < u; e++) {
              (n = s[e]) instanceof L.LayerGroup ? (this._extractNonGroupLayers(n, s), u = s.length) : this._unspiderfyLayer(n);
            }
          }

          for (e = 0; e < r; e++) {
            (n = t[e]) instanceof L.LayerGroup ? (a && (t = t.slice(), a = !1), this._extractNonGroupLayers(n, t), r = t.length) : n.__parent ? (this._removeLayer(n, !0, !0), this.fire("layerremove", {
              layer: n
            }), i.hasLayer(n) && (i.removeLayer(n), n.clusterShow && n.clusterShow())) : (o.removeLayer(n), this.fire("layerremove", {
              layer: n
            }));
          }

          return this._topClusterLevel._recalculateBounds(), this._refreshClustersIcons(), this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds), this;
        },
        clearLayers: function clearLayers() {
          return this._map || (this._needsClustering = [], this._needsRemoving = [], delete this._gridClusters, delete this._gridUnclustered), this._noanimationUnspiderfy && this._noanimationUnspiderfy(), this._featureGroup.clearLayers(), this._nonPointGroup.clearLayers(), this.eachLayer(function (t) {
            t.off(this._childMarkerEventHandlers, this), delete t.__parent;
          }, this), this._map && this._generateInitialClusters(), this;
        },
        getBounds: function getBounds() {
          var t = new L.LatLngBounds();
          this._topClusterLevel && t.extend(this._topClusterLevel._bounds);

          for (var e = this._needsClustering.length - 1; e >= 0; e--) {
            t.extend(this._needsClustering[e].getLatLng());
          }

          return t.extend(this._nonPointGroup.getBounds()), t;
        },
        eachLayer: function eachLayer(t, e) {
          var n,
              r,
              i,
              o = this._needsClustering.slice(),
              a = this._needsRemoving;

          for (this._topClusterLevel && this._topClusterLevel.getAllChildMarkers(o), r = o.length - 1; r >= 0; r--) {
            for (n = !0, i = a.length - 1; i >= 0; i--) {
              if (a[i].layer === o[r]) {
                n = !1;
                break;
              }
            }

            n && t.call(e, o[r]);
          }

          this._nonPointGroup.eachLayer(t, e);
        },
        getLayers: function getLayers() {
          var t = [];
          return this.eachLayer(function (e) {
            t.push(e);
          }), t;
        },
        getLayer: function getLayer(t) {
          var e = null;
          return t = parseInt(t, 10), this.eachLayer(function (n) {
            L.stamp(n) === t && (e = n);
          }), e;
        },
        hasLayer: function hasLayer(t) {
          if (!t) return !1;
          var e,
              n = this._needsClustering;

          for (e = n.length - 1; e >= 0; e--) {
            if (n[e] === t) return !0;
          }

          for (n = this._needsRemoving, e = n.length - 1; e >= 0; e--) {
            if (n[e].layer === t) return !1;
          }

          return !(!t.__parent || t.__parent._group !== this) || this._nonPointGroup.hasLayer(t);
        },
        zoomToShowLayer: function zoomToShowLayer(t, e) {
          "function" != typeof e && (e = function e() {});

          var n = function n() {
            !t._icon && !t.__parent._icon || this._inZoomAnimation || (this._map.off("moveend", n, this), this.off("animationend", n, this), t._icon ? e() : t.__parent._icon && (this.once("spiderfied", e, this), t.__parent.spiderfy()));
          };

          t._icon && this._map.getBounds().contains(t.getLatLng()) ? e() : t.__parent._zoom < Math.round(this._map._zoom) ? (this._map.on("moveend", n, this), this._map.panTo(t.getLatLng())) : (this._map.on("moveend", n, this), this.on("animationend", n, this), t.__parent.zoomToBounds());
        },
        onAdd: function onAdd(t) {
          var e, n, r;
          if (this._map = t, !isFinite(this._map.getMaxZoom())) throw "Map has no maxZoom specified";

          for (this._featureGroup.addTo(t), this._nonPointGroup.addTo(t), this._gridClusters || this._generateInitialClusters(), this._maxLat = t.options.crs.projection.MAX_LATITUDE, e = 0, n = this._needsRemoving.length; e < n; e++) {
            (r = this._needsRemoving[e]).newlatlng = r.layer._latlng, r.layer._latlng = r.latlng;
          }

          for (e = 0, n = this._needsRemoving.length; e < n; e++) {
            r = this._needsRemoving[e], this._removeLayer(r.layer, !0), r.layer._latlng = r.newlatlng;
          }

          this._needsRemoving = [], this._zoom = Math.round(this._map._zoom), this._currentShownBounds = this._getExpandedVisibleBounds(), this._map.on("zoomend", this._zoomEnd, this), this._map.on("moveend", this._moveEnd, this), this._spiderfierOnAdd && this._spiderfierOnAdd(), this._bindEvents(), n = this._needsClustering, this._needsClustering = [], this.addLayers(n, !0);
        },
        onRemove: function onRemove(t) {
          t.off("zoomend", this._zoomEnd, this), t.off("moveend", this._moveEnd, this), this._unbindEvents(), this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", ""), this._spiderfierOnRemove && this._spiderfierOnRemove(), delete this._maxLat, this._hideCoverage(), this._featureGroup.remove(), this._nonPointGroup.remove(), this._featureGroup.clearLayers(), this._map = null;
        },
        getVisibleParent: function getVisibleParent(t) {
          for (var e = t; e && !e._icon;) {
            e = e.__parent;
          }

          return e || null;
        },
        _arraySplice: function _arraySplice(t, e) {
          for (var n = t.length - 1; n >= 0; n--) {
            if (t[n] === e) return t.splice(n, 1), !0;
          }
        },
        _removeFromGridUnclustered: function _removeFromGridUnclustered(t, e) {
          for (var n = this._map, r = this._gridUnclustered, i = Math.floor(this._map.getMinZoom()); e >= i && r[e].removeObject(t, n.project(t.getLatLng(), e)); e--) {
            ;
          }
        },
        _childMarkerDragStart: function _childMarkerDragStart(t) {
          t.target.__dragStart = t.target._latlng;
        },
        _childMarkerMoved: function _childMarkerMoved(t) {
          if (!this._ignoreMove && !t.target.__dragStart) {
            var e = t.target._popup && t.target._popup.isOpen();

            this._moveChild(t.target, t.oldLatLng, t.latlng), e && t.target.openPopup();
          }
        },
        _moveChild: function _moveChild(t, e, n) {
          t._latlng = e, this.removeLayer(t), t._latlng = n, this.addLayer(t);
        },
        _childMarkerDragEnd: function _childMarkerDragEnd(t) {
          var e = t.target.__dragStart;
          delete t.target.__dragStart, e && this._moveChild(t.target, e, t.target._latlng);
        },
        _removeLayer: function _removeLayer(t, e, n) {
          var r = this._gridClusters,
              i = this._gridUnclustered,
              o = this._featureGroup,
              a = this._map,
              s = Math.floor(this._map.getMinZoom());
          e && this._removeFromGridUnclustered(t, this._maxZoom);
          var u,
              l = t.__parent,
              c = l._markers;

          for (this._arraySplice(c, t); l && (l._childCount--, l._boundsNeedUpdate = !0, !(l._zoom < s));) {
            e && l._childCount <= 1 ? (u = l._markers[0] === t ? l._markers[1] : l._markers[0], r[l._zoom].removeObject(l, a.project(l._cLatLng, l._zoom)), i[l._zoom].addObject(u, a.project(u.getLatLng(), l._zoom)), this._arraySplice(l.__parent._childClusters, l), l.__parent._markers.push(u), u.__parent = l.__parent, l._icon && (o.removeLayer(l), n || o.addLayer(u))) : l._iconNeedsUpdate = !0, l = l.__parent;
          }

          delete t.__parent;
        },
        _isOrIsParent: function _isOrIsParent(t, e) {
          for (; e;) {
            if (t === e) return !0;
            e = e.parentNode;
          }

          return !1;
        },
        fire: function fire(t, e, n) {
          if (e && e.layer instanceof L.MarkerCluster) {
            if (e.originalEvent && this._isOrIsParent(e.layer._icon, e.originalEvent.relatedTarget)) return;
            t = "cluster" + t;
          }

          L.FeatureGroup.prototype.fire.call(this, t, e, n);
        },
        listens: function listens(t, e) {
          return L.FeatureGroup.prototype.listens.call(this, t, e) || L.FeatureGroup.prototype.listens.call(this, "cluster" + t, e);
        },
        _defaultIconCreateFunction: function _defaultIconCreateFunction(t) {
          var e = t.getChildCount(),
              n = " marker-cluster-";
          return n += e < 10 ? "small" : e < 100 ? "medium" : "large", new L.DivIcon({
            html: "<div><span>" + e + "</span></div>",
            className: "marker-cluster" + n,
            iconSize: new L.Point(40, 40)
          });
        },
        _bindEvents: function _bindEvents() {
          var t = this._map,
              e = this.options.spiderfyOnMaxZoom,
              n = this.options.showCoverageOnHover,
              r = this.options.zoomToBoundsOnClick;
          (e || r) && this.on("clusterclick", this._zoomOrSpiderfy, this), n && (this.on("clustermouseover", this._showCoverage, this), this.on("clustermouseout", this._hideCoverage, this), t.on("zoomend", this._hideCoverage, this));
        },
        _zoomOrSpiderfy: function _zoomOrSpiderfy(t) {
          for (var e = t.layer, n = e; 1 === n._childClusters.length;) {
            n = n._childClusters[0];
          }

          n._zoom === this._maxZoom && n._childCount === e._childCount && this.options.spiderfyOnMaxZoom ? e.spiderfy() : this.options.zoomToBoundsOnClick && e.zoomToBounds(), t.originalEvent && 13 === t.originalEvent.keyCode && this._map._container.focus();
        },
        _showCoverage: function _showCoverage(t) {
          var e = this._map;
          this._inZoomAnimation || (this._shownPolygon && e.removeLayer(this._shownPolygon), t.layer.getChildCount() > 2 && t.layer !== this._spiderfied && (this._shownPolygon = new L.Polygon(t.layer.getConvexHull(), this.options.polygonOptions), e.addLayer(this._shownPolygon)));
        },
        _hideCoverage: function _hideCoverage() {
          this._shownPolygon && (this._map.removeLayer(this._shownPolygon), this._shownPolygon = null);
        },
        _unbindEvents: function _unbindEvents() {
          var t = this.options.spiderfyOnMaxZoom,
              e = this.options.showCoverageOnHover,
              n = this.options.zoomToBoundsOnClick,
              r = this._map;
          (t || n) && this.off("clusterclick", this._zoomOrSpiderfy, this), e && (this.off("clustermouseover", this._showCoverage, this), this.off("clustermouseout", this._hideCoverage, this), r.off("zoomend", this._hideCoverage, this));
        },
        _zoomEnd: function _zoomEnd() {
          this._map && (this._mergeSplitClusters(), this._zoom = Math.round(this._map._zoom), this._currentShownBounds = this._getExpandedVisibleBounds());
        },
        _moveEnd: function _moveEnd() {
          if (!this._inZoomAnimation) {
            var t = this._getExpandedVisibleBounds();

            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, t), this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), t), this._currentShownBounds = t;
          }
        },
        _generateInitialClusters: function _generateInitialClusters() {
          var t = Math.ceil(this._map.getMaxZoom()),
              e = Math.floor(this._map.getMinZoom()),
              n = this.options.maxClusterRadius,
              r = n;
          "function" != typeof n && (r = function r() {
            return n;
          }), null !== this.options.disableClusteringAtZoom && (t = this.options.disableClusteringAtZoom - 1), this._maxZoom = t, this._gridClusters = {}, this._gridUnclustered = {};

          for (var i = t; i >= e; i--) {
            this._gridClusters[i] = new L.DistanceGrid(r(i)), this._gridUnclustered[i] = new L.DistanceGrid(r(i));
          }

          this._topClusterLevel = new this._markerCluster(this, e - 1);
        },
        _addLayer: function _addLayer(t, e) {
          var n,
              r,
              i = this._gridClusters,
              o = this._gridUnclustered,
              a = Math.floor(this._map.getMinZoom());

          for (this.options.singleMarkerMode && this._overrideMarkerIcon(t), t.on(this._childMarkerEventHandlers, this); e >= a; e--) {
            n = this._map.project(t.getLatLng(), e);
            var s = i[e].getNearObject(n);
            if (s) return s._addChild(t), void (t.__parent = s);

            if (s = o[e].getNearObject(n)) {
              var u = s.__parent;
              u && this._removeLayer(s, !1);
              var l = new this._markerCluster(this, e, s, t);
              i[e].addObject(l, this._map.project(l._cLatLng, e)), s.__parent = l, t.__parent = l;
              var c = l;

              for (r = e - 1; r > u._zoom; r--) {
                c = new this._markerCluster(this, r, c), i[r].addObject(c, this._map.project(s.getLatLng(), r));
              }

              return u._addChild(c), void this._removeFromGridUnclustered(s, e);
            }

            o[e].addObject(t, n);
          }

          this._topClusterLevel._addChild(t), t.__parent = this._topClusterLevel;
        },
        _refreshClustersIcons: function _refreshClustersIcons() {
          this._featureGroup.eachLayer(function (t) {
            t instanceof L.MarkerCluster && t._iconNeedsUpdate && t._updateIcon();
          });
        },
        _enqueue: function _enqueue(t) {
          this._queue.push(t), this._queueTimeout || (this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300));
        },
        _processQueue: function _processQueue() {
          for (var t = 0; t < this._queue.length; t++) {
            this._queue[t].call(this);
          }

          this._queue.length = 0, clearTimeout(this._queueTimeout), this._queueTimeout = null;
        },
        _mergeSplitClusters: function _mergeSplitClusters() {
          var t = Math.round(this._map._zoom);
          this._processQueue(), this._zoom < t && this._currentShownBounds.intersects(this._getExpandedVisibleBounds()) ? (this._animationStart(), this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds()), this._animationZoomIn(this._zoom, t)) : this._zoom > t ? (this._animationStart(), this._animationZoomOut(this._zoom, t)) : this._moveEnd();
        },
        _getExpandedVisibleBounds: function _getExpandedVisibleBounds() {
          return this.options.removeOutsideVisibleBounds ? L.Browser.mobile ? this._checkBoundsMaxLat(this._map.getBounds()) : this._checkBoundsMaxLat(this._map.getBounds().pad(1)) : this._mapBoundsInfinite;
        },
        _checkBoundsMaxLat: function _checkBoundsMaxLat(t) {
          var e = this._maxLat;
          return void 0 !== e && (t.getNorth() >= e && (t._northEast.lat = 1 / 0), t.getSouth() <= -e && (t._southWest.lat = -1 / 0)), t;
        },
        _animationAddLayerNonAnimated: function _animationAddLayerNonAnimated(t, e) {
          if (e === t) this._featureGroup.addLayer(t);else if (2 === e._childCount) {
            e._addToMap();

            var n = e.getAllChildMarkers();
            this._featureGroup.removeLayer(n[0]), this._featureGroup.removeLayer(n[1]);
          } else e._updateIcon();
        },
        _extractNonGroupLayers: function _extractNonGroupLayers(t, e) {
          var n,
              r = t.getLayers(),
              i = 0;

          for (e = e || []; i < r.length; i++) {
            (n = r[i]) instanceof L.LayerGroup ? this._extractNonGroupLayers(n, e) : e.push(n);
          }

          return e;
        },
        _overrideMarkerIcon: function _overrideMarkerIcon(t) {
          var e = t.options.icon = this.options.iconCreateFunction({
            getChildCount: function getChildCount() {
              return 1;
            },
            getAllChildMarkers: function getAllChildMarkers() {
              return [t];
            }
          });
          return e;
        }
      });
      L.MarkerClusterGroup.include({
        _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-1 / 0, -1 / 0), new L.LatLng(1 / 0, 1 / 0))
      }), L.MarkerClusterGroup.include({
        _noAnimation: {
          _animationStart: function _animationStart() {},
          _animationZoomIn: function _animationZoomIn(t, e) {
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), t), this._topClusterLevel._recursivelyAddChildrenToMap(null, e, this._getExpandedVisibleBounds()), this.fire("animationend");
          },
          _animationZoomOut: function _animationZoomOut(t, e) {
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), t), this._topClusterLevel._recursivelyAddChildrenToMap(null, e, this._getExpandedVisibleBounds()), this.fire("animationend");
          },
          _animationAddLayer: function _animationAddLayer(t, e) {
            this._animationAddLayerNonAnimated(t, e);
          }
        },
        _withAnimation: {
          _animationStart: function _animationStart() {
            this._map._mapPane.className += " leaflet-cluster-anim", this._inZoomAnimation++;
          },
          _animationZoomIn: function _animationZoomIn(t, e) {
            var n,
                r = this._getExpandedVisibleBounds(),
                i = this._featureGroup,
                o = Math.floor(this._map.getMinZoom());

            this._ignoreMove = !0, this._topClusterLevel._recursively(r, t, o, function (o) {
              var a,
                  s = o._latlng,
                  u = o._markers;

              for (r.contains(s) || (s = null), o._isSingleParent() && t + 1 === e ? (i.removeLayer(o), o._recursivelyAddChildrenToMap(null, e, r)) : (o.clusterHide(), o._recursivelyAddChildrenToMap(s, e, r)), n = u.length - 1; n >= 0; n--) {
                a = u[n], r.contains(a._latlng) || i.removeLayer(a);
              }
            }), this._forceLayout(), this._topClusterLevel._recursivelyBecomeVisible(r, e), i.eachLayer(function (t) {
              t instanceof L.MarkerCluster || !t._icon || t.clusterShow();
            }), this._topClusterLevel._recursively(r, t, e, function (t) {
              t._recursivelyRestoreChildPositions(e);
            }), this._ignoreMove = !1, this._enqueue(function () {
              this._topClusterLevel._recursively(r, t, o, function (t) {
                i.removeLayer(t), t.clusterShow();
              }), this._animationEnd();
            });
          },
          _animationZoomOut: function _animationZoomOut(t, e) {
            this._animationZoomOutSingle(this._topClusterLevel, t - 1, e), this._topClusterLevel._recursivelyAddChildrenToMap(null, e, this._getExpandedVisibleBounds()), this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), t, this._getExpandedVisibleBounds());
          },
          _animationAddLayer: function _animationAddLayer(t, e) {
            var n = this,
                r = this._featureGroup;
            r.addLayer(t), e !== t && (e._childCount > 2 ? (e._updateIcon(), this._forceLayout(), this._animationStart(), t._setPos(this._map.latLngToLayerPoint(e.getLatLng())), t.clusterHide(), this._enqueue(function () {
              r.removeLayer(t), t.clusterShow(), n._animationEnd();
            })) : (this._forceLayout(), n._animationStart(), n._animationZoomOutSingle(e, this._map.getMaxZoom(), this._zoom)));
          }
        },
        _animationZoomOutSingle: function _animationZoomOutSingle(t, e, n) {
          var r = this._getExpandedVisibleBounds(),
              i = Math.floor(this._map.getMinZoom());

          t._recursivelyAnimateChildrenInAndAddSelfToMap(r, i, e + 1, n);

          var o = this;
          this._forceLayout(), t._recursivelyBecomeVisible(r, n), this._enqueue(function () {
            if (1 === t._childCount) {
              var a = t._markers[0];
              this._ignoreMove = !0, a.setLatLng(a.getLatLng()), this._ignoreMove = !1, a.clusterShow && a.clusterShow();
            } else t._recursively(r, n, i, function (t) {
              t._recursivelyRemoveChildrenFromMap(r, i, e + 1);
            });

            o._animationEnd();
          });
        },
        _animationEnd: function _animationEnd() {
          this._map && (this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", "")), this._inZoomAnimation--, this.fire("animationend");
        },
        _forceLayout: function _forceLayout() {
          L.Util.falseFn(document.body.offsetWidth);
        }
      }), L.markerClusterGroup = function (t) {
        return new L.MarkerClusterGroup(t);
      };
      var n = L.MarkerCluster = L.Marker.extend({
        options: L.Icon.prototype.options,
        initialize: function initialize(t, e, n, r) {
          L.Marker.prototype.initialize.call(this, n ? n._cLatLng || n.getLatLng() : new L.LatLng(0, 0), {
            icon: this,
            pane: t.options.clusterPane
          }), this._group = t, this._zoom = e, this._markers = [], this._childClusters = [], this._childCount = 0, this._iconNeedsUpdate = !0, this._boundsNeedUpdate = !0, this._bounds = new L.LatLngBounds(), n && this._addChild(n), r && this._addChild(r);
        },
        getAllChildMarkers: function getAllChildMarkers(t, e) {
          t = t || [];

          for (var n = this._childClusters.length - 1; n >= 0; n--) {
            this._childClusters[n].getAllChildMarkers(t);
          }

          for (var r = this._markers.length - 1; r >= 0; r--) {
            e && this._markers[r].__dragStart || t.push(this._markers[r]);
          }

          return t;
        },
        getChildCount: function getChildCount() {
          return this._childCount;
        },
        zoomToBounds: function zoomToBounds(t) {
          for (var e, n = this._childClusters.slice(), r = this._group._map, i = r.getBoundsZoom(this._bounds), o = this._zoom + 1, a = r.getZoom(); n.length > 0 && i > o;) {
            o++;
            var s = [];

            for (e = 0; e < n.length; e++) {
              s = s.concat(n[e]._childClusters);
            }

            n = s;
          }

          i > o ? this._group._map.setView(this._latlng, o) : i <= a ? this._group._map.setView(this._latlng, a + 1) : this._group._map.fitBounds(this._bounds, t);
        },
        getBounds: function getBounds() {
          var t = new L.LatLngBounds();
          return t.extend(this._bounds), t;
        },
        _updateIcon: function _updateIcon() {
          this._iconNeedsUpdate = !0, this._icon && this.setIcon(this);
        },
        createIcon: function createIcon() {
          return this._iconNeedsUpdate && (this._iconObj = this._group.options.iconCreateFunction(this), this._iconNeedsUpdate = !1), this._iconObj.createIcon();
        },
        createShadow: function createShadow() {
          return this._iconObj.createShadow();
        },
        _addChild: function _addChild(t, e) {
          this._iconNeedsUpdate = !0, this._boundsNeedUpdate = !0, this._setClusterCenter(t), t instanceof L.MarkerCluster ? (e || (this._childClusters.push(t), t.__parent = this), this._childCount += t._childCount) : (e || this._markers.push(t), this._childCount++), this.__parent && this.__parent._addChild(t, !0);
        },
        _setClusterCenter: function _setClusterCenter(t) {
          this._cLatLng || (this._cLatLng = t._cLatLng || t._latlng);
        },
        _resetBounds: function _resetBounds() {
          var t = this._bounds;
          t._southWest && (t._southWest.lat = 1 / 0, t._southWest.lng = 1 / 0), t._northEast && (t._northEast.lat = -1 / 0, t._northEast.lng = -1 / 0);
        },
        _recalculateBounds: function _recalculateBounds() {
          var t,
              e,
              n,
              r,
              i = this._markers,
              o = this._childClusters,
              a = 0,
              s = 0,
              u = this._childCount;

          if (0 !== u) {
            for (this._resetBounds(), t = 0; t < i.length; t++) {
              n = i[t]._latlng, this._bounds.extend(n), a += n.lat, s += n.lng;
            }

            for (t = 0; t < o.length; t++) {
              (e = o[t])._boundsNeedUpdate && e._recalculateBounds(), this._bounds.extend(e._bounds), n = e._wLatLng, r = e._childCount, a += n.lat * r, s += n.lng * r;
            }

            this._latlng = this._wLatLng = new L.LatLng(a / u, s / u), this._boundsNeedUpdate = !1;
          }
        },
        _addToMap: function _addToMap(t) {
          t && (this._backupLatlng = this._latlng, this.setLatLng(t)), this._group._featureGroup.addLayer(this);
        },
        _recursivelyAnimateChildrenIn: function _recursivelyAnimateChildrenIn(t, e, n) {
          this._recursively(t, this._group._map.getMinZoom(), n - 1, function (t) {
            var n,
                r,
                i = t._markers;

            for (n = i.length - 1; n >= 0; n--) {
              (r = i[n])._icon && (r._setPos(e), r.clusterHide());
            }
          }, function (t) {
            var n,
                r,
                i = t._childClusters;

            for (n = i.length - 1; n >= 0; n--) {
              (r = i[n])._icon && (r._setPos(e), r.clusterHide());
            }
          });
        },
        _recursivelyAnimateChildrenInAndAddSelfToMap: function _recursivelyAnimateChildrenInAndAddSelfToMap(t, e, n, r) {
          this._recursively(t, r, e, function (i) {
            i._recursivelyAnimateChildrenIn(t, i._group._map.latLngToLayerPoint(i.getLatLng()).round(), n), i._isSingleParent() && n - 1 === r ? (i.clusterShow(), i._recursivelyRemoveChildrenFromMap(t, e, n)) : i.clusterHide(), i._addToMap();
          });
        },
        _recursivelyBecomeVisible: function _recursivelyBecomeVisible(t, e) {
          this._recursively(t, this._group._map.getMinZoom(), e, null, function (t) {
            t.clusterShow();
          });
        },
        _recursivelyAddChildrenToMap: function _recursivelyAddChildrenToMap(t, e, n) {
          this._recursively(n, this._group._map.getMinZoom() - 1, e, function (r) {
            if (e !== r._zoom) for (var i = r._markers.length - 1; i >= 0; i--) {
              var o = r._markers[i];
              n.contains(o._latlng) && (t && (o._backupLatlng = o.getLatLng(), o.setLatLng(t), o.clusterHide && o.clusterHide()), r._group._featureGroup.addLayer(o));
            }
          }, function (e) {
            e._addToMap(t);
          });
        },
        _recursivelyRestoreChildPositions: function _recursivelyRestoreChildPositions(t) {
          for (var e = this._markers.length - 1; e >= 0; e--) {
            var n = this._markers[e];
            n._backupLatlng && (n.setLatLng(n._backupLatlng), delete n._backupLatlng);
          }

          if (t - 1 === this._zoom) for (var r = this._childClusters.length - 1; r >= 0; r--) {
            this._childClusters[r]._restorePosition();
          } else for (var i = this._childClusters.length - 1; i >= 0; i--) {
            this._childClusters[i]._recursivelyRestoreChildPositions(t);
          }
        },
        _restorePosition: function _restorePosition() {
          this._backupLatlng && (this.setLatLng(this._backupLatlng), delete this._backupLatlng);
        },
        _recursivelyRemoveChildrenFromMap: function _recursivelyRemoveChildrenFromMap(t, e, n, r) {
          var i, o;

          this._recursively(t, e - 1, n - 1, function (t) {
            for (o = t._markers.length - 1; o >= 0; o--) {
              i = t._markers[o], r && r.contains(i._latlng) || (t._group._featureGroup.removeLayer(i), i.clusterShow && i.clusterShow());
            }
          }, function (t) {
            for (o = t._childClusters.length - 1; o >= 0; o--) {
              i = t._childClusters[o], r && r.contains(i._latlng) || (t._group._featureGroup.removeLayer(i), i.clusterShow && i.clusterShow());
            }
          });
        },
        _recursively: function _recursively(t, e, n, r, i) {
          var o,
              a,
              s = this._childClusters,
              u = this._zoom;
          if (e <= u && (r && r(this), i && u === n && i(this)), u < e || u < n) for (o = s.length - 1; o >= 0; o--) {
            (a = s[o])._boundsNeedUpdate && a._recalculateBounds(), t.intersects(a._bounds) && a._recursively(t, e, n, r, i);
          }
        },
        _isSingleParent: function _isSingleParent() {
          return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
        }
      });
      L.Marker.include({
        clusterHide: function clusterHide() {
          var t = this.options.opacity;
          return this.setOpacity(0), this.options.opacity = t, this;
        },
        clusterShow: function clusterShow() {
          return this.setOpacity(this.options.opacity);
        }
      }), L.DistanceGrid = function (t) {
        this._cellSize = t, this._sqCellSize = t * t, this._grid = {}, this._objectPoint = {};
      }, L.DistanceGrid.prototype = {
        addObject: function addObject(t, e) {
          var n = this._getCoord(e.x),
              r = this._getCoord(e.y),
              i = this._grid,
              o = i[r] = i[r] || {},
              a = o[n] = o[n] || [],
              s = L.Util.stamp(t);

          this._objectPoint[s] = e, a.push(t);
        },
        updateObject: function updateObject(t, e) {
          this.removeObject(t), this.addObject(t, e);
        },
        removeObject: function removeObject(t, e) {
          var n,
              r,
              i = this._getCoord(e.x),
              o = this._getCoord(e.y),
              a = this._grid,
              s = a[o] = a[o] || {},
              u = s[i] = s[i] || [];

          for (delete this._objectPoint[L.Util.stamp(t)], n = 0, r = u.length; n < r; n++) {
            if (u[n] === t) return u.splice(n, 1), 1 === r && delete s[i], !0;
          }
        },
        eachObject: function eachObject(t, e) {
          var n,
              r,
              i,
              o,
              a,
              s,
              u = this._grid;

          for (n in u) {
            for (r in a = u[n]) {
              for (s = a[r], i = 0, o = s.length; i < o; i++) {
                t.call(e, s[i]) && (i--, o--);
              }
            }
          }
        },
        getNearObject: function getNearObject(t) {
          var e,
              n,
              r,
              i,
              o,
              a,
              s,
              u,
              l = this._getCoord(t.x),
              c = this._getCoord(t.y),
              h = this._objectPoint,
              f = this._sqCellSize,
              p = null;

          for (e = c - 1; e <= c + 1; e++) {
            if (i = this._grid[e]) for (n = l - 1; n <= l + 1; n++) {
              if (o = i[n]) for (r = 0, a = o.length; r < a; r++) {
                s = o[r], ((u = this._sqDist(h[L.Util.stamp(s)], t)) < f || u <= f && null === p) && (f = u, p = s);
              }
            }
          }

          return p;
        },
        _getCoord: function _getCoord(t) {
          var e = Math.floor(t / this._cellSize);
          return isFinite(e) ? e : t;
        },
        _sqDist: function _sqDist(t, e) {
          var n = e.x - t.x,
              r = e.y - t.y;
          return n * n + r * r;
        }
      }, L.QuickHull = {
        getDistant: function getDistant(t, e) {
          var n = e[1].lat - e[0].lat,
              r = e[0].lng - e[1].lng;
          return r * (t.lat - e[0].lat) + n * (t.lng - e[0].lng);
        },
        findMostDistantPointFromBaseLine: function findMostDistantPointFromBaseLine(t, e) {
          var n,
              r,
              i,
              o = 0,
              a = null,
              s = [];

          for (n = e.length - 1; n >= 0; n--) {
            r = e[n], (i = this.getDistant(r, t)) > 0 && (s.push(r), i > o && (o = i, a = r));
          }

          return {
            maxPoint: a,
            newPoints: s
          };
        },
        buildConvexHull: function buildConvexHull(t, e) {
          var n = [],
              r = this.findMostDistantPointFromBaseLine(t, e);
          return r.maxPoint ? n = (n = n.concat(this.buildConvexHull([t[0], r.maxPoint], r.newPoints))).concat(this.buildConvexHull([r.maxPoint, t[1]], r.newPoints)) : [t[0]];
        },
        getConvexHull: function getConvexHull(t) {
          var e,
              n = !1,
              r = !1,
              i = !1,
              o = !1,
              a = null,
              s = null,
              u = null,
              l = null,
              c = null,
              h = null;

          for (e = t.length - 1; e >= 0; e--) {
            var f = t[e];
            (!1 === n || f.lat > n) && (a = f, n = f.lat), (!1 === r || f.lat < r) && (s = f, r = f.lat), (!1 === i || f.lng > i) && (u = f, i = f.lng), (!1 === o || f.lng < o) && (l = f, o = f.lng);
          }

          r !== n ? (h = s, c = a) : (h = l, c = u);
          var p = [].concat(this.buildConvexHull([h, c], t), this.buildConvexHull([c, h], t));
          return p;
        }
      }, L.MarkerCluster.include({
        getConvexHull: function getConvexHull() {
          var t,
              e,
              n = this.getAllChildMarkers(),
              r = [];

          for (e = n.length - 1; e >= 0; e--) {
            t = n[e].getLatLng(), r.push(t);
          }

          return L.QuickHull.getConvexHull(r);
        }
      }), L.MarkerCluster.include({
        _2PI: 2 * Math.PI,
        _circleFootSeparation: 25,
        _circleStartAngle: 0,
        _spiralFootSeparation: 28,
        _spiralLengthStart: 11,
        _spiralLengthFactor: 5,
        _circleSpiralSwitchover: 9,
        spiderfy: function spiderfy() {
          if (this._group._spiderfied !== this && !this._group._inZoomAnimation) {
            var t,
                e = this.getAllChildMarkers(null, !0),
                n = this._group,
                r = n._map,
                i = r.latLngToLayerPoint(this._latlng);
            this._group._unspiderfy(), this._group._spiderfied = this, e.length >= this._circleSpiralSwitchover ? t = this._generatePointsSpiral(e.length, i) : (i.y += 10, t = this._generatePointsCircle(e.length, i)), this._animationSpiderfy(e, t);
          }
        },
        unspiderfy: function unspiderfy(t) {
          this._group._inZoomAnimation || (this._animationUnspiderfy(t), this._group._spiderfied = null);
        },
        _generatePointsCircle: function _generatePointsCircle(t, e) {
          var n,
              r,
              i = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + t),
              o = i / this._2PI,
              a = this._2PI / t,
              s = [];

          for (o = Math.max(o, 35), s.length = t, n = 0; n < t; n++) {
            r = this._circleStartAngle + n * a, s[n] = new L.Point(e.x + o * Math.cos(r), e.y + o * Math.sin(r))._round();
          }

          return s;
        },
        _generatePointsSpiral: function _generatePointsSpiral(t, e) {
          var n,
              r = this._group.options.spiderfyDistanceMultiplier,
              i = r * this._spiralLengthStart,
              o = r * this._spiralFootSeparation,
              a = r * this._spiralLengthFactor * this._2PI,
              s = 0,
              u = [];

          for (u.length = t, n = t; n >= 0; n--) {
            n < t && (u[n] = new L.Point(e.x + i * Math.cos(s), e.y + i * Math.sin(s))._round()), i += a / (s += o / i + 5e-4 * n);
          }

          return u;
        },
        _noanimationUnspiderfy: function _noanimationUnspiderfy() {
          var t,
              e,
              n = this._group,
              r = n._map,
              i = n._featureGroup,
              o = this.getAllChildMarkers(null, !0);

          for (n._ignoreMove = !0, this.setOpacity(1), e = o.length - 1; e >= 0; e--) {
            t = o[e], i.removeLayer(t), t._preSpiderfyLatlng && (t.setLatLng(t._preSpiderfyLatlng), delete t._preSpiderfyLatlng), t.setZIndexOffset && t.setZIndexOffset(0), t._spiderLeg && (r.removeLayer(t._spiderLeg), delete t._spiderLeg);
          }

          n.fire("unspiderfied", {
            cluster: this,
            markers: o
          }), n._ignoreMove = !1, n._spiderfied = null;
        }
      }), L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
        _animationSpiderfy: function _animationSpiderfy(t, e) {
          var n,
              r,
              i,
              o,
              a = this._group,
              s = a._map,
              u = a._featureGroup,
              l = this._group.options.spiderLegPolylineOptions;

          for (a._ignoreMove = !0, n = 0; n < t.length; n++) {
            o = s.layerPointToLatLng(e[n]), r = t[n], i = new L.Polyline([this._latlng, o], l), s.addLayer(i), r._spiderLeg = i, r._preSpiderfyLatlng = r._latlng, r.setLatLng(o), r.setZIndexOffset && r.setZIndexOffset(1e6), u.addLayer(r);
          }

          this.setOpacity(.3), a._ignoreMove = !1, a.fire("spiderfied", {
            cluster: this,
            markers: t
          });
        },
        _animationUnspiderfy: function _animationUnspiderfy() {
          this._noanimationUnspiderfy();
        }
      }), L.MarkerCluster.include({
        _animationSpiderfy: function _animationSpiderfy(t, e) {
          var n,
              r,
              i,
              o,
              a,
              s,
              u = this,
              l = this._group,
              c = l._map,
              h = l._featureGroup,
              f = this._latlng,
              p = c.latLngToLayerPoint(f),
              d = L.Path.SVG,
              v = L.extend({}, this._group.options.spiderLegPolylineOptions),
              y = v.opacity;

          for (void 0 === y && (y = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity), d ? (v.opacity = 0, v.className = (v.className || "") + " leaflet-cluster-spider-leg") : v.opacity = y, l._ignoreMove = !0, n = 0; n < t.length; n++) {
            r = t[n], s = c.layerPointToLatLng(e[n]), i = new L.Polyline([f, s], v), c.addLayer(i), r._spiderLeg = i, d && (o = i._path, a = o.getTotalLength() + .1, o.style.strokeDasharray = a, o.style.strokeDashoffset = a), r.setZIndexOffset && r.setZIndexOffset(1e6), r.clusterHide && r.clusterHide(), h.addLayer(r), r._setPos && r._setPos(p);
          }

          for (l._forceLayout(), l._animationStart(), n = t.length - 1; n >= 0; n--) {
            s = c.layerPointToLatLng(e[n]), (r = t[n])._preSpiderfyLatlng = r._latlng, r.setLatLng(s), r.clusterShow && r.clusterShow(), d && (i = r._spiderLeg, (o = i._path).style.strokeDashoffset = 0, i.setStyle({
              opacity: y
            }));
          }

          this.setOpacity(.3), l._ignoreMove = !1, setTimeout(function () {
            l._animationEnd(), l.fire("spiderfied", {
              cluster: u,
              markers: t
            });
          }, 200);
        },
        _animationUnspiderfy: function _animationUnspiderfy(t) {
          var e,
              n,
              r,
              i,
              o,
              a,
              s = this,
              u = this._group,
              l = u._map,
              c = u._featureGroup,
              h = t ? l._latLngToNewLayerPoint(this._latlng, t.zoom, t.center) : l.latLngToLayerPoint(this._latlng),
              f = this.getAllChildMarkers(null, !0),
              p = L.Path.SVG;

          for (u._ignoreMove = !0, u._animationStart(), this.setOpacity(1), n = f.length - 1; n >= 0; n--) {
            (e = f[n])._preSpiderfyLatlng && (e.closePopup(), e.setLatLng(e._preSpiderfyLatlng), delete e._preSpiderfyLatlng, a = !0, e._setPos && (e._setPos(h), a = !1), e.clusterHide && (e.clusterHide(), a = !1), a && c.removeLayer(e), p && (r = e._spiderLeg, i = r._path, o = i.getTotalLength() + .1, i.style.strokeDashoffset = o, r.setStyle({
              opacity: 0
            })));
          }

          u._ignoreMove = !1, setTimeout(function () {
            var t = 0;

            for (n = f.length - 1; n >= 0; n--) {
              (e = f[n])._spiderLeg && t++;
            }

            for (n = f.length - 1; n >= 0; n--) {
              (e = f[n])._spiderLeg && (e.clusterShow && e.clusterShow(), e.setZIndexOffset && e.setZIndexOffset(0), t > 1 && c.removeLayer(e), l.removeLayer(e._spiderLeg), delete e._spiderLeg);
            }

            u._animationEnd(), u.fire("unspiderfied", {
              cluster: s,
              markers: f
            });
          }, 200);
        }
      }), L.MarkerClusterGroup.include({
        _spiderfied: null,
        unspiderfy: function unspiderfy() {
          this._unspiderfy.apply(this, arguments);
        },
        _spiderfierOnAdd: function _spiderfierOnAdd() {
          this._map.on("click", this._unspiderfyWrapper, this), this._map.options.zoomAnimation && this._map.on("zoomstart", this._unspiderfyZoomStart, this), this._map.on("zoomend", this._noanimationUnspiderfy, this), L.Browser.touch || this._map.getRenderer(this);
        },
        _spiderfierOnRemove: function _spiderfierOnRemove() {
          this._map.off("click", this._unspiderfyWrapper, this), this._map.off("zoomstart", this._unspiderfyZoomStart, this), this._map.off("zoomanim", this._unspiderfyZoomAnim, this), this._map.off("zoomend", this._noanimationUnspiderfy, this), this._noanimationUnspiderfy();
        },
        _unspiderfyZoomStart: function _unspiderfyZoomStart() {
          this._map && this._map.on("zoomanim", this._unspiderfyZoomAnim, this);
        },
        _unspiderfyZoomAnim: function _unspiderfyZoomAnim(t) {
          L.DomUtil.hasClass(this._map._mapPane, "leaflet-touching") || (this._map.off("zoomanim", this._unspiderfyZoomAnim, this), this._unspiderfy(t));
        },
        _unspiderfyWrapper: function _unspiderfyWrapper() {
          this._unspiderfy();
        },
        _unspiderfy: function _unspiderfy(t) {
          this._spiderfied && this._spiderfied.unspiderfy(t);
        },
        _noanimationUnspiderfy: function _noanimationUnspiderfy() {
          this._spiderfied && this._spiderfied._noanimationUnspiderfy();
        },
        _unspiderfyLayer: function _unspiderfyLayer(t) {
          t._spiderLeg && (this._featureGroup.removeLayer(t), t.clusterShow && t.clusterShow(), t.setZIndexOffset && t.setZIndexOffset(0), this._map.removeLayer(t._spiderLeg), delete t._spiderLeg);
        }
      }), L.MarkerClusterGroup.include({
        refreshClusters: function refreshClusters(t) {
          return t ? t instanceof L.MarkerClusterGroup ? t = t._topClusterLevel.getAllChildMarkers() : t instanceof L.LayerGroup ? t = t._layers : t instanceof L.MarkerCluster ? t = t.getAllChildMarkers() : t instanceof L.Marker && (t = [t]) : t = this._topClusterLevel.getAllChildMarkers(), this._flagParentsIconsNeedUpdate(t), this._refreshClustersIcons(), this.options.singleMarkerMode && this._refreshSingleMarkerModeMarkers(t), this;
        },
        _flagParentsIconsNeedUpdate: function _flagParentsIconsNeedUpdate(t) {
          var e, n;

          for (e in t) {
            for (n = t[e].__parent; n;) {
              n._iconNeedsUpdate = !0, n = n.__parent;
            }
          }
        },
        _refreshSingleMarkerModeMarkers: function _refreshSingleMarkerModeMarkers(t) {
          var e, n;

          for (e in t) {
            n = t[e], this.hasLayer(n) && n.setIcon(this._overrideMarkerIcon(n));
          }
        }
      }), L.Marker.include({
        refreshIconOptions: function refreshIconOptions(t, e) {
          var n = this.options.icon;
          return L.setOptions(n, t), this.setIcon(n), e && this.__parent && this.__parent._group.refreshClusters(this), this;
        }
      }), t.MarkerClusterGroup = e, t.MarkerCluster = n;
    }(e);
  }, function (t, e) {
    t.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTUuNSIgZmlsbD0iIzE5N0NBNCIgc3Ryb2tlPSIjRUNFQ0VDIi8+CjxwYXRoIGQ9Ik0xNC44NTc5IDI2LjAyM0M4LjgwMzggMTcuMjQ2NCA3LjY4MDA1IDE2LjM0NTcgNy42ODAwNSAxMy4xMjAxQzcuNjgwMDUgOC43MDE4MiAxMS4yNjE4IDUuMTIwMTIgMTUuNjgwMSA1LjEyMDEyQzIwLjA5ODMgNS4xMjAxMiAyMy42ODAxIDguNzAxODIgMjMuNjgwMSAxMy4xMjAxQzIzLjY4MDEgMTYuMzQ1NyAyMi41NTYzIDE3LjI0NjQgMTYuNTAyMiAyNi4wMjNDMTYuMTA0OSAyNi41OTY5IDE1LjI1NTEgMjYuNTk2OSAxNC44NTc5IDI2LjAyM1pNMTUuNjgwMSAxNi40NTM0QzE3LjUyMSAxNi40NTM0IDE5LjAxMzQgMTQuOTYxMSAxOS4wMTM0IDEzLjEyMDFDMTkuMDEzNCAxMS4yNzkyIDE3LjUyMSA5Ljc4Njc4IDE1LjY4MDEgOS43ODY3OEMxMy44MzkxIDkuNzg2NzggMTIuMzQ2NyAxMS4yNzkyIDEyLjM0NjcgMTMuMTIwMUMxMi4zNDY3IDE0Ljk2MTEgMTMuODM5MSAxNi40NTM0IDE1LjY4MDEgMTYuNDUzNFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
  }, function (t, e) {
    t.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIyOCIgY3k9IjI4IiByPSIyNy41IiBmaWxsPSIjMjQyNDI0IiBmaWxsLW9wYWNpdHk9IjAuMiIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";
  }]);
});